var _style, _g, _rect, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _g4, _g5, _g6, _g7, _g8, _g9, _path12, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _polygon2, _path13, _path14, _polygon3, _path15, _path16, _path17, _g17, _g18, _g19, _g20, _g21, _path18, _path19, _g22, _g23, _g24, _path20, _path21, _path22, _path23, _path24, _polygon4, _path25, _path26, _polygon5, _polygon6, _path27, _path28, _path29, _polygon7, _polygon8, _polyline, _g25, _g26, _g27, _g28, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _path30, _path31, _path32, _path33, _path34, _g41, _g42, _g43, _g44, _g45, _path35, _path36, _g46, _g47, _g48, _g49, _g50, _polygon14, _path37, _path38, _polygon15, _path39, _polygon16, _line, _g51, _path40, _path41, _g52, _polyline2, _path42, _line2, _path43, _path44, _path45, _path46, _line3, _path47, _g53, _path48, _path49, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _path50, _g62, _g63, _g64, _text, _path51, _path52, _polygon17, _path53, _path54, _path55, _path56, _path57, _path58, _g65, _path59, _path60, _polygon18, _path61, _path62, _path63, _path64, _path65, _path66, _g66, _path67, _path68, _ellipse, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path69, _polygon19, _path70, _path71, _path72, _path73, _rect9, _line4, _path74, _path75, _path76, _rect10, _ellipse2, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path77, _polygon20, _path78, _path79, _path80, _rect18, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _rect19, _line5, _path97, _path98, _path99, _rect20, _text2, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _g67, _path107, _path108, _path109, _path110, _path111, _path112, _polygon21, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _polygon22, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _g68, _path177, _polygon23, _polygon24, _path178, _path179, _polygon25, _path180, _g69, _polygon26, _polygon27, _polygon28, _path181, _path182, _path183, _path184, _path185, _line6, _line7, _line8, _g70, _g71, _g72, _g73, _g74, _g75, _line9, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _path186, _path187, _path188, _path189, _path190, _line10, _line11, _line12, _g110, _g111, _g112, _g113, _g114, _g115, _line13, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _path191, _path192, _path193, _path194, _path195, _line14, _line15, _line16, _g150, _g151, _g152, _g153, _g154, _g155, _line17, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _path196, _path197, _path198, _path199, _path200, _line18, _line19, _line20, _g190, _g191, _g192, _g193, _g194, _g195, _line21, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _path201, _path202, _path203, _path204, _path205, _line22, _line23, _line24, _g230, _g231, _g232, _g233, _g234, _g235, _line25, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _path206, _path207, _path208, _path209, _path210, _line26, _line27, _line28, _g270, _g271, _g272, _g273, _g274, _g275, _line29, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _g290, _g291, _g292, _g293, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _g301, _g302, _g303, _g304, _g305, _g306, _g307, _g308, _g309, _path211, _path212, _path213, _path214, _path215, _line30, _line31, _line32, _g310, _g311, _g312, _g313, _g314, _g315, _line33, _g316, _g317, _g318, _g319, _g320, _g321, _g322, _g323, _g324, _g325, _g326, _g327, _g328, _g329, _g330, _g331, _g332, _g333, _g334, _g335, _g336, _g337, _g338, _g339, _g340, _g341, _g342, _g343, _g344, _g345, _g346, _g347, _g348, _g349, _g350, _g351, _g352, _g353, _g354, _polyline3, _polygon29, _polygon30, _g355, _polygon31, _path216, _path217, _path218, _path219, _path220, _polyline4, _polygon32, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _polygon33, _g356, _path230;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaceTrack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4096 2160",
    style: {
      enableBackground: "new 0 0 4096 2160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{opacity:0.04;fill:#AE4A42;}\n\t.st3{opacity:0.11;fill:#AE4A42;}\n\t.st4{opacity:0.46;fill:url(#SVGID_3_);}\n\t.st5{opacity:0.28;fill:url(#SVGID_4_);}\n\t.st6{opacity:0.46;fill:url(#SVGID_5_);}\n\t.st7{fill:#AE4A42;}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{opacity:0.35;fill:#AE4A42;}\n\t.st10{opacity:0.32;fill:#AE4A42;}\n\t.st11{fill:#DF946D;}\n\t.st12{fill:#A04750;}\n\t.st13{fill:url(#SVGID_7_);}\n\t.st14{fill:url(#SVGID_8_);}\n\t.st15{fill:url(#SVGID_9_);}\n\t.st16{fill:url(#SVGID_10_);}\n\t.st17{fill:url(#SVGID_11_);}\n\t.st18{fill:url(#SVGID_12_);}\n\t.st19{fill:url(#SVGID_13_);}\n\t.st20{opacity:0.61;fill:#AE4A42;}\n\t.st21{fill:#CA6259;}\n\t.st22{fill:none;stroke:#F9EFC7;stroke-width:26;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;}\n\t.st24{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0585,12.0585;}\n\t.st25{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0591,12.0591;}\n\t.st26{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0101,12.0101;}\n\t.st27{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0173,12.0173;}\n\t.st28{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0993,12.0993;}\n\t.st29{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:11.5937,11.5937;}\n\t.st30{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0062,12.0062;}\n\t.st31{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:11.9162,11.9162;}\n\t.st32{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0211,12.0211;}\n\t.st33{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:11.8443,11.8443;}\n\t.st34{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.073,12.073;}\n\t.st35{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.1361,12.1361;}\n\t.st36{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0603,12.0603;}\n\t.st37{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.2549,12.2549;}\n\t.st38{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0288,12.0288;}\n\t.st39{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.4686,12.4686;}\n\t.st40{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.023,12.023;}\n\t.st41{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:11.8236,11.8236;}\n\t.st42{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0011,12.0011;}\n\t.st43{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:11.6221,11.6221;}\n\t.st44{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.1927,12.1927;}\n\t.st45{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:12.0447,12.0447;}\n\t.st46{fill:none;stroke:#EF674D;stroke-width:26;stroke-miterlimit:10;stroke-dasharray:11.8987,11.8987;}\n\t.st47{fill:#353535;}\n\t.st48{opacity:0.33;fill:url(#SVGID_14_);}\n\t.st49{opacity:0.21;fill:url(#SVGID_15_);}\n\t.st50{opacity:0.4;}\n\t.st51{fill:none;stroke:#FCE0BB;stroke-width:2;stroke-miterlimit:10;}\n\t.st52{fill:none;stroke:#FFF6CF;stroke-width:10;stroke-miterlimit:10;}\n\t.st53{fill:none;stroke:#FFF6CF;stroke-width:10;stroke-miterlimit:10;stroke-dasharray:12.0194,12.0194;}\n\t.st54{fill:none;stroke:#FFF6CF;stroke-width:10;stroke-miterlimit:10;stroke-dasharray:12.059,12.059;}\n\t.st55{fill:url(#SVGID_16_);}\n\t.st56{fill:url(#SVGID_17_);}\n\t.st57{fill:url(#SVGID_18_);}\n\t.st58{fill:url(#SVGID_19_);}\n\t.st59{fill:url(#SVGID_20_);}\n\t.st60{fill:url(#SVGID_21_);}\n\t.st61{fill:url(#SVGID_22_);}\n\t.st62{fill:url(#SVGID_23_);}\n\t.st63{fill:url(#SVGID_24_);}\n\t.st64{fill:url(#SVGID_25_);}\n\t.st65{fill:#E7A887;}\n\t.st66{opacity:0.1;fill:#AE4A42;}\n\t.st67{opacity:0.43;fill:#191919;}\n\t.st68{opacity:0.44;fill:#191919;}\n\t.st69{fill:none;stroke:#282828;stroke-width:3;stroke-miterlimit:10;}\n\t.st70{opacity:0.33;fill:#282828;}\n\t.st71{fill:none;stroke:#722B00;stroke-width:3;stroke-miterlimit:10;}\n\t.st72{fill:url(#SVGID_26_);}\n\t.st73{fill:url(#SVGID_27_);}\n\t.st74{fill:#4F2421;}\n\t.st75{fill:#945041;}\n\t.st76{fill:#79271C;}\n\t.st77{fill:url(#SVGID_28_);}\n\t.st78{fill:url(#SVGID_29_);}\n\t.st79{fill:url(#SVGID_30_);}\n\t.st80{fill:url(#SVGID_31_);}\n\t.st81{fill:url(#SVGID_32_);}\n\t.st82{fill:url(#SVGID_33_);}\n\t.st83{fill:url(#SVGID_34_);}\n\t.st84{fill:url(#SVGID_35_);}\n\t.st85{fill:url(#SVGID_36_);}\n\t.st86{fill:url(#SVGID_37_);}\n\t.st87{fill:#FFD9C0;}\n\t.st88{fill:none;stroke:#FFD9C0;stroke-width:18;stroke-miterlimit:10;}\n\t.st89{fill:none;stroke:#FFD9C0;stroke-width:7;stroke-miterlimit:10;}\n\t.st90{opacity:0.39;fill:none;stroke:#000000;stroke-width:9;stroke-miterlimit:10;}\n\t.st91{fill:#DDB7A2;}\n\t.st92{fill:url(#SVGID_38_);}\n\t.st93{fill:none;stroke:#443126;stroke-width:4;stroke-miterlimit:10;}\n\t.st94{display:none;}\n\t.st95{display:inline;opacity:0.1;}\n\t.st96{display:inline;}\n\t.st97{font-family:'Brolink-Regular';}\n\t.st98{font-size:18.7925px;}\n\t.st99{fill:url(#SVGID_39_);}\n\t.st100{fill:url(#SVGID_40_);}\n\t.st101{fill:#A7E1EF;}\n\t.st102{fill:url(#SVGID_41_);}\n\t.st103{fill:url(#SVGID_42_);}\n\t.st104{fill:url(#SVGID_43_);}\n\t.st105{fill:#282D2C;}\n\t.st106{fill:url(#SVGID_44_);}\n\t.st107{opacity:0.83;fill:#7FB6BA;}\n\t.st108{fill:#FF9A24;}\n\t.st109{fill:#424242;}\n\t.st110{fill:#FF9A24;stroke:#424242;stroke-width:4;stroke-miterlimit:10;}\n\t.st111{fill:url(#SVGID_45_);}\n\t.st112{fill:url(#SVGID_46_);}\n\t.st113{fill:url(#SVGID_47_);}\n\t.st114{fill:url(#SVGID_48_);}\n\t.st115{fill:#D3E2E0;}\n\t.st116{fill:#7E8380;}\n\t.st117{fill:#1E1E31;}\n\t.st118{fill:#D68322;}\n\t.st119{fill:#82AEBB;}\n\t.st120{fill:#3A404C;}\n\t.st121{fill:#9E9E9E;}\n\t.st122{fill:#7FB6BA;}\n\t.st123{opacity:0.83;fill:#CA720A;}\n\t.st124{opacity:0.54;fill:url(#SVGID_49_);}\n\t.st125{opacity:0.32;fill:url(#SVGID_50_);}\n\t.st126{opacity:0.26;fill:url(#SVGID_51_);}\n\t.st127{fill:#615A5C;}\n\t.st128{fill:url(#SVGID_52_);}\n\t.st129{fill:#2B2B2B;}\n\t.st130{fill:url(#SVGID_53_);}\n\t.st131{fill:url(#SVGID_54_);}\n\t.st132{fill:url(#SVGID_55_);}\n\t.st133{fill:url(#SVGID_56_);}\n\t.st134{fill:url(#SVGID_57_);}\n\t.st135{fill:url(#SVGID_58_);}\n\t.st136{opacity:0.55;fill:#EFEFEF;}\n\t.st137{fill:url(#SVGID_59_);}\n\t.st138{opacity:0.22;fill:#EFEFEF;}\n\t.st139{fill:url(#SVGID_60_);}\n\t.st140{opacity:0.11;fill:#EFEFEF;}\n\t.st141{opacity:0.54;fill:url(#SVGID_61_);}\n\t.st142{opacity:0.32;fill:url(#SVGID_62_);}\n\t.st143{opacity:0.26;fill:url(#SVGID_63_);}\n\t.st144{font-size:17.8186px;}\n\t.st145{fill:#EFEFEF;}\n\t.st146{opacity:0.06;fill:#303030;}\n\t.st147{opacity:0.71;fill:url(#SVGID_64_);}\n\t.st148{opacity:0.71;}\n\t.st149{fill:url(#SVGID_65_);}\n\t.st150{fill:url(#SVGID_66_);}\n\t.st151{fill:url(#SVGID_67_);}\n\t.st152{fill:url(#SVGID_68_);}\n\t.st153{fill:url(#SVGID_69_);}\n\t.st154{fill:url(#SVGID_70_);}\n\t.st155{fill:#876451;}\n\t.st156{fill:#6C797D;}\n\t.st157{fill:#D3EC19;}\n\t.st158{fill:#859618;}\n\t.st159{fill:#A5A5A5;}\n\t.st160{fill:#76898C;}\n\t.st161{fill:#232328;}\n\t.st162{fill:#2F303D;}\n\t.st163{fill:#2A2D2E;}\n\t.st164{fill:#272832;}\n\t.st165{fill:#22222B;}\n\t.st166{opacity:0.83;fill:#1E1F20;}\n\t.st167{fill:#90A1A9;}\n\t.st168{opacity:0.51;fill:#D1D1D1;}\n\t.st169{fill:#D1D1D1;}\n\t.st170{fill:#BFD1D8;}\n\t.st171{opacity:0.18;fill:url(#SVGID_71_);}\n\t.st172{opacity:0.18;fill:url(#SVGID_72_);}\n\t.st173{opacity:0.18;fill:url(#SVGID_73_);}\n\t.st174{opacity:0.18;fill:url(#SVGID_74_);}\n\t.st175{fill:#757E81;}\n\t.st176{opacity:0.43;fill:url(#SVGID_75_);}\n\t.st177{opacity:0.43;fill:url(#SVGID_76_);}\n\t.st178{opacity:0.43;fill:url(#SVGID_77_);}\n\t.st179{opacity:0.43;fill:url(#SVGID_78_);}\n\t.st180{fill:url(#SVGID_79_);}\n\t.st181{fill:url(#SVGID_80_);}\n\t.st182{fill:url(#SVGID_81_);}\n\t.st183{fill:url(#SVGID_82_);}\n\t.st184{opacity:0.18;fill:url(#SVGID_83_);}\n\t.st185{opacity:0.18;fill:url(#SVGID_84_);}\n\t.st186{opacity:0.18;fill:url(#SVGID_85_);}\n\t.st187{opacity:0.18;fill:url(#SVGID_86_);}\n\t.st188{opacity:0.43;fill:url(#SVGID_87_);}\n\t.st189{opacity:0.43;fill:url(#SVGID_88_);}\n\t.st190{opacity:0.43;fill:url(#SVGID_89_);}\n\t.st191{opacity:0.43;fill:url(#SVGID_90_);}\n\t.st192{opacity:0.35;fill:#FFFFFF;}\n\t.st193{opacity:0.71;fill:url(#SVGID_91_);}\n\t.st194{opacity:0.71;fill:url(#SVGID_92_);}\n\t.st195{fill:url(#SVGID_93_);}\n\t.st196{fill:url(#SVGID_94_);}\n\t.st197{fill:url(#SVGID_95_);}\n\t.st198{fill:url(#SVGID_96_);}\n\t.st199{fill:url(#SVGID_97_);}\n\t.st200{fill:url(#SVGID_98_);}\n\t.st201{fill:url(#SVGID_99_);}\n\t.st202{fill:url(#SVGID_100_);}\n\t.st203{fill:url(#SVGID_101_);}\n\t.st204{fill:url(#SVGID_102_);}\n\t.st205{fill:url(#SVGID_103_);}\n\t.st206{fill:url(#SVGID_104_);}\n\t.st207{fill:url(#SVGID_105_);}\n\t.st208{opacity:0.36;}\n\t.st209{opacity:0.29;}\n\t.st210{fill:none;stroke:#E3EF9A;stroke-miterlimit:10;}\n\t.st211{fill:#E3EF9A;}\n\t.st212{fill:none;}\n\t.st213{fill:url(#SVGID_106_);}\n\t.st214{fill:url(#SVGID_107_);}\n\t.st215{fill:url(#SVGID_108_);}\n\t.st216{fill:url(#SVGID_109_);}\n\t.st217{fill:url(#SVGID_110_);}\n\t.st218{fill:url(#SVGID_111_);}\n\t.st219{fill:url(#SVGID_112_);}\n\t.st220{fill:url(#SVGID_113_);}\n\t.st221{fill:url(#SVGID_114_);}\n\t.st222{fill:url(#SVGID_115_);}\n\t.st223{fill:url(#SVGID_116_);}\n\t.st224{fill:url(#SVGID_117_);}\n\t.st225{fill:url(#SVGID_118_);}\n\t.st226{fill:url(#SVGID_119_);}\n\t.st227{fill:url(#SVGID_120_);}\n\t.st228{fill:url(#SVGID_121_);}\n\t.st229{fill:url(#SVGID_122_);}\n\t.st230{fill:url(#SVGID_123_);}\n\t.st231{opacity:0.22;}\n\t.st232{fill:#F4C389;}\n\t.st233{opacity:0.28;fill:#F4C389;stroke:#CC8E4C;stroke-width:15;stroke-miterlimit:10;}\n\t.st234{opacity:0.28;fill:#FFD2A1;}\n\t.st235{fill:url(#SVGID_124_);}\n\t.st236{opacity:0.64;fill:url(#SVGID_125_);}\n\t.st237{fill:url(#SVGID_126_);}\n\t.st238{fill:url(#SVGID_127_);}\n\t.st239{opacity:0.29;fill:url(#SVGID_128_);}\n\t.st240{opacity:0.29;fill:url(#SVGID_129_);}\n\t.st241{opacity:0.29;fill:url(#SVGID_130_);}\n\t.st242{display:inline;opacity:0.47;fill:url(#SVGID_131_);}\n\t.st243{display:inline;fill:url(#SVGID_132_);}\n\t.st244{display:inline;fill:url(#SVGID_133_);}\n\t.st245{display:inline;opacity:0.43;fill:url(#SVGID_134_);}\n\t.st246{display:inline;fill:url(#SVGID_135_);}\n\t.st247{display:inline;fill:url(#SVGID_136_);}\n\t.st248{display:inline;fill:url(#SVGID_137_);}\n\t.st249{display:inline;fill:url(#SVGID_138_);}\n\t.st250{display:inline;fill:url(#SVGID_139_);}\n\t.st251{display:inline;opacity:0.22;}\n\t.st252{display:inline;opacity:0.42;}\n\t.st253{display:inline;opacity:0.28;}\n\t.st254{display:inline;opacity:0.18;}\n\t.st255{display:inline;fill:none;stroke:#443126;stroke-miterlimit:10;}\n\t.st256{fill:none;stroke:#443126;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_26"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1247.2789,
    y1: -525.3198,
    x2: 2806.3035,
    y2: 2600.2793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B862"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7185,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 4096,
    height: 2160
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1123.3043,
    y1: 329.5439,
    x2: 1123.3043,
    y2: 329.5439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B862"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7185,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1123.3,329.54"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "762.27,1552.93 1029.85,1330.74 1530.76,1309.06 1690.22,1146.29 2219.51,984.14 2428.34,887.13  2816.73,753.16 3108.08,587.53 3363.56,303.6 3488.98,291.75 3488.98,2147.51 739.05,2147.51  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_39"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1419.7,1612.56c0,0,33.62-67.35,74.94-39.48c41.32,27.87,92.42,71.23,127.26,12.39 c34.84-58.84,48.77-135.48,94.06-102.97c45.29,32.52,106.43,173.42,222.18,102.97c115.75-70.45,179.28-66.58,204.42-134.71 s21.27-130.84,87.07-101.81c65.81,29.03,98.21,71.58,65.75,129.27s-119.9,229.57-152.82,278.34 c-32.93,48.77-308.12,192.77-376.07,213.68s-293.05,4.65-319.85-44.13c-26.81-48.77-59.13-135.48-65.03-178.06 C1375.71,1705.47,1419.7,1612.56,1419.7,1612.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 2367.9338,
    y1: 814.5277,
    x2: 2841.7715,
    y2: 814.5277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2415.01,722.24c0,0-65.81,13.9-41.81,65.79c24,51.89,105.38,52.84,101.85,75.59s-8.17,62.24,49.89,52.95 c58.06-9.29,85.94-44.13,137.03-13.94c51.1,30.19,116.13,97.55,157.94,53.42s21.71-253.34-43.72-289.25 S2415.01,722.24,2415.01,722.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1754.1068,
    y1: 1256.5116,
    x2: 2108.8889,
    y2: 1256.5116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1780.74,1527.5c0,0-10.01-152.8-13.14-224.8s-35.64-149.42,13.14-196.65s66.8-85.55,87.98-111.68 s88.91-71.81,151.43-24.58c62.52,47.23,104.12,67.35,83.32,94.45c-20.8,27.1-80.91,120.8-85.69,164.53 c-4.78,43.73,23.84,32.85-55.5,87.07c-79.34,54.21-68.28,91.37-93.56,161.05C1843.45,1546.57,1827.2,1603.66,1780.74,1527.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1406.48,1425.95c0,0-18.65-284.57-24.46-418.66s-66.37-278.27,24.46-366.23 c90.84-87.95,124.41-159.32,163.86-207.99c39.44-48.66,165.59-133.73,282.02-45.78c116.44,87.95,193.91,125.44,155.17,175.9 c-38.74,50.46-150.68,224.97-159.59,306.41s44.4,61.19-103.37,162.15s-127.17,170.17-174.24,299.94 S1492.99,1567.78,1406.48,1425.95z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3538.59,1100.2c0,0-18.65-284.57-24.46-418.66c-5.81-134.09-66.37-278.27,24.46-366.23 c90.84-87.95,124.41-159.32,163.86-207.99s165.59-133.73,282.02-45.78c116.44,87.95,193.91,125.44,155.17,175.9 c-38.74,50.46-150.68,224.97-159.59,306.41c-8.91,81.44,146.52,583.16-1.25,684.13c-147.77,100.96-175.9,325.98-222.97,455.74 S3625.1,1242.03,3538.59,1100.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.7,2043.73c0,0-18.65-284.57-24.47-418.66s-66.37-278.27,24.47-366.23 c90.84-87.95,124.41-159.32,163.86-207.99c39.44-48.66,165.59-133.73,282.02-45.78s193.91,125.44,155.17,175.9 s-150.68,224.97-159.59,306.41s44.4,61.19-103.37,162.15c-147.77,100.96-127.17,170.17-174.24,299.94S270.21,2185.56,183.7,2043.73 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2265.29,1754.84c0,0,285.16-4.05,419.28-8.93c134.13-4.88,282.67,44.02,363.12-53.53 c80.44-97.55,148.92-136.7,194.29-179.89c45.37-43.19,120.13-175.7,23.19-284.77c-96.94-109.07-140.47-183.31-187.69-140.68 s-212.27,168.11-292.74,183.47s-64.53-39.39-153.41,115.95s-159.51,140.31-285.12,197.55 C2220.59,1641.25,2117.03,1679.89,2265.29,1754.84z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1786.16,154.77c0,0-282.54,38.75-415.08,59.92s-285.93-9.27-353.9,97.35S886.03,465.85,846.25,514.24 s-97.84,189.02,11.66,285.48s161.75,164.84,203.43,116.78c41.68-48.06,190.22-192.7,268.22-217.75 c78.01-25.05,68.84,31.24,138.15-133.76c69.31-165,141.24-158.69,258.94-230.8S1942.45,211.11,1786.16,154.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 2226.811,
    y1: 1140.8865,
    x2: 2536.5715,
    y2: 1140.8865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2256.42,1117.68c0,0-61.26,57.59-7.55,97.08s140.42,11.61,201.58-27.87 c61.16-39.48,125.39-107.61,56.11-126.97c-69.27-19.35-67.91,65.1-111.56,35.65c-43.65-29.45-65.33-67.39-90.49-35.65 C2279.35,1091.66,2259.03,1076.35,2256.42,1117.68z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2155.25,599.7c0,0-168.37,158.29-20.75,266.81s385.94,31.92,554.05-76.6s344.63-295.77,154.23-348.97 c-190.4-53.2-186.66,178.92-306.63,97.97s-179.55-185.21-248.71-97.97S2162.43,486.09,2155.25,599.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1435.89,377.7 1394.98,274.38 1320.18,282.71 1356.56,385.31"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_31"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_36"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_34"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_35"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_37"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_9"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1377.6233,
    y1: 62.6474,
    x2: 1079.4418,
    y2: 2215.1455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1406.88,149.41l50.52,154.84l0,0l73.35,78.97l-0.77,37.94l-29.42,63.48l-103.55,51.1l-11.61,68.9 l-13.16,191.23l-217.16,900.39l37.16,303.48l5.81,39.84l27.87,40.29l-91.94-18.58l-92.52-98.71L956.3,1748.9 c0,0,18.58-229.16,18.58-236.9s125.42-812.9,125.42-812.9l128.32-257.81l143.42-190.45l50.32-66.19L1406.88,149.41"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_10"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "1444.05,200.51 1457.4,304.25 1530.76,383.22 1487.4,308.12 1474.75,326.33 1406.88,290.32  1444.05,200.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1444.05,376.25 1380.64,308.12 1341.85,334.45 1422.37,421.16  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1459.92,393.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1265.21,425.03 1396.25,537.29 1482.56,493.52 1341.85,334.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1244.3,757.16 1362.51,843.87 1330.95,974.74 1253.59,908.12 1188.56,855.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1248.95,1035.87 1293.74,1114.64 1265.18,1233.06 1151.4,1132.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1074.76,1579.35 1164.3,1658.02 1155.08,1696.25 1047.66,1657.54 1060.82,1556.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1054.63,1703.22 1172.38,1783.74 1185.27,1875.87 1019.01,1776.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1265.21,555.09 1293.24,632.9 1355.79,632.9 1360.2,686.32 1355.17,668.9 1379.95,686.32  1374.8,758.71 1180.59,673.54 1289.59,663.09 1252.67,676.25  "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2665.24,1260.12l12.39-13.16l51.1-0.08c0,0,41.03-8.18,43.35-8.18c2.32,0,36.39,0,36.39,0l33.31-21.68h14.69 l19.61-10.53l10.58-23.54v-36.39v-19.35l-6.97-46.45l16.26,28.65l-4.29,107.05l-62.37,43.66l-100.56,6.5L2665.24,1260.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1396.34,1709.41l8.97,27.22l4.96,32.78l16.26,24.77l5.61,19.08l36.19,12.73h14.32l20.52,9.62h27.58 l39.77-9.62h29.03l54.65-7.42l34.47-14.25H1727l61.85-31.82c0,0,33.53,0.39,38.25,0c4.72-0.39,65.64-21.29,68.28-22.45 c2.63-1.16,45.58-17.25,45.58-17.25l25.56-18.75l38.05-10.84l27.38-13.55l25.36-24.65l30.78-17.16l-24,84.94l-465.68,160.92 l-220.73-8.94l-8.05-95.24L1396.34,1709.41z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1517.5,438.19l13.26-54.97c0,0,21.97-14.3,22.35-21.86s-1.2-20.19,7.33-20.07 c8.54,0.12,27.7-11.43,27.7-11.43l21.02-13.83l39.38-18.74l27.67-30.22c0,0,18.15-7.62,25.91-10.76 c7.76-3.14,43.38-12.47,43.38-12.47l73.28-30.97l125.3-12.11l128.13-10.72l233.78,10.49l50.35,12.35l26.41-2.82l15.56,9.4 l30.04,1.72l21.33-10.62l-0.95,17.84l24.72,4.26l43.15,8.14l54.19-1.43l-7.74,10.52c0,0,4.65,3.23,12.39,3.26 c7.74,0.03,32.21-3.26,32.21-3.26l34.16,11.55c0,0,19.43,3.41,26.58,7.39c7.14,3.98,29.6,13.85,29.6,13.85l27.14,16.14 c0,0,20.11,20.23,25.4,25.64s23.41,37.73,23.41,37.73s6.9,5.97,12.62,12.75c5.72,6.78,46.18,17.78,46.18,17.78h-14.75l-8.72,18.68 l-657.66-31.09L1517.5,438.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1804.88,1080.77c0,0,64.46-87.52,67.93-91.04c3.47-3.51,48.3-34.16,70.5-37.24 c22.2-3.08,42.71-3.94,59.78,6.68c17.07,10.62,59.32,41.44,59.32,41.44s-45.66-20.82-59.74-25.88 c-14.08-5.06-21.51-7.45-38.12-12.06c-16.61-4.61-21.99-5.84-30.91,0c-8.92,5.84-49.22,30.22-54.62,35.45 c-5.4,5.23-74.14,87.29-74.14,87.29"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1444.05,200.51 1457.4,304.25 1457.4,304.25 1406.88,149.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1487.4,308.12 1457.4,383.22 1457.4,417.29 1487.4,347.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1244.3,513.29 1315.69,606.96 1315.69,596.9 1383.56,631.42 1379.95,686.32 1358.99,671.58  1363.12,675.82 1355.79,632.9 1292.46,632.12 1265.13,555.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1246.71,733.94 1312.43,757.16 1325.61,757.16 1368.04,813.27 1362.51,843.87 1244.3,757.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1253.59,908.12 1330.95,974.74 1325.61,996.86 1283.79,936 1289.98,952.49 1253.59,924.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1235.01,1113.67 1280.55,1169.34 1293.74,1186.06 1257.08,1145.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1159.53,1277.41 1267.72,1324.64 1277.79,1385.03 1210.63,1355.22 1180.82,1285.93  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1051.65,1683.73c0.11,0.69,112.65,87.83,112.65,87.83l8.89,17.98l-118.56-86.32L1051.65,1683.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1053.85,1962.58 1198.05,2039.58 1225.92,2079.87 1133.98,2061.29  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "1210.63,1355.22 1197.85,1392.38 1253.79,1422.19 1277.79,1385.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "1487.4,347.61 1457.4,417.29 1521.73,438.96 1459.92,393.29  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st12",
    points: "1200.18,1200.77 1261.84,1246.91 1282.37,1226.32 1238.5,1184.51 1282.37,1226.32 1293.74,1186.06  1257.01,1145.25 1253.59,1144.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1152.56,1433.03 1220.5,1466.74 1253.79,1422.19 1197.85,1392.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1422.37,421.16 1500.56,484.64 1521.73,438.96 1459.92,393.29  "
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_14"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_6"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1916.3549,
    y1: 94.172,
    x2: 2602.2903,
    y2: 94.172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "1916.35,92.62 1987.58,128.24 2125.39,128.24 2187.32,117.4 2269.39,145.27 2340.61,145.27  2385.52,118.95 2572.87,118.95 2602.29,108.11 2568.23,77.14 2354.55,77.14 2269.39,43.08 2013.9,43.08 1958.16,66.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 843.6591,
    y1: 1105.3503,
    x2: 1444.0463,
    y2: 1105.3503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1406.88,149.41l37.16,51.1l-37.16,89.81l-65.03,44.13l-76.65,90.58l-20.9,88.26l20.9,41.81l-20.9,202.06 l-55.74,98.32v136.26c0,0,30.19-3.81,32.52-17c2.32-13.19,32.52-66.61,32.52-66.61l-4.65,127.74l-97.55,97.06l-44.13,149.13 l13.94,102.19l-46.45,195.1l-13.94-22.45l-13.16,100.65l6.97,45.68l-35.61,73.55l26.71,106.84l8.13,78.97l80.13,98.71l-72-16.26 l-147.48-73.16l9.29-74.32l-37.16-196.26c0,0-15.1-195.1-18.58-200.9s-24.39-58.06-24.39-58.06s111.48-292.65,111.48-296.13 c0-3.48-1.16-229.94-1.16-229.94s41.81-234.58,45.29-235.74s135.87-150.97,135.87-150.97s56.9-130.06,58.06-137.03 S1294.24,288,1294.24,288s49.94-41.81,49.94-46.45c0-4.65,60.39-62.71,60.39-62.71L1406.88,149.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1152.5624,
    y1: 1355.2213,
    x2: 1210.6268,
    y2: 1355.2213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0726A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2216,
    style: {
      stopColor: "#D46F61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    style: {
      stopColor: "#E06647"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F15A24"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1159.53,1277.41c0,3.48,10.45,103.35,10.45,103.35l-17.42,52.26c0,0,44.13-36,45.29-40.65 s12.77-37.16,12.77-37.16l-29.03-68.52L1159.53,1277.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1200.1753,
    y1: 1157.2213,
    x2: 1257.0785,
    y2: 1157.2213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0726A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2216,
    style: {
      stopColor: "#D46F61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    style: {
      stopColor: "#E06647"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F15A24"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1200.18,1200.77 1238.5,1184.51 1257.08,1145.03 1235.01,1113.67 1228.63,1126.45 1217.59,1165.93  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1353.4656,
    y1: 430.06,
    x2: 1392.9495,
    y2: 430.06
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1353.47,476.9l27.1-20.9l12.39-43.35l-10.06-29.42c0,0-15.48,35.61-17.03,37.94 C1364.3,423.48,1353.47,476.9,1353.47,476.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1422.3688,
    y1: 364.6406,
    x2: 1487.401,
    y2: 364.6406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1422.37,421.16l37.55-27.87l27.48-45.68v-39.48c0,0-46.45,65.81-43.35,68.13 C1447.14,378.58,1422.37,421.16,1422.37,421.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1676.2075,
    y1: 169.5086,
    x2: 2604.8528,
    y2: 169.5086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2581.24,179.19l23.61-68.52l-29.42,10.84h-187.35l-44.9,26.32h-71.23l-82.06-27.87l-61.94,10.84h-137.81 l-71.23-35.61v60.69c0,0,15.87,1.24,14.71,1.63c-1.16,0.39-14.71,16.26-14.71,16.26l-101.03,3.48l-66.56,12.54l-75.12-4.8 l11.03,42.85l58.26,15.99l73.55-20.52l99.87-10.45l25.16-12.39l30.58,5.42l154.84-2.32l52.65-8.52l79.74,16.26l94.45-5.42 l40.26-20.9l120-3.1l10.84-6.97l20.9,8.52h27.1"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1990.14,130.8 1990.14,205.66 2129.5,203.57 2182.14,195.06 2189.89,119.96 2127.95,130.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "2255.64,210.04 2271.95,147.83 2343.18,147.83 2356.34,205.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "2396.59,184.99 2382.74,124.64 2516.59,121.51 2516.59,181.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2524.87,172.37 2572.87,118.95 2545.77,180.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1933.63,157.51 1944.08,200.48 1918.92,212.86 1918.92,173.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1745.5,243.83 1751.33,189.79 1817.88,177.25 1819.05,223.32  "
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1244.3,783.74 1159.53,801.29 1091.01,820.25 1047.66,820.25 1091.01,843.87 1165.34,843.87  1188.56,855.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "1121.21,1384.25 1091.01,1365.67 956.3,1256.51 1074.76,1304.12 1107.27,1282.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "1107.27,1282.06 1152.56,1277.41 1103.4,1341.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1265.13,555.88 1228.63,612.38 1174.63,578.32 1235.01,624.77 1252.67,606 1257.85,626.19  1274.38,587.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "1152.56,1277.41 1103.4,1341.67 956.3,1256.51 1107.27,1282.06  "
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4__x28_\\u043A\\u043E\\u043F\\u0438\\u044F_x29_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1526,2053.39c-3.73,0-7.41-0.04-11.07-0.1c-93.23-1.77-168.24-26.09-222.95-72.29 c-48.03-40.56-78.47-95.65-90.46-163.73c-11.27-63.97-6.11-137.52,15.76-224.85l0.29-1.13L1506.3,495.36l0.89-2.71 c4.07-12.41,28.04-77.55,100.07-141.14c41.61-36.73,91.3-65.79,147.69-86.35c66.92-24.4,143.45-36.78,227.45-36.78 c163.76,0,335.28,3.14,480.21,25.94c82.85,13.03,149.5,31.25,203.75,55.7c71.4,32.17,122.08,76.27,150.61,131.05 c76.6,147.08,217.46,469.05,228.43,494.18c4.86,10.51,26.19,58.66,39.7,121.44c9.02,41.91,12.7,81.95,10.94,119.02 c-2.44,51.55-15.35,97.73-38.38,137.23c-24.23,41.58-58.94,74.79-103.15,98.73c-44.11,23.88-97.94,38.27-159.99,42.79 c-24.82,1.8-48.74,3.46-71.88,5.05c-111.44,7.69-207.69,14.32-273.78,30.17c-71.24,17.08-81.54,38.25-85.94,47.29 c-9.16,18.84-18.02,39.14-27.39,60.63c-22.66,51.96-48.34,110.85-86.27,164.83c-47,66.88-104.29,114.51-175.14,145.61 c-117.56,51.6-227.98,90.28-328.21,114.95C1663.88,2043.17,1589.97,2053.39,1526,2053.39z M1403.39,1639.6 c-14.24,57.07-31.37,157.68,12.46,194.7c19.87,16.78,55.38,26.12,102.71,27.02c49.8,0.94,110.84-7.39,181.45-24.78 c89.54-22.04,189.45-57.14,296.93-104.32c87.08-38.22,122.07-118.46,162.58-211.37c9.75-22.35,19.82-45.45,30.73-67.88 c20.13-41.39,50.96-75.47,91.61-101.3c33.02-20.97,73-36.91,122.22-48.71c81.67-19.58,180.37-26.38,305.33-35 c22.96-1.58,46.71-3.22,71.17-5c58.05-4.22,95.41-19.87,111.06-46.5c14.44-24.58,16.75-65.7,6.49-115.76 c-9.4-45.89-25.91-82.43-27.08-84.98l-0.72-1.5l-0.45-1.08c-1.47-3.38-148.22-339.37-223.22-483.37 c-7.91-15.18-28.93-31.05-59.2-44.69c-37.88-17.07-89.93-30.89-154.71-41.08c-131.9-20.75-294.41-23.61-450.37-23.61 c-101.46,0-184.48,23.63-240.08,68.33c-34.78,27.96-48.96,55.79-52.5,63.7L1403.39,1639.6z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4__x28_\\u043A\\u043E\\u043F\\u0438\\u044F2_x29_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1873.14,430.92c1.95-0.41,3.91-0.8,5.88-1.19c-0.61-1.91-1.21-3.81-1.82-5.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1873.53,412.53c-16.61-51.95-33.28-103.31-47.92-155.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1823.99,251.16c-0.53-1.93-1.06-3.86-1.59-5.79c-1.95,0.45-3.9,0.9-5.84,1.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1804.85,249.66c-17.17,4.47-33.82,9.64-49.91,15.5c-56.39,20.56-106.08,49.62-147.69,86.35 c-72.03,63.59-96,128.73-100.07,141.14l-0.89,2.71l-6.65,25.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1498.11,526.43l-1.53,5.8c1.89,0.67,3.78,1.33,5.66,1.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1513.61,538.09c51.57,17.26,103.45,30.43,156.6,41.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1676.09,580.98c1.96,0.41,3.92,0.81,5.88,1.22l1.53-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1686.56,564.77l3.26-12.36c3.54-7.91,17.72-35.74,52.5-63.7c32.75-26.33,75.01-45.33,124.94-56.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2512.51,263.2c-1.95-0.39-3.92-0.78-5.89-1.16c-0.68,1.88-1.35,3.77-2.02,5.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M2500.59,279.1c-18.05,51.83-33.63,103.73-48.56,155.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2450.36,440.85c-0.55,1.92-1.1,3.85-1.64,5.77c1.98,0.34,3.95,0.69,5.91,1.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M2466.03,449.76c49.53,9.43,90.29,21.27,121.45,35.31c30.27,13.64,51.29,29.51,59.2,44.69 c3.5,6.72,7.15,13.85,10.94,21.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2660.23,556.29c0.89,1.77,1.79,3.56,2.69,5.37c1.73-1.01,3.46-2.01,5.19-3.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M2678.51,552.66c46.85-26.78,94.71-51.88,143.39-75.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2827.3,474.53c1.8-0.87,3.6-1.74,5.41-2.6c-0.9-1.8-1.8-3.59-2.7-5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M2824.62,455.94c-2.62-5.13-5.17-10.09-7.66-14.87c-28.53-54.79-79.21-98.88-150.61-131.05 c-41.51-18.7-90.28-33.76-148-45.64"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M3059.24,968.86c-0.73-1.94-1.44-3.81-2.13-5.6c-1.92,0.57-3.83,1.14-5.75,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3039.85,968.41c-51.46,15.43-102.79,31.52-152.9,54.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2881.48,1024.94c-1.81,0.83-3.63,1.68-5.44,2.53c0.68,1.7,1.41,3.57,2.19,5.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M2882.31,1044.17c5.28,14.95,11.36,34.68,15.84,56.53c10.26,50.07,7.95,91.18-6.49,115.76 c-13.43,22.86-42.88,37.63-87.68,44.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2798.1,1261.26c-1.96,0.24-3.95,0.47-5.96,0.68c0.62,1.9,1.23,3.81,1.83,5.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M2797.57,1279.18c15.89,51.96,27.56,104.12,36.62,158.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2835.17,1443.83c0.32,1.97,0.64,3.95,0.95,5.92c1.98-0.31,3.96-0.63,5.92-0.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M2853.98,1446.61c37.52-7.37,71.18-19.06,100.54-34.95c44.21-23.93,78.91-57.15,103.15-98.73 c23.03-39.51,35.94-85.68,38.38-137.23c1.75-37.07-1.93-77.11-10.94-119.02c-6.95-32.3-15.97-60.72-23.75-82.14"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2484.35,1482.47c1.96-0.34,3.93-0.67,5.92-1c-0.11-2-0.23-4-0.35-5.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M2489.18,1463.44c-3.46-54.19-8.38-108.23-10.08-162.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2478.93,1294.93c-0.05-2-0.1-4-0.15-6c-1.99,0.29-3.97,0.58-5.94,0.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M2460.74,1291.72c-19.77,3.23-38.62,6.93-56.64,11.24c-49.23,11.8-89.2,27.73-122.22,48.71 c-40.65,25.83-71.48,59.91-91.61,101.3c-10.91,22.43-20.99,45.53-30.73,67.88c-1.04,2.37-2.07,4.74-3.1,7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2153.99,1533.55c-0.8,1.84-1.61,3.67-2.41,5.49c1.71,1.04,3.42,2.08,5.14,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M2167.18,1548.09c2.43,1.29,4.89,2.51,7.39,3.65c46.04,22.44,97.05,34.96,144.26,54.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2324.38,1608.14c1.84,0.78,3.68,1.56,5.52,2.36c0.81-1.84,1.61-3.67,2.4-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M2337.28,1593.58c8.73-20.01,17.05-38.96,25.64-56.62c4.4-9.04,14.7-30.21,85.94-47.29 c9.21-2.21,19.01-4.24,29.35-6.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1394.04,1683.67c0.34-1.98,0.69-3.95,1.05-5.9c-1.93-0.52-3.86-1.04-5.79-1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M1377.68,1673.11c-52.48-13.9-104.76-26.72-157.46-39.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1214.38,1632.33c-1.94-0.47-3.89-0.93-5.83-1.4c-0.4,1.97-0.79,3.93-1.17,5.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M1205.21,1648.44c-11.28,63.4-12.47,119.02-3.69,168.82c11.99,68.08,42.42,123.16,90.46,163.73 c54.71,46.2,129.72,70.52,222.95,72.29c3.66,0.07,7.35,0.1,11.07,0.1c7.12,0,14.36-0.13,21.72-0.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1553.62,2052.77c1.99-0.09,3.99-0.18,5.99-0.28c-0.12-2-0.23-3.99-0.34-5.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1558.65,2034.51c-2.64-54.2-3.07-108.25-8.55-161.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1549.47,1866.78c-0.22-1.99-0.44-3.98-0.68-5.96c-2.01,0.1-4.01,0.18-6,0.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M1531.18,1861.36c-4.28,0.05-8.48,0.04-12.61-0.04c-47.33-0.9-82.85-10.24-102.71-27.02 c-32.78-27.68-31.47-90.91-22.77-144.91"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2156.72,1542.15c-1.72-1.02-3.43-2.06-5.14-3.1c-0.81,1.84-1.61,3.67-2.42,5.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M2144.2,1555.68c-31.72,70.66-64.58,131.02-127.21,166.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2011.65,1725.11c-1.76,0.93-3.54,1.84-5.34,2.74c0.82,1.82,1.63,3.65,2.43,5.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M2013.45,1744.41c20.61,49.72,35.39,101.95,54.81,153.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2070.42,1903.1c0.72,1.86,1.45,3.73,2.19,5.59c0.51-0.22,1.01-0.44,1.52-0.66 c1.33-0.58,2.65-1.17,3.97-1.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M2088.87,1901.22c64.11-31.09,116.7-76.63,160.39-138.8c32.23-45.87,55.62-95.28,75.82-140.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2327.48,1616c0.81-1.84,1.61-3.67,2.41-5.49c-1.83-0.8-3.67-1.59-5.52-2.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M2313.23,1603.62c-45.63-17.93-94.44-30.32-138.67-51.88c-4.31-1.96-8.51-4.19-12.65-6.55"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M1526,2053.39c-3.73,0-7.41-0.04-11.07-0.1c-93.23-1.77-168.24-26.09-222.95-72.29 c-48.03-40.56-78.47-95.65-90.46-163.73c-11.27-63.97-6.11-137.52,15.76-224.85l0.29-1.13L1506.3,495.36l0.89-2.71 c4.07-12.41,28.04-77.55,100.07-141.14c41.61-36.73,91.3-65.79,147.69-86.35c66.92-24.4,143.45-36.78,227.45-36.78 c163.76,0,335.28,3.14,480.21,25.94c82.85,13.03,149.5,31.25,203.75,55.7c71.4,32.17,122.08,76.27,150.61,131.05 c76.6,147.08,217.46,469.05,228.43,494.18c4.86,10.51,26.19,58.66,39.7,121.44c9.02,41.91,12.7,81.95,10.94,119.02 c-2.44,51.55-15.35,97.73-38.38,137.23c-24.23,41.58-58.94,74.79-103.15,98.73c-44.11,23.88-97.94,38.27-159.99,42.79 c-24.82,1.8-48.74,3.46-71.88,5.05c-111.44,7.69-207.69,14.32-273.78,30.17c-71.24,17.08-81.54,38.25-85.94,47.29 c-9.16,18.84-18.02,39.14-27.39,60.63c-22.66,51.96-48.34,110.85-86.27,164.83c-47,66.88-104.29,114.51-175.14,145.61 c-117.56,51.6-227.98,90.28-328.21,114.95C1663.88,2043.17,1589.97,2053.39,1526,2053.39z M1403.39,1639.6 c-14.24,57.07-31.37,157.68,12.46,194.7c19.87,16.78,55.38,26.12,102.71,27.02c49.8,0.94,110.84-7.39,181.45-24.78 c89.54-22.04,189.45-57.14,296.93-104.32c87.08-38.22,122.07-118.46,162.58-211.37c9.75-22.35,19.82-45.45,30.73-67.88 c20.13-41.39,50.96-75.47,91.61-101.3c33.02-20.97,73-36.91,122.22-48.71c81.67-19.58,180.37-26.38,305.33-35 c22.96-1.58,46.71-3.22,71.17-5c58.05-4.22,95.41-19.87,111.06-46.5c14.44-24.58,16.75-65.7,6.49-115.76 c-9.4-45.89-25.91-82.43-27.08-84.98l-0.72-1.5l-0.45-1.08c-1.47-3.38-148.22-339.37-223.22-483.37 c-7.91-15.18-28.93-31.05-59.2-44.69c-37.88-17.07-89.93-30.89-154.71-41.08c-131.9-20.75-294.41-23.61-450.37-23.61 c-101.46,0-184.48,23.63-240.08,68.33c-34.78,27.96-48.96,55.79-52.5,63.7L1403.39,1639.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4_\\u043A\\u043E\\u043F\\u0438\\u044F_2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1606.3546,
    y1: 335.6467,
    x2: 2327.8174,
    y2: 1782.066
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B862"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7185,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1526,2053.39c-3.73,0-7.41-0.04-11.07-0.1c-93.23-1.77-168.24-26.09-222.95-72.29 c-48.03-40.56-78.47-95.65-90.46-163.73c-11.27-63.97-6.11-137.52,15.76-224.85l0.29-1.13L1506.3,495.36l0.89-2.71 c4.07-12.41,28.04-77.55,100.07-141.14c41.61-36.73,91.3-65.79,147.69-86.35c66.92-24.4,143.45-36.78,227.45-36.78 c163.76,0,335.28,3.14,480.21,25.94c82.85,13.03,149.5,31.25,203.75,55.7c71.4,32.17,122.08,76.27,150.61,131.05 c76.6,147.08,217.46,469.05,228.43,494.18c4.86,10.51,26.19,58.66,39.7,121.44c9.02,41.91,12.7,81.95,10.94,119.02 c-2.44,51.55-15.35,97.73-38.38,137.23c-24.23,41.58-58.94,74.79-103.15,98.73c-44.11,23.88-97.94,38.27-159.99,42.79 c-24.82,1.8-48.74,3.46-71.88,5.05c-111.44,7.69-207.69,14.32-273.78,30.17c-71.24,17.08-81.54,38.25-85.94,47.29 c-9.16,18.84-18.02,39.14-27.39,60.63c-22.66,51.96-48.34,110.85-86.27,164.83c-47,66.88-104.29,114.51-175.14,145.61 c-117.56,51.6-227.98,90.28-328.21,114.95C1663.88,2043.17,1589.97,2053.39,1526,2053.39z M1403.39,1639.6 c-14.24,57.07-31.37,157.68,12.46,194.7c19.87,16.78,55.38,26.12,102.71,27.02c49.8,0.94,110.84-7.39,181.45-24.78 c89.54-22.04,189.45-57.14,296.93-104.32c87.08-38.22,122.07-118.46,162.58-211.37c9.75-22.35,19.82-45.45,30.73-67.88 c20.13-41.39,50.96-75.47,91.61-101.3c33.02-20.97,73-36.91,122.22-48.71c81.67-19.58,180.37-26.38,305.33-35 c22.96-1.58,46.71-3.22,71.17-5c58.05-4.22,95.41-19.87,111.06-46.5c14.44-24.58,16.75-65.7,6.49-115.76 c-9.4-45.89-25.91-82.43-27.08-84.98l-0.72-1.5l-0.45-1.08c-1.47-3.38-148.22-339.37-223.22-483.37 c-7.91-15.18-28.93-31.05-59.2-44.69c-37.88-17.07-89.93-30.89-154.71-41.08c-131.9-20.75-294.41-23.61-450.37-23.61 c-101.46,0-184.48,23.63-240.08,68.33c-34.78,27.96-48.96,55.79-52.5,63.7L1403.39,1639.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4_\\u043A\\u043E\\u043F\\u0438\\u044F_3"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 2146.0972,
    cy: 1140.8851,
    r: 931.6267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B862"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5615,
    style: {
      stopColor: "#3C3C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6636,
    style: {
      stopColor: "#565656"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7939,
    style: {
      stopColor: "#7F7F7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1526,2053.39c-3.73,0-7.41-0.04-11.07-0.1c-93.23-1.77-168.24-26.09-222.95-72.29 c-48.03-40.56-78.47-95.65-90.46-163.73c-11.27-63.97-6.11-137.52,15.76-224.85l0.29-1.13L1506.3,495.36l0.89-2.71 c4.07-12.41,28.04-77.55,100.07-141.14c41.61-36.73,91.3-65.79,147.69-86.35c66.92-24.4,143.45-36.78,227.45-36.78 c163.76,0,335.28,3.14,480.21,25.94c82.85,13.03,149.5,31.25,203.75,55.7c71.4,32.17,122.08,76.27,150.61,131.05 c76.6,147.08,217.46,469.05,228.43,494.18c4.86,10.51,26.19,58.66,39.7,121.44c9.02,41.91,12.7,81.95,10.94,119.02 c-2.44,51.55-15.35,97.73-38.38,137.23c-24.23,41.58-58.94,74.79-103.15,98.73c-44.11,23.88-97.94,38.27-159.99,42.79 c-24.82,1.8-48.74,3.46-71.88,5.05c-111.44,7.69-207.69,14.32-273.78,30.17c-71.24,17.08-81.54,38.25-85.94,47.29 c-9.16,18.84-18.02,39.14-27.39,60.63c-22.66,51.96-48.34,110.85-86.27,164.83c-47,66.88-104.29,114.51-175.14,145.61 c-117.56,51.6-227.98,90.28-328.21,114.95C1663.88,2043.17,1589.97,2053.39,1526,2053.39z M1403.39,1639.6 c-14.24,57.07-31.37,157.68,12.46,194.7c19.87,16.78,55.38,26.12,102.71,27.02c49.8,0.94,110.84-7.39,181.45-24.78 c89.54-22.04,189.45-57.14,296.93-104.32c87.08-38.22,122.07-118.46,162.58-211.37c9.75-22.35,19.82-45.45,30.73-67.88 c20.13-41.39,50.96-75.47,91.61-101.3c33.02-20.97,73-36.91,122.22-48.71c81.67-19.58,180.37-26.38,305.33-35 c22.96-1.58,46.71-3.22,71.17-5c58.05-4.22,95.41-19.87,111.06-46.5c14.44-24.58,16.75-65.7,6.49-115.76 c-9.4-45.89-25.91-82.43-27.08-84.98l-0.72-1.5l-0.45-1.08c-1.47-3.38-148.22-339.37-223.22-483.37 c-7.91-15.18-28.93-31.05-59.2-44.69c-37.88-17.07-89.93-30.89-154.71-41.08c-131.9-20.75-294.41-23.61-450.37-23.61 c-101.46,0-184.48,23.63-240.08,68.33c-34.78,27.96-48.96,55.79-52.5,63.7L1403.39,1639.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 344,
    height: 251,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVgAAAD7CAYAAAAvk4y0AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAALwJJREFUeNrsncty20jShUGAsuz2 bcZP4MXsvJz3f4RZatERjgkvZvdH9Iyv3bII8K8sVZYPEllAkSIlUjonggGSulhWd399cPJSTUNR FEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVR FEVRFEVRFEVRZ6wVfwUURZ0pr7YELEVR1P0xafuY/jIURVGnzJ7tU/hLUhRFmN4Hj7anBFoClqKo +2bK6khM2lZAdXtqvwyKoqh9GbLa4f1a8Na41CXYbk/hl0NRFHVomM6+/vDhw+T7XF9fx/cuLy9H YLy6uiqBdbsneAlYiqJOFqi1MF0lmI4AKtpsNpPvq++t1+sJEPW9jx8/bguQ3c7A96iQJWApijrU Lf0iTBWkCFF9PgxDfq/v+0U2dV0Xwdi27VZBK48AWoUmAnVb6XAJWIqiTg6oo+ceTC1IFaL6ervd TkD77t270R/4xx9/5OcK1tVqtZXnAly5FkD7IJAlYCmKQL0LUF136sHUA6k8//vf/54/z15LEpAq YD9//rxVyMr14uJiMKCtgSwBS1HUwf473wWoO7lTdKYWpm/fvs2v8eNytQAW/fbbb/n5jx8/MgQR qPr8y5cvch2Smx3U0T5//nyQ4tjV1dW9Q3bNf/co6sm61L2A+v3793gtuVPrTBGmP3/+HAFXHgJR Gw/oa/385EwncBXoylWA+vLlS7muvn79OqQ/cxA3+9dff7Xyrc3fdZv+nuwioCjqKC7VveWvvd33 3GnJmVqY4nvpc/PXBLc5cbIK1gDLRl2rfIo41vS+OFdxrfG6Xq+H4Gjja40MxMk6ccFRXSwBS1FP x6XuDFR7u48O0wLVA6cA1b4XHq1cBaQGsg2CFgGbgKrXCNjgbofkZuUqUO3//PPPDNoA1t5C9j// +c+QIDo0810GBCxFEarVLnV0/cc//jHJUBWo3u2+vJ4Dari2Hkzlz5OPWZgqZOXjAX75cxGsFrAK 15ubG81eI1gFqOG9Xp4HmPYC1OBoew+yz549Gz59+jQ4LvYoHQXMYCnq/KFa7VIVqAFAK++WHwH5 5s2bEWAlyyy5U4FogNxKnam81s8Lih8LcBvBVaGafqZVcKCrW5aumvR1o3hAwSqw1HggfG0fPlfc 60ogq58f/k7565Li/zz0z3JAepQ8lg6Woh4PVIsu1d72exnq69ev26Xb/fC1bcmdynO9xReIJmfa mpy1VZCim8V4QIpZ6F7Dz67xwKDONbw3gIPtBbQBvBuBrLwWJxv+h9JLbCCPb9++9Tu4WDpYiiJU 61xq6bbf3vL//Plz5FCfP38+eq0fR4eK7jR8+1ahKx8IP0eEqUjhKw/5eRC0q1ubqd0CKzsqm/pd o3tVsKZ2rF4UvrdMcYlrjZ0GAuTwnj4G/B9FpWM9mJulg6Wo04Xq4q1/jUst3fbrxxSWxqG2zu1+ Bm4AmX3POtbWulZwq6POAf2Y83fMjlLgKWBN0YA41gjY8F6EbHi+CZdN+thG3Kw8xMWGn2sjWSy6 2NRRMDRHzmHpYCnq9KFavPWvcaniJMGFTopSClB1qMGNZkimXHUCT/mzAxhbdafqWBMw1a1m1yof k6v0qaJrXd0SMsM1fTxKoKqw03asW8M6yPcRqMasVaa1wrVLV3Gx8vPJzyQ/zwD/I1mNgt176IMl YCnqTKBauvWfc6lYmBIQvnjxYlSU0gwVXarAyQGq3tJneOKtvjpTeF8g2CJM5XPS/wQyaBsoaiX3 /esXEd7XzgGhqsAyQDV+vnyePFIBq9VCFjpjdeUSm9jMOf0ut8eKBhgRUNQJQ9XmqbaNystS9fbe tk7Z2351qAmqLdzy4+dlcOJ7CY56m9/ibT+8n6MBhakZJpi0ZKFzTe41fjgBNhe3UhwQYwExvxIN hL/HJl1vNCoIP3v4/8eNRAMbadmSa/h791+/fu210PXy5cvh6upqaI44cEAHS1EnCFUcR/WgihV/ ue3H6r4Wp9SlClDRoYb3Wi1KKTj1lh8dKtzWt8mFtqndyX0//TwtutPmtui1MiAdFbUSaEe/NB2F TdmrfHzQ75f+jEHdsNc3a6fAHkoELEWdJ1QzUMNtf4SaQlTAKFCV2+kE2RaLUsKv9J7etrd4y18A qoJTP5b/PHkfMtUWNmFl9wogXS0BUKe2BLrh65tbs7rK0QLGCEvfg4ClqMcB1qXFKW6m+vnz59nK vwdVe+ufHGkGqudSU4Yanad8Iuaq+lpv6SuAmotXqciV3apmpOheK39f21/mMw8ZTE4eSI5WrqOx WZj0msBVX//3v/+N7VyqdNyM9zMQsBR1rlCV56VClUAMi1QeVO2tv7pUBKrnUlOVv8UqP8YAANN2 R6BOMlXndxDdqEh+B3MOE8Gp7Vk6ZNCMc1nJZHVUNm7YSu1b23BXEBdwy7at8DvI27c0fvCOnqGD pajTA2spAtgLqvIcW6kwTxXYasUfb/0VqgJdeS0fQ5eabvkzPJPzbdOt/SRXbaDFCoFqbve1Uu/C VCUAbn5ZU9wpMHGuCtDmtmsgQ1RBmopaWuAa7ENAmzoN8gP3xeKS7mM51pr8iKKo/aAarwjVmkw1 AXNy66+3+7bqrxCFan+rLtW+hx0Apvqfn0PhadQFgNV/eH/yd57LU1NvqhsFoFtFx5qeDwm0CtBe uwi0e0AHDLSLIA0abHTQII3KSkdB//379zgyy1FZijp9sHpXAavb/D+XqVqoJpfapub92TwVbv07 gae4RYWnfD9725+caJvAqaOueYzVOlQnP60uUKlwWMACVV8DVDUO2CbHutVdA+Bg4zVBNe4fCD9P dLZylQGE4dbC6yPHA/oc4gFvgosOlqJOLQKorf4rSKXyj05Voeq5VL2CK82OFF+XXGr6PBwGyM61 1qGman5TAdadgIpuFcdhDWh7iAp6jArEsabn8SrLXtS9CmzVvUpbl/TBJveK+2C5rpCiTs2tvn// fpXcauwAEJdZGlHFQpVmqtapOnlqa/NUdKXNbVtVC21VbcmlYjuVghSmq3AHQARpTQ+pB1Tz3taD aRy7guUt8nHJTXENoUA1tRJojooZbF7yksZl4yYthWtytXnptpxsoN8b8tc5gHKSi6Luya26EYDn VtWNvnr1KvenasUfq//CFyxUBYh26FRtvmpcagfOM8NYnamCuMKlVgMV96oWgDp6bYGKz4fbBtYt OlR9jZGAfjy9N3rAkpdBwSqgRbjK5JY4V3nurCn03GvTHOlEAzpYimCtdKs/fvwodgBgT6pGAKJS S5W61fC8Q6eqVX9wqR3c+seHmZjK01delmpdKgC3Sbf/LlSdntIJUFOlP0M0VfC3cLs/gln62JAg rC51m04i0D2vGbICRnxPACqONPzO9NytCFYBt0BWzuVKscBg4QrZ63bGtXLhNkXd4d/x2mzVdavJ hWZoiVvFDgDMVbX6X8pVEyC7Bac6ylchTx2tAgRH62WpVbf9CZazDtUAdcDPMflpfl5wpxOYYoFL run0ggjSBOcIVn1PzuMS4GoUIGdxCXBP6cBDApaiWy241VIEgG5Vb/slV8WWqjmoSqFKDJcD1lqo 5ub/0q2/Lk7ZEaqTotQcUEu3+wJTfA+/Li3Lxr2u8YqgRaAGiI5ey0MGCBSyClZ9Lg85slszV4Tr 5eXl9urqygPr0eBKwFJPHaxVblUA+fr165XnVi1YE0S7Qp+qB9HuAFCtcqk6YlpwqV6GOligGtAO XuW/1p3CiOuQztwa7HHcAlSELB7RrSCVR3CsCmF9byuZq8QCjnNt7sO9ErDUU4sBqtyqzVZta5Xj VjstUClITfP/BKIYD9wjVEvN/YN5zwUnAtV+bMadjqCJ7tSAdwsONf9sCk0ZeVWopn7W+D6CVT6G eetDw5WApR47WItTVvtkq9ivqsWnFAF0nnstxAHdvlCtvfUHJ7rkUkcOU4tPAEoPtEWgOu50gNNg Z90pLmxRoCJg7cjr58+f82t1rAWwNhV5KwFLUXuC1Y0BsG/VdgLI1XOrCFV9jm5UYYpgVYA20FJ1 aKhqpX8BqoNt7Hdu+0dVe+cU18n7XjGqxp2iG5WrAhXfKwFV/84Jrh5Ym5ms9d7gSsBSjx6sS0Wr JbcqIDUFq/hanKqTq3a3ffRtdx9QLdz6D3OVfVuESi7VwjM3/NcC1eakc+5UClMWpgjNJaDKaxx5 LTjWmiiAy14oqtlhdLUEVowBZHT1EG7VRACdU7zCkdWDQ9W79cf2KDNuOnKpBrST9+wt/xJQpW3K c6foTEvuVB6yq9UC1wJVYapgNW51Caj3ukWLgKXOFazFwpXNV0sxgMK0Nlt13Gp+bdusblnQ2m1V RajW5Klw+z8LVXPrP8pSEbR2Mgrdq329D1Dt7T8Cc86dynO95VeY4jW1WpVgWQPT7UP+C0xR5wDW xcKVgnUuBpANVLZvVcdWPZAW3GppUCCPrjZO9R93pJq/67YSqoNzGCDuT8VbfwvUETwBqhgD4Car vYBqYaqArXWnFUBdgueDgpWApc4ZrKPClSxOsfkq9q56MQDuANDKvwDUdAV0jlvFLgB0q62dqtoF qhAB7ALV2dt8s6x6tJhax00bMyWlBSmF6r5AnctO93CntfnpvWesBCz16MDqFa5w9Z84VuxdFbfq xQB4639Ht9omgI5GVk2f6lGhWrj1L7pUhWrjTEnN9Z/OAbXkTmdgWrrF3xeoJwNWApY6e7B6hSsv X3327NnIoSpgE0w7Mwww6gQoZKt3cquFYtVwRKgO4FK9W/88FbVL/6kF6pHd6RI4t6f+LzhFnRVY S4UrzFfRrWLRSh2qcaxdxW4A163qUuo5t2q3TzXlqalqqOL5VHjrb8ZPhzmXim1TaYPVzkDdwZ0e AqYnC1QClnoUYMXCFcYAmK+qQ/ViABhV7TRfbW5XAXZ7utVqqDamyd+p/peg2tv3LFS9PHUXl6rL UkoN/TNAPWR2erZAJWCpRwFWW7jSGMBxrNahepAtLV1x3Wpycfbn93LVpjGTUtatHhqqnlPVrVO1 LnUuQ71jZf9RuVMClnrUYBWYYuFKnKuTr3aFGCA72DtkqxaqNbnqAKDtDwxV99Zfgeq5VO+232ao Mw39NUB9MjAlYKmHBCvC9CBg1TFWBStC1bhULFy5k1cN9K1WZKt756oQCQzJwfYI1rtAVW//7a2/ LKAuudTK2/5DAXX7lP9DoKhjgnUE1WOB1earc1DF7oBdstXaXBUHAGT7vkJVIQpnS+Xnd4UqrvGz 46kll0qgErDU4wBrfC6TV3/99Ve7J1hzq1UBrBPIegtYPLdagOocWN0IoJCrYrW/x5aqdCLqwaCq kYB367/DHH9T+ZpAJWCpe/r3Z7UEVjt5pUWqA4O1mK8msLaOW/X+W9jCAYCjRSoC0ZkIoPdyVTx6 uuRc94EqRgJegcpAdVeXSqASsNSJuFYXsLgrQPYEIFilj1VarI4A1q4QA7QmW3XB6sUAuETFulWM ADBXNRDtsfk/HTd9MKjObJzaddn0lkAlYKnTiwOqwGonr54/f97tkbFOnieQlnYFLLnVEliH9J5t o+orI4B+yalqn+ohoDqTpx6j2Z8iYKl7zlknBSyBqwdWHBCQPtb7AqvuB9CcsimcoAoxQHarCtYE 3n4hAhg9L0FVW6oIVQKW4r8nczlra8GK2610CYsFq+1jvS+wplaqEVgXGv97dKuOOx05V+tWrVO1 fap6OqodBjgyVAlUApY6l5xVC1h4GquAVYGqcD0gWDs7HLALWEtjqiYG6E22im7Vhao+11zVHjlN qBKwFP+92DtntZ0BmrOmolV3H2C1qgBrjzEAglSdq3Wr+tpCdcmtfvv2bXIulR45fUeoEqgELHXm ccBizoqdAcm9drrdCoEatD4yWLXVKh/Al/LTYr6awJpBmp5HeEKWal+7ULW5qh1T9fpUCVUClnrC cUAAa2snsORR6gyAApbdDyDvr2vBmkBa2xVQW7jCGCA61uRKPcjiUIDrVksRQKlYdYeWKkKVgKUe YxyAOStOYIlTLXQGZLAKUE0csL6DY7U/szdxtTRZNYIqRgEYA1iwltxqKQKQ9wlVApYiXL2zr6pz VlvAEppiBBCua3w+MyCwE1i9iaulwlVyrxOoQovVKAaQwYAlt1oTARCqBCxF1zqJA7DtSuMA41rd Apa61ATQtTN9NZq8SktZqsCa3GrTwISVGQwoFq7srT9AVbsBMAboS9mqulWvCwCgqmCsGVeteU0R sNQZudaqtitvUKCUs0IBa50cq3Wtuiug23HyqgTWxcKVOlQoXE0gq25VW6zkuYJ1LlvVLgC9/f/0 6VMJqFtClYClnngcgN0BGAega7VglYy1UMBaw+rA0RrBI4B1tnCFkPXyVXGuNl+VK7pVhexMBNBU ulVGAAQs9RTiAG+N4A5xwNrJWW0Ba226AkZgTZmr9+8lFq+WwGp7Vr3C1ShftYWrAMneK1rZTgBx rHu6VUKVgKWeomsFx7p68+aNwHQEVi8O0M4AuTo5K4I3QtWsEVSwLu0JcMFq3OoIrKXClW6x0uc6 aWW7AWwM4HUCLLhVRgD8D5B6yq7VFrGWugO8OAAgOilm2c4A2MfaYhSgYAW45j5WgGmVYy241VHh SsHq5avqVksxwB3dKqFKwFJPxbWWiliVccCkiOWANZ8oUAnWxjt5VcC5L1ht4cp2BNh8FbsBZmIA ulWKgH3C/yxX+7jWXeIA7Aiw7VfqZJtxztp6YHVcqz16pd8XrF7hCjLW3GZV6gbYMQYgVCkClq61 7Fp3jQMcyLamBWt0YmukTn0cYMHaF8C68fpZcTDAFq6W8tVCDFDTCUCoUgTsE4DromudK2KF52sY Flg7cQC2Xa0Xcta2ANYGT2IFsNpJq37OsYYfZ4OtVgrW9HxSuMJpqwWw0q1SBCz/2bmFrEXXqhuv PNcqQC11B0AcMAJrOhK7SyBt981ZtfnfAHWzFAXMgXXHwhXBShGw/Oc271qxr9VzrbjxKrjVNRax EK6ee51pu2rTgYJuHAA7WWdzVgSqTl2JU60Ba/g797YjwCtcVYywMgagCNgn/M9rNedasa91ybXO AHVtugOKcYDXzwqu1ctZvcUrfQmy8roGrALUr1+/bhGshcLVrm1WBCtFwD4x19pYuO7qWnXjFcB1 DRNZXua6U9tVIWctFbA2JaAGbUw/6ygKkEKWbbWqAKsHUMYAFAFLuP56/uHDh9X3799bz7WWOgTQ rSpYDVA1c42vvThgn5zVtFptMG8Nn7KBJSwbmLzKV68rwEYBCNaFjgC6VYqA5T+f3QpZr169EpjG /tbLy8tOOwTmXKsAVa6moDXZfNXAeGtNPyvuYq0oYOXnkrkqWHVA4A5gZQxAEbDUYSKB8LzD9isF q5O1ro1bRRfbme6A3HZlwapwnYkDbM7qRgHacmVy1h4HBAhWioCljhoJBLC2c4UseYhzdfpa19a1 QssVuta1Zq07TGFhHDBaGahw9SIAyFYnYNVdAVrAwj5WeU6wUgQsdbRIoFTIMjsE1trXupC14rKW XMRy4oCVgglc62wcoBBFyGLbFeat2hmAjlWeI1iddiuClSJgqcNHApK3eoUsca1YwFqAbMm1tiWw ahFrLg4wrVYbk7NubAHLa7nCOEAHBMLfb1joCiBYKQKWOkwkUCpk6VIWyFbXCNRK17pCOFnXaroD JnGAdaylnBULWNpyZXcFEKwUAUsdCq47RQLqWmcKWRfoaJ0jXEquNQKq4Fr7UhyATnVmUCBeMQ7Q nFWfm5HWgWClCFhqH7C6cK2JBKxr9dqvUtaawZocbQvHZs+51sGsErRTWBvTHYCQHXUJeDmrXBGs FZ0BBCtFwFI7udYM2LnBgUIkMHKtsK9Vnl/Ygpbpa40dAsnB7uNa0aHG504csKnNWSs7AwhWioCl 7hYJ2MGBUiQwV8iyW7DMwYPY11rjWkttVxvMXG1va23OumNnAMFKEbDUbnCdGxzYMxJwC1m6BNvC 1bpWPfpaXastXgFQs5O1YC31s9qcNfz9BoKVImCpu/yeZ+G6NDhg4YqRQCpkeVuwusr2q1nX6sUB mLNib6s8sXGA7Wd14oDBiQG4hIUiYKlq1zqCq5e3imsNzq+zgwMIVViMfeFEArmYZbZgoWv99cPM u9aNFrIAspMilhkW0COxexsHVAwKsIBFEbDU3pFAA661XWrBCu+vTQvWTpEAFrIKcN3VtWaglopY pe6AmX5WFrAoApa6M1xn+1tLLVgC19LgADpYz7U6kUB2rU3aIbCDax3B1StiVXYHLPWzEqwUAUvt D1evv7WQt066AxJgL+4SCZhprEXXaoC6gRHXDQ4LyFW2IX758qWmO4BgpQhY6jBwlbz1+vp6VMzC SEDAKpGAk7dmyGohqyYSgN5W17U2pq81dQZMXCuOu9qsVV0r4wCKImAfFK41xSyNBGzeaqKAtbNi cDESgJWCoyNbtNXKc60wibWxrVfoWhkHUBQBex+/xyJcS8MDwbmuF/LWC4DqReHUgblIAAtZvS5o QajWQvYORSyClSJgqTu71hFcS50CODyAnQKicEW3GiOBAMSLu0YCWsgSeHrOFV5vMGuVHwlbrwSs lUUsxgEU4UAdPBJoSnDFToEA1XWhmHVh81Zxsd4Jr2lhixsJwALswYy4TjLWkmvVQtaca2URi6II 2PuCq9uG9fbt25y3wrIWr6/1wlzdAYIdI4FSIevGulaNAtC1yo+oQwOea50Zca05FpuiCFhqN7hi G9br16872ylglrVc2GKWLWot5K1x3NWLBNC1JrCW3CpGA4sdAnStFEXA3itcS21YpU4BWNZygcUs 616dvHWyS8DAFbsEvLarm3Rky6THNfW3bry+1h1dK8FKPWl1/BXcL1yTc41wTa5VXOpF+HoBa74m 0GbIBkiu9Qjt8LyYt1rnqhNZCtXw9Tfha+Wqva0xChDI3tbWNpsA0I3EAeHz+vA8tl+FtwW0g3QH hPekS8BzrSxiURQd7HHgantcl9qwKjoF7LEuk0ggwXWSt9ouAZOz3th9Apq3YiRA10pRBOzJwHWp DauiU+DCW5C9Z966cboEckErRQIbO+qqLVg79LXStVIUAfswcC20YeUiljNE4HYKmONcSnmr61o1 b4WstehaBajfvn3rd+xrJVgpioA9PlydHteaNqyLlLFGxyrPm9tTB7qFYlbv5K0b7BRIueukSwAn skqRAF0rRd1NLHLtCVcZIAi30y32uHa35Ip5q0DSwDUXtJJzfZaKWs/S6Os6gVWLWV1FMSuCNbw9 msIKXxMhqsUshap8XAtZ2oY1V8h6+fLl8Pvvv9O1UtSeWvNXsB9c5wYItMdVgCmFrATZi9QN4LZh Yd5qJrMmxSxswVKwClTlGj5NrzfJzd5IV4COu0reKkAV1ypXjQQErDOFLPa1UhQd7HHh+s9//nMV XN0iXFOngIA1tl1hGxa0X+F1dG5WigdGxSzdhKWRgDhPaMGKMFWXKl0CehX3KtCFFqxYyJKrAFWL WRoJLLRfEawURcAex7lauMp0FhazpP1K27AgCsgwDa81DrjAdizNXis6BXqvU0CLWCkCuDHXOEAg kBWoSiyAcGUkQFH3AxT+LnaIBXD0VeAKznXU4wqQ9RZlY4/raqZTAItZG9wnIDmr7W9NuesN7hII 102pS6AQCbCQRVF0sCcL14mDdWIBycA7aMOysQBOZuFEVi5miXsVdyqg1ShAp7I0b9XeVnnOSICi CNiTgWsaf233hOszhapEAlL0sgcTpk6BFv7srVkzmJe0KFQVshAN5G6BFAW4easWsxgJUBQBexJw xT5XKWhh5opwddqwFKrxAaDFeCAe7zL6gRy4mv7WG40GbCuWutemkLeqc5VI4MWLF9urqyt2CVDU PQGGcF2Aq3YLlOCaClkxewWo2jYs3YqF6w1zGxbCVdxqguyNGXdVqI76XHXk9Q55K8FKUXSwBwXs weAK27CeAVwvdJDAca4rcK4ZrikK6J2JrFH7FRazMBJg3kpRBOxZwFXGXmFCq0utWBewyzVPZTkd A7bH1eatEWYWrmYx9g30tuqawRunmLXx8lYZdRW4Mm+lKAL2IaKByT5XgasWstLKQW+IIBe0BKQB nM+8Pa5yFUCn3zV2CmTI6RABwlXbr2B3a3aw4lobU8zSfQIBpiPnqsUsk7eyBYui7kFPbVR29gRY b1m2PDdwdVuxvMxVOwaEnTYSQPdqj3QRqAJko3PVsdfkWm8ErGmPQHSuAla7rIV5K0URsA8J18kZ WrgVSzsGBJKyW0AgK1AtwHXtwdXLWxPQBoRrKmiV4Hpj81Z5LWCVrxfnqsUsiQNYzKIoAvYs4Kor B6W9KjnXNU5oYQvWHFyla0Ans6xzrYDrjd3lKp0CuKzFWTE4NMxbKepB1T7RiGAypSUDUxoL4CCB rhwU1yoPKGZFkJZigQW49rvCNcUCNwpX7RSwcJW8FeBK50pRBOy9QXUEVylq4QisPaBQTiLQfa4i szBbW7NGfa66anABrkMtXFPHwI12Cli4yvXy8rJXuDrFrKXCFkVRR9Jj7yKobseSEVhYO7iGM7Ry 3tqYlYNY2NKNWA10CwBcG4gFhgTT0ckDJbjqAEEqZm2wDWthMouulaLoYI8O12YJrumIl1aq/eJc UzzQ4QGFaUk2bsfCdYOjU1/1zwbnigUtC9ebWrhqG5aFa/gfAuFKUQTsg8DVbceSaCDAcgXHa+sg QQdTWtrHOhocwLx1aYigGRe0inAN15/yWIKrbcMiXCmKgH1ouBY7BiR3lavtdbX7Bcwe18lWLLNu EOHa18AVN2NpQYtwpSgC9tRBW9WOpbEAjMC6DhZOIujMqa8jsKZYoC9krqNYQE98tQUtwpWiCNhT heoIrtoxMNeOZeGastfRIAE4VutcEWp7Za4IVzP6Gq8vXrzoBa5v376VbgFpxRoIV4oiYO87GpjA FYtac+1YANc8PGBiAe0WwEjAxgKTIYK7wBUHCASu//rXv7ylLYQrRRGwR4frxL16HQMKVy1qJbDG vFV3umrPKzjYzilqNScA14ZwpSgC9t4jAsldvY4BgSv0us61Y2ksoB0DbTqgcFUDVyhkEa4URcCe P1Sbio4BLGphMUsKWaYdq1tqxxKwppNe+30ntAhXiiJgzwautqhV0zGgOwawHQtPIYBBggy1wjEv G3OsNuFKUQTsWcK1sXBtZnLXmY6Bi9SOtbYdA/J7kh0DTRp/bczR2h5caye0CFeKImDPxcXmaEDc q8L19evXLXYMBIh1TsfAOg0UuAcVioM9JFwFqoQrRRGw5xINNE1hmAA7BuyOAegYsA5WoWqLWlvd MXAX54pDBIQrRRGwpwzXvYpa2iWA+11xkMBrx1K4mmNeejj9NU9l2WXZhCtFEbDnBtv8KE1qeUUt PP210DEguSsOESBch1Tc6i1U1a2mk2D15Nfi+CvhSlEE7Km61/z++/fvR0UtO6lV2jGgk1qyKRt3 DOjibNvvqsuycYmLxgEAV3Wui1uxCFeKImBPPhrAYQIpauFuVx0m8Ipa2palDrZJHQMWrrAsexQJ SP6qz3Vpizz07Kx0HRW0cHEL4UpRBOypwLVx4Npix4DNXe2klnWw4lrDc8xdI1gNXMW55p5Xca5p sGCDm7DUwabTX2/wgEKBq3esNuFKUY9X53aq7KpxcleJBgSq2O8qwBS4pqO2R+5V/t6QwUru2sEY 7KSoJVBtfq0fHOWu4T08VltAugmfu7FwtQcU6spBwpWi6GBPKRrI79t+15cvX45yV+x5hc6B4sJs O6ll27E0c+0li7hty8q7XNW1pqu8119fX/dzcE0rBwlXiiJgTwKuxZasitw1u9YUD0yKWs2vSa0M OO0YMO1YsdfVdA9E1ypw1aKWwFWgOrMsuyFcKYqAPbl4wLZkzeWu2DHgDBPEwpaZ1NLcNRe1vF5X hasWuASuP3/+jK5V3WvlAYWEK0URsKcRDdiWLNvvmhZodwhWPKgQe10hdx2NwUKvqxa1RnAVoGL2 6u0XQLhKt8DMMS+EK0URsA8K2WJL1lK/60zuimdqNQ2MwTbTolYPHQMC1Btsx7L7BaRjQOEqva4v X74ceIYWRRGwpwTWqmjgxYsXuikrdgTYBdqF3NVbPxghp9EAFrUkd1XniuOvpV5XHIElXCnqaao7 g2hA4dqaaCDGAOJYAwT1uO0LPfYlfH58HiD5TK4BqPE9AW76e3fh64q5q1zVuaaBAh1/HY3BSiQQ PtZL9irdAgLVANcIVp3S+v333wlXiqKDPUnYVkUDXksW7hcwgwTdUu6a2rB6LGSJi4W2rEnHALZj ybcXuH78+HEgXCmKgD0197q0yKUrtWTZPQMAWYUrLs6OCl8bc1d56KRWigewqLWxRS3sGLDtWAGu dK4URcCeZDSQ3/e6BnRyC7sGoCVLOwjyYYVpv0DuHIA/ZwuuVftdI0yxLUuAWipqhfdjLCB/rMS8 ybkutV8RrhRFwJ5+NGC7BkxLVt7t2twucrFnauU9A3bHq23LmitqpYggF7WaaZ8r4UpRBOzJuNdJ NCB1J+wa0GhAIArRQGcXZ0PXwMrLXZvUkqVQNcMEOXfVSS0cg9UFLrjXdaHXlXClKAL2QSHrnq31 6tUrd6BAowE8S8ueCOtEAwq7wZ5MgLmrutb0vNdJLTsGW1nUIlwpioB9ELBO4Gp3DSx1DSS3Gq8p GmjT37EUDUz2DKiLVbgiZO0wgR2DrShqURRFwD5oNNDMRQNa2MKBghQRdNiaZbdklVqycKhAowGb u2o0gLmrFrV0DJZFLYqiTj0imBS2hH9eNKBgtflrmtbCI1/auZas5FhxYmuUwQb1NhrwxmAbFrUo ijohwBZXEdqeV3Gw4l6Tk41dAwhWHCio6BpYbMlSyHr9rl7uyqIWRVHnEBFMClva82oGCjo8pSBB NZ+ppacSFLoGqluyxNmGn6O/Q+5KuFIUAftgYB05V3mUClspc81rCBNcc0SgrhXcK8YCEa4aDUBL Vl9yrZC7bipzV8KVoqiTiwjy6/fv38/1vHaQuXapU0BbsybHvpg1hBgP9HAETM5dtTUrwXWf3JVQ pSjqwQFbbMtaKmzZcVh1q/oce15Hf+A4GhitIlxqyfrzzz8H5q4URZ0DYKsntrSwZXteU0SQ3Wup 51Xd68K0Vu8UtKJ79VqynD0DzF0pijrZiCBC0JvY0sIW9LxmBwuFLXsyARa20E1uTTTQYzSQMtge VxCWooFPnz4NM46VcKUo6kEAO7uKsFDYarGwBQMFo8KWOtdmXNiqjgbkfQleBbJ4aKEXDTTz/a4U RVEPHhHk17qKUPgnzhMLXOpe7aSWQtZMao3ca200kApauSVLogHJXXEF4UJLVkP3SlHUQwJ29owt XEWonQM2FsDCFjxvFbLoXuHgwtloQKCqxS1tyYLjttmSRVHU2UUE6F6r2rJMYauDwpbGAyubvRai gRFccaDAbskSBzsTDRCuFEWdBGAX3WvlvoGuMLG1wtNhC9FA3paVooHe6xrYMxqgKIo6mYjAda9e WxbuG8B+Vz24sBkXt2w0MKRoYNBYIMUF/dxAAaMBiqLOBbDV7lXP2Lq8vGxN90CHZ2vBwYW5sIV/ oLdrIMUCPe4a0PzVDhQwGqAo6lwjgp3cq4kGOtOWhcBuAHoaDwwwGosDBTEy0HO1SjteGQ1QFHXK gN3XveJSFxyFbb22LISrt0Qbel7zchc8/iVNaA2MBiiKOueIoNa9tjPuNWauti1Lo4EGFrrIFXpe R90D3hpCRgMURZ0LYA/qXgvbsrxx2FFhC9qyFLLaPRCfa+5auWuAoijqpBzsonvVgtacewXXOnGu KRrAntdBXauBbHavtudVug/EuXLXAEVR5wLYlfdc3eubN2/i9fnz5xGetnMA2rEwc7XZ6za1Zo36 XtND+12ze8XCltfzurBrgHClKOrBAevFA3ljlt05IM+Dc8QDCvNDi1te5grAzu61iVHsr/YsOJ0g DxNUFLYaRgMURZ1TRDCCKz4UshIPqJMNsMtQ1SseXiiuFY/e1odObEE00OsyFylqiWOVR0Vhi9EA RVFnA9jFeCCBdnTUdnKxqwRajBn06O0YD+gyF8xcdccrQDZnrzsWtghXiqJOArDuiQUaD+gb1snq 7X8AXYapDG+ZxdkIvJFzxZ0DWuBKwJ20ZWnnwA6FLYqiqJNzsJPM1IsILi8vc0wATnVSINM9AxoP JMhmoHrbspbasljYoijqUUQEAle5vn37NkL0t99+Qwfb6PMAvabgJGMxC8CaC1opGoixgDpZ25aF ewbUvbKwRVHUuQM2xwN4y49gDbfpk/fzFye3Oty2BWzTNccCuswFugdG2astbM241wnQ+a8HRVEn DdgPHz5MnKy62cZpuwpQjMDT9iu9NtM+1wxXW9jCWAALWzu0ZRGuFEWdFGBX+35hgGB2q5CxbtG9 YjEruFyF6UajATx+G8/XwqGCHdqyKIqi7qz1g1A9AE6BhjANUIzZqLhYgWF/e6yBxAZ6SsGq+bXQ ZTBrCOO5WmKC9bm412fPnkWnK+5VoMq2LIqiHi1gFa7oVuGRnaqMw6a9BY1AMbyXx2N1oYseuS0O Vg8vFMcaPidGAxcXF9G9SisWutdPnz7xVFiKos4qIqjPEgJMf/z4EaF6fX0dwRrca6zue8e8CEAF nvKAOOAmvb4J4LzRaMAu0vaGChq/JYuQpSjqoOoOyU3zPD7+7//+b/W3v/0trygMjlLHYlc6EqtD BTK1pVf5JpIKbG93Fm41Q9XilrhUPHY77RyIx7/oUEH40hgRhLcjXOWUArpXiqLOMSLYNn6hK7rG 1B3QYDwQYBsnqcLtfKzsi4sVMAqM5WtkDWHaV5D7ZVMP66BtWAJagGs+Y0vcq8D1y5cvEa4cKqAo 6pwBu5xHtO1Wm/zTI7pSqWEJMNMR3PFz5U5f6BrAONpDIKCWCEHcqcQAAll5rkUtyV0FrnJN0cDW OQaGQwUURZ1VRIAxwegUgz/++KN59+6dbs9aBQA2OiIbHGec3pJhhADBuMhFnKs8T2sIYxOBPiQi ULAm9xrjgATXjQ4UCFRTNBDhGtzsNvwcHCqgKOpROFiEVrzll35XjQfEwQr8kmsV+Ep22ggIZeF2 ihRW6GCljUu+VkCro6+St0omq841wTVGAwJZnhBLUdRjc7DWxTbBPa50D4G8py5Wuq8ErOJiUxdB XEUYXmeY6gM2Y8WIQGOCANU8CotdAwJ1+T7//ve/5wpbhC1FUWfhYEuFrvixVGSSgYE4MitgDE61 kTjg+vq6efHihY7ItuH92FkQ3Gf+BgJlgS4sbBGwDgrZNA7b6zisFNDYlkVR1GNxsOhiJ6D93//+ t3r37p1uzorADFCV1406WQFugGqe7hpAab/AkLoE4t4Xda0CVFzkonD9+PHj0LBjgKKoR+Bg0cV6 bjYWryRfFQjKG1++fIm9rq9fv86RQICnuNdBVhriF8twQiR3+Dz5enWzOEhg4MptWRRFPZhWR/6+ bleBnHAgEJWYILjWVrsLpKtAj5PBXbGjbwxFsgBnbfXaKmALcPXcKwFLUdTZOdiSi81Au7y8lEt0 quI4b/dlr6SbYPvt27cIVimIwVrDKN1j8Pnz5whZAam6Wd2QRbhSFPXYHWzJxTbWyUr/q544q+O0 6lxLgIU2r+0MWJumnLsSsBRFnTVgqyCbQNsgaOUTBLbeNxSoKmwBrM0OjpVwpSjqUQF2DrL5PXv6 LD6PecZty1V+bk4kaAhXiqKeEmCXIOuCV46Zub6+dn+2y8vL7dXVVTMD0hJQCVeKoh41YEtwnXvu aQmiXEdIUdSDq7vHP6sWtEva7vCaYKUo6kkAtga0+wCWjpWiqCcbEez6Z9f8TNsd36coinpSgD3k z0CwUhRFwB745yFYKYoiYA/w8xGmFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVR FEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEVRFEWduf5fgAEA1UZJ3jXyYnQAAAAA SUVORK5CYII=",
    transform: "matrix(1 0 0 1 2166 1308)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 344,
    height: 251,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVgAAAD7CAYAAAAvk4y0AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAMApJREFUeNrsnc1y20gShEFQGtnj v9l9Ah/25uO+/yPs0QdHTEz4sOedsSV7xiMQ2C6oE04UqgFQEiVSzoxgAPwRRcn250RWdXVVSZIk SZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIk SZIkSZIkSdIJa6NfgSRJJ8yqToCVJEl6OB51T+0HkiRJOkb2dD/CDylJkmD6UCzqjgW0AqwkSQ/J lM2BedTteV+AlSTpJIG62ePxfd+nWwHY7rFBK8BKknRId7rmMb6/effu3ejJb9++Td7j4uKiB+T7 9+89MCOoPhpoBVhJkg7pTjdLIGWANk0z+np/Hzo7O+v8+a+//toVwNrNAPegkBVgJUm6LVBvDVOA kwHatm1/vtvtRu+Lx6G6rgcgbrfbDo8BtHbMsGWgdnu4WgFWkqSDMuC2QO2PBtQSTD1Icb/ruo2H 6S+//DL5HH/88UfHsN1sNh2ga8AFbB1oHwWyAqwkCah3AupamEYgtfN//OMf/evwGEPWnh99gART hqvdPn36NEAWR4D22bNnreW179+/X4KsACtJ0qMAdXK5HwF1DUzfvHkzAikAitcxUO38xYsXwzf+ 8uXLCLIM1QTU9vPnz8O5Hc/Pz1u42fQ+7WNAVoCVpB8DqvcG1JI7BRxxHsHUg9SOP//888aDOHKv EVy/fv1qxxZgBWjtMTu31xhoFyB7MMCe6e+iJP0wLvVWQE2X4AMkOTctARX3//777w2DFTBlkOJ1 9n3tPF3OF+FqSp9rAGy6tT/99FMP07/++qvF+718+dKAWtnnNsjmL22TA67tSG/X0c/f0VEOVpIE 1b0fW5WhskONLvcBPw9Uft5uz58/rz1gAVLANHpujXs1uCYw98fsYPtj+jl2cK92u7y8NNju4GQt kw0KXwdzsXKwkvS0oLo3UL1DjYDKMMVz5jzT62vvTnH/+vq6Zpim52oGaXq+P0/gWw1YuxlYM0T7 Y7rt0mPmYHfJ0W4MqMnRVvk/ge7z58/1zY/XbqgtrJv5HXeH/AOTJOl0L/030fFf//pXWJTyl/yl y33vTgFUBiwAmSBX0+uG8wTS2rtYgqqBcQRZD9cEZDvaJf7gXNNjPWDtfjrfJeiaW91lyPbHq6ur 3sWao3Uutq2W27fkYCVJLjV2qQBqgs0mKkqxI3316lU9l58mMDE47TV15E7NuZqTdICt7bPArZrs a/Jn7m/4rBm0g9Lj/UfMva49XNPPYI61zUC1r92l97Y+2Cp9/y4936X372+vX7/uLi8va4M0udjO /e7UpiVJguo6lxrlqEtFKXajEVANkshNAVQAFO6UgQpXisfIudbsVvNrq8C9bjJQAdYu/Vw9YNNt l0HbO9Z0awyyCbBNdrINu9gvX77sAhfLDrarDrDwQA5Wkk4cqt6lrslRSxkq30/vW7M75Vw1A3Xk ThPAajhTO+I9GLQ3V/ub/jMyaL8nAZsqcpbmSO3/BhS07OvtaI41nfevS9+3jxKss8C+r4Wu+NzJ xW6urq6sq8D/fg867EWAlaQTgmrp0t9f9jNY/GU/gGlAre26my75C0Ct86X9BKjpI+Ayv2ZoZicK 0Nb58xrgNvgagBY/W4bf6PeRwYoFBRwN9F9uDLWvs2P6jBYNGFjrDPk6/Ywtfkf43biY4KDAVUQg SUcO1TWX/uxSzb35wpQBB1V+vryPLvmjy307GlB9BEBAnTyeYcqPDXmrPUf3uWtg5F4RD5gbzfc5 GmhwTE836Xid7jYWD+SooEk/S5P+Q+rjguRsd5eXl5bVWv9smxceHLTQJQcrSQ8D1qUm/xFkGapL l/6+OMWX+chRDaDWFmVHdqnRJT8AveBQkavWiAES1IZogItYgCmes8c4E85udOQicdmPmxWyMlgH +ObP0rdf2Weyn9ucdv6ck+/zGBJgJenxoTopUu156V+zSzVgAaAGP2ubMkDZY3Y0qDqXOnvJT+Ds n4uAas/lzzM4V9wIcogIqgzcKjvbySU6pmPBubKrxfvk/2yiwtjRSICVpIeBqgfqYpFq7tI/56k1 F6fgUhmoBjy0TRm37H5ua6q5KDUHVHvvJaCSc7XvUTFQ4V45Cghc5ah1CtGAfT251irnrXN/Ht0x /eUQYCXp/sG6mKnuC1W+9McSVACWi1MZsiOg2jG7VoCxzgWm2l3yl4Ba0+eaBarROwNycK8r/yPi vtTSjgN9dGDf2opf3L6FG+CM5zBtyx7//fffrcd2eFPabkaAlaRTjgDWXv5znppeV/O6flz6Izc1 p0outc9RAVUANccCiAFGxSpEAcElf82Frz0c6iYoVo1+R+ZA7XfAc109TAmcLUCae1/7Vi069l0F eUVXD9P03v0ELRsKY0tpbdqWdRcwaHn3g0O7XwFWkg4E1QzWvaDq81S41uxKJ5f+KE7ZY8hRcR8t VrnXFPlqGAXMARVZZwZq5YDqOwD89i6jS3wC6MSdAqzVTdfAAFGA1Ey3LSrA4gI8h5uB1lq48nyC lp0thnPzdjMPESeoTUuS7i8CGOWqvN5/7vIfEGWoogIPlwqo2qU/znGk9qka4Mzw48c3+fG5dirE Cr6VavTzLblU71i58u/hxlDFpT/cawZtG6zcanIP7HDMLVtNXtHV5AEw1p7VYCWXreKyVi1r0fr4 8WO0ikuzCCTpWCOAKFfNsCxmqh6qKFJxnuov/VHtN3eJS3x2qZyt4jFum6pzz5N3qHS5X1XjgSxz /8GUhBVYHqYVw8xBdYgCsmPFUJcdOdgW/a923/pdbYqWvcaONpvAoJxnFLRwrZzRUjzQVdq2W5KO wq3ORgCRW4UztZYqnHOhas6pGlRxzi615FrJvQ7FLTjSDE6eB1BXQbP/mgx1DqaBM52FaX4emSoK V8O0LAIt4oCdiwqaPIdgOMccApsLa5Bl94o5BP/973/te7TVus0Q5WAl6R7AusatTiKAr1+/zuaq BkS0VBlUsTQVmWrJqaKNivLVbc5MB9eaIVmXXGp+fFT99y1TDrD7AjWC6ShPzUCtbgxzx04SkUCL x/PuA/wYzx5gB9vnsBhNaENeAFc75q1ieqDaQgS8N7aOKQD0IAO35WAludWVbvXt27ejWaqo5pdy VX/5nzPUtU51izw1cKmTLJVeN+dSJ44VOSl+ruEXUShERe4U9507HZ2ze2WHinOakjW42AzV0S1H Ay3Amge+DHA1x/rnn38O81+vrq6GCVo5e+0eyr3KwUoC6x5uNeemxQgAuSqcKtzrxcUFO9XtjFPd 2n12qvZ+AGpukUJmWnOWSh0ANVf5XR9qf25fNrJueSXVQnV/BFSGaf76lua1Ds/DiVY0zxWTseBc 7dxaqjxo8+6w9tjQJWCP2ZDtnLf2Q7aRudq+XAZdc60ertSa9WDuVQ5W+pFjAH++l1vlCABHzlUZ quxU4Uxdprr1ThX3KU/lLLUmR1ovuVS0VkW/nNwOVUV5aQmo3p267JSfa7krgB0rz3blx+g5QLnl 3QvwmIGVoQvXavcNsJ8/f24ZrjN7cR0UsHKwktzqHm715cuXw+qpoANgiAByprqtxtX/LZxtdqrb wKn2X0O56bAgwK/15wEqblLVCKi01j8CawjV/Hzn4DeabAV3au7TXeoPl+HsTN2l+ZCHAqbdzTre 3tkaJG3vrSr3wtJjbR5ROIDVvsZAik0OOXMFXNN/eA8OVzlYSWBd6Va5C8AAaVOqcFlubtVqLpFb nXGu2xmnOuoC4Ev/yKXyAJW5X46H6oJLbT1QnRNtvXNlNwrQUjzQZphOvibvtzVyuVgoYEDl1xk4 bXUWngdok2PFBoh4zAZv9xAPnGtVHWgHAwFWUgxAfatz7VVwq4AqRwBcsAJUDbIEyfD8Ji68H6gu ATVDM8pTi439gBlyUoJkG7VRcW4aXeozOPlx7AxL37PL2253HrIGTYZq7m3tYQrHil5XzlsX4Hpw 9yrASk8drIurrJbcagmq7FABzoI7HeCatL0DVGez1AJUS3nqKA+txgOtGZRcdJoANXCnrZsb0D9n MOXHafvtNhrYEgGVnzO3ivu5JavLW3hHYK1WRAICrCTdAayjGMCguo9b5YJV4bJ/iAfYrUbFqypX /8nBFqFauPSfTJzyUN3DpbbBZT9DsvUtUzNAjRzrAFRzpt6xMjwNqP4xniHw6dOn4T5+5hmwVtX8 8tcHm0cgwEpPDayTbgAfA/Da/+RY++OSW7WClc9ScQ73WnKuDqpDj2peDDBxqr6Nagaqs5f+ACIg WnKpDrQT5+qA6iOACUz5Ut89PgvT6uYXtQhUvA5LXguOdU0UoGEvkrTgUlflq5gJYJBE3yovW7WV UktuNZ9vXWvVmgig3hOqmwgCK6A6Guk3k6VOXGoQBwztUs6hjoAKmJbcqVX5PUwZmLj98ccfAzgZ tiWg2jFwq9XKGKB7jL+4knRKYC0OXInyVYOixQClvtXkVrclt4rLfu9Ug0hgFAtU4z7Vegaqm5Kz KkGVLt2XLv1L8By9Dv2mvv+UoDoAFfkpvicKTuxMS5f6drPB1x64HqYMUhyt1SoPyd4HoI8CVgFW egpgnQxcKeWrczEAqv/IUpfcqjlVXPrba6JcNT82Gv9XTQtVIVhLmWoBqi0Npp5c+peyVALv6LIf Df2RS+X7Hqh51dXqS307R35agqkdHVD3udx/VLAKsNLJg3UpX+XCVRQDMFipharkVieRwFwEQKut qgW3OgDANfePpvoXslOu5jNUuwiiJZfqV0lFGSr6TxmwkTtdc6kPkPKuAoE7XYLkmh0JumP6Cy1J JwlWnrmKNquoG8DHAABshumsW8X9wK3eJgKYhWpVaJvKj43y1Mip+vvelUb3qW2qLWWocKkeqHOF qJWX+msc5z5bvHTH+Bdbkk4SrL5wBbCaY52LAdi5Ose6xq2GEcCeUK08RP2lPoPWFalmoepdK/Wj ts6lji77o6IUzm2p6hJQZ2B628v7teDsjv0vuCSdHFhLMUBeXRVlqqMYgIpUW1plVXSrCxHAZu4f f+BW26D6H17+A6C8F1V06c+uFaulSi51zWU/Z6h7AvUul/prgNmd2l90STopsEaFK8QAzrEO3QDe oXqoziwOuKtbjXZLLRalANuk3VKeGkQBIVAjl+ov+z1QOUNdCdRDwPRkgCrASk8erOxcKV8tQhZg XeFWl6BaVeNJVKMIwF/ul6Cat6IOnWqe3D976Y8WKkDW5qRG1X6/lt9f9kcFqXsA6pOFqQArPSmw Gky5IwCFKx8J+CgACwKoxWq70q3uHQHQ9tMdudKW4wDaa6qlaf2zUJ1zqn7iFNwo1u2vuex/QKB2 P8o/AEk6KbBiRCCDFW7VF618FOAXCCBvZcea5wTwXNUNXB4esn5V36caRQBu8z7vXnduO5TBucLJ eqhykWrp0p+Ho3iozqyQuk3v6RIwux/5H4IkHQKsDNMHAWuGp4fqZJHAQgwwGbTCYF1wq8UIwGWq O1+88pkq9p1agurcpX8pS73jCikBVYCVjgCsI6g+IFi5f7WUr442Ccyb/20KbnUEVh6kYtR0hali BIDLf85Y4VxLThWX/9geBZf/XPW3FqrSpX+UpRaGo9wFqJ3+GQiw0uOAtT+3WQF//fVX/QBgnRSu 7HwpBrhHt7qLYgG3I+oA3Dmowp1iaxQeNr3Ppf+MSz1ET6okwEoHzlknQ1hsHyte0voAYN2uyVdX grVd4VZ3vgOAoZojgB0y1ly42s1BlS//sTUKPzZ36e+mTa2JAARUAVY6crAOgOXpVhjCArBi5ZUt DLhnsG7nCldRvsoxQC5ORdP+2zUFqgiq/JxtL81u1V/+R5nq1dVV6wtX93zpL6gKsNIRxwGrwOpn BTx79mzLfayHdKwLYC3FAKO+VStQzbhV5Kw7V5waRQAG2FysGpr/rU8VgPVQjfabYqiuvPQXUAVY 6cRz1kkBy+AagZWXtD4kWCOgrIwBosr/4E6plWqUrZYiAF+sAliXClUrnKqgKsBKTzBnrT1YeX8r y1kjsEYLBO4ZrNHf8bB3tRADTMCaYbroVnEeRQC+WOVbqg4MVQFVgJVOLQ5AAYu3YjGwAqiA6wHA yquu6urmQe9a51ZacQywA2gNkNW4b3XnW6w4a51zqz4CiIpVgqoAKykO2FQrCljcGUA56wDUA4A1 mhMwQGXPGGACz0InwGq3Coj6XNUej1qq9oSqLv0FWOmJxAGLOau5VBcHbDGPFUBN52d36AqYA2tV gGpXzXcD7MjBctFq5xcHEFhXu9U1EUBhA799nKqAKsBKpx4H+IUCdos6AwyoVMDyTvXsDu1WRbBm qFbVwqKAtVD1YPUxgHUCLLnVuQggQbUE1E5QFWClH8S1+jjAr8BCL2vQGTA4VgfZM4wNZMhW8WSr yYDrFWAtLgpgsFKhagRSX7TCfWuximKAObeK1qo9IgBlqgKs9AOAtcpxQO3jgFLOCrDazTIA71gB VAB2Caw8gGUJrNHM1bl81RWqFt1qAuuu1Amw0q3uEwEIqgKs9AT+vDdzcUDUHYA4wLnWIWc1sMK9 EljPCnHA1m8qyBsILuSrEVhnV1qhxSqCbARWuFVzrpFbtU4AHrri3erHjx+7PSIAQVWAlX60OMB3 BzBYSzmrB6uHrM9Y8+4CxZGBDBs/zaoA1mK+6hYF7JZiAC5asVvlAdZ7ulXlqgKs9MTBWnStKGKV ugMsDkA/qwcrugPsiCiAYLp15xOw+pGBDJ21YHX9q2G+CshiLgA51t1c0Yrdqh3NsS641bvOApAE WOmpudal7oAEljPXzzoA1XcJBJCdZKxzYM2utbg54BxYKV/l3tUdu1XuBrB0Y65o5ftW5VYlAVZ/ rrOudamIxZEAFbHOuJ/VjhmiZ5SzMmT7QpYbfA2wLg1gaXnVlZ+1ugDWUSzgFgjsom6ANUWrO2ar gqoAK/0ornVtEQtuFd0BM3HAJBZwW7VsqJg1+vtHCwI4DgBYJwWrNWD1jhX5Ktyq7wYoFa2CvtV9 3Kqgqn+M0hN3rZPBLFzEev36tcG0WMTi1VfZnY7iAIA1yFyHbVpKYHVwHeIAONYqzwagAtZuLViX 8lXfDTATA8itSgKs/hxv51rnilhBV8Bc5rrNxSueHbDJ0cAcWIc4wI8EBEzvE6xwq6VugDsUrQRV SYD9AeAaZq0l1zpTxDrzkKUYIIoDRhsMot2K4DoMYjG4+YUBnLMyWAmgzRJYLQqICld2//LycjSD dQGscquSAKs/u/t1rVERK3Kve8YBI7DmrVk4DohWWzW8QACPLYHVLwyICldBvrq2G0BglQRYuday a033R2BdUcQqRQQcB/hlriFYXRwQ5awToHqYpu/XRFFACawLhavb5KuCqiTA/iBgHTnWNa7Vt16l o89SfRHrLDvVSU8rdwe4iVffP1xuvQriAL/iCjlrwxmrAdX3scKxImP1UQCD1ReuFvJVuVVJgBVc y5GAX43ls9bItbqslYtYw7kHK+KAaqGIhThgIWdtXAGLo4AmAGvveO8AVsUAkgArLUYC/f0E1rq0 GivKWmdca1jEsser6WKBqIg1AWsV56yDa40KWOxaGax50HUfBaT/SHYHBKugKgmwigTGkcBdXKsB damIZcdq/WKBxZzV4oBCAasBUHH0CwTsnItXAqskwEr34VqHcy5kRauxog6BkmtdKGL5rLViuO6T s3LhClGAP/c5K4OV+1ijrgCBVRJgpbtEAsVC1osXL/pdBS4uLra8GssiAe4Q8K6VVmKdFYpY+8QB uyBnbSLIchTgzoeWK85ZMYBFYJUEWOlgkUBUyPLtVz5rZbAuuVYuYt0lDpiLANi1esfKLVcGWJ5s Zecz7VZ32YpFkgTYH8y1jgC7NhLAaixkrZFrpaz1LMhaF3tal+IAg+hMztpw4YoLWKXOACxpxRxW gVUSYKW7RgJVdq21jwRevnxpMK1dJHCGJa6ctWI1VgLUOToE9nCt+BxdwbX6nLXx/awBWBuAFQsF DKxLnQHJlbcCqyTASvcB170iAbhWdqulaCCYJTB0CASudYCrG3492pnVrbxqXD9rE+WsfqHAis6A ttpvgYDAKgmwAuvofALXuUggPXeGvBXu1UUC57waK7tX71rtHNu3jMCaI4GWXCsXsaLugAaxAIAa gRU5K1zrngUsgVUSYKW9XOsA2Hfv3m2+fPkyylvNtSYwbecigZlC1plbjbV1HQK1iwMG18orsQDU 6qaINay+ynFAsxQHRDmrnZcKWAKrJMBK9x4JrFk4sBQJpOM5xwG8eCC71trND9jLtTqgNhQRFOMA jgJuWcASWCUBVro9XH3easWsqEsgigQMqjM9rndyrS4SaAiyzUzmOsQBpX7WOxawBFZJgNXvuXi+ mLdiApbFAjQQe20kEE3AWutaJ7sJBK614Zw197Q2URzA/ayFnHWpgCWwSgKstMq1DoCN8la0YPlZ AuhrLXUJJGido681iASKhSzeEyvoEGhKrtUXsey4Jg5QzioJsNIhI4Gqcv2tvgXLzxKwSCAPwo4W DpzfJRLI7VeLrpXB6otY6WM1URyQYLr7/Pnz0M+qnFUSYKVDwrVYzPJ5K7dg0QQszlfPgy6BszWR gHetldsGO7daTVwrOgairBWLBXwcwP2s6edqlbNKAqx0ULhyMcuAuk/eSr2tI9cKyK6JBGjRAHcI NHNZK80OaDgOYNeKxQK3jAMEVkmAlW4HV8tbv337Nipm+f5Wc60zeauPAs58C9ZMJFBqv/Kulfta i67VIDtXxFroDlDOKgmw0q1/lyFc1xSz0ILl81bXgmUOduuWvda0u+tiJMBwpSJWs49rTf9Z7FYU sdpKOaskKEj36FpDuC4VswBXl7ee+2IW56wLeauffhUVshq/zLVU0FrjWmeKWIoDJAFWurdIoD+P OgW4mJUuoc9KeSu7VmrBGs0SyENa6iBvXSpkNT4SYLjm1isAtVnrWmeKWHKtkgAr3QtcZzsFXDFr WJHFXQGUt577Ga7sWvOWLvXcTgN+d4GZzoDJ4oE8R6CRa5UkAfao4MqdAq9evRry1lIxK8hZo2lY +0YC6BJo1hSy4FzzaqzmnlyrwCoJsNLd4TrXKbBUzAqger5P3nrHQtaQtSISmOtrXXCtigOkH15n +hU8PFx58UAC1bn9OQCuFgWk+zgOLVi5Y6BfLltNt3KpArgiEmjciiy41ev02ia9Rw9cA6pFAna0 SMCeS5+xjwRsJZbtl2irsewo1ypJcrCPAte5NqyLi4sz3ymQjpNIwBWzVuetQZdA41ZkFQtZaL+y SECuVZIE2KOE61wbljnXoFPgvBANrOlvHS0cwG6ucKszkcC1L2Rx+xXgCteqrFWSBNijgutcG9ZC p8D52mLWTN4adQlcry1kYYeBlaux5FolSYB9WLj6NqyoU8Af3WyBuXkCUd6689u35ON1KRIoFbKu rq52e67GElglKdBWv4Lbw9UWECTXN8D1zZs3lpEOYE2w62FJcD3PjvU8O9X+Vt0UtfojO1dTeo86 w3XkXHMswM61v8S3ohXgalFAPuJ+D1kDqx3Ta3dWwDLnakcDKpyrnZtrTbfut99+k2uVJAH2YeHK CwgMrugUQI+rRQIGTYNqgtoA1wzTnxi0cK8GZUA2O9jJPIE+cO26USRgsEzPY2WW3UeXgB2v0/e3 3PU6dwsM8wQAWettTQ/3XQIG1vRY9+LFi/bDhw9yrZJ0S6lNa0+4/vvf/958+vRpFVzRKZAdqoHz nDsFfCRAQ7JrHwn0J1TMotaraMEA8tZrRAIG2/SZ+kjAgGqRQHatuxXtV1qNJUl3BIl0C7jy6iwr ZnEbFncIcN5aGtqCYhZFAhU517ZQzBq1XjFcCzMFRl0CyFtXFrIEVkmSgz1MLLAEVzhXO3KPK6IB 345lUM2RQE3OdTMD19E2LhFcc856zXkrZglY1mpfawsIot5WFbIkSQ72UeDqM9cSXN0CgnPnWMNY wC0eWIJrQ7HAdeRc4VjRJWDRwFyXQCESUCFLku4oFbnuGa6AKncMoEPA3Gr1vVNgFA+kx0exQI4C uhwFtNzbynC1W3r5dS5uXaNDwKBqzjV3CTRzXQKKBCRJgH0UuObZAvVt4ZqLWdwxgE6Brctbo26B YSg22q8wO8Bg6lqx+tVZVS5mEVx754pYQF0CkqSI4GjgyosIuFugBFcuaGW4TlZoBXBlkHW840CQ t3IUcM2dA352K+Dq81Z1CUjSw+hHLnIdBK65eHVObVij2QK3hOu1iwYmxawMV/S39nECugRWtGAJ rJKkiOAggL1XuPqVWh6uCZyct25KcOUVWexYOQ7IiwcwarDhSMDOC3lrq0hAkgTYo4CrzRbg5a8G 1XMLOZfh6mcLnOXfd125glYEV+px5az1Oi97RTHrmvLWhpe8wrkW8lZFApKkiODg0cAErjYsO5jn OlqhRX2u/fAWM4+0SiuC6zZHAlEs0M7B1Za6AqpwrgbW9HXocW2wMgvFLB4xaJFA+uzd+/fv1YIl SQLsg8F14l6jnQjsPFr+yn2uQUGrCFfrdcUkrCXnanBF5orOAUQDFgnkOQK9czWwmmO9vLy0c+Wt kiTAHgVc+yM2KIyGZRskbYsXg6xB1S0iOA/mCowWEgDgAVx3K+E6FLVoWMuwMsucKy8e0JJXSRJg j8a5erhaLAC45mHZfe8qxwIOrsVVWhmstfs8oxVaK+B67We5WqeARQN+ZRbBVcUsSXpk1YLrzSot Yx2cKy8kwLBsc612o2IWNiOciwVGcM3udbRn1lq45ljgGnBFp4CHqxWzCK799xNcJUmAfSjQjopa vATW7/5q27xgWLbJbU6I7oEzt4dWWNC6LVxzx8B1LmZN4GrHi4uLHeBaKGZ1gqskKSI4JFQncOV2 LFsCSzNdw15XdArkqVhn2LGA+1wrasPCzq93gSsWEPDAFu9cFzoFBFZJkoM9aDQwC9e8OWEN55rj gS3v/moQtRv3utLQli3v+orvja1d7gOueWBLI7hKkgB7THDd+Fup15W31kYxC7u/lnpc91z+emu4 osdVcJUkAfaY4Dp6LuoYoFVavXONhrdQFDDpFOCiVjVd/rq7TeZqBS0P1z0WEAiuknQEeopLZYu5 q3UMMFzz6MEeqJan0kKCYexgdq3DuEFry+JowBW1WC21Yt2qoMWjBgtwbRnmgqskycE+Gly5HYt7 Xc29pse3WKVF2etcp4B3rgy1O3cL8NLXvDpr9/z5853B9c2bN22Gq5yrJAmwjwvXqB2Li1rcjhX1 urpY4MztQLA4FeuucOUFBAbX//znP1ELluAqSUemp9KmVewYsNtcx4CfMWCQtd9LsFprWEDgNigc gJY7BjoP1wzV5oBwrQRXSZKDfXDQWlHL3GuC5cZ3DMy0Y3kHu6Wtte184zcozPtmtRFcCbLmYP8W XCVJgD35aCAa4GJHdAxE7VhWyIoGt2S41kE7Vge4pvdusW9WBFc5V0kSYJ8KXItFLcCVs1d2rdyO xe7VtteupoOyO4YrFbZCuGJ3AsFVkgTYk4oD+MZFLc5dMcCF4ZrbsSYLCrCttv2eDK45f93cFq5y rpIkwJ6yi+1vb9++HRW1Xr16NeoYSBDbZsie8WwBWlCw5YUEiAcIrhXD1S0mmIVrNFtAcJUkAfbY o4GqukVRi7PX7GDPXMeAxa4jt+zhujZzBVwNqoKrJAmwpwLXVUUtWgbLYwfPfMcA3zDAhSdjRXDN W7o0+84WEFwlSYA9ZtiOctdocDbDlVdqoUugNFsgvWYzB1e0ZPHuryhi+Z0IBFdJEmBPzb1WPhqA e/WDs6NlsIgGrJhlLQK+Y4BzV+yllb4ObVm7DFNAddhaO5832IkggqvNFhBcJUmAPblowIpaCXI1 ctfckjVxruRgt24frUlBq7pZodWDlYtaHq52zM61GAtgcIvgKkkC7DHBtQrgOtlTyy8m4KIWOgd4 roDrGEBRa7QLrINrgwUFube1jwLsMTtiY8J8HBW0eCqW4CpJAuyxgXZVvyt1DFi/65a6BSYOltqw ai5qEVw7XgqbXrJDUQuZK/e45nmuDW9QmG6tHzkouEqSAHts0cDwuM9dfb9rVNTCsZS7VrTdS/V9 McEQC/jcFR0CvK22bUI7t/sr5rkKrpL0tHXsA7dXDc82qNLOBP18gXOj2m53nl577nYn+IlmvPbH /HuoE0QnO8HmjoE2AXiX27F2HA8YSLmoZXlr+kw9VO1rVuyhJbhKkhzsccUDc7krRwO+uAXXGiwm 8HCN2rF27Fw5HrCiljlX3o3AoLqwzYvgKklysEflXmu3FLYHKbZ9sVkDNjTbb/tiTpbmDPStWen1 HA3wfzaj3DXd7xcUcMdAemzkYAmuu/TZ+qIWnKt1C8zsoSW4SpIc7NFEA6OlsGjJev78eb1P7pr7 XId+VwfXFr2uyFvtPHcK9B0DPnsFVNExwLGAdQvMbFAouEqSAHsa0YDtrWWgXdnvuuF+V+dcd9wx QJ0CvYM16KJTwA9vsY4BwNXc64sXL1rt/ipJigiO1b32+ehcNGBFLYsGEAkkcE4iAYsJOBoIctf0 cMdFrSEayJFAvzIrr9DqH8sOdocdYA2ql5eXPVixkODDhw+CqyTJwR4lZPvzKBrgliweQ1jod93S XlqYMzC6PEfHABe1EBPAufp2LHO4BNchGrBvY3D99ddftfurJAmwRwXWMBrgKVk8gtAvhWXI5px1 m/PXvpiVc9fRbrCcu7qOgT4OwCotHA2uyF3tFnUMJLjKuUqSAHuU0cDwOKIBZK+2WisfJy1ZlsFm uG5pviucKw/OZrhOVmpZzysDNc8YaPx0rKioJbhKknTsEUGxawDu1cAZdQ1QNLB18119v2uXV2zZ ZXzrIwFqyxrAGg3NtszVdwxU004BwVWSBNhHd69LM145GughS64V+2ptg00Lh/mu/I0xfpDhylOy yMHyMtjRAJeVHQOCqyQJsMcXDfAgFzvaDdGA2/pli35XHp6df87ZflfcclvWzueuSfbNdpy78gAX FLUW2rEEV0kSYI87GkDXgEUD7F55w0K3WWG4r1aOCAyoLfpdOXe1o89dDaylZbALHQOCqyQJsI/u XifRgPHPjrZai7sGXDSw5a22M2wnIwgBO0QDuTXLIDpyrUu56y2KWpIkCbCP7l4rP4bw5cuX4YzX IBrwW74gHhiNIEQ04Ie4GGR97mqTsSwa4NzVF7UIriwVtSRJgD0K91rsefWzBnhBQR6kveUFBRwP 2HshGoB7tZYsRAPIXHnmgC9uYYgL566+qFVNh7cIrpIkHU1EMNznnleDIvpd3ayBMzhY9LpyQSuK BuBeM1x5FOEwzIUh64e4+Nx1oagluEqS9GiAnV2xxYUtZK9uiMvWr9ZyW25v8X48zAULCvxS2Cga MGeLeODPP/80oLYcDazIXQVXSRJgj8K9brJ7HRW2fM+rL2yVugZyNDDactuoaoydiwZy58AumjNw dXW1b+4qSZIAexTuNSxs+Z5XbF6Y3es2r9Tyg1wwJasCXINooEXXgIPsDtOxuN/Vhrhg3gCigUq5 qyRJRwbY2basucIW9bwOW77k1qzbRANNqWsA0QC3ZK3sdxVcJUk6qohgWFSwVNjyPa/cmoXFBFE0 kIGHeKBFNOD7Xn004FuyjOsUDVSVcldJko4IsMW2LNsddk1hCw7WjSEcZg1wNEDuddTzasoZbDMX Ddi3QUuWMTtoyaoEV0mSjjEiGO6jsMXulVZsTdxrHj24xXl2rrhtgsLWMIqQZg1wYWu3JhpY0ZIl SZL0KIDdqy3Lr9iK3GvQ8zra+qX6XtgabbtNswaGmACDXAyy1pJl36YQDaglS5Kko44IJu7Vt2XZ ud38FjC8O0HOXXkpbKmwxbNeEQfAtQKuo9Va1jVQWK1VKRqQJOmYALvoXg2yUVsWO1ga5jJqx0L2 ytGADXKpvhe2uOd1UtjCvIEoGli5WkuSJOloIoLQvUbzBlw0MNqdoPo+33Uz+Wa0/Qv3vCIaMLBy YUvRgCRJpwjYVZsYsnu9uLioo6WwgKzrGCit2PKFrVHmyj2vfuNCew90DXz8+FHRgCRJJxMRjNyr gdFuwaKCsLBFPa/c+wrXOlqx5Qpbw6otOFgeQxjNGiis1pIkSToKwO7lXoNFBVixhbasYcYrbb9d XLFVzRS2ouWwhVkDlaIBSZJOISKYda/IYb17pbx1cK342sC9TlZsRYUt7nlF9moOtjBrQNGAJElH Bdi9OweQva5wr/37pOMIrrRiq+UVWxwL3LGwJUmSdFQONnSv3DmQ99tC50B/P2+xXfMqLXQMUOfA KBqovhe2dnCwecXWBLJ7FLYUDUiSdJSA3UTncK+vX7/uj8+ePevhCdAiIuCilt+hwO0QOxlFaGBF /yt1DAwrtvYobAmukiQdFWBn573yzIHsVjcXFxcbyleHG1xs5FoBwWgDQ4wkhGvlpbDfvn1DHNDO DNFWNCBJ0slEBCO48g0xAUCaC10eqpucvQ6RAHpeDa5VLmzlW8MTs+Z2h+XC1sePH+dmuwq2kiQd LWDDeODnn3/u4clQ5S4Bv3Ghe6+hc4BdKy8sQOYKB8ujCH1hq9LuBJIkHTlgwx0L3r17V5mDJQc6 igmq8bCWHqwJeiOg5m4BAI8d62ifrdyWtVtqy9pjxZYkSdLROdghM/327duGwcq3nL/2t/Pz88Gp +l5XQM/ASLHAAFS4WA/WubasmRVbigYkSTqdiMDgasc3b970xxwPVAWYbrxrRYcA3GsW71LQ+O4B bsvixQRwrzMrtiRJkk4CsBvEA+xOZ1zq4FTtBFlrHkPYQxVg5Q0M3YaGyF7hXlu/x1bgXn00INhK knTcgLX8dUkXFxeTxxIbuyhnpby14YUEfB+xgC9srZw3ILhKknR0gN3c9gu/ffs2LHlFxkr3h7mu cKY0IWuIBmgrmMa7Vywq2GPegCRJ0p119pjfPMN0uJlrNQja0UCYJ2D14DPKWpxArx+igvSaazO9 6Hm1o7lWc6+2/Yu9ztyrQXXFvAFBVpKk0wdsdq8jN0mTsHolWFYGxRse30S3KHhxO5aBNS8yGEYR WhRg7tVasfZYVCBJknR0EUGo9+/fjxyrAc6OX79+ZfdqrrXlI2/zYhEA3+wxc63p/JpdK3YpQDzg C1taVCBJ0qk62N5lht8kQc0u++38999/r168eNH5eACOtKJhLuZeO9tC9uysxXuh+JUebl2va78c NrnWJj1nMwcMrhYLDM5ViwokSXpqEcEAXrhXHJPD7C/f0+V8D0Jzr+Y4DawWuSIayD20/B69wzUG 283cqrnW9LUNcle8V94httOiAkmSniJgBxebHGYPyAS9LrlYq1vZqIHejRokq5ueWXttD7ybutbN Ci+8T3oPuN0WcwbsaHBNzzW8/bZFAwbuFW1ZkiRJ967tPb9fOIvgf//7X/XLL79gelZ/TM61PyYo GkD7WQUZrP3iAoOrQRGrtgzCLhYwICNz3aXnGK49VM3FIndN369Ln0OLCiRJOnkHy3lsf44cFvGA tU0lF9tDNm9eaANZ+mggwbCfqpVe3w+CSff7N0qX//37UUdAHy+Y+2XnahGBRQMGWbs9e/asVVuW JEmn7mC9ix2yU3Ox//znPzHYpV8mm8DXv87AmiFq8O2LW+ZiLZ/NDrbLeQJWZ5mb7ftb0ZJl59m5 InftY4F0v/vtt9/UliVJ0pNxsBHIRi42T7WqXr161T+Z3GfvXhN0DbL9TFiLDfysAnO/BlIUyeBm 8x5bLeBqztUAbVlvpbYsSZKeiINl91pFLtZcqrlY0/PnzwHO/mjO1SCcQYuuA4AUUUCfy+Z5A8P2 LzkuGOBqQP/w4YM6BiRJenIO1uewN9/wplUKO8Ga4+wjgTdv3vQwzRFCazNk7RxjDb98+TKML7TC FcYOGljharGYAHB1uat3rYKsJEkH1ebA7x3lsRtsgJgcZ41tZGzhlgHV5sXafXQbTN4099Faqxcc LhYSoB2rMGtAu8RKkvSkAFstQRabIQK03MqF4dyQQdRWgvFihZznDgO0aaVW1PMquEqS9CQAG8F1 Atq3b9/2j3vQ9hSccbCICgisax2r4CpJ0pMD7CxwGbR2BGQjAbAOrNXKOECAlSTpSQA2gmsE2Iqi g4pBGylnrNXKGEBwlSTpyQN2jasdvcZvN8OjD28BVMFVkqQnB9g5yJYAW/q6udVY3crXSZIkPYi2 D/z9NnsCfo0DFVglSRJg7wDaJVgKrJIk/bARwW2+/2ZPyAqskiQJsAf4HAKrJEkC7D1+JkFVkiRJ kiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJ kiRJkiRJkiRJkiRJkiRJkiRJMv1fgAEAyTWh5+wkpMsAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 2179 1323)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 344,
    height: 251,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVgAAAD7CAYAAAAvk4y0AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAL3dJREFUeNrsnUtz21YWhEGQiuPI jyS/wIvZ+f//jFl6MVWulBezTia2HD9EgnMPdPu6cXguAEqkRErdVRqQFC1Lzvhzo8/jNo0kSZIk SZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIk SZIkSZIknbEW+iOQJOlMmbUVYCVJku6PSdvH9MNIkiSdMn+2j/0HlCRJWhz4ffsCdXvKP7QkSdKh uLI4EpO2M6C6PaU/CEmSpGPAdHHLrzcXsFOw3Z7CH44kSdJdgTrntcHzt2/fzmLTu3fvamDd3hK8 AqwkSScB1LkudFF7nEDaP/j27dvg16zX61lsWq1WBZDv37/fViC7HYHvUSErwEqSdBeg3hqmgCjD tOu68niz2VS/l+VyWaDYtu0WsLWPBFpAk4G6nelwBVhJkk4CqDW4TsIUIAVE8Xy73S48aH///ffy G/z5558DqC4Wiy2eG3TtWgHtg0BWgJUkAfUg7nQOTCOQ2uPffvutvM9fvQBXu/79998FtBmyXQDa OZAVYCVJOipU5wC1v3qgzoXpr7/+umCAArB4n/81phcvXvTXq6urxrtWewy4fvz40a6dB+3PP//c PXv2bPvu3bt7h+xK/9+TJLnUMaBG7jQ5xwJJvs33zvT169cDmNrX8SC1j19++WXh4wE8T7+m/0Yu Li4GcP3nn38KYA2ol5eXdl18+vSpy79fl35N9/Xr19a+rPu5t/lnVBeBJEm3+rt8MKDateZO/W0+ O9MIps+fP2/9axmm/TU5zoGDZaXvq0QC6aMDXA225l7tsV1Xq1WXHG3/3CALJxvEBUd1sQKsJD3N 2/7B9V//+tckUCN3WrvN984Ur6VrC5DaR7p1XzjINvj8zg+W3av9NgZRg61dDbSA65cvX8rjBNaN h+x///vfLkO0a8a7DARYSRJUZ7vUsCh1F6BOwTR/tB6mHrL2OAFwLmC319fXxb3aNQF08/37dwPo BnD9+vXrJoLsTz/91H348KELXOxROgqUwUrS+UN179t+n6HOAWqC2MCJGlAZpvZ5+73sc86Z9pBN YFwkwNl7dgCbQb9It/aLDFP/MxpYmwxUALZLv66zr59+3ca+fnq8yf9IFChn9T8nfp8ApEfJY+Vg JenxQHXWbX8tQ605VAMmHGp0q28wxXsATHtuMPUu1h4TSHfyV3zvAK0pg7V3mXCtBtYcDWzyc3Os 6/Rec7H2eJP+QdkYeO3j6upqs4eLlYOVJEE1dqkAarpNDm/793WogGd2iOZCE8PaAtn8eovbfHts n7fvI7tLM6T9+xc3lrKHvF3T59r8M/SmFZCFAzWhHcvAl75miQXsal8nySBqP+PWOg3sPen3wgc6 Cux72joXux35b7E91n9USZJOA6qTt/7sUrkX1QMVbvXly5dtlKH6W37AE7f7gCy7U34PHCiAyc41 P+9By8/ZucKxcg7LkDN4IhaAg83udWNKj9fpsrbX0ufW5mbtw7tYy2TNxVJHQdccMYeVg5Wk04dq 9dYfLnXubX9yqS3BtX3+/Hl5HDnUBLD+9QSllt1peg2OtX+ewdgGzrQ41Py51npVIXtvdrcFrvb5 DNUGsUB2seZYOzjY9Fr/HpvWStdlvpqLbdOfTf+9p6/Z8UQY/izyP0ZHX1kowErSmUDV3/pHt/32 8erVq53bfs5RzfABlvY1g1t+gyfA2b/XgGXQ5Ft9e43cZ7n9Z9AmELb59p9h2gKk9GtKYSs9RzRQ AGvgNFjmtqyNATlD2Qi6RCGLXTF+XhtU4CLexH8ntWlJ0mOHaq2NaixLBTjHclQDpitKtXzLTwWp Fi6UIgAAteWCFb3Or5UowK4Jpg1HB/TzFted34NIoBS2mh/FLUsD+mhgcxO+9tFA+v7W+XqNqMDi AUQF6R+ZdfoHY51+xs2nT582KHRdXl52796965ojDhzIwUrSCUL18+fPo1DlLNVcKrlSm4Rq+bbf 56hwqHCiZhb5lh+v56/ZMjjJnbb5Vr641zwyu8hALW42Q7ph8AK4gGsucJU/HKwjRPZqRjV/rd61 WkdAvvUfDDnc8r/Z0aICAVaSDg/WWdNTd4Rqy6OnBjQA1G7dR3LU8h64VEQBdMvf1oCac02+1S8w pdt97qtdIFMFSDMUx+6gt/nXGkib3ClQwAxYH+i/3VFzWAFWku4ZqvY/yFRvA1Xc+sO1mvtkoBoM 82s9IDNU+7w13/YXeCJbdU609UC1z8ExtjfhaHGrDFNA0MG05jAXEewQxUYwzI520LuKEVq+4j3U 4tX89ddfVhArXywfN3NUCbCSdPwIYHahygDpilQ7UMWtv0HVHtuHfV1zqABqhmdxo9ltshtFUaoF qHNBqhSl4FB7cpM75WJS/nyBKdypg+kct8mQLOBE1wBGY/l1g6f1vOZr/9zGaC1esD0FdrUlMMh2 eRPXfblZAVaS7uZWR3PVudV/OFWDmmWqgCrnqQZbZKkZsi1DFQ3/+ba/jW77cetvULVfl2/fWw9U dqgMVI4DGspQ9/hHaDsCVjzve6syTAtgc79rX9zKr+F5WfjSB7PZwfKuWF7S3YOPzvK673+RJUm6 QwTgm//n3P7DmfKtP273zanycxSoAEx2qfQaqvstV/vRNkWN/sW9siv1QHWv1/4M5rjCCKgNOVO4 1ALYDM0CVYA2DxasedAgj8uW7gHrl7Uhg8+fP/dX6yTIo7LRkIFGZSXpBNxqdDWwhs3/U5mqFamy 41xkl4pKfpinIjcFVPEcrtXf9vsclToAOA4IHSo16c+B6WyHitcIqDeNrD+cZ4feVwIrNmaV6S17 nN6Da9lDkE826PLJBuifvZeDDuVgJenuEcAgV53qU8WtOrtTvv0HVCOXiivf5sONepfKrzXUh4rb fnatEw51sScjtmNAxXMGqvtcyVYpGuhdJsDqQIuxWHaz/ZisXb17BWitBzbYCXu0pdtysJLAegu3 +ubNm51cNd/ml8zyxYsXLfep+kKVsQCZas5Tl5SnFsjCmdqvo0JUS9X+4nZzL2qbwVmy1Kilao5D 5Uig4gCrQPXuFO8DPPF5OFcDHkZisdQln1iwoTHZHpYGVnOs9jlAFnA1qFrRy95nJxvQsTLbnL1u a0670SSXJB30//cHcatwptYBgMe4WgQAqNrX4uo/u1Ub+fT5qnepNz32BZ4Dt0oulTPXwRrAxq0F 3AOoO7f3Y0CtuFOfr5bnGaiD7NWeYy0hVhPymkKDa/qHqH+MNYUGV1u2bVcDrJ3PZY9HTjQ46pEx crCS3OoMt5qzVdtN2k51AOQlKiVXRZ9qrfpvxsuoae/Pj9mlLqk41VZy1LbmUl1L1SRQZ7hUVPkH EOX8tKEuAO9Om5te1o5/jX0OS7ThXAFBc5zYnmXKt/o9WC2fNXjaaQbY/2rvA1zNveb8tZwue5/u VQ5WElhjt1oKVt6t8kgqIoDo9h/V/1quikw1LyrxbnU5I2NdsEt1znXHfVuvqv+DoXn/vYHqH3Nb Fb3esWtlx5rd6eD9fAyMPxbGilQGVTy2DwOrPTeg8llccK6cuxqoK0u2BVhJOmIMELrVsSEAjgDG ilXRLT9V/yOILmdAdbStCj8LpqmiP5gMy9pt/yRQUeGvAdXf5sO1+tcMiA0t0ebX7D0ZqAWw9hhQ 5UMOcbKsvXZ1ddXR6bJbwDUvdonAejS4CrCS3GolW40KVhmaJQKI3KrPVIM+1R2I2gt3hSplraGc W50D1W4CqB3f7gfZ6c5riADca+VxgucAsHxyLL/29evXDo/z7X8PVoDWrnxUd/pHb1uBayPAStKR YgB0AgCslo2OudUaVNmtAqQJqkvfYhXEAcs7QHXUpQZudceNBi61G7nlnwLq4HVypx1DFJ8zmLpY YEsOld1yD00beWWo4vWPHz9uGazsWu0jn1rwIHAVYCXFAEEnwJhbrUUA7FYD5zqIAxqq/u8DVd5K Vf0DuanWD+ARQZUKScWhBrf2HR/V0sTV/dHs1N3qF8DaY3OnEWQNkgAqv0ZRwPbvv/8evG5XuxGw KS0CazMzbxVgJWkPsFZ3AtRiAOsEmOlWd6DKt/j2GoP1AaBau/Xv2KXSbf/AeWK5SjPcA1AFqr3O jhXuNLrVjyALQDJQ8RovZxmDql3Jsc6B6r1NdAmw0mMF6043gG+xMkj6ToDIraJVKoN16SKAZXTL HzxfRHsBjgDVrtZzGsGToUrw7Nyt/WygsjtlyDI8UZhiWOL7B0zt43//+18BLMOWoWqvVRzrHKBu 7/P/sJL0aMAaxQC+xSrDs3QC1NwqAMtuFU6VctWoA6BMYTXDxv/2EFANVvvt3PpHWSqvAGTYMoAz KMstPwOUq/tRdsrutHar72Fqu1rxGsPWHgOogCmuuXjV3NKpaheBJLDOAOtovjoVA9ixTSMxQM2t Ln0EALcaQbVxKwD3KVTtA1VcM1T51r/j4pRzqTsO1fefRg4VQGXIAqj+9n/sVj+CKd4LkAKqBNR9 YPogYBVgpXMDa7Vw5fPVWjdAFAMkqC6DolUBaZCzjkUCVbe6L1TtWhs9BSwreepgSQoDteZSPVTz +GkIVO9Qo9t9dqeAae1W38OUr4FDvQtItw/9f2RJOmWwThauANZaN0D6Cztwq7j1N4fqOgGWI251 WYkAWjf7394DVKOl1OFrkXMNbvu7qP/U3/JHDnXKne4B05orvS1Et6fyf2hJOnWwDgpXtjvVt1kZ KF++fLlAvspu1SBZiQFKnho51gSFsuUqP2eoLjJoPVSj5v8F/6U/JFS9U2WIjrlUD1V+vi9Qa+70 SDA9WagKsNJZgnWscIWOAN5ghXzVugHMrY6BlYpUPVgNquxWfRGrCbZXNbtz/7VD/UqVn0DbHRGq XeRSfY5aa+ifC9QD3ervC9OTBKsAK50tWKPC1US+WroBfAzguwGycy1gzaDlwwT98upy8N/I36f+ L35tcipo8p8N1c3NmdYDiLIz9QtS4FJrOSpPRO0D1D3c6aFgepJAFWClswdrrXBljrWSr5ZugCAG KI61uVkFuMy3/MvArbYBVMf+HoVLU6LJqWZY/a9BdeNf81AdcaoDl1q77bctVLUMdQKod3GnjwKm Aqx09mDlwpVvs7ITAeBYubUq6AaIYoBqH2vjVgHmY6D3dqs0UTU40O+QUPVOFVDdx6WOZah3rOyf 7a2+ACudC1gZpnuD1ReuEAMEjnWJ7oAMzwFwueXKxwBRtprBWn4GFK94QxVtrPKN/aUf1Tf/8zlT B4DqoEDFq/xqLnVqQsqubkpqX6A+GZgKsNIpgHUA1duA1WDKhStzrgAsgXXpYRrEADwgsBMDZMdb vu/KcSrbilsdzVAb6lOlA/1GM9UpqPLtP9/622b/sTn+Gbf9hwLq9in/RZCk+wJrk8HaHgKsDFXn Upe+fzXYvVqLAcLRVW6t8m4VOWrgVrvIrQKsVu3H47tCFVes8RtbjjJy2y+gCrDSuYIVAwLoY90T rIOOgMCt+nx1dgzAnQA1t5pjgK6WrQZudXAiqneqGYibQ0IVkUB06z/jtv8uE1Fb/VUQYKXjwzUs YPHkFTZbIUudA9ZaR4Bzq3Py1bbWYhVkq1EM0I25VQMmvRZBtepcbwNVjgSiApWD6iFn9wVUAVY6 VbCij9U6AWaClTsCwu6ASpvVaAxQAWtYtJqo+m+CHHXDIPUZa/rc5lBQjfLUClRve9svoAqw0gPG AaOdAQZXBiv6WH/++eflLcG6nOhfHWy2mhsD7ONWOVelYhVy1o2PAPA4Oh31EFCdscJvH5cqoAqw 0onlrCFYeVcARlq5j9XarVzxajUF1qBwtbPgei5Yo6IVr/3Drb9vpyKQbtwt/6ZSvNpEzf84dlpQ FWAlwTUCa9NUOgM8WHnyivtYuSsgaTUHrHCuQb7azugGqBWtBi1WlqPOdat0y7/xUEUEEB05PXaI 35GhKqAKsNKpxwFTnQFwqjzSCqBG7VbpY3ULsM5ts5obA2witxoVrOw5Hnuo+gjAwMrN/zhymg/1 E1QFWElgnd0ZgJw1t1ntANXlrasArH0/6xywRntXa2CtFK12wJrhOdutRlDlCKDW/G9HTt8RqgKq ACudeRwwq4BlTrWSs4ZOlToBVrdxrDWwTuSrgxgALVbkXje1TgAqXoVu9evXrwWwHAHUclVBVYCV 5Fp715rg0fqclTsDAFYDKq8NhDsFZK2YxTlrvq4qYF02QavVHcC6ybEA56kFnkHf6mYftwqwjkUA d2ipElQFWOnMXetoHDCVs1Yc6wCyeOyHBY7hWA2gQb7qM9SwM4DAOtut+qUqdvtfOW5aUBVgpaca B0RnX83NWaOWK8QCiANcKxZPYXmwtrWzrSpg7UYKVxuGKkPWg3WqEyByq1EXANyqG1MVVAVYSXFA HAeM5axwp0EUsHK7A5Y0ILA8NFipfzVyqxvXu1rcKopY6ffejHUCzHGrHz582FaAeogdAJIAK52r a+U44NWrVwbTAViRs04UsLgzYBWBlY+/rkQBi8ada+VOCRisA+QcNeetNbdaIGswdTHAptYJcAC3 KqgKsNJTc608LDAWB9RyVnOrkWvllqvKaQKDAYHbgpVBymAl4O7EAOxWEQPY48it+k6AmW5VEYAA K8m1DocFRuKAZTAosHIRwKrSftVDtRnuCrgTWP0gwBhY2b1yvmrONYoB2K2OdQLIrUoCrMA6gGp+ 3qKnNRoWmIoDvGNFBOAhS50By4cGa5Svpp9hE8UAvm/VHOuB3KqgKsBKj8y1To64eteK7gADa3o+ KFw5iE7mrFzAoqUsO2AFXHkvQEPFK99O5bsCgox1p4gV5av22McA+bVDuVVBVYCVHrlrHUxisWud KmKZVR2LAwKwDo7F5vOvxsCKgwKjrgB2qDPAusmFqw6P0WYFx8otVjjOOooB9uwEkFuVBNgn4loH gOXWK14lyMuvoyIWO9UgDigdA/m1MGfF2sCJOICPtd6MdAWsZ4AVLnUTFa7sc58+fdpyL+tEDCC3 KgmwAuuOazUNsla0Xr148WLJy68rRawBXGmktUDWrnfMWRmsZfKq1m6VXl/fBay+zYq7AfaMAeRW JQH2qbtWZK3sWi8vL/sBAY4EoqyVxltXlThgNTNnbYIooBwaSLsCNuRgN0Hxal0DK1qtfMbKYK21 WVXGV+cUrQRVSYB9xP/tqoUs9LX6rDU9X9Zcq2Wt6Gl1RaxV1B3gx1ybkZzVrQ4Mj2AZAWvvXOeA lboCdjoCfOFqohtAblUSYOVa667VdwgYUGuuNQDqyg0LrMaOxQ5y1obA2gSdAf72v2Ssvt0qfRvr uWCd0xGwR74qsEoC7BOG60Fcq2u9WgVFrNUe3QFRHOA7A3aiAMpV10Ef63ouWLEfYEZHwF22WUmS APtIwTpwrId2rVy8QtuVvd7Ep7dWXWutgOX3AiBXJciuowEBuFeBVRJgpXtzrb79yve17utac1fA yh/dkl1qWX4dFbFqOavvDPBAZZjWClncFZB+3s0YWNM/It0eHQGKASQBVnCNXSu3X431tR7AtS4R B/QUCo7BnpGzbriXtVK8WtfACsdq/z7MAOsUUAVWSYAVWGO4TrnWDFxzratKh8BerjWDdTQOmMhZ 11Eva82xWhRQ62NFG9YMsCoGkARYaX4kwIWs2g4BnsbipSyVDoFbZa21flaOA9AR4AtY7Fq9Y7Ul LPaYM9Zau5XAKgmw0kEjAS5kGUixr/XZs2dL3iFgkQCmsRiuHqzBztYyMADXypFAkLNu/XYrc6oG UW67cgWstW+5ylNYg4x1Rh9rJ7BKAqx0lEjAt1/5rNW51qigNela/Tc8Iw5Y13JWFwesueWK1wba 4z0GBARWSYCVDhsJ+EIWZ63BDoHa8MCOa83dAaWQhQJWM9EdMOZUybGu57Zc4fHMdiuBVRJgpbtF AragJShklSiAs9YMWS5o7UxjzXSte8cBuAKoEVhrLVfREpaZfawCqyTA6s8+fD47EqgVsihjHYsG xlyrh+vWDQzsEwesowks5KzsWH3LlcAqCbDSoVxrFa5RJGAfVsziQlat/Yqy1jHXWvpa6Xva6WkF UJvhsMB63zgAYLVr1HKFfayuM0BglQRY6daRQP/47du3i8+fPw/yVh8JuImsyK0WuCJrpR2ugx0C e7jWsZ2s67lxwFTOukfLlcAqCbDSLLiGe1vHIgE3kTWAbLpe+Dasu7pWtz5wjcy10na1rsUBdp3I WadarjR5JQmw0v5w9XkrThsAXNPrK44EUMAitxpNZhW43tK1Imut5qtTcUDUzzojZ1XLlSTASnv9 Ge/A1SKBb9++VfNWGhxYzYwEBoUsXi/YjHcI7ONa1zSRtTM04OOAqJ91Rs4qsEoCrLS3a20YrnPy VvS21roELBLwi1rye8opAxXX2uSVgdvo1NZgT8AAqOZYeVhgKg7gftb0s3UqYEkCrHToSKDJkUC7 T96KSMDlrGFBq7agJXCtZWBgpmsdwBXFrDndAXvGAQKrJMBKe8O1WszivDVBdeVbsBisI5HAao+h AUQCG16CTVnrwLU6oHIRaz02LDARByhnlQRY6bBw5WKWATXobw3zVnatCYYXACqvGGwqC1ow6sqR AE9j5Var0LUyXH3WykWs2rDASBwgsEoCrHR3uEbFLIsEEqSW2IJlXQL5uOyVGxhg13oxEQnsrBWM Thgg5xq1XBXX6luv0re2jopYNufw8ePHnWEBxQGSgCAdHa6+mAW4+mKWRQJ5n0B/BVyD3NVHAku/ oMXBtRspZK1zNDAF2YFrrRWxgmEBxQGSACvd+c+wCtfaspbkXFcMV9ffeuEdLI+8uhNed04ayEtZ BpFAcGTLOoDsmrPWOa61MiygOEB6slrqj+CgrnUUrpS3LnOnwCo511UeHujhmkB1kV2q5as/4WqA tczVrunrArL91f475nhg0ClgcDWrml7vPFwpa12nt67Te67T8+v0+12n164TJK8NsvY5g6tBNgHU zsXapPf2j61DIH3PBtrOHGt6zZzr9o8//lAcIElysEeJBApgozasqFMg97gOIgCOBigi8Ptb0SXQ BudjdZS38u6AwSpBLmTheS5orblDYMq1qoglSQLsseFa7XF9/fp1yVt5MmukmOWLWn6HazUSaChv rbnWSsZaslZEAmNZ6x6tVwKrJMBKd4Zr2IZlkQDlrYN9AhmuF4GDvQhWDg5asFDMYrhS3jrY1erb rmqQReaKaSzA9ZauVWCVBAvpMHAda8OKOgVoMuuC26+cex0coZ0jgcUIXAfONShgXY8VsiwScHHA Zg/XqjhAkgTYh4Gr34SVrhe8R4D6W3Fd0qrBNu8VuE3e2hexapEARl0BVwwNWCFLrlWSBNizgKt3 rj5vpcmsnWNd0N96y7z1mgpY137slQtZ1iVguwM+f/68mdnXKtcqSRWpTesAcOU2LHQKYGFL7nEt cOU2rOxcf8qO9QJXasHyZ2bNgWvJV8215rarNdqv7PNmng2yNyY62Whqv7Ks1dqvOBKw9qvLy8vu P//5j1yrJMnB3j9ceYCAt2HBuY60YV2MnJs1NTxQy1uLYwVcfSQQdQn4QtbMaSzBVZIE2OM7V141 6Htcg/arUshCNOAms5YzilkbgutO3mqOtdIlMIgEJgpZU8e3CKySJMAePxZwAwQ7Kwb5Cqim64qu yFv7OCCAa1/MMqg2eZ+A24DFeeu1HxzgLgHubb26utpMFLLkWiXpFlIGe0e42gDB8oZgfd5qoHRw RdZaMlZ+jIjAwXXQ45pd6yBvtbwUcOUowF3XGHdN8BzkrXY1oMK5IhKwUVcVsiRJgD0JuPJ0FnYK pPf2LViJsQWueYeAh2vJXR1cd/JWOFccPsijrgxV2yHAcEVBK+8PwMIWA2kfC/AeARWyJEkRwcnC NWrD4h7X27Rh1YpZyFu5iMUtWD5vRdYa5a2KBCRJgD0buJp75WIWHUiI7HUwQDCjU2Dj4eons1DQ GstbZw4OyLVKkgB7enDFTgFAlaa0LsbasKY6BQBWigUGULUrbcAK4Zr7WzfB4IC6BCTpSFIGW1k1 eFe4Zqj+xE6Wuwaamx2uy6hTwAAbwNVyVOxtxRDBICKYyltHBgcUCUiSHOzDwZVOIZgL14u8JLsH KmeurpiF33tLBa1wvSC7Vx4egIPNp7yufd6a44F9IwHBVZLuqJXgOng+2C1g+1zdES+z4IqOAYMr drnmeKDNJ8C27vefA1eOA6rFrPQPQt+Khf5WiwYmprLkWiXpSGoF1133Gi1usetcuOaOgRX1uPKU 1my45omsa0A1Pf/ujnTpr+l7uc6RwBrFLB4ecHlrJ7hK0v3oKWawY3BtsSw7Wtxi0MxnZ13kVqyL Clx3BgjcmVljsQAWtaxd1nrtBgh6qOazstY8PADnWulvVd4qSYoI7t+5jsEV468GWW7FqsDVb8Na Ut66AMhqcHU7BXrHml/zBxH2cQA6BayYxW1Ylrcm17199+6d8lZJEmAfFK79GVo2jUr7XFvairUE WO3PzRe0mh+Z68rFAm0QC6BbYC5cr+FasWIQnQLmXA2s5lg/ffpkj9XfKkkC7OnBFR0DU8uyM1xX 3OfqMtflCFy3t4ArL8leo1PAfr0510reKrhK0gPrqRW5wnYshqsdUEi9riuCa1mS7bLX1Qy4Lgho 4RABWrBqcEUxy+CaOwXWI3BVMUuSBNh7h+oOXP0gAU5/xQGFdoYWudVVPpRwMKHlprN8t8CCAQe4 0iYsXi+4A1d0DOS8dbRTwIpZNJm1JcgKrpL0AHrsXQQ+GhgdJOC1g74dyxyqXaMjXvJ5Wpy5LgO4 lligBtfcijU44gU9rgZX3ikQdQqomCVJp6XHnMEuxkA7MUjQO1eDLO9zRSTgjngppxAEmeuWY4GR BdnFrQKqHq7p++07BninwJ6dAgKrJCkiOBpcq+1YtUECPpEA+wS4HYtPIqgVtGpw9UMEPhbwcEUb luAqSYoITgWwYcfAnEECc65c2PInEdDJr6u8W4BjgQLXfFZW5+GK5S0erlTQwukD6zv2uAqukiQH ez9w9b2uKGphkMA7VxS2qJg1iAeam+O0d2IBc60GVy5oObgaUL9HcI2cq+AqSQLsycLVt2P5Xlc7 ARZg5VggX9HrekFbsVra5xoOEYzBtdaK5QtaI3BVG5YknbgeU5Gruh3LPnzHALdjWURAHQM9YLNb HfS6BsdqV1cOTsHVFrfMgSums9Dj+vr16+7f//63dgpIkhzsg8B1B7RW1Io6BnhKy09m8SkEiAfo aO1yzAtDjXcLHAquPEBQgetWcJUkAfa+I4JqxwDasTBIAOdKkcAq97bubMXCwuxmeIbW6MrB28QC e8C1EVwl6TT1GLoIbtMx0LtRasfCGVoA6k+5U6A/V8uuORpYTRytzYcTXvPKQb+4BUdsC66SJAd7 DtHAAK72wR0DnLuae02vDwpbLh5YcTxQOeqlClcMEdScqx9/FVwlSYA9ddAOPt68eTMoal1eXlY7 BriY5dqxuKgVdQuUglZ62s2JBWrjr4KrJAmwpxwNlNd9Uevly5et9fpjgQsVtXqwjrRj7RS1AFl/ tDbigCnnCrjykdqCqyQJsKcM19lFLdcx4LdjwcHutGONwdXtdb2e41x5iEBwlSQB9tTgGsYDnLvy GKzbjuU7Bjh3XQKy5lzTexZTcHWnvpbl2XR+1roGVxsiEFwlSYA9RdCO5q6+qDWywAU7BZa829UX tQyuBrf063EqQQ9XiwT4SG3XinU9Nf4quEqSAHuK0UB5Hbkr4Gq569gYLIpb6HllB5v/XEK4WiXL wMrRgOWv5Fx7sAKutYIWj78KrpIkwJ4aXEdPg/WnEpiDTSBbAqgcE7iOAewYGLRiEVw7d7z24CQC e80iAZydla+loGX7XP1uAcFVkh6nzmUXwezc1YpaBlrjmgGTFmf7zViD3NWfp9UMJ7WsB2tLcN3k NYQ9ZJG5cjEr/ZIC2doxL1jcIrhKkhzsqbnYu+Suq6Co1Y4VtZqb8606d0hhf81FrHLyK47XNgjb 6a9jcKWtWIKrJAmwJxENNE2l33Uid71Av+vcolbQjmUALdNa0bHaBlfkrvYtGFRH9rk2gqskCbAn FQ3U+l2D3HUVFLJmF7XQMeAOKyznaSFzxdXgmhx171rhXmce8yK4SpIA+2Cgreauuc+1B6vfkMW5 K09n+TFYK2qNdQy4nlfkreupE2AZrtYtMHISgeAqSQLsg0UDjY8GqGtgdr+rG4Gt7XblohbcK+KB 3rnCtXI84EdgzTwDrtbrOvNobcFVkgTYe4dsGA1gz8Dz58/tuY3CYlPWzsQWHVRYWrJqY7DGWO9a 2bny0doZrhtux/IjsIKrJAmwpwbWpployUJEgGiAwRrlrrxnIP/8iyB3DYta7FwxRICiFrdjodeV R2AFV0kSYE86GphqyTIHy61YUe6KaMB+dj6w0A8TuOXZxcHStFaBK4pavh3LvrzB9f379zqgUJIE 2JOEbYkG5rRkGUQr/a4+Glj4/a48TBAVtXipS9QxELVjJbjKuUqSAHty7nUyGrDcNWrJ4pgg97cu o9y1/KbJvZplbYa5605RK+8YKNuxANeoY8DBtRFcJUmAPatooNaSFewZGPS7Nm4MFu7S4Er562Ba i8GKohZvx/r06VPn27HkXCVJgD3raACdAwZXXubi9roOlri4M7U69LvalY/b9pEAL2+xx9wxMLMd S3CVJAH2wd1rGA0Y/zgawOkEvILQtWQtM2xbLHExyLpooPS7InvliS2e1ErqW7HQ7+q3Y6GoNdEx ILhKkgD78JCtDRRQS1a/gtAXt/qlAsP9AkuCdoFrbYkLj74iEvDDBCNFramOAUmSBNh7B+tONDA2 UDAVDXA80LiWLECP9wzk/HXgWoPcdT2zqKXcVZKkBwdstbAVRQM4uBBdA4BrFA2MtWRxNOAOLOyH Cujx2g0TFLj6opbrGGgEV0mSTi0i2ClsGWSjaCAD1Y/ELoPVgzu5qzlXRAM5cx1Alve9InflYYJo x0CjzViSJJ0QYGcVtqznFdFAdrLod126kdgwGsgLtPn3GSxx4ZYsD9mp3FVFLUmSziki2ClsWc8r 9g1Q18DSdQ2UxdnNj7yVo4FFBmsUDXDnwACs5myt3xW5a3recTQwI3cVXCVJgH0wsA6cq334whZ6 XrFrAAWtDNclnKzLXX3XQA86RAPUjjUAa5S72nsMrvZbff78GfsG5uaukiQJsA8O2f75mzdvxnpe e5hmoC7z8pZyIiwPFNjXoq4BLHNBrysfAbNG5wDtd93JXbNj3czIXVXUkiTpQQE7uopwrLBFPa+D pdm0a4ALW5y51qIBHiTYjLVkzcxdBVdJkk4vIvDulQtb9uF6XgFUXkOIPQNc2Go4Gmioa8BNa22o oLXJo7A7LVnGcRcNKHeVJOlkABu51yaa2LKrfcC9soOlwtZyRs9rF3UNUDSwQTTgVxBGLVkfPnzo Rhyr4CpJ0mlFBGjLMjDah5/YQlsW8lcUtrgdC9lrs7uGsNo1wPkrugYA1y9fvnRRS1Yz3u8qSZL0 IIDdy73yxBb3vCJzpVNhy35Xf0IBdrw2wUABQXYyGlBLliRJZxkRMFzNuVbasti98hLtFpD101rN jx2vcK8dHCsPFERdAz4aCFqyBFdJkk4GsFX3aou0EQ+Ye0V7VnKvLY3Coi1rmSe2SqGrocIWZ69z dw2Yq+WugZnRgKAqSdLJRQRhW5bvew3c605bVkMbsvwiF9c10CEa8Nuy7HVaoL1vNNAItJIkPTRg F9FrNffqhwr2actCNEBdAx3A6sdhqTVL0YAkSWcfEfBHU3OvBs5K9loy15p75WjAnVBQYgEA1+8a uEU0ILhKkvSggL2VezWQeveKHJYKWnCv/na9nFCAtiya1AJYS2ELuwb2GCiQJEk6yYjgTu61cjpB GYnNkUBpz6Ke1w0tcSlg5V0DGiiQJOmcADva93ob90qHFqLvleFajt6uLNHeZLgOel4tGrA1hDMG CgRXSZJONiIY9L1iYovdqz337tWdSsCLXAbLXJrcMZA3ZQ16XnkcNup5vbq66sGqaECSpHMAbOhe G3dawcuXL3sXy32vBtAEOd6K1b+Wj4BZ+EUuaMvK0UDJXZG5UlsWlrzsFLbMwcK9fvjwYatoQJKk c3CwAxZiYxbvHOCPi4uL1rtXA2vzY9fAYN+AxQI4GRYOFt0DXNjC9qyxwhZ6Xhvtd5Uk6QwAu4ge Y9/rq1ev+muCWokH7IMjARcPcObK0Os/gmUuk4UtiwYqPa/KXCVJOknAzipu8d5XiwcAUo4HOBbw /a4N7RrIha3iXucWtjgacIUtRQOSJJ1NRDCA6+vXr0tMQB/Fydr7qZC1cEWthsA6mNjywwQOsrct bAmukiSdNGAH8QA+fvnllwLQdJteQJpzVzxeeDeZM9etO19rsG9gamJrj8KWJEnSSQB2EcUEb9++ 7YcL8AKcLBW8SusVX30swGsIu5sRrRCuDFbOXwFXP7HVqLAlSdKZOdhyW//t27cFg5U/nj17VqCc YFeAmh7D9fZgze1YXdbGDxT4dixkr1zYQnHLvpY5VzexpcKWJEnnGxGYfvvtt/56eXnZMGi9C06A HDjW5qYNa7DIBUtc7HRYbsdCi1ZU2OK2LBW2JEk6plb38HsU98rXoCuAAbf1ccDNqTA/4IfCFg0W 4PiXzY3x7Q8w7N2rwRRtWbZzwLVlNYoGJEk6SwfL+SugWoNret+WroMhAuoUKK7VPtA5YFecDMuF LXOtt2jLkiRJOikHuzjA10AEALCaQ+2jgqTM2B95rD+4EAUtu5p7Tb9m8+3bN3Owm+xe1ZYlSdKj igh2SZwhaR8JgD3wktvsq/oGzjyF1bdo2ebB7c1KrR7g+TiYbXAMjEUD6xwNrBENkGtVW5YkSY8r Inj37l2Tb8cbVO/t8T///LMl2PoClj+RoI8A6CTYawMpnwwLF8tTW7VF2o3asiRJegyABbQA1r/+ +gvdAcXJJrfZw9VcLK8aBFRdGxZgep3fc00RwRo9rxYN8CLtoC1L7lWSpLOJCAxSozmsQQ4u1q7J YfanB8Cx5jYrRAGNHQeTR2HRU9tnqPZaYmmXj9xG3yt3Ddhzg+smL9LeBm1Z6n2VJOlsADv+G93k rD1k8w6A3H3VdlbAstt6G5fNBaoeeLaOEGO0+DrpfT1gDawZtD1gLXdNn+shy9HAzLYsSZKkg2t5 4K8Xjsr++eefza+//lrGY798+bJIzrV/nqBoAO3fR9NbVuxqDIxN39W17fCBpdkm6xJA10B6zHDt oWouFrlr+v226fvQUIEkSWfvYDku2GZ4bq2/FfGAQRBTXHkdofWtNgZCA7+9J/fPFgdr7rW56SAo nQHfv3/v3Sw7V4sILBowyGKRttqyJEk6dwfrXWzZR5Dc4+L333/HeGxjLjaBr39fBqt9rs9ezZwm MJZWLnavee2gPe+HDuy5AdXyXIZrLnD1X+ePP/5QW5YkSY/GwUZu1lxrAxebAVhGZxMge7gm6KKI 1cLhZhDb0pgeuHbbDxdrU1q5oNUxXHH8ttqyJEl6rA6WrwMXiyz2+fPnvXO1iS2TuVdb9GJRARws Vmhh3NVgam1YNpSANiwDagTX9+/fa1uWJEmPxsEWx9q4HBYuNqnDm6+urvqdAy9fvkQc0Pdlff/+ vXeveSl3LxtOAHQNnhm4Wx4kcHDVtixJkh5MiyN/3SiPXeB8rgRRawfA+Vz9KbM4DHFk4XaZCDOw 5sigHP9SgWvkXgVYSZLOErB7Q9afcmDndvVWN2e0mASzK6bBkOXmTLZ3tYKrJElPCbAM1yaCLA5E BGh7Amb36gHLDnYCrE1Tz10FWEmSzhqwNRfr3WzDoGWoGnD9FzSoArgOrM1Mxyq4SpL0qAA7B7Y9 aO0K0PJBiSZs5cLjyuir4CpJ0pMAbA2yo8C1UxBMOCwRevbsWQ9IW4F4C6AKrpIkPTrARr/PYiZ8 a5qCqKa2JEl6MoAdg2zt+1jMgOvUc4FVkqQnAdg5oJ3zfW1vAV1JkqQnAdip33vO97Td83VJkqQn BdhDfg8CqyRJAuyBvx+BVZIkAfYA359gKkmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmS JEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEnSmev/AgwAbH8p9cwPrH8A AAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 2179 1339)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 226,
    height: 237,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOIAAADtCAYAAACiRqkCAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJT5JREFUeNrsnd2PG8cRxGf35Mix 5BhxAgeBXxTAb/r//xS/GUHe8hAgsSVZH3HIzdbc1Li2ObPcO51P/KgGNktSdyTP4Y/VXd0zm5LD 4XA4HA6Hw+FwOBwOh8PhcDgcDofD4XA4HA6Hw+FwOBwOh8PhcDgcDofD4XA4HA6Hw+FwOByO4zGc 6Xua/H+dwyCe1nswlA6D+Bu/9nAH4AykwyB+5Gve931MBtJhED/utYaPfC/THe87HFcPYg+64YFA nAyk45xjfGQIhwaEQ+MYebx8+XKU+8OR4yGU1uG4OEUcVlRwaMH53Xff5Rv/+9//Fu/tyZMnVdl+ +OGHKaidnrcqpcNxFSAeg3AB4IsXLwYFcL/fL97bOI6TQoljBjLCN3XgNIiOqwdxNRUFgICP4O12 uyFCGGG8ubmZcLsDpGF0GMStEM4paAbwv//970j4pmmqaojbf/zjH+sT/uc//0nDMGQAeW4A2YPR IDquHsTF7ZcvXw4fPnwY3r9/PwK4X375ZQR0hO+rr77Kt1uqCOhw/PTTTwrjnkB+/vnn+6dPn07f f//9FnV0OE4mnjyCGi6UMEI4q2EG8csvv+Rjg4JZn0DU8NmzZ/n269ev9wXa/WeffbbH80JQG+9p Kq9vCB1Xo4jdtgTS0QjhH/7wh3FOUfHYWKDKYH7xxRcH7+3t27dUwn1Rx/2cku5fvXoFVcwwUhkb aapTVMfJxs1vCPZBb3CGDnXhGCGcj5v5fj5miGaWxny7wFmPGbp8zHVlVkse8+9AadN8G+lrNny+ +eab9O9//3t6RHPK4Tip1LQJJPqDsxoOgKQFIQAEbPg3quL8GOAaoIJ4ohm2rIi/+93voHz7+f6O 6evz58/Tmzdv8gtCGUsbZGikqMlpquNaFLGrhgCvqNsNbs+wzVnlDQC8maHCvz2ZQcJjuI3HRp6z VM4/C8jmQD9xmKFMs0KihkxzOgvYcz2J+0UVYypqVXRcjSIu4KQaIiVFHQhjhnUhFLCkoTcAEGcq 4nx/Ac38OzBiplIL4vl282MJykkAEXhOOKlFFafUXk5lVXRcpCK2eoZ5PpRpKKGDGuL8+9//Hqr4 hBDOjz2BKj6B1A0DFTKf8VzzYwBsYNqJ2/Pv5NpwfixDNavihBS21ItTRxUdjqupETOQxSkd2LQv KWp2R5GaIuUkhAC0KGJ+HDzWJ5zVblZAAJYdUigiIJx/BhAm9A/nFHUqNWZub0CBy4xqbF9YDR0n FeNjvRD7gjgDFpgzhBDgCYRPctE4jlDKJ/PPfsZjfhj/lh/Hz5bbNaWdFTbD/fz5c5o+GXp8GcQv CNeLjmuqEescKadm2LAvUNIhHRVCqmJRRMKCmg8mDAjclTZFHgCfz9lJnZ8bvzeV59wTfHFQrYKO 61PEly9fHjzGZj0NmZKCMhXFYzeMonw8oiLydq058RxQWqghVLGor6qi1dBx0Yq4+qFmfcij9P7Q etC+IVXxZla9DBi+KGDIkGH87Pxvu/kxPGeu/aCAqB855gZnVZv9jZnV+nyuFx1XVyPGOlFhAQxF DamK422ZONbe4nxe1I5URqayM4QVaNSKgBZtkkZ66nBcN4ianhJA9AoBDw+2K/RACJCA8aaYNawl a9OfKksANT0tqbJhdFwsiEdTu6+//npxH014poYEk+YMhC+oYj5TIeXQlHYszusoJhANoQwfVn5I OmqFdFyvImImNCrjrIoEksqYhwHkfgWPMFIly3ksipkBxHPBECozrcOG9NRAOq4LRA5mRxA4vA1z hnOlmrJGIOX+yPSUj/fSU//f7bh6EMuYWTeoikGl8jGWYMoqqjiWkbhq1NC00fRUFdFtDMfVK6Lu xBbjl19+iQDm1BXU8TGAVt5zSy1HAhnTUwwSNFoZrhEd1wUi95TJn/7bJUoT1xaWtYaL/UfRJ2yk rmNRR01dqYqjpqYxPS0rPap76jrRcVUgYhMn3RiYMIoyTlRDBRKja6wXpX7kmQpZJ3Nk3eIiPdVe paanbmM4LhnE7q7a3PRJIeR9/Cwh1Mdaz0MYixou2hyyYkMBzM19zrnySUIbw1A6LlIRuxs0EUhs AkXwsLRJYcToGoGkMkbzRmpGVcghpqdPnz49GK1rtDFs3DguvkacsE4Q6Skg/PHHH2tdyN3YsJoi KGI9GvXjQhVTmUUNkzn5iO5pbGM4PXVclVkz14nVsKkkHRo2GUYucxITRw2fJCZOVUQCyDQ1tjDi kisqotNTx1WBCEWjYcOdulUVBbyFOpbVFRVK3C9KWFPTAl9tbagq6v2yQ9ywMmXj9NRxUSAeNWwI 4/v37/cKITeGIpCEkMudDl7o18HxhRqyTqQCoo2hrmljysbgOS5WEReGDepE/gOvW6F1YqkVK4Ql RY27cyvUw7H0tPQS404ArSkbp6eO60hNUSfSsGmYNXnTJwCI+6qKxUHdB/NmUSf20lOdstGV+ytr FK2SjosGsdaJchk17sQGCPdSHwI+TU0JJuvEhXnTS095myv+mZ623FOD57hUEGOdOMU6kekp+4lM T9FTjGpYANzH56IKHktP1UHlXjnqnjZ2eDOUjotSxAWQuDpTTE+1PmR6qoekqdMd09ObOH8616l1 i0WvUXRca2qqKeUU2xhITwXKmp7ydlq2Mbamp3X+NDb3y47j+apUAqJTVcfFgdhqYywU8dWrV7GN Qce0pYr3Sk91UyndWCoOguPaHCE9NZCOi1LEZhuDFxmVtsVUakSFcKfKuDE9XaxV1E2ldGlUa99T 14eOa0lNaxtD01MC+UDp6RC32ChqyC39u0ujbNo4rsGsSfdMT3d3SE8XAHLLxVZP8Y77nhpIx0Uo 4mJCplzbfmt6ut+anpb1iRVKgqkXPJUrT9UWRse08aSN42JT06qSR9JTXGBmJxDuWC+mvFn4Pqan dRBc1PCgp6jpKa8cFcfeXrx44Ukbx0WbNd309PXr13nKhukpoQR5sa/IiZvUnkFtpaj1Yqet7RY3 mjaG0HExiniQnvaa+5qeBmWEGi7aGlBHPidNm6KOdYdwdU+DKo5URfYW3cpwXEtqulDJ2NyHMjZm T3OqWpQwAyjbaUxaIx4xbW7UtImTNlZFxzWYNZvS03fv3tX0FBcjnaGo6ekcu06KmiKQ3EYD8Ilp U1WxXGF4oYZHWhkG0nExirjYj6aVnjJFBYRIT0uqutN6EUCqaVPS04Vpk351UUdeNUpqxXxRU17Y lK0MAumxN8e1pKYLVWR6+ubNm6yKOD58+NDrKe7uatpQGfUybtrKmJ8/qyNMm5V1igbScTFmTVRG mDYpGjZYGkXTBqlpo51RTRtENG3CTuBHWxlRFTutDEPouChFPAASqohLbnOhcElN4ZzuWqYNVDEt Fw1rrTi0VFGvqSgQ1npRVVHTU7lgjVXRcbGp6Z1Mm6iKspJ/iqrIJr20MqoSMj3dooquFR2PFTeP /HoHH2pcru3rr7/OrQN8+NFsL1f/zVcQhjohZugyKDjjAGA46xWjEMW0yTDiLvZgvGUzX7EmnwEt vgBwxjG/Zt4RAJtWzUDmRcolzZ2++eYbXFJu6vwtDsfZKmIzPe2ZNqwRi3MaR98Wxo2oYrysW23w t1QRDirH3jgMvtFBNYyOs1TEnioO5RqGGR5sg4iduNGAh8lCVRxviawKeevZLFRxpCoWNdysinOt mBWRwwJl/5zpiCo6HGddI25WRR0El1px12ln7HUY/C6q2FoitbIywys0HGeviKn1gf7xxx+zKiID Lao4QhWhiDgAg6oia0QABNkrrYqqhh+jip9//nk+UxXxZH/605/wHuOXiCF0nLUiLtQwNVoZUEW4 pvNjO7Yy1lQxtRv8PVW86dWK8xdAbmeoKjZmUO2kOi4GxFhzLVoZ7CeylcGxt8ai4Z02+Mt50eBP vy4U5lQNIXyCY775ZH6uJzqDOqti7S9yOPxIk98wOs4uNe2ZNotWxgxDPsO0Qa2GFfgt06akoTk9 1ft8jZKaptLWSLdtxdsUlfOqoZ0xaTtjTpFTgZrGjT85jotLTZumDQSLDf4ZhJyOQhVDg78OhK+p YkgnDyZtQor6hEPhXK/Y2dvG7QzHRShiVxVLK+NAFUsrY00Vx2LORFVMQRWR+mIJhxo3SU0cGjfz 6yXuRH5EFQ2h46xBjEAOSE8J4lwjDk+fPmV6mqdtiou6mLhBhL7iUKCsz3trnKYKXFnVXyEEgAio MlJT3MderHBPv/jii5qi4nlevXp17G9yOM4GxAMI8T9sZUiDf5wVKW1UxV6tWFVRodSaEUCutTPw HvAc+Pkj7QzD6DhLEOOHd6GK79+/v4sqji1VZD+x3J5uuxn5SlSplZpSFWHcMEW1ceO4ZBCjmfIx qpjNmJYq/pqh3qqhqGPu9cdakYoIGHFQFWcYE1JV/k5RRaeojosB8eCxlirOcAwzkFUVYZqirVEu PKozqHXapqGKsZ1RDZzQzkg942bjxI1hdJwViJtUEQ5qGAbPELZS1FAjjlRFGXlbGDeSomYTZ4tx U3YWSEdSVMPoODsQu6oIcFqqGGdQOysz1EHVNYvVsKESEki6qtG4mV8fqWkijGUSKK2kqA7HWYHY U8Wc/um0DVQRS6WoiIBPVZEQcryNAOLxYtKocXOQokbjhkDqxA1+lcaNU1THJYJ4EH/+85+5KqOq YklRqYoUxYEQdtYrNkffwuoMmjWJY3ClZswwAsSoikdSVMPoODsQVRXrfXy4VRWpiEhROYNaDJux KGFuYwBMAsj0tKGKB8YNFbGkrXX6Bmsd59dM2lucYUxOUR2XCuIBkFBFgAKQinGTWCd2asUhTt3I esVV46akoimaOK3eolNUx6WC2FVFGDdFpQ7aGVTFAuRQttFnujq22hli3CwmbaiEsWaMvUWnqI5r ALGpikhPuYqftSJgLDu+DaqIBLLRztAmf0xRc63YgLDCqClqhJE1Jt6rWxqOcwexpYpQmaGnihx9 g3FDJ1VS1CGMvo3FpGmlqIOuWyxtjQpjI0XNICK4QqPQfaxeNIyOswFRgew1+VOrnQHVpFnTMW5G TVFVFZmiEsIyFJ5UFeGiQhm10V/eS/79MIvqfW4cZwtiUxVTp8mv7YwC4ahAinEzEMyWcdPpLaZG ippio5+zqLpcyvWi41JAbKniQZMfZ6aoQRW569sgfcahN3GjvcVWitqqHVkvzqqcWi2Nb7/9Nv3r X/8yjI6zBbH7QdV2BlSR7QwaN2xntBSRakgQC2zdFJVn9hjVUUWrQ80btjQA47t37/Lv4nc6MDpd dZwdiJvbGTRuJEVlI1+d1C0p6sD6EGdt9HMRcYHwoKWB39F6Ec8ZUtQpeUtGxxmB2EpRqypy9K1n 3HDihjBKb3FTiorbpdE/SG2YOH/Kc2xpHKkXe+aNYTSIZ6eKtZ2xZtxIg/9AEddS1BQa/VTEsmYx RdOG0zi9erF8WaQNG08ZRoN43sYN7gNEnEuKmu6bonbqxWHNtGnViwgqI1PUTrPfMBrEs4Jx6Bk3 AA4feKSm2FbjnilqiimqtjQKyFNjMDxDyP4igWyZNxucVIdBPG/jpqzOSFtS1LBucdHo1xSVrQz8 fKgXB60TmZ4KkE3zhmaP2xqOcwVxk3GzNUUlhFTFkqKmmKLykHoxceKG9aKmqlTFnnkjvcn017/+ 1W0Nx9mDuDBuYIQwRaVx00lRqyISOkLIepEuqsKo22tIT1HXMOZMVVzVhXmDLwQdg+PgQIDRbQ2D eLYwDgXGRW8xpqgFijiLWs0a1oZMS0NLIwmMfA1Vx9Yo3KJW7Dmp0mN0W8MgXoYyxhQV6SDAiY3+ MgZX1ZHbMbIWFCgXabDUi3FV/yDbMdZmf0xTo5PqtobjIkFspKgpNvoBBxcRS6o6lhR10DaHQqm1 qcJH84ZQxqVTeD0sl2o5qXh/bms4bs78/W9JUVOYRU1cRBzqRaaeFT5JUbXRn1bMmySTN4v0tOek xraGYTSIF5ei4oPNRj9WaGiKCiDVtGm1NHSfm9DSqNDqYuKVyZtFisp6sQfjhh6jYTSIZ5Oi1kY/ DlzerTWLyvQ0pqOafra21wjmDZVxYAsjOKmLPmNJVbMywtWNMG7oMRpGg3he9WKcRdXlUlAobWmU NJKmS916kYA2XFSFkQMFmqrqladSbGtAEQkjasZnz56lt2/fGkaDeDEwHsyilnoxLyLGbW7FyJZG q78oKsmxt1RSVH2dhTLG/VH1vpg4izRVa0bDaBAvUhVZL7KlgZZBbGmEejErWVGuQTafStzzRurF Bfg6q9qCUhUxDohrzWgYDeLFpqhsafTqxWKm9PqLC0iDKlYYdSaV6areJ1jaY0Rbo2XgGEaDeGkw LloavXoR6SnA4NQNgCR4cZUG60ddpaGv1UpPG45qig3/Fozz+5zo/hpGg3iOIB58MI/Vi1yl0eov tpr9nXoxaZqqSnofGOmmGkaDeBX1Ij/8skqj2+w/Yt7U16aTGo2b0gZZDIe30tRy+Te8x+Hnn38e nKYaxIuvF/Hh1yVTAsmwYt4MK+ZN6jT8q5FDsFQZASN3EOd1PVwzGsRLgnFYqxfDkqkk5k3S/iIg KKaMTt6kFRgXDX9RxmEFxqEo4/AABo6BNIgnVS+mXr2IQJraMm+02U/wNjipBwPiIU0d7gDjqpu6 MptqdTSI51MvllJvYd6UNDXFZj/ruTUnlWCtwDhIrXgMxqOtjc6g+OBU1SCeU73YNG8Q2uzvOKkL 84XnlbbGAsZw2XDWmx8LY/NaIYbRIJ5iirrFvBn0g1+c1MVUTNjrZuGoxv1RGzASoDiJcwBj+QKo MNJQws/DTeWgOL4k8Hd09sAxjAbxZGHsmjesF/WDr2NwXFqlA+FMWamGvZpRt2dswNhKUwfWjGUd Zf6CwFQQ+4yzMg667YZhNIhnWy/CgWTK2XFSF2NwHAzXulGgSveEsVUzDq00NS6hwkp/w2gQzx5G fGgVRgQ+4Phg99JUTVVLmpqCabMVxlgzKoxDL01lqwW/h3Ra98C5wxSOgTSIpwejOqlI+QijrmHU toZM4CTZYiM1eoxrMFYDR1sbXIisaaqkqzVNxXvDE8JoQo1b1LrXa7SjahDPwrxZOKll86mDtobO iEp6qs16nb5JG/uMcZY1KYxxbhWvr3UsQpWRMIb2xuBU1SCeC4wLJzW2NVirsemvMKblIuEFjK3J m9Ru+itwFeCeMjJdpTJyE2PCSEe1tDdcNxrEk4dx4aQeaWuwx6jTN4vVGhFGbVFsUMYUt+rI/4fd 7oEzRCOnnAfdURztDXVUO3unum40iKdbLyLgPNJE4cVt2NbgB76XpoarSN0FRh0UP+hRhkXGWRk5 cKC9Rm1vqKOKNo3rRoN4duYNYGTfkBMt0UntpalrMK4sn6qzqyFNTTJSt0h38TrckU5MnJ6jOrhu NIhnCaO2NTBWpjAeqxl7MDYMnBRhDIuLh7izXKwXQ3tjaDmqrhsN4tmaN1thLCv80wPBqIrY2gNn FUp1VMuaxrzuEoMKnCDacM2NwXWjQTw7GCVNfWgYU2eudWi1NdjbpKNato3MdSNg3FA3OlU1iOcL Y6gZj8GYViZwDs6t3+NcawtG3cWcqaqOxaFujM1/WcHR+m9idTSIpwVjmL7JbQLc3gqjpplhNjVe 7CY1HNW4XUd1WCOU3MU8LDIepN84dPqNW+pnw2gQPy2MnL4hjFiKdBcYmW6WMTaFsQ4CxGts8Nxo /B9cPg6vUy4VpyZOdVSRpjKVbtWNTlUN4tnA+Le//S2ne/eAcSKMVEgOjMddwnuq1Og1pta6SDVx tG5kqqp1o1NVg3iWMP7zn//cBCO2RNSmv26h2NqAWLfqDxtSLV4/9hplvrVCpxDGVFX7jZqqQh35 GvhdqCP299nw5WQYDeLpwqh9Ri5lIoy4UlSAMq7wT2ESJwU3lSnl0Lp6VbyvqarCqKkq1mCWurEO HmCTLaujQTxLGHtuamscrkDZ3KpfYGx+6OmehsZ/NX20btR6sZeqwlUFjCsDAFZHg3g+MG5pbfAK UWCtAWGz1xhMnJajurqfTkhde6lq6g0AIFXtqKOHAAziacAY3dQejNjJG4oYnVRcVZiOqtaOoW5M G7dsHOIkTrhUuS5uHsVVHeIAQDRyNqrjYHU0iJ/MTcWH81jTH4rYS1HFSdWtFmPzP67gaMGYVurG hSpqqqoDAC0jx+poEM8GxtYEDpdQwUWVejE7quFiNLw4zdRzVBt1o37YB3FUFz3G8vgY3VW93zNy 1tRxg7NqIA3iacDIlf6Y86Sjykt2a1tDe40BxqEBo9aNiw+67Cq3qBtXUtWFKhJGHFDFI+q45qx6 Kscgng6M84c813/cdgOMbOk19hzVRt14oDqNzaniZeWyUKawCFmNHO5EQFe1pY7qrBZ1HFL/+htW R4P46WBkvafKyLqRykgTp8DICZyp1IuTqmsY/l5dwdFKVVNjBwBAqeoYrvuxWR2/+uqru5o5g0F0 PAqMuu0Gd4eTrRozjNL4n7jIWFNUnKfbIq+qrKSqE2FojccFANMxCNVNVXXcUjve0cwxkAbxcWHU DakAERr/gDGmqS1HlSZOgRAwTmWWdNJUVRTzoIUgzf9Fqkojh6lqqCFHVcde7ViuulzVsWHmrNWK V18/GsRHhBFBGHUKZ4ujShMHIa2NScCroGrbQ4yc1HNVGzUkIBxFHUetHXFHnNVm33HFzElH6sar VEeD+PgwTrHx33NUWyaOpKo1RZV51Sm6qp01jkNwVasSFnUcG+o49tJWqmNMV1UduWFzJ129+vrR IH5CZdT2BpiIjmqEMbqqZWh80W8MqSoUc2j0HFUd01Z1bKWtuhNATFcxs7ohXXX9aBA/LYza3mA6 qY4qIORYHBSwN4nDlLWRquYaUp3W1qxqdFLX1DGYOiN7kdHMmc/jsXQV7moYBhiuFUiDeAImDj6I uqs4HFWqIz7UK5M4E02coIqLVLXTczzYE+eYOhYuF9M5eKyo4tgwc8YN7mqrftxi6AwG0fGbmTiS UlYTp5WqUiELhBNVUVLVqTUSt2LkbFFHNW5GVUWFsZg5Yytdje4qLyEX6scths5FOawG8cRMHHVU NVXt1I3TSqqq43VTazzuHupIJYw146itDkIa0tWFu4r6kYYOnuMOhk7PYR0MouM3MXFUGbXFIf3G mqqWFJWpanRVpzsYOYvh8aCONR0tEI4tM6eVrvbc1QLkoEAeMXSOKeRgEB0PZuJo3RjnVNlvjOoY WhwHriqVsYzLLYycxjpHVcde33GMgwB8rMA59tzVopBjC0g8P683IobOXWZXzw5Ig3gGdaPWcr1U VRcbUxXVTeWsqlz0dIoAdtTxoHYsitg0c46kq6Omq/PtkfUjYMTvhV0BWg7rRQJpEM+gbmTz/0iq Wl3VqI4rjf+qiCvqmBrqmFgvsmbkvxFCruoISpkncgqQY6t+ZP8Rh/YfLx1Ig3gmyniXVJXqqKoY VJK9ywpkTx17zioVkZM5auaoQiqEHadV09UxGjpxIOBSgTSIZwLjHVPVDOH8gZ4aPccKZEsdU9nI Kqhja+fxg42OC4BjJ12thg6ApJnDiO2OWD9eOpAG8YJS1RnISQcAyrKqqVwzsTb+j6ijAkhnddI9 c3rqyPuddLVCqDWjQqgKyfoxOqx3BPJsJnUM4oWlqoARt8t1LSZ1VamK0nvsqiPBXElXD9RR0tWx ka4eQKiPSepaa0lRyPEYkB2XNZ0LkAbxglJVDo6X2nFq9BxVHRdpq6jjVJxVTVEnncrppatla46x l64CsJKiKoQVzlBLtlLWVSBX2h4nD6RBvIBUNQ6O49wxcrgdx6RtjlA7Vgg5Rx5uT3ydRro6HElX hxKjpKtMYyuEW4CMNaS6rB8BZPpUQBrEC1DHtQEANXKYqmqbg7Vjw1k92J6D8Md0tdV/5MZV7D1K ulrbGlJLVkNnK5CsIVtAvnv3btwI5DEAB4PoWIMxHUtVW0ZOp82xUEKu5uBUjsypxv1x1GFd1JPc zIrX4IjqKPcrjGk5ZL4FyCECiUP7kBuAPJmtHw3iBaaq91DHSVZzTAqh7iBXzJwDILXfSBdWh8up jgHIkWmpmjX3ARJnHZuLQPYmdU7p6sgG8XJgnLYaOaqOBFKHAGSNIx3VZrqqKz2Kck49IDVlJYxJ Zlc5GFAMnZrKtoycCCTbHhHIlRqyrj5pXB25B6NBdHycOmLhbUxXsYVjcFaTOKsLE0fMnEXNWJRy 4nhcUMipAeSg9WNIV0e51uP4MUDGPiT3YNXBcr43vBekrXdcB2kQHXczchBMVVUdW84q1ZFTOS0z J6SrWj/26sWpo5ADL1se3NZVIO9aQ3LHAA6WE0ik6dgJgeqI97ICoxXR8SBGzmZ1xDF/UKdo5jTG 4yYutWJaqinqESDZ9tC9VtNDAClpalVHuWRAojri9eIlA/DfpZGmPooqGsQrVkfCiNvzB3RC7dgz c3rpqhg7KSy90tUdzZS1pIaLS8jxmhxrQLZMnbAHq271mLhrOs6AEak4vnwQyAigjMwS8HvhylaP oo4G8fpgbDqrx8ycRrqqe+REQ2exFnILkGWh8iYgW6YOAJTb8epWCxjxuhFG/N2sGcVNnR7LQTWI V6yO6qzeN11lSP04RUNnBchJ6tYKpLxnBXLsKKS2QLoXYuVu6QojvmgY+JvxXtmKmb+opsf8P8sg Xnf9uFDHlpnz7NmzZro6A7mPY3EKpxo6ALMDZGoBySPJ/jl6Pw4J6ASP7iQglypYXLqA+8PiSwVu MZ6bqsi/vaGKv2mtaBCvVx2nLWYOasdWulrmVScZIO8ZOgulbAA5tYBUKFswhpQ1NRQxXjdksQUl AETgbyqm0YS/lbcfWxUNooFcNXPW0tVYP+5vY2HoxHS1AWS6A5AHyhQmdup6Svwbt5PU6SCe+QXC VFtUcQqqON3TqTaIjoczc1ruKg4CWWZXu4bOBiD3HSCn3t458bYMCKT06/U8pnhJO50YwmsVAPN7 L/Dlvy3Uir301Iro+LTuKutHKuQMY/5Qq6FDdbwPkD1jp5FSVxAJcIGSQ+lJdrCrZyo23hveAlUR r4EUHDDiPeH49ttvp0Zf0SA6HtXMqe7qq1evDupH1lUAkUAGQ+dOQBYV28vuAFNrtwDCRmOJgFIJ 8wc71Kh43gL1XsDMbw73CSJ+jrUiU+KV9NQgOh5XHVk/EkitHxGAkIaO1o8EsrQ89mtAEpAAZNy+ Y6F85b1NhImP8WeL0vK59gXMfXntCmIxoPaln1oVET9nEB0n5662DB0qE9LVCCTWPtJhvSeQC6e1 DJhPv2at02ITZXgzRekyhARQgFycSxsGgO4BIlV+I4gPVi8+8WfPEUErH7DW7Ro//PBD3uHtu+++ w8QKPrwjr8n45s2bDNLz58/zhxpTL3PqusfqenzYZzjzeY7dDOTNfPsGLMzPk8+3XGTpwjHK/bEs Is5NfaywKHXgIGlqBp1AUuXwpaATPZLSnkRYER33SVcnqR8nKORf/vKXuhyKhk50WJmy3kMha30n KrmXi7PuS024ZzqKCTg8TiDnM4ZQd/N72POMx+f3l3/2nopoEB2nCaQaOg8BJEAilPP9fUlJ9wqg pqTzsaMSlsd2u9tJ8Azg/Gu72zHVPBeX01Oc379/nyHEa8zp9b4YNwbRcZ5AqqFzHyCjy1oMFbYc qjLSzCmgHhyADoAVlQOcyIUzpPPr7ubf383A7fhzrBNfv36dTaj59fOXAtLZFRAng+g4G4f1Y4As UJLBvaSl9QCMULICVQWQ6SiOAmG+XR7fUx0/fPiwY3oKNcSZqenf//73R6klDaLjpIDEUACBLCNo e1HJXyWyQIjHIpgAjHUi0tICXIYNaohzST93rA1nkHcwmfBvgBoKjC8EGfyeHlIB1/5jOhwPBWT3 8tovXrzIK+e5TT7Kt3Kl4PH58+dj2fowu6MzlHBQ8zrDGQo4rdU5nQHMj3OLfzqnizd2C/y+pKP7 AucOBg1SU9yGGuI2QPz5558zmPNr7fAF8I9//GMqhs/UgdGpqeOkgUwfoZCJOwVwIIAqSWmkSsa6 cIZzJ+lpdkahhqwZS11ICLMKImUFfDOE1awRNZyO/T1WRMdFKyQU7ssvv8zbYpTV91k151pypEry MWwGxcXCLVWEApZBbqrioi4EwPOXA2/vV9QwNc4G0XG5QJZzhW2GMp/1sbm2HAqUdddu3C6X/64g pts51AxjaVNk6FgPEkK6pfPv78vAwtRJS6ff8j+Ww3GSQLJuxJl1pD6GY05n83PJVhs5mPq+ffs2 n9n2wHkGcBIoM4RIS2c13B8B0CA6rgLIhNE5AEkocVlvuThp3jJfVVMhDCNvWofmHiEAVCgBYKkP p2fPnu2///77FoC/GYQG0XHKQOZzBFJVUqFUEFUVdcnWTz/9VGHkGb1CnJGOwhTqQJgMouMagVyo o6atuBOhVBWMqanCqApJAKGCOBo14aNBaBAdpwrkprRVoeQv8fJrMTiQTigDgGljPWgQHQaydQaU BHLLi5RB8tQAMH0qCA2i4xyBXEtl08uXL7tPPNd/Pbi2gGcQHVcP5BqUa5/jYQWgHmiPCqBBdFwC kB/7OV6DbvqUf6TDcS5APtRn+JMooEF0XDKUd01PPzmABtFxjVCeHIAG0XGtcE7+z+NwOBwOh8Ph cDgcDofD4XA4HA6Hw+FwOBwOh8PhcDgcDofD4XA4HA6Hw+FwOBwOh8PhcDgcDse5xv8FGABSYSuG 1NGA7gAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 1273 1696)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 254,
    height: 206,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP4AAADOCAYAAAAe7L/8AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJA9JREFUeNrsnUtz21YShUGCiuL3 xOtZZDE7L/P/f0IWs/BiqqZS2U9VYsdxMh4RwNxz3X1z0Lx4kCIl2TpdxQIBUhJl68Pp1+3bNDKZ TCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWQymUwmk8mibfRP IJOdlZ1B4MtkEsUHeUMQ+DLBffc2CHyZ7OH9vd+V2g8CXya727/tzR1xMay4Ngh8mez8f8ubC18/ BurhIdwABL7ssYC+5tro/M2bN6PzT58+zfJyfX2dwX379m0EuQb7vd4ABL7sa4D9WKhHzxPgVbD3 +/2m9nzOdrvdwEfcDOxGMEyAP9wH/AJf9iXCvnRtNeQONIPd93153nVd9XrNtttthrVt28HP+Ubw 73//myGvPV/yBAS+7NHDvhr0KcgdZIfbz4dhGJ2/fv16Efpff/212Ww2BXg85xuB3wToBjB1E5jz AgS+TLDXjhH0GuQ1wPH8u+++K++LR3/v5Icn6PF4//59gd+PMzeAtR6AwJc9CtiXnhdFr6l5hJyf v3r1qrzPwa+9z4/Pnj2bhP+PP/4YHH6GHY8EeO83gQR+7zeAb775pp+A/05UX+DLvgTYR8d//OMf VUWvge6Qs4LjWgQcj6dPn1avLym+Q+7Q40Zgz3vzAHq/AQB+e9wr/AJfdl/Ar4a9puprQI+Q+3OH PAJucOfj9fX1Ivzu3uOYPt9AN4Aex//+97+9we+w5xvAb7/9NgV/vxD7n812+nuU3RPsk4rOyg7I k1IeqPoc6P/73/9GoAPy9HVbBvzm5qY8B+QRfrxOsG8SoAfgp/dkOM2lL8/Tz8+wA2oc002h4xvQ y5cvmwR//pXSe7cE/CaAvqHrwyX/Y2Sy+1L3Eew1Fz7Cnt6zrSn6kydPtlHh02PrkKfXtqzu/vzq 6mpTud74+URCryh9uhH0rvgJ+A7Qp2sdztONofvzzz/zEdc/fvzYuReQfm7/7bff9hMu/0VUX4ov uxTwq9XdYcdJco83NdgBa1LKci29j6HfJthZzfNrSXG3EXwoeQKtCj4+A96XXgfUI/hxXvl9M/Dp 6xz2Ar3dlLoEOn4mzpv0GZsEP2r6zYsXL4bff/8d78+/E/URDDP/tsOl7swy2SXUvXYE8CVBtwQ7 ntNr2+C+T4LukPu5H/HzASWO+H6k6ht6fVbtE9ANxfT5kX6XnhQfwEPZ94Af53D70zluCB1UH8eK 6veXTvJJ8WV3BfyBK//HH39U3fikhluH3eL1DGsCY+vgQ7kBur8GoPE9ATqumZJuXcUN8q2Jd/45 UGW/ARjc/nqO572xJ4EZW3mbULZj4DP0/rW4eaTnA7wIeAbpd8iJwGQ9bmofPnzAZx1I9Yfwb6ly nuxBu/Px+Qj677//fpSRd3c8wm7AbRl2httV3a5tWdFduRNs26jwOBLk0dXPrxng5bNzjF9z8XEE 1FBoV/lM/GbT2fM9HbPqQ/3TzWwfVT/9Xh1l+PuJOP9sNwIpvuxcwE/G7nhAuVnd3U1//vz51jLx BWiGHapMyg6lx3lWZ1N5qHkGdwsJNuVnlTeF37LKE+T+einv+Wuu/JWEXmPA5xo9oE/nPb4+neP7 ICmJr82Gz4ffN31u5APy74fMP7733/72tybF+rmjEJ/be/svbQJfdk7gR7G7J+pq6u7g4zWO2c09 P4DdlB3Q+nlReUuksTufYfafkUDO53wDMMjzDQDnDj9+EerLP/CIATKOAB6n/jsBeNwo0jmadFrc GPBz/XewRx/KhqVzML33Tv9TBb7sNsAfuPO12L2m7paJ35pKb0zJt5bEA9wtw+7KTqq+NaCLojPo rOYG8paUvCTwuF2XYvm5hh137zem+Bn4dK35/G0z4APBvrEkI/4dmqT2qP83aAFO/w739p8r8GVn A97deVPuSXV3V74Ce1Z2U+02wo7vY1Dnh31fvwFUQff4fQJyV/vGno9+Z3ttiGqPLLypfU9JQbyc cwj4N8AR7r4DX/MgePXfhw8f4v/BIPBlDw74GL+zOw+Ip9Q9uvIGd8sxO1zlCuytw+6KDrU3d38W 9AnIa6pec+0LhPa1g98Q6PuttRHMvmz3l19+wQ2iOXcCT+DLzg484ndT8AN33tXbu+jS+9s5Vx6v eyY+vdYGZY/n/jO37NLPgF6DfBb2CqwjBeYefQ4BvJkHQOOIXny09abzxo/p362563he4MvOCrzD zgqP1wC7J+rMfW+jurMrn4BpXemh4qbsbXTrLRnncf+GbgAHoJ8IeU1xS+nOnyPGR0TRWBkPGX0+ 94e//7Oj0/MinryCDzV+X78v8GX3Bf3JwOPcgYfBvb++vs7wMvCs7gA/qn2AvY2wU/3er82BPsqU 43fgeH0OdFbzGvDcrWfQ59p9+mydXfM6fq7to4cfeQGU8Lw/328A7969y00+8A5WlPLUuSe7CPAF /GOBt+etu/PuykfAWd0/h7nb9jMn29ZzAO7Gr4S9Crq9XlzzAP0wAzmrfOOwW0BfOvVc5a2s1xv0 GXj06OOIa6b23NXXQ+0BOnsA/sFoLp8UX3ZRt/6gDo8s/VrgOX6HYjPwuA6lR9wOqB1+iuNbitu3 diMo5wuwZ9A5OeegO8yUTa+BXoXczz2Dz+vr8Tpq8e6+A3hXdVd4QI/uPO/Rx9FUv/N1+X78/fff fVDHwIM5m3rH3sX+IGSPN44fleW86aYGvGfoAbG1zLaWsGsdclPs0XNT73yEujeWxcc1z+BbnF66 8PxzzcE++mUPYY+gD/S+oRa/T9wIej6a2vsNoWOX39t2fYEO7nfo5/F2XSzSQYsuHh8+fMjLdLFA B+26P//8c1ygc7H5e1J8xfEAfhvLcg75lMIDeCg8JexaU/SWFZ1id1b3UeLO++W5HDcFO6t6Bfgq 7BH04fPdp6dMfMPuvB8t6VZAt+u9uellYY5dA+j4nlnZXekdente3P3ffvstz+MLaj/cRXwvxX/k br3H8UjGeeMNl+UAck3hLWnX2kq4ltXeoG5JzafUfeTK+7l/Rm+lnfwlA+xzoFu2Pb7WB4V3mIcw YINvECP195uHLcwpcTygx3MCPkOfwidX+zJ+i9R+Suk1iEN2FpWfTNy5wnsZ7ttvv209aRcV3pJ0 OyvBtdR401J2vrVYvSi8r6DbWq9rjNtxea2yT5XZKBHnsblfy3BNKTmukZoPnz/GUG4ersr2Gtz7 weN1ZO7xHDkAO+9sxl6evGMDN6vQV2L75pLQS/Efn1u/nYrj0VoLVce5KzzU25N2FVXfWQzfejxv 6t1yLM/qTsm7U+L2Kdh7VnWLt0fnQc37ipIfXPNzNN7EEVt280B5rqzO41l7rvw+bNNd/Ag9bkAz I7cEvuxybr330uPhCg/QE/BtDXg8T9d3AfgCe8WdZ9i3UdnPCHsBPCThRnV3V+xwfQS5X/Ofx0M1 GXyfrusuv0OOch0Dj38OJPJ4tPZ9Qi/wH5Fbj0fNrY9xfA14gF5Tewcez03NHf5tUHcHvjHgN7XE 1QTw/VrYQxfdqMmGzkfq78AS5D0DzrV2HqHNrznscZa+A8+baUDptZOO7KIq79n6ObfeVd6SdRl6 Oxa403H0fA3wFXWf+lvDKrdaSa2n1tgpiEew12bfhdFYB0rvoDfUXsuQB6Ufjdxy2Pka/omQseeb wpHbZ11c7QX+V67yx7r1rOwcw6c/2J2D7vAH4FvqtttQxv5gBRx3yQXge7o2Um1YE/rgCfauAv9Q g5/HXxOwfQ3yGuAR/DPsl7cEu8AX8LMqf1CTZ5XnbP319XXr7n0NeFd0Oo5U3kt0S8BPjayaAX60 0GUG9m5K6W2Ofc8JN4O9r6h5P7X1VQSfgWfQfYdcv16DPZfO1u2Qe2fQC/xHpPKAPcbxeIB4juND 4m5nkDPwBXpeKVcBfhNi95ikY7iHmnI3f/XAF3WPsPN0W4afYY+g+yKZmqseVZwB9+v8HEeA7ucM e7rJDm/fvm1WqPtQy3kIfEFfg/0glufk3cuXL/OqOAae3XpQ7kk8d+uj2pt7z/DHGH67AvimCW2v Uc2jkjvgaH6h93QMu79GoA+8EIZh5+Qbg88q7Y93796tAtz/Uxh0HFfAfm8qL/C/Dtd+VuU5eRez 9ZSVPwA+JvE8gTfRdRdXyJU/XnfnZ4DvzL3vKureMey0HVWZW++qHkF3dx4fFY0zEfaakkfI1wDu kOM4AfoS1PcCvMD/SlSeY3lWeU7eXV1d7SrZ+p2tmtsFZd/FON6Ab82l31YU/mTgTd27MJe+KLr1 vMcYvouwc/08uu7mgvdRzVnJ/fkRgK9x0Y89F/gC/nwqz/G7HytJvF2M47nPvvlrbn1tss0Q4vh+ AnhWdHbnR8CzK2+LXKK6V2GPqj6VZWc192z7kYBf4prAF/TTCTxsFnmMyteSd1Mx/ZRb73X4FYm7 ReB9ySol6jraZ26k9KTm2HOuJOvwUd2NZ9i9WabmusfE20Q8vlaV10zyaR4i8AL/C3Lt37x5s/n4 8WNJ4NUy9nMqH0DfrXXrQ1/9OYEfwU7wF+ABO3rfa678HOwMek3RZ+LxY13xNRAPX8IfneyBu/ZR 5bkuP6XyDnpI3nF8z6W5ltz6qPLNBPCowXcnAF+ec9xui186VvapNtipRhkHfgH0tZAfA+/wJf7x yb4A1/758+dtrMs78BWVZ9CLynNtPq6i4/ba2HEXFd7Ou1OBr6m7r11nV57bYFntZxplarDfxoX/ YgEX+F+Qa5+A3/LCmpjAwwNK73V5rIv3jD279gT/rtKQU03erQB+CHV3ztKPgE+X9zyOipJ3HZXo uqllrDV19+WsJ8B+CujDY/gjlN0v9IuuPcfytnquAF7J2E+qfGVRzYFb7112oTzXcynOJ8tOKPye 58+xS88Kz4MqXM0xhHJO3VfCfizow2P9Q5Q9gHh+zrXnBB5Unnrsdw7/jIvv0Jd18jTjrqj8WuBx DXBPuPT76N6TS38Qv7M770of1d1gd0Bv2/o66A9Sdu/x/FzW3t36WgLP1R1JOlJ5T9qtUnmHPs6R b6j5BlAb6B1tFuFz5EeQJ9vPAe8Kz+rOdfio7jZ59rawD/ozFPgPMp7nhhyofHTto8qzuidIrkK5 rnTkRZX3OL7yfz9aEkuludHIaFb2CLm58fsl4HGeYveD0pwPqcCHCcCfspJNsAv8Lyuex3DLGvSu 8gH6cuS180sqXwG+5tZ3HMfbzjB7V3veMCLAPwl8jN8r7vzc0lXBLvC/fOg5ngfgc1l7h95j+ZDA 21Vabw9m3kW33qBntz6W5mrZ+T27+gy/J+3wvAb8Qvy+dvzUINgF/kP/9zyAHvH8p0+fMvSs8gmY 1hty0vVdLWsfXPuq0h+p8mUtfG0nGIec4WfQpzaNwPz4GvA8aLISvx+j7oJd4D9olT+APibxavE8 EngUz8+59n7exs0rllR+Ilu/Z5UPcXxJ4gF+mxvfeR0+zo9nl17AC/zH5to35Npv18TzDv1M1r4k 82rxfFOpy4cSXRmAQWW5UnunGnx+zhtA1uL4WId3ha/F8CcCL9gF/teTxOP6fIrjd1Sqq9XkHf6r WKrjTrwVdfmDTjva3rlAH936ShyfjxzH4+Gz4wW8wBf065J4peXW43eGPx2vplx7W0m31H0XZ9b5 /u17jt/Nvd/zTYB2ei1xvAOPowPvbr2AF/iC3qBfk8SrJe/oGBN5BzPwKirfTEy+2bvKO+j83GP6 msrjY9YSdys2i2iaBzBgUibwLwr9XOZ+KYkXoZ/pud9W1stPufZdyNjvJ1R+lNCrufWeuIuZet/8 UcAL/EcL/VLmHko/kcQr0EeVd/ibvybkrHLtYz0+xvIOPCXv9ktu/USmvm/m58YL+Adk2ib7AtDH 9lvO3NuW0zvbYvrKjoDb4/irBCkn9HL2PmTtt7UBGXGHmeDS52N66z59bX4AdoM+q3y61qXPtofK p2MGHt8DLryrPFoLFuJ4xfBS/McJfa1cN5O5v6q5+JV4vvWsfQX6fsq1N5d+T+22e1Z7i+UPVN5j edwAsLWzu/UrN30U8AL/cUJfKdftViTxrk6M52sq3xnwoxjeVZ5j+vSx9jF5h+crt3aOrr2AF/hf P/SxMefVq1cliUfLaRn6Ky7T8TFk8EfxvNfnK679EDvvKup+4+ru8Ht9Pqo8jnDnofIrynP3suGj 7PbW6p/gctAjiQe1Ry4lXbtK8FxZTR7K/o0l8b5Jr+drOLLS4/+HxlwvxvOAG7F7Ot4A9gTuTTrH 0bP4yCZm+HGEIab/9OlTZ/F9zthj8i3gB+zI1qfH8NNPPwl4Kf7jhv6HH37YvH//fhF6ztyDsZCx j8fapJzNmng+1uJDtv6Gy3S4CdRce4/lKyrfy62X4gv6CvQvXrxoOYlnwy9L5t5V3pU9nWe1twy+ q/yO5tyXAZj8WWgiTu6vh0qHBF7O2tsxqz3OTeVvXOVd3a1Gj3n1nVReiq9/kyOh58acmtJT220t c3+g9LWNKBn6WvKOjjecyLOM/YHK1+rynrE/QuUFvMAX9BPQu+LPuvfNuD4/Bf3BJByL5wv0MWvv 8C8l8CY676TycvUfdyLv2bNnq6F32NnNN9iza09JvB2to8/wR9fedqrp4zp5h92Td3502PG6u/be eltL4AH4dM3r8kvddwJeiv94oI/Z+zXQs1sP2IPK74Jrz/G8702XIeSWW2TsQxLP1f4mNuQA+vS5 9tG1T9B3nMCr1OWl8o/A1LJ7Iej9aO237OL7ZpW+ddXGlL4JgA3cjGOZ+1yus2Reht2z9g48knko 0QF6qDugx/EI114Ze7n6jxt6W2W3PRZ6zuC7i89DNOLEnAg871Lj0EPdPZkH2M2Vd/hLbR5Hg7/z nnuAjiQeu/YpdOn/9a9/DXLt9Ycv6GfacL1Onx67JehDXD/qyAPoCeC2Ga/dH2rQm2t/kLH35hxu wbUuPI/n90e69lJ5gS/op6D3Ov2R0Gd3v6LymwBYPwP9DSk9wz8Zz8eGnBWuvYCXq/9owP/ioGc3 H0pv8Xznrbfu2kPp5drLBP4J0KNM3n6WVV9wA+ivToS+lOts3HWzwr33XvsMu8X5Nx7Hu9J7Eg9K n0Avq+pwA4Br/+TJk+Ht27fK2suK7R4p9M1EIi9Pww172I1673G05pydA29DNJagjyvsHPpuDnpf cEMZ/Nh6m5Xegbfna+J5AS/wH21cX+CvzcjD86kFNzxAYwb6nbv3tXX03JG3AP1NLNvhCMhx07A5 eJ1Px1E8LxP4K5J5cRouj8uCYmP/OsBvo7JGHXlhTFY1pq9AzzH9fi30iOs5c2/x/FQST114skcd 4y826ExB75NzcIP0tfQG/TehIy936dlKu1FMfw7ocaR4Piu9Z+5d6X1VXUjiqVQne5SKv6orD942 jcA+GJcFlfc4nhbcZNBDnT7G9GeB3mv0gJ7LdVyjB/iAPiTxpPKyqm0fmas/SuZxK26ce4/BmD4u Cxbm5F1VBmrwJNxRIu9c0Celz8cIPZJ4gl4m8A9hP4Cey3bcint9fV1q9TQjLy682VFsz279QZ3+ nNB7uS5Cnz7zIOhlAn+hbBdr9Viujm2tfIcbJPN4BLbNtedhGge999aGOxqXdcuY/iZ9lpsIPSfy BL1M4K+M6+dq9bytlbv2ONb67n1ZbdiLvgDv+8+fCn1N6QW9TOAfB33TTGxiiWOs1cfltWFMVm0D y1ob7nBb6LkbD9DjGKDvBb1M4M8o/Vyt3t173suOk3mu+DQYsyh9ZShm7Mi7NfQfPnzIR5TrAP2r V696QS+7je2+Utgj9ItlOyTrvBWXh2NW9rFrqWy3DcA3zcKCm1Og58YcQP/jjz/ODcIU9LJHo/iz ybw1ZTvU6r0Fl2v1tdi++SuDf9QqO0EvE/iXi+tHj1oGv1a2Mxef96S/CttVH2x2UXHvBb1M4N+3 6iOur2XwF8p2I8WnxTYc128CfIJeJvAfSFw/mcHnZB6X7aw+v4vjslZudiHoZUruPaRkXlxtF5bY jlSeR2FzuS5k8D//wDACW9DLpPj3lMzDg5N5HNd7Bp/78FGz50YdlOswdQdHXmLbVPaxOwX62oIb QS8T+Ker/objeof+xYsXW87gJ7hag9+VfhcbdXh/+ia04TKEPAL7GOh5KKaglwn80138pplo0plJ 5o02sDTFHy2tnYjrR5NzaO4972izesGNoJcJ/DtM5lGdfjeTwd/MQY9HmHe/p8GYo11upnrvBb1M 4N8yrufOPI/ra+24vK/dQgZ/Owe9u/i8ycXUuKwa9N6GK+hlAv+4G0CG/vvvvx816cTOvNCDP4I+ 7lobVts1BD1i+oH2p/fdavdhm2qHfjKR56vscG8R9DKBf7yL38QmHSTzeG29d+bFRh1282nhDRL6 nMzbEPRxf/oMv+1FX3a4wblPwfUtqqf2pPcFN4JedtfWfkHQH7j3Xq9PLnRr0JcpOr75Be9Tn77m G1P8fOSJOtaDj4Ea2wg9VD5d6w32UTKPd631Gn36urKfne9jVxuXhaW1//znPwW97M7tS2rg2TQT 9XpAj0ds0rGR2CO1x+8c+u/z7PvQjjty89PX9bWynSfxfDsr3+gCR8C/BD0trRX0Mrn6My5+uR7r 9c+ePcuqb3H9jmv2tMzWO/N2try2uPgLZTvetro06tT2p+cNLBegj2vnBb1M4DdHlO4qcX0b43ov 41EybzfTjnsQ15N7X45QfYvxy/70PPsesK8clyXoZQJ/zs339fVcuuN6PU3HzUdagONNOi214VZ3 ryXoSwY/xPZ73s8uduX5hhdHTMMV9DKBP+Hiz66vnxqUiWMYrMGDMqsr7tL7fahGyeDDvXd1B+jm 3o8adLgVN252ocGYMoF/motfLd1xvX4qrp8akDnVmRcadFzxuVafofeyHfanj2U73stOm13IHpq1 Dxz82dIdsvaxdJfeW6bjWunuyra6uqo168wl87xWD+AtoZeh973smnrZrsd21QDeu/Im9rIT9DIp /lJCb6p0R4tv2jPE9UPM4HtcT/34N5zBx80hbmLJXXm0a62gl0nxj4B+Cxcf0KMVF4CjdAfuoPaA Gypvu9l6S25Rfn8e1tdv5zrzEOaTyme3HupOiu8Z/Ax7+l7ZvYfS+x71SOZV9qcX9DIp/sJNYLZ0 9+TJk63H9FhKG2bh82q7diGudwDzzjes9lyqc+jJte+mknmCXibwz+DiT5XueH19XGLrSb0V9frY pMN1+gI8nnMyj1fbQeljBr/R3vQygX809E1T6c6LS209ro/r6310lg/VODKu7yiuL4pvmXzP4I9W 263M4At6mcC/rYvvS20BN8O/sg//IK73uXlTnXnJcskO0Hsyj1fbeTJvoWwn6GUC/zYuPsf1oSW3 pZLddm4sNsf1nszzZbYW1+85ruce/Fo77kIGX9DLBP6ZXHyO8Vufm8dJvSZMx52I6zsYu/mVuH5/ y2SeTPZgrH0g4I8addzFB3No1AHotgDnoHTHTTtQfCvZ5SN+vwkX/2ATDFN87r/fh7X1uV5vtfpS tkuP4aefflqK5XUDkEnx17r4iOlXuvht6MrbVkp3GXruw/dVdyGu38e4npt0au24zeFKO0EvE/in uvjPnz9f4+IfdOf5lNzajra04q5k8WEM/Jq4fiGZJ+hlAn/hJnByFp8HavCKO/xe6T1TS207Ou59 Sq6DHkp3t4nrBb1M4E+ofDPn4rPaz2Tx4xSdqotP6+t7a9IpiTzu0OPVdrziLjbpEPSCXSbwT0jq NVMuPmJ7A37KxY8tuTGLz0By6c7X1x/E+DxJx138FXG9knkygb8A/MjFd7WfcvF9Hv5aFz/sX9/M lO72sXQX+/Dj+CzF9TKBf3v487lvhgE2AWzNxU+wtTZJJ6s8ZfGnXHyHfnKpLT934OEJ8FCNdN6z i6+4Xibwz6D2tYk6OELt3cV36FuzqSx+c7iNdSndNVa+A9gzpbvR+nr8KNTrZ+L6RtDLBP4J8MeE Hu9sG5bbtmH13UHJLrr4zV+lu7jUdgQ/ZfI7d/F9qIaX8NzFb+br9TKZwF9Q+2pCz6frxJp9XGNv q+/iXnfNgotfGnZC3b6rle5W9uErrpcJ/AX4JxN6UHtO6PGADV5848Cb4vtSW97rzqEv7v2ci8/7 29VKd/hx5OI3iutlAv+0ZF7jsT0n9GKHnrv4Ft+3VrZbmqjD6pvVnra+YpXv3MX3llx28RdKd4rr ZQL/RLVvOKHnzTqVhF4bevFHZTtqx13K4ldd/Nid9+eff/YnlO5kMoF/qto7/ElhtxbTj9x6T+jF /euh9gH6AxefWnO7td15wcVX6U4m8G8B/yq1Ty72Afym8CWuj2oP6KdcfIees/hrXPyff/65b1S6 kwn8WwE/yuRPqT2Arqi93wS2U2oPECu72na0I87+WBe/UelOJvDPczNg6PnhWX2P7Qn+krmn5weJ PI/ray5+zOIvLcCZ6c5rpPYygb+s9tWGHbj5gN/r9gk0V/r88KYcfrDKx9l5gL6pzMSPbblrXPwV q+4EvUzgr7wJuJvvoFbV3iFP8JXn5t7n7xFLdgCek3nRxY/jsWOjzkoXX9DLBP653PxXr16N4L++ vt447LgJEOgFehusUa3XBzd/H7P4gH6uUWeliy+TCfwTXP/G3Xx/PH36tIDtD5wnKAv0PknHFtww 6KPtrG1n2xH8Ft933Itv5bp+wcVvpPYygX9afH+Qzae43N38AnwCsLyf3foE7V/f/K+yXRmhxa69 b3/FXXq83LbWi78iiy/oZV+d7e7yhznoRU5J5flaspHqGvC93QRG+95RAq/zoRoN7VuPhB5Ax462 iOt9/3pT/LlGHZlMin8u++677zLc5uY3KbYeeQsG+SiOt4acaizPk3R4fT25+KMxWlhu60qvRh2Z wL9/K5AllfYOvBLTezceZewP5uXFLa+ii4+JOrzcVi6+TOBfyH744Yfq9Y8fP+ZjAjLCn2G3YxeS eKMNLe38xrezjsttfaKOl+7Sz+xW9OLLZAL/CKstyml+/PHH+pvNpfeEXVJm7rPPu1z4kdQ9jsQ+ gJ7gHzXqeDYfLn5I6MnFlwn8S9uvv/46gh4PuOCm7KNynWfnPVsPwE3xb7C/ne1oW+D3a+bi79nF R0IP339FzV7Qy756O2dWf5hS/XKXSUproOdjcsGRYBs+ffqUgbSW2tzWm45IAiKxh9V5vdX288/x HIDvaxc3xPBmHSvdFRe/UrNXTC8T+Hfqanx2ueF694nvovI4b3L5vmsAP4C1jr5yg0GM7h4B7g2c wYf5pFxk8D2LP1Gzl4sve5R27m2yq1tf//LLL83r169L005S+k1S+nyeXPLcqWeg+/Ezhbgj9D1g LWEAQn7cGPDwzL1l8zuHPsG+xw0BX+c1e7XlymR3o/hD5YbQeEwPyL2BB9A2n9tzc4dO4jdDj6Ec tslGafJxTyHdMHLbni2+yWU7h963tJ5p1Gmk9jIp/vkVP6p+8+7du7I4B9eg+tfX142rfgI2t+fC e0+Qlg0xYIAWsKcbQlZ7d+8deJx7Ft+UPqs9bg5o0sED3yN5HqrZy2QXUPy5BF8G2JbTeny/sRge 7n5W+saSdxBzW7Xnip9DANwQEuCD5wPw9VB4POc19rEXf2Euvkz2qGxzwe8Z4/283Pbvf//71ufp 87ZZSMQDdhvMsQnLcxsOFRrr30/Al4Sg1+ppYGaM6/tG6+xlsovF+K76Uf0zYJZVLyn6BGqT4M/P 4donNc+h+9OnT/u4qMfBRxkQR8rW533u7AaQVb6SzFNcL5NdKMafUv1iiPVfv34NgBHf52to24X7 jgU73lkHdx83AjwAMABP78sJPV5P//Hjxxz742u4Vo+vSaHC8J///EdZfJnsDhR/TvU91vfnvas4 3P0EMXJ5m5cvX25Y7dNNIb8ZCUDv+kueglcHBocezz2RVynbycWXyS4Y4y/F+qMtsmnH3E0c0IEq QPym79+/9/X5DQPvSbyV0At8mcC/L/hxYeoGkMkM8b17BwT9FPCNoJfJ7h/8GvxN8AAavgHMfVPA nuOUMfBNBXRBL5PdA/hz8NduAgfz+aqJic+wNwuQC3qZ7IGAPwV/9Qbx5s2b0Re+ffu2qUB8DOgC Xya7I/Dn4J97XjuvgSvgZbIHCv6xN4Dae6bgFfAy2ZHW3tPPXVL2JcCXXhPwMtkDUvxjfv7mDDcA mUz2AME/1+cQ8DLZFwj+KZ9JsMtkMplMJpPJZDKZTCaTyWQymUwmk8lkMplMJpPJZDKZTCaTyWQy mUwmk8lkMplMJpPJZDKZTCaTyWQymUwmk8lkMplszv4vwABn9FvXyIqpNgAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 1548 308)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 254,
    height: 206,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP4AAADOCAYAAAAe7L/8AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJHJJREFUeNrsnc2OG8mxhYsstiyN /uyBH0AL77T0+z/CLLzQwsDFQPsBxtBIGrndZNXNyI6TOhXMrCLZ/+IJgKhiNZvNlvqrcyIyMrPr FAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgU CkW30j+BQnGnjIwCX6GQAI4CX6F4/H/zqzuCfBT4CsXD/X2v7hn88THcAAS+4pxAX53wfbcJ/tzz UeArFDf/+z0U8tXSa96/f38wJ8+fPx9/+eWXQ+AeH/IGIPAVPwrsqxMg5+erBHh5cnl5Wb623W4P 5mSz2RRw//KXv4wfPnxgmGuAjw+RAgh8xY8KegvyAngLbpwPw1Cu7Xa7RVb6vs+wrtfrkW8Cdmzc BMaHUn+Br3jKsK8OOTfQATmgZtABOODG83Ec915j8fPPP08+xO+//94x8KvVqtwA7GbANwJ7/N// /d/YAH/JBQh8xVnAfqhVnwU9KngNcD7/29/+Vr7GwPN5DMBtR3v85z//yTcAO8cRN4Hnz58PwQGM DSdwZ/ALfMVjA/5YVZ8FnSGHguMcgOPBKs83g6j+r169Kh/iy5cvXVR5Owfsf/zxhx0HXL+4uMjn DfUf70v1Bb7iqcA+Of7jH/9ogh6VvAZ5BNyOuPbTTz9NbhIR/L1fJkD/559/5mNS+AFHvgHYc1P/ Z8+eDQ8Fv8BXPBbgZ2GHqnOOPgf627dvFyEH4BF8P+bnyZZ34foe9P/97387qLy9zAD36wPOHfbh 8+fPA84PgP/OwN/ob1HxWGG3R1L2DPmnT5/2VH0O9P/973+LkNtrAHjKuct1ugmsrq6umuBD6b16 Xyx+et8MvEFtR7sB4D1fv35tr++SA8i/Tnrt2o4NwFd+bXXb8EvxFQ8J/CzsUHUU5CLsCaI1g8zn L168mHzNH+sa5IAf5ykPn1yfU3s6junzDqT4Q7pp7Nze70zh0w0gHxP4u/Qw+5+V3/J+K/jdp+pL 8RUPre4lZwfsKUfes/DpeYb2zZs3rOprgn6dYC8AJ+gK5PY1hj99bZXUeAK7vWZlBKfn6TPkz5bg XOFailZub8DD4tsLM/TpmsG9Nujt56X32FnaYGkBIv1O+T3s96HhxXtRfSm+4sHUnWGHjQewrNaA 3eAk1V+bfccNAWqegF5HhU+KOnkNq7nBGRU/qr3dAGq/tAEP+B34rPoGO+B3td+6+tvNYGfKb8f0 uXam+nYMqj90y40+UnzFowB+7rxq5RMAq5izs7Lj3PP1tRfbcGNYm+IHRV/b+xroUHA72jX7GhTc ruGz2M/mGwB/Xqi9KXNQX4zR2zFDml6Tld6se7puNzOz9FbpN2W3Ybx8o7Dz9PPz8frtxxG1Cb8B jvTvpQYexZMCflbdawU6gzEqu9v3cg64TdX5OSs6oDaQSeHLERaenwcHUJ4vMDI68MXe22Nnv9hq ldXdIh236bC1o6m+qX967NJNawvV//Llyy7k+kMjz7+1m4EUX3FXwFfVPVp5FOhcwScW3s7t9VB1 hz1fY9jT+6+h2JZUQ/ld5aHknMPnawm2lQs78ng0/NjXugb8ozsAHrobXPENdPsM2SVYtT/9rN6P NnRnx/W1yA845n+LUES49Sq+wFfcFfCT83fv3u0V6tjKv3r1as0FOgPBbDxuAAn2NWAH6Aavq3SB nez8Gnbevg7Q8fMSyHs3AC8elhsA2/v0taba85i9kWsA+w3Avm83Xkd//aVMN7uPMrxofQmxo5Ds fneXNwJZfcWtAV+z867ce+oOIM3KQ92DjV8jV4eF5+d4GNBk2QtgDvqabHxR+VjEw+/g37do8ZGf U1FvcFtf7L3dc9JnNVt/Batvx3RjSvexq236XbZW5LNj+p13nz9/zgU+G/t/+fLl8OHDh6G7wy4+ Kb7iUOAX8/eanUfubjyYutesPGBPj55sfFF6+5pFet6Tfc8PL87lG4Db5TUX8Oz7OPUghS12Horr ar+Y1/v0W6g93nudZb7vBy8sDqFXoMPNBZ/jIf+DBb7iFOAnY+8GvEFas/Ocu0PdvRpv532w8j3b eAs7768JXSN/t/eAojusawdp7YpeYAd4sPPI5QlCbs6Zg3H0b7P3MJXv6L3yTWQuPXhsIfAVS5Z+ r2Bn+btdSPn7Gvk7YDeQkb8b0GzlHfA+sTKB3dW9B+wEd++qXmw9KT2se8ndSdHXZOlL3j4DONQ/ Bw3fTay1gz427H+H+wkeobNP4CueXA6fnyfgc7XcFDwCb/m7ndsDwFtA3T2v713NAXs5txsAKXkB vgJ7UXXcaGqK3gB9Aniw4F0F0kle7V/LjToYt0fjjl+3XD938FkVn4/pd80pwuXlZZmXj59lc/dt zB/h8/QFvuJxFO0M4lrBjvN3KLwpOHJ3O/e8vfehtt4r8j2svLkAh7uvwW7Btp5VPYC+B3kN8PIL O3yk8jXYi4Ib2FzUo7H7weHf8ddwY6BiYJm6m/5NJjcAzNNv1BYEvuJ+gY+WvlawM+ANaBTrWN1N wRvq3rut76PSR9gxZj8HO9v7IyGvgd5VYMdjQHHPx+6H65HD3UCV/XJMv3vu6MPRJ+4MWKwDj7sE fe4PQXHehbumwteAtwdgp+G3HtV5QG7nAJzPof4pMuxxeI6H6AjodU3V5xbJAMzUdNOEnF7LOfrk fLiu4BX4GXga1ts6+Pm4tX+k3u6D2/zcuvase886975+/Yq+/TyU9/Hjx1rXnnr1FXdXuKtV6WMO bzcDAG/n6Y+1j/m7ia/b+WzhXdH79TUNE3X3m0ax9xUbj4p9+axmBFqqjrCRtjnb3oC882acyTUD e7z+MLlTz4t5mIK785V2ylg+qz1gxxRdg9z6+H167kT1yebXWnWl+Iq7qdSj8cagrxXtWOEZeFZ6 qD2d5+uAG0oPtUcnHhTdoV7PWfhDVb2m2NR806FQFyHn13OjDmbjkdoPVOTLYNuMPHvu0GNG3jbd JO0Gsbu8vNz5fHxr2hmC2vPMvDvr05fin7etnwBvlXo03sDW27BcS+G9YJeBRvHOVby/drZZ4XFe 8nqHG/Z+5TeASS4flT001YwN2GdBH6/fBLl0mVwDJWdF9+m1fD3DaFkKpt6ikg+1t2vmFjyHz9B7 Xm8dfDtYe3cCWe39taz297bJphT/jG19svRrbq3lxhsoO6CPCu/NNxN15/y9ls+H/L2m7mzjV7U/ /CXYATRfwzBbyM0zuKFwN7RUnir5I6+4Q9dywc4KeG73M/R23YD/9u1bPvqSXDusvoN19xq5fddp BR7Fbah8zOMxNAeFR6PN8+fPewzLGehR4TmXh7pz/m5UG/xQd8/V15S/F+BnYC9/8JSz12AfXJ2x jDWAHq4NwzjJzVnJ0X5LefwEQFNiX0ZrxHsBflNtu45hO/uaXfM197Dc1uBz84cW9JXcvrtL6KX4 Zwh8zOMZ+JDH9xiWY2VPsQkKX1P3Hh14qNh7z3xN3Zuwz1XYATDydOTbpMwT0DkvZ7vOKg+F5+ec 6wN+HtbjBTZZ+W9hhV2Br7gbW4/CnYGOxhsD3Wx9zcrbebq+OQR4O1+w88eo+zAHe4C6es0t+xCA hWJPIDdgE8hjrfHGHtZ9V1tO2351s/StNfWR01sxTxtqKO5F5dnWv3nzJk9+AfBcqWfgDfJKHr+Z Ab6n/J1Xt0FbbdPO16w8LHsNbAdu11GrbOyYY1VnpQesLcgBMkPehd57gI7NM3i3HHzNFJ62zxrQ qnsE9AJfcZzKo69+ztZbHm/QY6acPTaWjAbI2db7EFx/APAF/AbwTXX3a0Noi61d24XnsU12iEte u2UfIuRRxVnheYecCD6f2+PTp09ja8+8hU0z7w16gf8Dqzz31ddsPat8Ot9wpZ6Ar9n6GwOPZaVD lZ3VfbieUj8MFdgn/fABdqj8wIoO0AG+XWMlB/zd9S9SVDwCDujxuqUNMvG6AHx3hK0X+IK+Cv1R Kp+UvY+23ux8pXCXgY/wU9PNscAfq+78fNd6TstYT5Teh9SGGuhckAPkEXxS/irg/Dqc2zFuiY0j KXzXHb4l9nhff1CKM1D5GvA4D4W7Ddt6dNlR0W4CfGNIrgY8T3BpqfvOr+1YyQF6tPmk6gV0rrIz 6Ci+tay6fV7Y9TnA+XkE3Y5B3ZdAv9cJOgL/B1X5WvGOq/Wb6xYyVvZSsAv23s7zeLwX6PpDga/Z eYJ7JOB3FTXnttehds6wY7abq/pQq7IfkpNHK38I4Ba01/2xYN+rygv8p13AW1R5B70U77haT1X5 aOtr8PMsOl7ltjUktwR8NU8PM9x2tFT1QDvSYD+6Aj6UHXm6fXS27ocU31qQtwC3o0M+B+0S0A8G vMB/4tYe4/I1lUfXnbfXbqjNdgJ9+iO344as/Cba+tB4s54bg4elrwC/YzuPYThSe8xkm0xvbam7 2/ihBjvGzw8BvQX5DOCHLpJxk2sCX9DvzZNfx3H5mMtHlef8ncbmN6zsAf41zaTj7jteevpo4Enh dww1n7O6YwELVvdk5YfW3vO1sfM50Bnyik0/VJVPmVQzPrY/NsUTsfZLuTxUHmPyoXi3Z/FRwec8 PiyEUftbOQT4HRfrMEc92Pmi9KzuOG+p+xzsB4J+THHtNmbNjY/1j07xyK09L47x6tWr/hCVD6Bv qFo/Z+sPyePL+Psc8EHRd7xYBQMPK2/TV1ndDXAr0KEzDsc52Nm6L4A+3gHgjw5ygf8DWXvvuOu5 Yk+NOBuGHsCzult+H2x9f2AeX+2L951jAP+upe68QAUvXOEbSU7U3YCPPe/R2tdgP2Ao7bby7vFH +ONTPMy/+eoUa88qb8AD8CWVDy23vAoO7zoT15AfqdEGjTdR4WHntw11L8pvkGMpKrfzu5a6f/ny ZTIcF3vej4T9FNDHc/gjVDySfB7Wfq6Ax7k8V+wJ/kkhLzTkHGTrQx4P4Ft5O7aFrql7KdZFO4+F Kmoz2g7oeZ+D/a7ydYGvuD1r//79+9XXr1/XbO1N5ZMi9txySwW8SS5PFfumylNOz6vg8K4zY83W Q+E7H46rAL/jFWYZeLbzWJUm2vmo7pjCWoEdgN609XXUH6PiIaE/ytpD5VnVKyrfB/j3VD7aeoJ+ YutjNx3Z+ryWHHaGJfi3tVw+LkMV7XxUd8xZt8/li1DeFPZRf4YC/9FBHxtyalX7aO0ZdjTjeNHu RiofbH0EfovzGui+fvws8FiFhu38zHz1lsLfRv6uP0rF/efzNWvfqtrD2nOl3q39BaCnXH4Tp8/W incNlS899MHWc+6+9WG6Ceiw8mzpI/BQ95adP1LdBbvAfxIq30XoudfeVL5VtZ+z9tR6W5T+Biq/ o+E5KPu2Bb8DvwXwqNLfEPhjrbxgF/hPN5+31Wtr0M9Y+wsq4G2wcQVvSxWWwOqWVJ7zd9j6msLb kfN4H4ffxSp9DfjKmnPdAcALdoH/4+bzCfYNN+QA+oa1nxTwKotkVFU+rnYTVH4bcveo9lXg7ejL Se94VdkF4JeWlRbwAv9pQ2/W/vLycjI+z1V7yudL9x1b+nS8aBTy9qDHuvWH5vIzKr+tbACZ1R6d dr5FVFF4bA11AvCCXeCfB/Q2Pr+UzydwLgLsFw76xNqH5axb1j7m8ruwrTOr/LZi67fUdTdReB6W E/ACX9BXKvexiJeub2r5PKCvKH7L2tdUvosLYQB6KHzF4k+gDyo/KdzZOY/Dz2wWcSjwgl3g/xjQ x8p9LOLZUB1DD+Cj4leq9v0RBbzJJJoIOvJ3AxzKz9X6dNy28njeHYaq9IOAF/hnDX2rcm9Kz+Pz MZ+3IwHftPbI51vWnpa22oZcfgI9nrPtZ5UH8DGPN0s/Mywn4AX+eUL/9u3bnM9jHbx0vuGmnGjp aahuUsQLBbx12Fa6QB9XrGVrT0W7ia3HebT12N4Zu70emMefUq1XCPynCz3m0EfouXIPa9+o2F+E Y5xoc4y1LwU8U/NaxR4qzx14dsLVejseselj1x3fbacQ+E8T+n/+85+rT58+zUIfi3jpeMGKb0dY +wTpBa9v331fFusgax8LeGTjS8V+TuUvLy932M+dVT7Y+qU8XsA/0uj1T3B/0LvSXyRoLtzSX6Tv nxzd4peCXoK291VyettjHvPn8RmwaUQDegP7CtDbMX1Lgd6Odg3P03tv02fcGvTpaOBn6O1oD1P4 dN2Ufvz1118PbbEV8FL8s4e+KH0jn8exjxNtyNrj548hn29Z+4mlB/Co2NvHOVTlnz9/PiiPF/iC /kTo2dpXKve1OfQMfWm7tXwei2Mgd69U7A3yq1pTDobp5nL5hb3cpfICX9Az9NZzz4W8BFHJ5+Nw HZQeHXlcxKN8ftXR3vEVaz8p3BnsjQLelsflDXZT+huovIAX+OcL/evXr0s33hHQX9Sm1B4I/a6S z29jXk8qn4+w9hiXP0HlZesFvqA/FnqC/WJmsk21cl9Zznob83koPR23NMGmDNMBeiva/fHHH1L5 MwtV9Z8I9DmhH8eJtU/PLb/fAvz0/Mqe42jqbtDbEdbe1N6+z6r2Zu1tU4tYsZfKS/EF/e1Cf7Ew rbY2f36cGarjRpwrHJesvUEvldcfuuJpQb83RMfQx7y+Zu2T0u8Wuu+k8gJf0B8LfRinX4KeN6hc hVVyJtAD9gD/lefxV9yYA2uPsXlMrIkFPOq+k8oLfEF/39AzYAY/rWUP6GudeHv2Hvl8rNpD5Wes vcblVdwT9LcE/Vwhj1tvuRtv0n5rbbQEfYbcW2+vXP2vUMSzdlvrxuO2WwMdSm/nZu0XCngCXuCf J/T2ePny5V5zDubS3xb0cXYdqvcOvFXsUb2Hxb/CkB0P3aXXMfRF6dPnzPaeq/bp9xr+/e9/y9pL 8QR9hH5uau0NoV/7TLs96CmfHxpFvAnsbPF9lZwtuvBq+XzD2quAJ8UX9N33hTHXtwh9nk9P8+jX XLl36MdKEW8X83ku4mFWHY3P53F9VO2h8lbAW4BewEvxBX1t5ZwbNOfsQZ/p+l6935tdx5141ohz TBEvjs/TUN2x698ppPiC3lfO2dwG9K70XQP6Yu+9qBdz+qz4rSIeK30ln1fVXlFic8Yu52DoeWrt gc05TegBGu83Hyr3V7GCb0U9FPGg9LGIx0pv1j597vHDhw9L1l7Qy+qfDex3Df0mrI0Xoa+tlpMV Pk60iXk9OvGg9OjE+/z5825hfF4qrzg7xV9Vnk92uOHNLh4KerL1Rel5hh167w14+z5f8XZXyecF veLswZ/do762rZWdN1bOuW3ot9Sgc8U2H0pvxzCzLlv82ImnIp7i2FifazEPu9bGzS5qW1Rjuay4 eEZrws2p0FsV36G/ojH63Jxj0KNyH6G3Ih5Bn5fXFvSKc83xVzPQrxl63tbKhu3iOD2vnGPLXh/a kUdDdrtDoK9NtPF8fhtn1mGSjUGvIp7i2OjPEXrL6dFzT9tabVztLf258H3sDPYMuuf4WAb7GOiH I6G/ujYZ22zrAT3ab7ly/+LFi0Mq9wJecRbgz1bwuSsvQd/TVtUb2suurHMPe1+z+QdCP1kbrwV9 gvuKV8vhyv0NhusEveIsinvNCr494iaWYavqPm5g6QtgliWwF6bWTmw1mnO673vRb+eg5248g/4W xugFveIsinuzFXwr5lX2qN/btXamcn/RWDlnb2cb673vvCMP4/OnQm9j9HYU9Aop/uFWv1rBB/Q+ bMf99xPFN7vve9iV/elry2UBtjDLrvTe3wR6Hq5z6AeCW9ArzlrxV4dCb8U8t/l7Y/W8ey1vYEnH 5hp5BP/cUlmTQt4x0L99+3Zw6KX0CoG/VMwze281NkCPvN7U3vaoC/vZlWG7ylh9FXoU8njlnJml snin2qtjoP/ll19qHXmCXnFS9D8I9HuFvM5X0aFiXt5xFhV8B74M0QF6z/Gfdd93r5105YUda/dW zomz7Gh2XWnOuSH0NcgFveKsrX55Hot5r1+/LhV8zKs3a29hcGMTSx+z39Cuta1trXghjUn1Pq6E ayqPVXPikJ2gVwj8O8rrWxV8FPF8qG7Se1/rv4/QG3S8Gi416WARjYnSow03bnBxIvSjoFecG/gH t+NyMY978A16g9uPzSWwl8bqeTVcAz7afFpAo9qGewPoFYqzAn+2SYeLedykE4t5oYI/6cHnMXpa BrujvH5odeVxTm9H5PQt6K05R9ArBP5pqp8f7969m3TmvXz5slh8K+4BeIYeim/DdVb842G7FNyK W7aqtv0reUVcUvds7zmfxzx67Etf68gzQyHoFfcZ/ROGnaFfW15v0EPhbfMLgz0p/cbXy8tVe6vk G+jd96r9XpeeQW//Nl7Bn0BvsHfX693v7UnPK+j4XPq8ay1sPk2tHeKEG2vO+de//iXoFQL/1Lze d7zZg56H7NLjmUP/LMFtN4JJd57n9RPoOa+3paxp0k0G3gp6WDWHt6i211pBzxfFnMynpzbcQdAr ZPWXbwLVvJ7n1oflsLmYx805PGSHvH5i72MxrzZsV9uploftsIfdzISbrgG6oFecLfirVmEv5vVm 9e3oeb3l8QZ/j7we4/WhHXdSzIsbWcZiHm14UWw+71UPpcewHabXNpRe3XgKgX+kxc9qn0BboUkn gbim8fo+FPNq4/R7xTwGj7ryymIaDD3WvG8tmYViXlw5Z2aWnUJx9uA3h+6wkk4cr/fNL/J4PQPP Y/ahF7/3Yl5W+koFf2+2ndl7V/e4DHYZq+cGHWsOjGvkaWqtQuAfmdMjrzeLH8frD8zruUFnTRa/ VsHf68GPO9badQzb+QaWza48Qa94DNE/cthrFr8M3dmyWZbD03h9nmWXQI0z7p5ZXp+uP6OFMrlZ p9qOy1tWexEvw4/tqnm5rG5m2M73pM8WP2xpJegVUvxD8/owdFfyelf7vbweil9p0omdeQW+UMHf hSWw9za7MPgtDUAhj4ft0KATlsAW9AqBf6jNj/PrOa+Pk2/Y5nte3yOv9989duZ1PMWWJ95wD37s zjtk2K6yw42gVwj8GbUv12tDdzz5xtty+1ZeT7l9M6+nYl5pxw0Tb65qE2/mhu0EvULg38Dix6E7 7sOPk28AfGMFHe7M6zrqzKsU83ZQdzTpuNJf1Sr4tWG7bn58XtArpPjHWPwXL16sofbWgdcar495 fWzQCXl92czSiEdzThyyq028OWLYTtArHjT6RwZ6PK4rFj/beVN4q9770N1kpxve/Yb78P33zY06 Ia8fCPqBO/O4mMcWH5X8G1TwBb3i7BW/ZfG7JYtfa8mt9OFvFvL6Ms2Wh+3I2leLea7yp1TwBb1C 4M9Y/L3uvNq6eQy9H/vQh79u5fWhSWcbOvO23pnXLOadWMFXKM4e/FoVHwtr5EYd5PY86w5V/DB0 1/PQHRfz2EVwjm273vAqOujM41780JnXLOYF6FsKrxuAQuAfY/FR0OMltOw8WPw+tOTmMfug9nt5 PRf12OYfWsyrVPAFvULgLwB/rMXPVXyGHmqP6r3fBNZhfj2gn8vrtzRkl61/rTPPoOf18lTBVwj8 0y1+d4rFx9BdLtd7Xu+V+z2LjyadI/P6HebWt4p5CxNvBL1C4M8V9E6x+J7Lw+7PWnyAadBjTfxK Xr+dy+uPLOYJeoXAb+T0k0adJYtf684LXXllCa3JD22M19OqOtulvB6LZFpPkA/bydYrBP4NLf6a LT6W0YoW3/P7Ajyfu8Uve9ZD7St5/R7wvHxWK6+PnXmdNrJUCPzbtfhQ+yWL7/CzxV9xQY/z+s73 uIt9+Di28noer1/I6wW9QuAvqH21F99c+FIVP1p8zud5jj1Nvhl5fr0Fhu5o6+pi8Y8Yr1derxD4 p8Afd7Z99epVWVKLp9tyFT9a/DjHnqFvLKqx5aIedeXlpbNqeT3G6xeadAS9QuBXgN+z+HFFnYVe /L5h8de1gp7l9a72yOkn8MeiXuzDPyCvF+wKgX9EQa9q8VvTbX2BjZjfs8WvLaNV5tfHobsIP62X t6v14SuvVwj82ynodTWL39jOug8TcSZDd2TxJxCSxeehu21t6M6cAK+Qm57v7W+nvF4h8E9T++ri GlaQe/v2rZ1ntWeL3+jFn9h7svgrtviNobvdUkuuwf7ly5e5vL4T9AqBf1x+33WVgl4cs3eV72ml 3L4y3bbnMfvy5j7VtvOhO0zA8RV1sLLObEsuhvBg8bv58XqFQuA3gJ+ofaugB+CxaKYrfk9LaPHy WRn6UNDDVNuhNusujNvvDmzJHZTXKwT+DdXeJuEYk7D5XNhLar+mMfsyxRbnlbZcLuiNB1j8Ha+H 3xq6Cy25nfJ6hcC/odrPTcLx3L4Kf+f723Xfx+r3NrisWXzAzxY/xQ4W30EfFobulNcrBP6pN4OW 2lc69HqM06OgF7eyjgU9tvgB/i3l983uvCOH7hQKgX+g6gPQPbU3kO0GENUeSj+j9pPuPFh83+Nu hzH7Q7vzKrPuZPEVAv8GNr+M27dye4e/5yIeZttxk459b7r+/QfQZhhs8Rn+msVvded9/Phx6DR0 pxD4t3MzYOj5YfD7A0N25SbAY/V0Q7GbRplq6115e3l97MWPVfxv374Nte68TkN3CoF/sto3bb7B /+bNm3x8/vx5sfkJugI5lB7n9h7pOLH4ltN31y25qOAPPMeeLT4adU60+J3UXiHwj7sJzNp8Uv6y c21Q+MlutlGJaYPLIVbxqRd/x406rSq+LL5C4N+BC+D2XLb5nt+vvLhXQDeFD+vllZwem2GQxYfK b0MVf8e9+HNV/BmLL+gVAv+UMLXHud0A7PjTTz9FRY/qPoEew3Ud7WgLhceU20ovfino2deR1x9p 8RUKgX9svH//fpLfM/wIU/osrQn8BOLEZqMxx6A3+IfrxvvSmWcqn76P23H3uvTiMlpQell8hcC/ JUt/wLWOrX/NzrOtd6Uvc+v54ZX7XSjk7Vl8U3xTe0y3tffDzDtZfMW5xeY+fsjl5eUqWv0W7AZk eq0N2OdhOlNme22KyY3KVD9dH2hFnbzllWUV1IufFT69Lk+39Y0wclGvMt1WFl8h8O9A+ZuKbo+k yhn2WLhzlc/j9qzE/pod2fqyGQZ2xbE59mbxk53Pub/b+1pBTxZfIfDvIwxcV/XSeedqn+E0tbej ATteT8+bzMJD044pPu9sC+BN+dnim8KbxYfaz6yoI+gVAv9OCgsJeIYs2fCsvq7wRe29Sp9f49Z+ RTcNrKVnVmCyPLavqJNV/kiLL+AVAv+2wraPtrw9KXCGHo8///zTqurF2pvam0Jb9d9m3hnTrPae 649R8WvQm8U34BcsvqbbKs4y+jvM7ct4/G+//bb661//Wjr2EvDWtFMadjpq1sFqOlYAtDF2A93i WvDHXNCzLzPwltPbDQNr56EXn9fPM7W3obsFi69QSPHvKrfHw1Q45d/r5AiGpNBmww3eMo5vNwlr 3aVuvhzmHkztrVrvwOfmHIbeuvPs/b5+/brTopkKxd2CP3b1in621ximM+g/f/48vnz5MsPv+9yZ PV8ZrN6kM/rcfOvCWYX8Pn+fAW8OABNv4sIa6MVfaMvtBL1CVv/27P5kua3ff/+9+/nnn9Gfv/Lc Pz9PwBrweazeoDfFR+OOgW0Aez6fYTczYDcKUvn8nKG3G4j14h9QxRfwCoF/y+BPrv/973/vXL1z Dp9y8Ay/fTHl31bI6zy/z9AnYJHjD3j48F3uxrMbgBfvcjHPzh30MgHHVN7e59dff5XFVyjuAfyo +l1S/VVS/c7bdPMLkhLnr1nF3x52A0ANwG4A9rCinKcEA9Tdq/S5gGfAG+zI5Xl5bCya+dtvv6mg p1DcUY4/l+cj1++Q61tYU83r16/LC6zIZ3l9uiGMXsG3G0J5P1T6v337lvN8zuPt3KEfAf3MoplS e8XZxuqO37ea7797927Nu+j4qrt57zxM2vGK/iqpdccVfRv7hyMw2O1owH/69GnEDcDAB/SNzTAE vUKKf4eqz+pfIPPqek7n810hhTmAr1+/msrnZblMze3cJvjwGyPvRxOQAQ/47TmG7SrQd4Jdobhb xV9UfSzFRdtkl2W5eKWefHfwUQC0+gJ2DA3a0VTejkfsaqsbgELgPwD83dINAG8Swfe23Y6BN4X/ +PHj0rx6Qa9Q3CP4Nfi74AA6vgHgm+xGwG9ooPNNoAJ8d0A+L/AVAv+B4K/eBHADwDfwOdUGOs/h 5yBvgS7oFQL/AX7G6sBjXquPi3s2y8+OHz586BYsfMvSC3qF4p7An4O/CvwBn228wblCcfbR3/PP OxXupetzkAt6heKBFP+UG8DqhjcEAa9QPDLwl37+0ucaT/yaQqF4BODf5ucQ8ArFEwP/1M8j2BWK H/jmtNI/g0KhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVC oVAoFAqFQqFQKBQKheJm8f8CDADBkmVdp+CN9wAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 1555 320)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 254,
    height: 207,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP4AAADPCAYAAADVsGxZAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJNxJREFUeNrsnUtzG8cVhQcPWpb1 ilP5AV5kp6X//0/wIgstXJVKaZdFquLYlmTLBGbSp9mnfeaiZzAA3+K5VagZgCAJy/z63Fff7jqb zWaz2Ww2m81ms9lsNpvNZrPZbDabzWaz2Ww2m81ms9lsNpvNZrPZbDabzWaz2Ww2m81ms9lsNpvN 1q38T2Cz3Tgrg8G32SyCD24xMPg2Q36z3zM8hkXA4NsM+c29Zzjxa4PBt9nu5m96dcPftwTk4cTn Bt9mu8bf8OomX/v++++bv+SHH344BfThISwABt/21ECfe756+/ZtffL58+eT+Xj27Nnw7t27CHIL 9qWLgcG3GfbrQN0CXOHe7XbNe1jf97OsrNfrCux2ux14/ec//zlMAD/MLAS3vgAYfNtjgv3Ya637 fAXohJxQK9wEe7/fr1qgD8MwycpqtRp0AdhsNgPvuQi8f/9+KDAr6MNCL8Dg25487EdBn4N8CnCA rffffvvtAfwt1afS4/rTTz/lRQD3XAy4EHARCAvAvcFv8G2PFfbR9e9///sB6Aq5Qk2IFXB+na9H lZ9y9Qk+QCf0ePzvf//D13ouAlwAvvrqq15CgGPwG3ybYW+p+hzoEfI3b97U5xHw+Pybb745Cr9C /+nTp0Hh5/2HDx96XBP0+XpxcdFT/V+8eNG/e/fuXuA3+Lb7BP4k2FXV1XWfA10hj+48AW+BX+7r 53n27NkBK2nhqXASdADORQCKT+CxAPA5wMcCcAT+WwV/679F22OB/ffff18p6FGtI+h//PHHCPoI Od+D34N7wM3Xo7t/eXkZPzfAri4+HlgI0s/u4c7jefq8eJqBT4CvEuzdL7/8ktem9PPWuDZKhoP8 GwxyteLbHj3wJyl7VHUF9/Xr1weKXq5rgK5fS4817xuQj+4TpNHVPwAUcCeAB1X89OjTYtKX+H6P KxaApPR7qH36ufsEf1/us/p//fXXfSPmv1XVt+Lb7kPdT1L2lqqnr62p2C3Q8RwqjfukwOsIP76W Xp8Ev4QSWaVbpbz09aGoPq89run1DDcWgPL791hkklvfpf+u/L1psaLyd4BfyopD49/rVlTfim+7 K3VvXQH8UWUH7OnrFV5Cj0dSyzVBx8/DlWqurwFyPo+wJyjj6x2f638L4E2fY6T4hB7KD9ih8rim 90HtofL79LV8n75/n+DPV8T8uFL5RfX7u4j1rfi2mwJ+ibrX0hth//Tp01HYoeqE/fnz5+sES4YY z/EeKHqy1VU4vYaarxNM+R4Kz9fw+xNsKxgXATzw+8sCkL9G4JON1D69Dy/Whp0CeHrLwCQenq8L 5CsuEvAasDCk70cOID+S6g+//vrrGj8L/81F9Qf593IDj+3RAD+r7t99992o9AYYlyg7YBeVX9N1 L/CvVdEljl9TyYPS1wVAnwcPQBX/8D8+wQrgGdMX4Kvap+tujw+cnqfXd2lR2EH1cVXV//jx476h +v1EnH+ji4EV33ZbwB+oe1HuCjphRoIO91HZYSUez7AD4BK7Z9DTj18XcNdF5VdcCCDX5WetC+Tr ouIregp4Du9BXy/eQFV6LALl9YEKLrX6HiqOX1UUH79zj/fgZwDU9P0bvCd9Xnw/Pluvicnk8uMz tOL6O43NbLZzgT9J3V+9erUupbd6bSk7YcdzuO+i6hl0fU61h9Kr8hf1XhPyqPJlAYgqP8VGVnrA DL6p+FT4wj7ud+mz7Yr65yvVP33uXVR9KD7KgFLX77tbbOax4ttuHPg5dX/58iXj9jUz8fiaKPlI 2QE7lR2KSaj5dXXp8T48SswO0NcSs69L7T8/xyKg8XxR6FEJT5W4xPdD+TpbcVel5z8vHHjPlZOS bbRA4X1IOrLSwN+BluEU68/927uBx3avwMfXRqW46M4XmKu6E3zACmiRjccV709AKOybOdj5vIQB +UGXvsC8VtDldU3asQGIgI+Az1m9q+dV5dmsU5R+VRS5K8AP5XuYW4BHn/MITBxqJSHuG5jb+df4 /zIYfNtdAt+svbPuXoCumXlAGtWdcTsBprqrsoOlFuybK3rze0oCsCo6lb4FOr5HIF8hw69wF1i7 KQCLyq+uvjzg+3N3XgwV6EWo5zBn6d8m1/WP7fO/LTP4tmMufXTra+3906dPa7rzWlsH8ARa1b3h ymd1B6z4GhJhujAA/gTeprjvCjsXhQw9gGNMr6W68voqQD4VwzdbZ7ko0AkQlZcfe5gHCAvHgX34 8AFlvkEHeCwwx/i2O43hR/G71t4JvCo8IGaiLj02Qd03LXUH4OrGp/duitLn9wrs66Lc/BkrVXoF vbXZpjtjaCYbdTSxV5J6tYmnvJ5jf5T69IoaPrbkSsPPoAvC1OJgxbfda9IuAb8+Fr/jQeBhcO8T 7JviaivwFXDclzh+Q9f+KvF9per8XsnIK+wHqt4A/WgMHaAbZc9bwJf7UTYf104y/OFRgccmHiwA 2L0Hr6Hs2x80iVjm9bVq+AbfdjfAM4YHxAo8oJPae43fAS3deSo93Peg7huN27u8rX29uaqAraur H2FXVe+kJCcxcv3sjONhpazezajrEEDvFPbyM1Thc5mtxPm5aafLZfs+l/NY1ivqj1ZebsWtD/YB 8ANweAfHdN2We2/wDf1qCfAxhm8B/+zZs40k6Daq7sVd37TUHV/DzyH8Be51WQgmYY+qHjPyC5T9 mKpH8GuHHhcAVX0qPqFHhQ/3XAj4wI49LAC//fYbAM8LwC+//NKC/U7cfoNv4DtJ2h1k6RnD06UH 8FT3otybhsJvJBO/mVJ3ceU3IWZXN74Ju5TCDv6DteauwEdFv2qiGyrcuBXYe3Xvi7rXBQC1/AJ8 X1pzuQ0X97k9lxt1dIsux3GVB6fzDGEi760m9gz+03XrD5J3SNwtBZ7xOwAF8A2Fr1+DTak7gGfy jl12hF3c+EWwd1f+dlTxkaKXr4/2z6uyF0WvoA9XO3zyvcb3XAAAe/EAcsvu/mpFyPeN3Xncl5/h //XXX3sO4Qxu/q3H90sznLYv060fZerZVhuBx0MVXoGHa48rwC6NK/keD1hR6ww3rnzO5hsCXzyB lTzvNHE39x8qMKuqtxJybLE9gFzc9/q9iNGjq8/X1dUHxFwAdEsurq0tua1hHGjVff/+fWtzzq1N 3LXiP9E4vpWpZxyPspwm7dL9hsAXdQfEWenp2ktGflPceap5Vnu6+arumfY/O95GffPlPc1YXeLw SdgB3nCV7h/F53yNqi2LwOj9LL+VgRv1a5yhB9hLa27dkotEXlF53CPOz/BD6Yv734S+ofa3nuCz 4j8xt34uUw/gqexU+dJrvokK31D3TYF5o+pe1L4+Guo+gn2BsqsL38cyW0zG8T0Tij2K58tW29HP 4HumvgbY+RzqX8ZuVdeecT0UH0m9E8Zudd0tjt4y+E/Erdd+eo3jCXxx39FltymvV9Dpxqf7bQv4 6NrLAlB77jV2V+C19Dah7lHZe1V1Ufq+lNgOMu+Edm4BCJBHN79O2klgj+br4QrYFf6Sve+npuze N/R29Z+IysOt5xy7VhwPlz3U4TclS1+Vvbjx24Y7z9r7RrPzVHi68zrxpvS1x88+NFz5Juwl6Taq p3d/zr3rJT7Pz6G0hL247HTl++jK4zW43nGIJhN+aLNFI47Cj/dzqi7HagNunauPz6Bz9QE9Dti8 i3jeiv9EVV7dejxaiTtATOCjKy/3W2bp1b1vJOzWsgBMqftop1nMuFONY+1cYRcFJ+yjhyh9r8Mw Va1FtetiEkdmxwqAHpyBLjxtymEeADV6zQn4JB3bbar8QfJOVV7desBO6KeAh8JHtz79AW8bwG8m 4ne8pp10x9SdYNchF8GNnwRbGmriexTwg7hcQabLHgEv/w2j03LiiTksy/3888+jr/nsPNuDUHkF XuN4SdxVVed9iOM3E8Br/K7Ar+If8gJ172PMztfREddQ9qrqfE7XX5JuFXQ8FyXvWzAr5ARfm4Kk CefgsEyFPcfTh8B3nU/Ltd2Qyq9Zk9fk3evXr3NfvALfcuuZuMO1ZOMz+CcAvw7u/BLge1X3lmqr G886+RTs6tbHbDsVnb9bD7RsnXsXASf8Crm+B/cR9uLSd92y47Ec49tuTuUL6Dlb33LrAbq69bwW yHHdapYer58CvLTPRne+b6i7LgB7XQDYFst7wt1SdZbQiqr3Crqea7dUxfl1wk/I9Tlr8bxKDH9M 0e+lV9/gPz7oDzL2LZVHpl7Lc8Wd34pbvw1xfHXxJY7f3ATwraScAL9vwL4P6r8XZd8r7EXZR6pO 2OMBlq2YfO5c+znA9R7Z+bKddonbfm8qb/Afv2t/VOVbyTt159WtJ+i80r3HtSTqNhPAH0ytOQL8 COYIPF157nibU/qWshNu1ND19Nqp5Nucq95S8VJ+yyb75pdAPPd8uO8/MtsjU3nN2EeVj8m77dUE yBH0Ue0L9Fvtrde6/AzwnWTjW8Dv1Z3XPewEX3e4NQ6oqO2wx2An6AQam2FaoLeUXNWckB8BfArc Ja8ND+UPzfZwoT9L5dO1Gb8XuLfBrd+qWz8HPA+YOAV4Ufh9Yw97PHMuP4/KTjeeHXCsoasLj/Vt qqRG0FtKfibgN/m6wTfwbeh///33dVR5ZuynVD7E8lvJ1seYfhTHh7r8ucBX2BuHTjSVvuxo63kf Y3a2wnI/O65slpmrnx8B/RTX/FyQh4f6R2d7BAm8Vl1eM/YTKj+Cntl62VAT++t18o3Omx+NouoO m2sOgA+KXkdTxeEVCntx5Q+UnW58qzOOaq6wLwT9usr+4CE3+F+Aa//y5ctNOYMtj71iXZ4Ze43l CT0UXcGXbP1mzq2PwHehqy7U3Pfi0u+n1J0Tahiv69716MrHuJ1976rs6H1XF/5IOW1pYu2Lgtzg fwGuPRJ4GssT+EbSrkIfM/fM1ktMP3LrdXssM/TBrR/F7UXh6c7vJtS9Kr9OpSmx+z7ualNXXhN0 LTf+hNr5uUm24Uv+I7Tdn8qPwJ9y7ZnAg9Kz+w6uPevyUeUF9KbKl5j+FLeeqj4Vt+/1iOig7nsZ VDFy55GKUHWf2+RyBuyngj48tT9E2z3H80nl11Ou/UQCL4MeVV5i+ZHKxzFY3Z8HU3TH3HoqfFfK cQ3gK/gR+DiKKrrzModutNOtLAK3CfvgP0bbvcfzc679TALvGPyb2IV3hlu/lziebj1HSO8C/LtW LE/gqe7qzjN2n1P3G4J98J+iwX9w8fxS117KdJq424aM/bkqH936GMfveN9S+ThWugW8uvNah+eQ iokNLobd4H8Z8fzbt29XHz9+PIjnX7x4sYmuPbP1LXWfgP8cla/ZesAd3HqN3Xd6eARVnq68uvQR eI6gosIf2a/e3VKyzn+c/ie4/3h+qiEnvb6lypes/bZVpiuxfAU+tt3OqXzcB99y6wX6A/gL8DsC zyz9NYE/pwxn4A3+w4/nI/RI4sWGHJTqFrj2oyx+yNgvVvnQZUfod4zjqfB05XHVOL7U4feapZ8C Hi59iN277rzBFIbd4D/OJB4Ab8XzpT6/nXDtLyZq9LqF9lSVj4c+7oKy71pZewKPK8DmoRF4sP4+ A/zUPPnrlONsBv/hQI94/vPnz6MkHlx7HFbBLjy49oznFXbCH4AfJfDksIo4BuuYyjN5txO130XQ uRBQ7dlpx1NiqPC4PxN4w27wH/W/YRP6mMRr1efp2sd4Pl0vplx7PcCCrn257xrQ9zMqr6DnewAe ynM7PRZKFZ5lOcb0Bt7gPzWVb0Ifk3ixPj8Tz18I7BcN134zpfKEPgzCqGU6qrxCz9eo+jFrHxN3 uCfw2nTTGCO9FHjDbvAfrWvfdROZe03iJTi2U/G8qnwC8aLl2i9M4C1S+Qbou+DWT8bxvA9Z+t7A G/wnmcRrQR+SeLXPnvE7oVeVn+jEq1NuWyov0I8acJitb0HP59qEg5vo1sc4XhtvFsyNN/AG/8uF XjP3r169qvH8VBIvxPEX4Rr3zy927UOL7W5C5TVzv4vZ+s+fP++jWx/j+Jk6vIE3+F829HOZ+2NJ vAbsFwr7MeiPuPY7qcvvgsoT9F1M3jGWx7Xl1k8cB9V193hQhG2Z+dDMO4ReO/ESOBf49yf0cO3T c15r9r6MxtrIHvpjWfvq2hP49H6CnlU/vXfHjD2v6bV9WpB2UHmc4Q7g8b1QdKo8uoaDW38sjjfw VvwvG/q5cl1y77cxc5+uB659SOKNXHs5Z/7AtW9MwtlPxPAjtdcuPFV5xvJYAHie+0x5zsAb/KcL /Vy5DkrfyNxfTLj42o0XZ9pH6PMRVNwnH1z7WpZLv+tS1T1m7NPn26lbz+TdCW6943iDb+gJfSzX TWTu9XosiZePlo7x/ERv/a6RwFP4a8Z+SuXt1ht8Q78A+kaNvtmBF6+hI09Pr9F4vgW9luj2MXGX rpcKPF16RBqasT9R5Q38F2Ab/xNcH/o3b94gBmd9HrF6hP6iKPxFUfb8KMm8fFWlh6WfUafeKvQy BqsX2HMCj9DDtQf0+EjlORN4u6v0wm6HRB6gh8InwDP0SN4BeCh9egwvXrzof/zxR7v1VnxD34Ke mXvW6Jm5B18F/uzOC/ia1IuHVEbXviP0Or9ex16p0lPlo2tf1D7H9PhIUptH1n5vlbfiG/prQF8y 9wA+K3kp2wH2rwB9ydxfxGSe7KMfqXxM4hV137M0x9o81JzQ45pev0yf4XJ3VUagymfg8f0F+HxG HeN5q7wV39CfD30t12nGPibzWkk8gb4Tpe8nknjNeL4R19esPRJ4JZ7vYwLv66+/7q3yBt/Qnwm9 lukkrm/tpY8z7lcz0I+m2qrSE/bi0l8G1z6X7NS1T/8ddYPNkbq8Vd7gG/ql0LMxJyTz4vZanX67 FPraeZeuly2lZ9sts/ZI4FHl2XKL+xmV77rle+VtjvENvUAPpf9KM/eI65HpV+h1Yo5+Dp4M24B+ pPAlrr8s6o94Pis9YIfSI54n9Lhn1h7QI4GXHlb5J2zu1b956DPwgL204Va1F+hjEk+VdtAddSzT sd8ekIduvEuW6rTXHtDjyqx9Sd6pa3/qfnmbwf/iYD+AHhtutPf+VOgRxxP+I5n7Cl7cNx9VvtTl c7Y+lupgWByYuWdtXuN5J/BsTx381py82V12uD9B6S/izPt4/nwAbAr6S4H/spXEg4vP+nxanHLL LlVed9NNQG/gDf6Tjuvr8wnos9oDXDTnAP5SstO++znoN1Plugi9duCJ0o/ceq3PA/oYz2upThpy 7NrbnmxybzaZhxl5Cj1678OGm7xXHs05rNMT+jI4IzbmbE9x7wG9lOkuG+23TOJdShKvtt6WvfNZ 6QF8oyHHrr3tyYF/EvSi9FvdcAPgu9Jjr9CzKy/W6ls99wRtDvr0vMJe4M/Ad6XfPiq9xvSM558/ fz68e/fOWXvbk3X1j0KPRB4qaBOTc+p8PBjAlm22LNkduPelRp+HYobP0x+DnjE9M/nq4qPllkoP 4KHwCXrcO563WfEnYG8l82rZLkG/kQz+VoZo1CQeFZ877TS2X+DenwJ9Teax3x7PUbIr/fYYfomW 3KX1eUNvaya3nhz0WqvHNNw4Iw/xfGzBxYabRulOod+cAj1g5zVAf6nlugL9jp143FXnJJ7tVFsb +j8bdOIR1To5J8TzdXDGAuiH60Bf3PtLhR6xfYQeSTyBPv8+Q297ijH+0Vp9q0FHoZdyXb6W2D66 9giXpjbbDHMx/Rz0zOCXJN5Oy3WxEw/QTyTxfBad7UmBP3umXazV84Sb0qBTa/XamINrKdeNknhF 7U+q0y+BnoMzWtBr5j595mEB9Abe9sW7+scy+AcNOri29tTrUdXRzddDLmZi+mtDnxapfDX0NoN/ enzfhF4bdEqTzkb31GtXXjzLjvBja203PkKrQl+20V4LetboDb3N4J+ZzIu1eibz2KCjSq9Tc6Qh p55sw003UqsfqXw5dbbnzroW9On6Bx4S0+dEXoReW3ANvc0x/gnJPM3gzzXo4N+ECb3QoDPVintw yAVPttEz61rQ6xANQB9j+hnoe11oDL3tqYK/agHPR5x/H8p2mzA2q/bcF/g1gbeVGXlxEu5i6AF6 uZ+Fnt14rNG/efOm/+GHH9xzb7Orf0z1eU59gnGlGfypo63o2ms8r9n7qQz+KdAvUXpAr405E9AP ht72VMFfLU3maQY/JPO2PNqqnFA7cu0L/Iug10m4C+r014W+M/S2pwj+HPSjjTcxg98q22kGn8m8 cEb9UeivU6c39DaDf41kHh6AvhXXM4OPwyzjEVfszmvNvpey3SiRB+gi9Bx/fQx6nXVv6G0G/3zV X2lcT+hfvXpVk3nl9NpNgX+rSTzAf8IY7NFgzHBw5eWpdXpDbzP457n4XTfRpEPoGderay9JPFX8 Vq1+tOlGT7iZmJG3M/Q2g/8Aknm68UYTd637Y2U7mXvfnJHHIRrx0MpWc46htxn8a8b1c8k8jev1 aKuw8WYzk8FvHmsl8Cv03Fo7yt63OvIMvc3gnxnXf/fddwdNOriWuP4gmafQSwa/briZgH4op9bq 2fQ87EIPq8zQc3jGsY48Q28z+GfG9dqkg2ReAnEtTTo1maeNOsG11w69TQt6Ai+z7/dlCObBKOwy /prwT55UizZcQ2+7a9s8Yuib03ExPguwl7i+NS/vq6L4+aq77cq/R56M241323Vynl1fzqevcX05 1mp0yEX6lhrbT03OYe/9P/7xD0Nvs+IvWARm4/ri6h8k86QzL3bkbUvmvjlFJ55yg5geW+9Kzf6S is94nsMx4RFgEu6RIRq9obcZ/ONq3y2N6yc68/RMu004wXY1AX0s2+1LbH9w6EU44aYOxpzZWtsZ epvBX+bid0vietTjNa6n4jfaceeSeTWu1wYdJvNwL4pfz6YH8FT7hUM0DL3N4HczpTv24Wu9njPz YpOOuPYxk1/PqC+P0aw8jemL2u8K6Afn1Ldq9UzmKfTI3s8M0TD0NoM/FdN30ocP6PGYi+tbjTmx M68R1xM+LdsdZPBxZa2+1X+PDH4cge3JOTaDf1pc33WNPvwE02amXl+Bn2jSWc/E9a0e/IOz6nGV Ay8mN90YepvBPy+uP2jJ1bi+qH2GH4oe4vqLE5p0Rsk8Qs9dd9Koc6nAa9mOtXptxTX0NoN/ppsf h2XGPnxN5Gn5Lm+vG4/C3szE9bVRJ8TzugnnIINfgB+V7bCuhGOtDL3tQdjmAYLeUvt1KN3Bnc8N Oui2wx57zswru+wuisp/pQMz2Z2H/+4Q1x9k8Fmyo9Ijlk/vUzef0GfYSyYfp9ZC4WsGv3GApaG3 WfGXuvixdKf761mvFxf/ohXXi4u/itB3f543p/X6nZbqSjJPO/L2msyLZTuBvjP0NoN/hosfS3cS 129jH77U6zcL4voMYIjrc2feXDKvKH3dbQelj2U7K73N4J+p9nTxGdvHk2/o9iv8jO9PrNfvY2de iet3sutulMzTDP7Csp2htznGPxbXw8UH9JyXhw044uIjVr8o59fXuB6vcW6exvWNev1Bkw5ieNmA k9U9vTZq0kFcD0Ncj/cCdqo9lD6BP/z4449zam/obVb8ORc/TtMJLv6oJTfOwY8HWrYm6TTierr5 VeVbnXlsx2314C/I4NtsTx78uQ04tXQXXXwt3QH+kMBb2ocf6/Uj156ZfNzrQI2FyTzH9TaDfwL8 ow04UHuwye6858+fr4vK57i+tdVWW3KPxPXNDj2t3VPlW515MZkXMvidobcZ/Hngo4tfN+DANcce +9id13Dxc5NOHJQpaj9y8dP31j58wq7Ay467PZt0dG99qwe/80472yOy7T1Df9CLDxdfs/jcfAMF 1w04AJ9tuHLK7WgDztRQDZmZV9VeY3nM0JNkXm7OQTIP72t15h1pxzX0Niv+XEIvNurMufji1mfg sQiEXXez++vluuOUXLr2c3F9I5ln6G0G/4yYfrJRZ4mLH0692RbY1+k98bgrbdLpSzJvsl4/F9dj nVkY19tsBv+Iiz/ZqBOy+LzfNLrz1lMjtDop3ZW4vtWhR7WHK7+fi+vfv3/fiuudzLMZ/HNdfPTi z2TxN+Lixz78Yy7+ZOmO8Md6fZyZx7jeyTybwT9P7ZvbbeHezzTqbIKLr+fbbRoufgv62dIdVB59 +Neo1xt6m8E/Bn+cqPPy5cs6Uou9+LFRhy4+1Z8NOq3uPJbu1MWfUnmW7rQP/0i93tDbDP4C4A+S enGijm635Rgtbrdlo45k8bfhRNuD7jwZllmn6TCuB/ACfY7rudV2Yb3esNsM/gnwM6E3cvH1ykm5 Cn1o1KntuDMu/mR33lzp7rfffutbcb133NkM/g2oPRN6gB8uPkdka0JPxmhtQt1eE3qrBd15ky4+ 4/qFpTvH9TaDfy78Ue3xKFn8tQ7NLNn82LTDQy2za19Uv+nip5/Tt1x8jszmVlssAAtKdy2FN/Q2 g79A7bsuNOu0Enos30k2f6TywdVf4uI3u/MAv8b1C0t3ht1m8M9Ve7roVHsm9FjCa7n3LNsxmXfC Bpx9mJ+31+48xPXptV6z+DOlO8f1NoN/E2rPUVqs2dPFpzVUfiUJvWHGxd83uvP2RflH3XkfPnxw 6c5m8O9S7RnnE/jo4rNkp2o/+kU34OJD8WdcfENvM/i3pfYFfsJNtV9Lkw7VPkLfT7n4msW/IRff ZjP4SxeDlto3HtXFZ/Ze1b4blwQz9GVQZoa+5eLHLL5dfJvBvz21X7U8ANbtX79+na9JXbOS083X cp1O0cFnlZbcGtf3V4TXGXpU+ejiYzGwi2+z3V2MP5qjR8Vn/Z7KT8jFzUc3Xm3DFeCzIZ7Ho7tK 6u3LYyebb/ZzjTp28W0G/w7cfIX+zZs3I3f/2bNnK5bmWJ6Tvvv8WsngH+yvL8DX8djx2CsCz0Yd u/g22x3X8enm8/HNN99UsMsjw58grHE8S3alPj8wpm9twIGxPTdsvhm5+OLa28W3Gfxbiu+rmy9u OtW+Qp9Ud6UK3/zhV4dbsn22L0My62CNmaEa+3LsVXM8tl1821Oz25yyG0+tqcBnCf1T5Ufvw/Nk nXgJyO5l0NO9LiqDTsulm0/g4dazWw/3UHuccYfX4OLzKGu7+DYr/h3Yt99+m+F+8eJFvia17Qh/ AjG+vXbkdWE0djzHnnF9PPJKXXxut7WLbzP4t2zff//97NeLwmfAkkue3fkUFmQIS5kO174Mx6wP zL6nwsPVx3FXsRd/zsU/st3WZrOrf5tG6BU+JvAS3Fnd6fI33Pxe3XuN64+5+N5ua7Pi31xMv9g+ fvyYof/8+XOGPalzVXfZZNNrpj4ed4WjrPlcj7Ym/Ce6+B6nZXsytrkl8GuG/t///vfqr3/9K6ft oGa/LuW82qzDo67Yh8899ijlIdE3QPr7Pl/wgANQJurkhB7OqSf0HJjJGXqo2Zdjr7LaA/j0fPjX v/5lF99mxb8BWwTPTz/9VF38kq0fkjJntU+qX1WetXi68HwgludMfCq+Qs/y3cLDMOzi2xzj3/oq k0An8Hh8+vRpSCDWeB2uOIAtLb1QfKg9FoK15gTKz8kLBNQfyk7oeaXSc6IOoF9wGIaht9nVv4a7 PxqqCVcfL2KPDJ6nmHuVgF9pl176Wof7AvyqbLXNbj4Umwk/LA4CvJbuKvxQ+Xiy7REX38DbDP4N gV9f++9//9v95S9/GXXrEfzklrN+j0UgfwOAB9sEnrF9jO+D4u8JvZyA4yy+zXaHrv6o9FagzvV5 uvuA8sWLF3UDDhJ0qOOXRYB1fG3nzVay/zVD/8cff/Ss1Sv0KOGl+55hhV18m+32FH/K3e+S6sPl Z6tu7drD1xO8q2fPnuG1vN0Wbj/ccsbzqvhF7Xsk8LBYlIk6uTsPJUBCf+I59jabwb9h8Otrf/vb 3zqqOJ4j1gfwKNkB/gJ8nZ+HB1z0sgBU2AvwPct1eM7M/RHo7eLbbHcA/ijeV9VHrI/Xnj9/npWe G3MAP7r0SrY/T9ihlax/fiTg8+684uLnWB7hA0qCusc+/fzhP//5j2v2Ntstx/iM7w/ifFyRwEOs DzDxhaTOOXP/6tWrgYk8lO8Qu3MzjxpKgHgfoAbgzBdgMQD8CA0IPQ65nDjvzmpve9K2uuWf2yzv YX8+TsmF6mPiLj0AiDpn8cmW3fEPvirr5dg/LRr5ngsAa/Vw71MIMRh6m+1uwZ+L9Sv8aONNyr7m ZB4t92E8F8MBNYD9888/D9LIk6/YbYd8wMSOuxbsBt9m8O8w1j+An/P4dAHAG6fA544+As9y3fv3 75duvDH0NoN/n/DjSVwA8BoWgdYPBOiEPicp2sB3ht5mu3/wlywCB7P59J5WGnG64tJ3C2D3QZc2 2x2Dfwz+5kLw9u3b7vPnz83PVpJ23QTcht5meyDgT4G+9L5lwzXubbYnb5s7/F2rhYvBEhsWLgSG 3ma7Z/CXLADngm/gbbYH6Oqf8rtX14DfwNtsDxz8m/4MBt5me0TgX+fzGHab7QsAf+7zGXKbzWaz 2Ww2m81ms9lsNpvNZrPZbDabzWaz2Ww2m81ms9lsNpvNZrPZbDabzWaz2Ww2m81ms9lsNpvNZrPZ bDabzWaznWL/F2AA5WoaidGqrrAAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 1608 363)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 383,
    height: 229,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAX8AAADlCAYAAAC7zvf2AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAALtNJREFUeNrsndty28bTxAGQsqzY spM8QS5y58u8/2P4wlX/+spPkES2fIpI4NuBdtaN4exiQZHUqbuKBR4kmZbs37Z6ZmebhqIoiqIo iqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIo iqIoiqIoiqIoq5bfAoqiyLkqDfymUBRFkU+PeqEg/CmKInee4YJA+FMU9VC58pSd//BUfkgURRHw x/i8x8qo4Q7PEf4URT06wLcH/rrtkd/vqZz90seEP0VRD44D7R1eX/zau3fvqt7fjx8/Tsaz8/Pz HVi/f/++BPSa+yddBAh/iiLojw3wtgboOXhvNpvie557/Vhar9dD7rEsDmExyIF+eAiLAOFPUc8b 9PtAfhbwFu4W7BbY9nHf95PH2+02+z7tx55KXdclQK9WqwGf04VAr//73/+GAvyH+1gACH+Kej6w 3xvmznNtAHwV3PE+ghqBbgE+DEP2td9//30W+sdYEBD2qn///XcC/bZt02NZEHAxkFtcBBTsw8Lf Bgh/iqKOCnoX8gj4JXDH5xTq+Nyvv/7aesDGxx7McYGoef7O3/AIdvtYAa/Xq6urQV6Tx3rVhcAs AnMLwVEXAMKfop4u7NtDQd4DvOfcLdw9sOt9+zk5t4/Py/1Xr16dfAHwwP/ly5f0PMJe73/69Ck9 DvDvZxaBky8AhD9FPT7Y17r6thb0NZCvBbxcc2D3nheYlxYAC/8KyB+La4NdDBD2cv369etkAQi3 /vPnz+NVFgB9/uzsrF+wABD+FPVMgb84qlkC+hLklwIen/PAnlsU4nUC+ZcvX7qLQs0CcEznb8Ef vq9DfE6h33/79m28guvvr6+vx2v8DaA3C0DvgP+o7p/wp6inA/vxKrCvAb0Hebn/22+/JbgvAbz3 mgW73D8/P9/5mg7ks5HQixcv2vuMfW5ubhKgdQGQ+wJ2WQgi9EfQf//+XYE/On+5hd8E0n1dAML3 sI/7BE7m/tf8/0dRjwr2O67egv7q6qoK9OLmEfByldfD10sfVwN4qBG0CncLdoR6gOdkUQgw9yA/ fk6QhXkb/p5VkU8A651+WOF9upEPdP0k+IePDd+WXlx8An94bhv+bn1cFLb6fi8vL6X7p/n06VNK uDJ7HAbz9xpO8Y+RoqjTAn9v2Mu1xtG/fft2x80j5PW5X375pbXwR1gj4B33vgP7AOHWun8LefhY NwJyYH+K7H/IuP8U+4TvvcC/jwuBQl+uW3ksC0Bw+OP9APxt+E1gK1dx/dfX11t1/7JIOPHPUd0/ 4U9RpwH+QWCfi2+woFoDeg/yHsQR8hnAj3C3i4OFvdwPcKtaAPR1WAh2YqCFi8BB4h4LfXX+Cv7w sxhdf7htZREIHyPX8SaLgFxxAQh/vy0uAC9fvuwzxV/Cn6KekLt3M/sS7LEgW3L1HugV9vY5hLUF Pb4mOXsO/gbuTeb19Lz9uNICYL9HAZRL3f/B4B+B32BxV2Cv7l/BHxeBEfZBG10AwseN9yUCkt8G ZAH48uWLLgQl93+Uwi8zf4q6P3c/Xv/8888Ee+kd1xjHg70CzsL+v//+m4D94uKis6CXrB0hH17v ENDyegbyXczp0b2nm+Ty8nHyfhXuMaxvIyzT15On498LYe5+X1Lg3/ibw07Q5jnp8AngbtDth7+H XPvY5qnQb2NxV36O487eWKOQj1/JNTj8Ify8el20g/sfv3fyc4/jIA6e7xP+FHVa4Bfdvbr679+/ t16Mo1fpvhHTiE5fYB8+tsu5+gDrDh09gl4XgeA2O+vk5T1FgHcG8K0HeIh30i18jOvyncXA6+Vv BZzOQrADe1wcjuH+vYw//oxSd0+EeoJ+uI2rgHwPwntpYhF4/K0hLKyyEMj3vI8/j14XcJFc478J uwAcZTFg7ENRxwF+1t3bKMeLcS4vLzt0+gh6hT0+p7ANgMGPS/cd0Hfx+fT5AiSMcXQRsPEO5vnq 3M0i0HiZP0DdbevMPZfjlAd6EwvtrQh4dxFofmb8GPfI462Ne+J1I9fw3jZh4R2v4fu+CQZgI5FP +JltP3/+nKKfTNvnwXN/On+KqoP+XsC37t7rxvEy++Dsi7DX1x1X30F0ox/fyfsA0Hfq5qMTHR26 uFZ8Pbp4dPCT3wIwkrJwB6ee7oeP3fkeIcAF3GDmZ4HvGH95LweJeWLE03iO//avP7Qx7kk/Txnd IB8TJd9XdfDj916+l/Lz0ljP67aq/Hd5kAWA8KeoAwHfuvsAfNfd63/6N2/e7GT2CvIa2GsWr65e HgvAY3TTRWC7oEfAt7eBdZeDfHx94vZxAdD7JbiDI588HwGuz+2VSjhx0HCgn3/88rdfX0c4wCLQ x0Vv/P6pQ5c4R76P8j3Tq/e1X79+Labg3v6xE/4UgV9+rhr4c9k9RjkKfC28amavYK+FfczpBfSd Qlieb243Q41XAZA+lwE9vpbgL04eFwCn6NrWwh3APrs79666y9d1Fo7W/lYg3xesa+DfSV6L35/Z sRT3LcKfIvQXAj9CfwJ822+vgDXuvoNf9buLi4t0X6Au1wLsJxGOwl4+1gBdHX1aDHQRgM6azgG9 hfzEyTvRTgM7cJfA/S4ArHb0d3D/s39mBH/TTMc7pNdMK+iQe0/X19fjTl/Cn6IeTqxTBL7cvn79 OhvnCJitu4coZ4S4FGglqokQL8IeopouZvFddPXq3vV5gXQH0U0HBeUc6C3krYPHaKYE+IPuqp2B +aE7YIp/Nmb+EPsMsLlLHve6CUxiIr02u3OAJqOgj7EAEv4UtZ/LnxRt54D/+vVrzOeTe3/58qWC VxYCz9l3cVCZAr8G9lrgTc9DDt9BEbJTt18LeoB81Y7aQ0HWgXt2Y1OFq78zIL1uH+z6cbp9trjD F7uA4kawcT+ADH6TwjD+VvDPP//snAd8pMWN8KcI/JLb97p0tG8+B3x9XTdXKeAlchF3L65eP06c vcY1Auj43Aju2G6ZhT1GOPo1Nf5xXH2n0Q2C3nHzs7Nz7gL3PcE++RiNWmKnTS0c94anfGtKff5S 1I0F4HGsQ3O72WurLZ+xzXOrEz517o+OeZa5/wJ8LSLL19VDXszB70dbAAh/6jlCf3GOjxm+3kfg C1Rjdp/cfVwAFO4Y43Sxf76L7ZUddOJ0GdhPCroa4XS3PYkpuzetl7WOvsbdF52pNwOn8DGDB/X4 vlzg6u7aisWk8RaNvVYwzbjMe9MYJ0J/MH3+vY5zCB+uYx3GRUB29eosf3X+ctqXLgKFvw8Pc6Go Y8Y6XlumABwzfL0ah9/p5ip9rO5e3Xx08ZMsH55Lj6NL7zSzx+4djXcas6kqk9O7HSd7gn4O8oMH d41OPOjD88PMwpB7fckisDdEZ2b7aL6P7n4bI57JPB+Z5RMnfMrmrnGej9xktj/O9vn48aM31+co vwXQ+VPP0uX/8ccfxVhH2zK1aIsFW3X4WKyV/+MC/CZm9xjviOQ5+dwI9fEGXTodxjjyWnwfmOW3 4Px3CrcZVz8H+qES9FnII+Cta1eHbEGvYB9u33xy1fbPw6Ko/fNlXs5gNwYcpxaALZ6TqZ76nqOT H3N9iYN0hLNO9VTwx/sp/omuv4/HPQ6Q+w/NCWb70PlTjx36NR07O9066PJxM5Xm+PqcwFuKtprh n5+fdxjpWIcf/gOv0O0bx59cPjj7ruDsO3Tx0mZ5B1dfG9tMDioBB+9C3HHvA7r2zOs7rzl/hrvY 5OKleKDKkoVgEfi99xH/zDTd0xR30zz/CPs0zjmOcN4G+Pc4zz/j+puGI50pAn9/lz8X6yjs1dmj y9dYJwf8+HjlxDvpJrBHyCvco3vH+Tkpw5ffKmxMtdDV14DeHVqWA7UH7NwCYKZfFhcDvG/jldKC UKg1FCOcGuVO8nL6+Mfop4nD3rS4Kxm/3BfnL8c5ytUDv7h+mOXfN/45vhzsRhH6FS7fzfIjzCfd OjbHxz58Bb6CXfvvAfjjaxb48FyLC0B07x3m+Oj4zW7RdsmQsxzsc6CHPL0IenDk3gJQBLx3FaCa 5yeO3kJeD02Z+Y3g6PsAnDN8J/DX+7GomxYCPcNXXH+89gXwn/QMX8KfemzRjr3vZvkCfcnda1w+ xDoIfHT5O65enrMOX57TTL/g7ru4CStbuK38/1kF+5Kjh+MHJ1FNA8VM/Drx0JKhBHjvY/R92UWg ZgGwz8lVzhguuP+jgt/+ufH9TA5xl/sC/biBKx3WLhm/Pkbwn5+fD6c+vJ3wpx4j9LN9+XNZvufy vVhHcnuIdVbW1VvoB60s8LXIW3D31tlnT6Va0GFjB49ZR9/D66Lec/O6eSkHeecIQy8G8T6m8R4H t2wXiGy8k3P7eF+GpR1wvEMx/9f3rP360r8PReDx/vX1dY/PzYDfxj2EP0XoG1DuFHCxY8dz+Tng O7HOCHiNbyCzt48x0pkAH2KekrvHIi7OjMkCvxL2bnRjgd78HE0wOZbQgXxfC3gLdyci2XH0HuAN wKsWANXCcQl7u385dQ3fvy4AuhiI00foxx7/AY5rrHH7wyn+w1HUo4B+roCroC+5fO3WkSP1sHgL OX1y/ZLhAOBXC4Hfee4eYW8lpz4VgF8F+/52S+8OzCtAv/NaLeRLGTgC3oN6ztnbNk+Er7jrU8O/ FP/on6ctm//+++9kMVDoazvnx48fl+T7hD/1LKFf7NrBAq705de6fAt8hLx1/QD8lQIfMvzORDpd 4590VRznC9B3u2bi6657V9ib53t0+86mJPz43natFCA/+VgLdpt/e87eg7o6aA+opWw/B/ljwd9+ XXn8999/N3ax0vsIfHnsQL+5L/AT/tRDgX62iGvz/Fy0o6D3XL6B/sppz1zZWMfk+JOYx8nwOwv8 udntJeDr0LDGmSBZgr0FerM7gmBy9mzO7WsOb+GvxUwBvM3vc/EHOvU5V48O2oOuXhW4JdAfIfMv LgS6AUyfV+BDvNM08y2cJwM/4U89FOjPFnEV+qVoJ3zsynbsBMivPJefyfVXhVhHu3Q6A/zGZPvF 2CDTYpnN5mEh6CGqcWEfNxhln7fPYWSjC4Ln4j3II8C1yGnhXwI7wlNjEm9hKEFegXtK94+ykzjx cSzk1jr7k8zyIfyphwr9SRFXxh/bPF8gfnl52cbMfifaUdBjdm8dv3X54vAB7uPzXo6PA9Qyu273 Bj7m8rcDOnfcfY9gN1DHRWHH1VvHD46+R5jHDUl7QR4fW7iXwJ5zz95rmZHH2eePKQG793zs2qlx 8ffm9gl/6sFB3yvi4ogFcfr6WF2+V8CF8Qqrgstf2Sy/EOt0RwC+gravcfd4a+DwEAf21tUj4Ht0 9J7Tt+2KtZDHAmcO7jmwl9zzHGwd4J5KS2cIze1DGO77PyhF3Tv0vSKul+e/ePFi4uwV/hH0sy5f Pu6Qsc4M8G1Mg3PgBw/s6PDN1Mga2Pc2o7cLgAd6G9cshbzNvS3MLdg9qGdgfi8nXR14cRge2nsl /KljQh9BXwX9XBEX83x0+Rrn6H3H6Ve5/H1inYXA7wvPTZy9fc5bBHKwL7n6b9++9XOgl5ucLOV1 5mjLonXwOcBbuDtgH44A8IcK/4f2Hgl/6qjQnwB/DvpYxMVoB/N8dfZetAMF2xWOWljg8o8KfDjj 1Y10FO46HCxOjOzhNCgF/sTZS17fQEeO/DXR0SPsS6Cfc/LYweIB3hQ47+J2hyPD9yEuCIQ/9eSg 30Tod3PQt0VcjXYcp2+dvbcAlDZmeTtucYrmEuBPMvgZ4E9gXxPxSIEW4a/uHh8j7PWxl9FfXV3t FHFtT7p18HpVyDuAr824Twl/gp7wp07wb6YtQV9bNrV7Zw76Anos4orjd/L8VSbaWTkdO92+xdvS blpTtN0b+Nbto7tHZ4/xjowLyMEeXb3daWqjG3T0mTbFOSe/j7N/rGAfnvp/ZIpa6vZz5+GmPn2d rqmOvgR9uWp/fry/snl+dPdYxPW6eCYtmjhkLYJvicvvbVtmJq/PAX+LgPeye+vuNcrRBcBm9jgv Zomr9xx9RVyzFPIDQUv4U08/4qmCPnbvSJafgX7q3LEuvxb4uDlrJtZpETJmhAKOVnAjHXD8Wwt8 Pcc1B3x5zmb3OXeP8Ed3L3PhczNkcq4+4+iPHeEQ6oQ/9cSgj/DfKeYK+C305fby5csVZvq10LcF XW+DlufyzWlYOyByoN97sU7ceOVFONsah4/A1zNcNbvfx917sN/D1R+j+4aAJ/ypJx7xZKGPO3J1 cxZ27wD03Xgngn5tRjKsoGtn5RRwO8fle/++B5ir01e4/KzDvz1/fZvcfg3wMc4puXtx9hb2Cnk7 MKwA+2OCnpAn/KlnBv1JxPP9+/cOO3hw9o7CXsGP3TsV0F/pcLUC9O0Ihrbw73rwXH58bsflK+zh ua13QDc6/hLwc3EOunud/+65+5kYZ1/YP4fOG4rwp+4Q8exVzIWIJ8G+FvqwIWsS9djOnRmXX4K+ t6lq6xVqnRx/cr8G+Lk45/Pnz32tuz8B7Al6wp8i9Jfn+uLuTcSz0h25Cvtwf10LfXX8kOd75+Dm jjx05+AD9F2XDw4fY54t5Phb2ISV4F8CPh7p58U5JXefGQd8CNgT9PyPT/Hnn4929D5u0sJc3yvm CuyxmOvBHnL8dSX0U/dOCfqxHXMC/YXF2m0u1vFcvgJfM/x9gL+nuyfsKcKfOn7Eg5u0LPQzxdzk 9M0CsFbAx+u6Bvoa7XgbsqAH3zv4JAf8rcnyt+Dy3VgHXf6PHz9Sl873798T/JcAf6G7XwJ7gp4i /Km93H5Vrq/9+raYK7mOdfoIe9u+eWTobzHaQcirq1eXb11/LtaxnToK/T2Av9TdE/YU4U+dLuKZ y/W9Yi5A38J+nenZt9DvbLRjIp6U6Zs8f9s4eX6EfoJ8vD+CXXL8nMv3Yh0dqaBXW7RdCHy6e4rw p07yM27vEvGUcn1TzE3xDi4AUNhNM3hmoJ924mag3ztFXIx2Rqcf3by3AIz3Sy7fxjpy1bZM7Nw5 EPAJe4rwpx5GxOP163u5/kwxd9LNgwekO9DH9z3UQD/C3ItzJo8x2rHQz7l8Bfz19fVkHr487xVt DwR8wp4i/KmDQD/r9nWjVi7iKfTrr51cP7cAjE6/8efqtwXoN+ZMWw/6kzwfXb5CHto0J1FP+LO3 cy6/JtYxRVsCnyL8qcfh9pdEPAB47NFfg7tfO8XcnYPRzdGI7V2gH6Mez+Wn+zHPx2hnm8vy1eWX Yp0A/BzsD9WLT1GEP3U4t+8VdEtdPE4Rd2cBwFwfox5bzM1Af3Jc4D7QN0XcrenbTy5f2zTlvkLf Zvk4Iz/8htMvjHUIfIrwpx6m288VdBH6GPFkWje1oLtvrj/9CwTQHgr6Xp4vjt/m+XJFl68LwAFi HQKfIvyph+/2EfpzEY9x+Gvbr+8cqNLlevXNrtweWja3d4G+l+cHgG+9Ai66fLmK01eX//Hjx2FB rEPgU4Q/9TjcPhZ0K7p43NbNuAB4M/bTKVrW7dt4p4ExDNqnPwP9jcn0e5Pvu3l+7M6ZRDu2Y6fC 5d/l8BOKIvypo4B/1u2/efNGnhvBjwXd4HjXhS4eL+JZz/Tr77h96/QL0E89+jPQl9w+xTtyX8cu qNO3Lj8X7dzR5RP4FOFP3WvMs7fb1w1aeFVnb3bpTqCfi3jQ7Zeg39xuzMI5Ox705bqZg74t4ua6 dgrRDl0+RfhTj9Pte3371u3nCroIfs/117RuKvRhtPKdoC/3w9fdGOhrpFOEfq5rZ2G0Q+BThD/1 IH5Gbcnte337ntsP13WhoDve14JubcRjwQ9D17xzcLdmomZy904hd7MP9G2en4l2ajp2CHyK8Kce hNtvLPjv4vZNQXftZPwY8az0QJUc9Jufoxh6ODlr60zZ3OIYhvD0Jte9o67fFnL3gD5dPkUR/o87 5nn37l375cuXLrdLF8FfcPsW9mmnrjx2Ip4a6Nte/Z14B6FvXb8H/QM4fUKfogj/Rwf9bMyDRd3X r18L4Mf+/fPz85X27Wsnj+f2taDrjGhY2YjH5vrjm6rv4Nlx+AD6zQOAPoFPEf7U44x5wv0VbthS 6DuF3An4bUHXRDxzrZsY8fTm3FvP4ee6dza2T5/QpyjCnzHPLfS7UlFXbuL4dZeuxDzat++5fThG EYu7uFHLTt1E6Odm8GzNoLXxvsDeLACbUqaPffoHgj6jHYoi/B93zDNX1NV4R2DvuX3bvw+TOVdN fgBb1u3bw1MU/E6Wn9y+bd+UMQxy/8jQJ/ApivB/fDFPbVEXTtRazy0AntuPxd3Z4Wv20HMv1zcd PBvs1Yf2zTHeCX/HLaFPUYQ/Y55MzPPq1atVqagbxzNgvOO5/jm3nzs+cedQdAW8wt7GOgD9jUJf c30cuCb3CX2KIvyfK/gXxTzo9qFff8ftm7799YzbnxysUuH2NxDrbGyu70Q8O7m+npil9wl9iiL8 nzr0XfBjN49A3ot5rNv3irrR7a8XuP0GHH+fcfuTIq6NeBT2HvS1g0cjHoS+HcNA6FMU4f+U3X6C f27TViHmyWb6mTENq1q3jzP2FfbNbc/+JhZ0N7oAOK5/4+X66PTlvp6NK48JfYoi/BnzFGIe7N0v xTzg+LXwm/r27+r2Dew3cxGPgN4r5upoZZ2yaY5IJPQpivB/+uC3m7Zkt+7CmOes0MM/gj+6/TY6 /x2339wWdXvM9iHasW5/A22cdgFIEY+6fblKB+rV1dWAuf6LFy/6zLm4hD5FEf5P4ntbBP/cpi2M eaCH/yzT1bMziTPj9hP4ceKmt0HLun3M9WPv/saLeOQ6k+v3M9An+CmK8H/Ubn8Cfi/fl5gnOOaV t2mrFPMEoJ7hxi1T1F3Vuv3m5/TNbSbb38Q8f1LQlStGPAp9G/HM5PqEPkUR/k825mka6N/P5fvB 7a+dTVvFmKeiqHsQt+/17IfrBiOeCPrtp0+fUr9+Ra5P6FMU4f8kwZ8t7Np8Pzy/VvA7m7bOCpu3 VrBjV0/YyhZ1deomnp4V2zV33H7cvOVm+1rQtREP9uuHv1fPYi5FEf7PFvxe/34p34frmenhP9NO HgT/nNuHFs7JjH3s1c+5/Zjrb3IF3TtEPIQ+RRH+Tw/8ku//+PFjUtjVfF/798Xte/m+E++cHSDm SS2cGO/YBQAzflwASgXdQhcPc32KIvyf7PfPBb8t7OqhK7aN0+b7CnrH+WM3T4p5vKIuxDw7LZxQ 0N1Akdd29CjsN+r2w0K2rSjo9g1zfYoi/J+J23fBb0/b0kNXLPhNvn/mOP20aWufmCdT1LWZ/k7c Ewu7m5LbLxR0GfFQFOH/5GOeBP9cRw+CHwu7AaBnNt+XqzObZ71nzOMVdTee29d4Z4nbLxR06fYp ivB/0uCv7ugJwF87hd0J8LGrJzN/vzrmyRV1nUw/LQA1nTx0+xRF+BP8mY6ey8vLFfTv62C2Ut++ F/fYQ9V109ZcN88E/Nbl42PN972+fR3NIH37C90+oU9RhP/TBn+po6e2sIvXffL9BTHPDbp93aWr Mc8d3D4jHop6JFrzW3Aa8NuNW+HzzhT84u7lcbymtk4A/zimIc7m6cx7G+ymrfAxG4W+3Ffoy325 Kfj1KpCXFSC8tpWduQJ+uarblyvdPkXR+RP8C1o5dVSD7eixbj/O58F+fox5OifmQfBjvr/JxTwB 9jeQ6Y/jGbyirs7ap9unKMKf358C+EutnJmOnrNM3LMu9O9PflYC+5jv407djY15EPheUVfyfcz2 dSYPs32KIvz5vZkBv9fKubCj52xpYdfm+3bTlmb7Xu8+DGUbwS+OX1s4Neef2aVLt09Rj1wrfgsO A/4Y9SD4JeE5i8A/i4BP1/D8C3h+cvqW/Fwyjn+S74vLl5xe3b7GPOL2FfxyDR97E97Ljfbui8Ki tBHoy+dLph/Bnxx/uA2vXr3qP3z4QLdPUXT+BL8F/9u3b1NhN9PKuRPx2D5+dPzxuMWuUNidy/dv rPP3Yh7t5qls4WTfPkUR/s8X/HbXrgU/5vtiruMCMELey/edAW3ZfL/5eejK1kQ9Xr5/UxPzhEVs u7CoS+hT1BMRWz0rwP/XX3+1V1dXs+CXfF+uogBxzfGT05eOHgP+VQ34Y3HX9u+PwIc2zpvY2jle Nd7Rbh6JecTty+eL25dunljgpdunKDp/fh/uAn5t5RTXj04fZ/TgkYsG/LhTeGjKhV27S/cGN2/p 3H3ctBXc/saLeVjUpShCj9+DCvDjuAYp7GIPP+b7EfhzrZyz4DdjGvSErZ1c3+b7OHdf8/3wfidt nAJ9Keq+f/+eRV2KIvwJ/qXgD6+dqeOHVs4zr5UzAHydKexa8G8Lhd0bM6bhxuT7m7lNW4x5KIrw 4999D/B7UY/p7BkXgAj7ScYv1+b2fF0P/H2psCuZfi7qkbdhu3kqN23R7VPUM9Nz7fM/FvgF+C8E +uFrJfDLVR0/zuJ3oh4L/smIBi3mho+9iYuBVJdHxy8FXeno0f59gb7A/vr6esz5JeKRfD/cJN/v GfNQFOFP8B8O/GexoDuCH+IeC36cyong11ENAvgtAl9ADxu4tI3zJnwcgn+S72vUk9m0xZiHohh9 EPxLwW/m9CD419jSmWnlzIF/p6PHFnS9wi7272u+X9HGOWRAT/BTFOFP8C8Bv3f6Fjh+29GDm7c8 8N/AtVjYDe95ozN5JOZZ0MZJt09RjH2eJ/jl9urVq3sBP2b8cQb/JtPRcxPn7utV5/Mkty/3MeYB 8DPfpyjqWTr/RSMbTgX+TA9/cvx2OJs6f7tjVzduoeN3+veZ71MU9aycf80JXN1S8Avwm9tuHj2A pSbjz23e2kTnf6MFXgG9AF9u4XNSYVdbOUuFXcn3Ly4uBgN+5vsURT0b57/3dM458OucnsribgKt B/5cxq/uP/bv3+iOXW3lVMcfwL9l/z5FUXT+Bwa/TubUqAcd/0Lw4zjmDRR3d7p5bMyjHT0S98T5 +1uJecL7TPl+7N8n+CmKqtJTnOp5J/Db83Yzffz7gt/dvKXAx15+LfBiR4/EPYWOHhZ2KYqqVvcM Yp9FB7EsBL83knkC/Rnw34TP+U87evCq4JeYR1s5Bf4W/FLYBfDLrSf4KYp6brFPWwt+OXpxdbtL ys7jP1sA/nU8ZH2Ff1YE/whjGNCWJnJKWyfs2k0FXty9q+DHGT06qkGgrzt2WdilKOq5xz6t8xi7 elpp6bRn7ubm8S8FP7R0juC3B7DoQeoR/BPgw+atG+zokRn8crWtnFLYDe+7pqOH0Kco6knHPsWc X8AfHHRy/G/evBmvFvwC/AXgXy0Bv07kjIVduf6n4I+btxD8Gz18RVo5CX6Kohj7LAN/9+eff07A L7384f7o+mX4WizyntmunnjQug5p88DfzYE/7trdxmJudtcujmPGqMcevkLwUxR1rKjkSTl+2b2L 4JeoR8Ev0JfefZE6fjyBS2fyw3TOCfjtLH4P/LBrdwJ8KO5Ooh576pbt4Sf4KYo6lB5z5l81tkEa bTTqkWKvBb9APx6yjkcvpnn8hwQ/Zv2e45fNWwJ93LylrZwR/D0AnuCnKOrZOf/F83qgpXPcxBWU du0i+MNVDmNZQ9a/dsCfRjIvBH826tFduwL/q6urXA8/Z/RQFHUQPdbMv9jSaef1WPBLgdfu2sUF 4Fjgl6vAX1o87clbleBnKydFUQfRY+z2qe7ll01cOqjt5cuXaRNXdPzreN7ueIPIZ10B/gTdJeDH OT1zjt/ZvEXwUxT1bJ2/jXtqN3FNHL9X2DVXgf8qTuycHdkQ2zm3M45/MqcnAF7B33vgZ2GXoqhj 6jEVfNvSIqCbuAJkW2cT1wp6+SfOv5mOZsazdqtn9Wgffwn8eOSigF+6emQDF7ZyEvwURTH2mQc/ FnirNnHFXn4Fvzp/jXkw51+ZkQ058G807tENXF7UUwK/XMP73BL8FEUx9snDf1Evv9nENdm9q10+ GvWA85fFQRZFd1CbPYELRjakgW2xnXODnT0W/Dqnp3DyFsFPUdSzjn2K4J/r5ZcFIPbzY5EXj1+c jGZW6DvgH2Aef8r3dVYPHLSepnJKV08O/Ny1S1EUY589wC8FXuzlj+BfaWdPgPxKN3HZqEc7euK5 u6uK0cyDOYhFwX+TA7/28RP8FEUR/vuBv7Hgl5vt7NGWTtPZk07iilGPHrKuu3dT1BMndHZxVs/P P3T36EU9gQuLvJORDQp+OXlLRzbY4i7BT1EU4V8G/05njxR4vfHM2ssfnPbK6eU/c5y/On4Efwvg nzuI5cbM7Nk40zlHp6/FXYKfoijCf1ns43b2YEsnnsSFLl+yfXX5eC1t4tJTuMLd3oBfJ3NO5vHP jWxQxw9zegh+iqLuTQ+x26e6s0dGNwjwhbkS40Twa0ePQP6FFnXD63p/7fT0u+CH3btbGNE8OWRd u3tiZ88Y+eR27i44fYvgpyjqWTn/2QIvdvZAzr+Swq3p5Ve3v9PKib38HvgbZ2yDRDxa2HWGtU3G MpdGNhD8FEUR/j74Gwv+xinwep09An2T9Y8LALZyxs1bXezl35nV0/w8d3cbr6m4q9GPM6XTPYiF 4KcoivC/wyJgC7yXl5fusDYRwH4EvywEXktn7OXHAi9u4uqxq0eLu+r8BfjymhZ5LfjlbRD8FEUR /neIe3IFXgE/tnSi28eNW9b5x86etgD+LbZwmquNfIoncBH8FEU9VD2Egu/eBV4d3RDz/XRtbufz v9DfAEzO783ld8c26Lm7Cntb3PUOW7cncH348IHgpyiKzn8u4sEbFnjNRi6vwKs7eNdw4PqksFvY vTsUxjZovJOKu17Uo4etLzyIheCnKIqxD4L/jz/+mBR4X716NVfg1R28Z3E426rQ2dM207ENWzuX P+b6k8KumdC5xYxfd+/K+kLwUxRF+C+Le5oGCrw6m18KvAHC3UyBN13h/ir+Hb2Z/IPZxLWFTVwa 9aSYR644mjksTGPUk5vXQ/BTFEX414F/djZ/4RjGM8z3M8Padmbzay8/tnRqgVejHt29q7388puB 9vEXBrX1BD9FUYS/D/7Ggr8xOT/O5vdGN+gVnP9OO6fp7Bkap6VTs35dAOy8Hju2QcCv83oyg9qa DOwJfoqiGPvYxzbnlwKvXGPOL05fFoA0tA128LojG3Ize+wRjHZgmxZ59YoTOtX1V45mJvgpiiL8 5+KeXM4f+/lXzg7etbeDV67ODl73QBbczKU5v9fLj509CP6ZQW0EP0VRzx7+2bhHT+TK5fx2RDNE Pmewg9c7jcvr7MEC75j1a2ePXBX4uHsXN3FJjXmPA9cpiqKefezTNk7OL3GPZv3az1+Z86/NyIad nL/Q2TNx/HKV57WjJ4B/iy2d3L1LURThf7e4Jz1fmtsjGX8m55+0c+rVOYZxBH/jdPZsJV+6HeNw A5092ZZO7eXHTVwEP0VRhP8ezh/bOsWpxzHNOwPbcpM6dSMXFnidBWbwOnvgJK6N19mTa+nkJi6K ogj//V3/pK1T4x5s64w5v+zkXcWcfxWd/8pM6tRNXCP48Qxeu4PXOYoxOX/s7Jlr6Qzgp+OnKIrw X7gAjPe97h65XlxcdN7cHtvPDzm/7ee34J+MaHamdG68Am+upZPgpyiK8K+H/iTuacxmLmnpNHHP OLjNuv0IfY17vHk9Cfy5Aq+6fB3aFh2/O57Za+lsyv37BD9FUYS/swCMj22R9/Xr151O7pyLewT6 6vw17oHxDQn8udENCn4YzXyTG9ZW2dJJ8FMURfhXuP5GwS/AFtcvN4l7sLtHAC8LQIx7VnZ8g3b1 GOhrZ89QGt2Ap3Ap9O/Y2UPwUxRF+JcWBHX9GvlcXl5qb/8Y4chCoM4/uv2dfL/5OaWzDS9P3LdT 4E1jmiHmwWMYtxr37NnZQ/BTFEX4G9dv3X+j4BfHjs5fbur44yKQ4h3N9mVkA87ssUcxOgVejXxu agq8e3b2UBRFEf6ZhWCnw0c4rVl/gGynrj9AN4E/QLkDp98Z199ozNNH2dO4dAevae3EHbzZAq8B f87pcxGgKIrwn1sEsK9fnT+6fx3P4N10A5eJeRo5grGJY5qhwLut3MHrFnidzh6Cn6Iown/fyEck TBbga19/hH4bYNuq+4+Ov41RT5rTo4sFwDe1c+YOZdH7pR28tsDLzh6Kogj/A0c+0a0n939xcZGg byCPmf5OR4/ex4zfHseog9qwwwdn8+cKvOzsoSiK8D+wFPrJQv90820AMd63vz3obw4p4lHYaytn jHkmbl+uWOBV8Gvcs7DAS/BTFEX47wN+uf72228I/SZAd+c3BVwgotPXiGfcwCU3jXl0EQifg509 I+x1Q5c3ovnz588j+KWbNLZ0MuKhKIrwP6BS5BMLvOP9V69eNVj4nXzCdMPWYB2/df7x+MUbjHx0 bIMWd23Ob3fwNrtHMLLAS1EU4V8Dee/Jd+/eLf5CgdeY7/e3vziI4d9KNq8uP0Ffi7tmA1cCP07q XJDzE/wURT1Jre/7DUDhNoE3wj45/aBGWjzlt4NY3N2Z4YNRj4Ifd/AK8NX1a2cPc36Kouj870Ff vnwZrwHKI3SDSR8zfb3GXn1dADYx6sE5PaPz12MYwfHfeGfwhtf7mZyf4Kcois7/WE5fohbr+gXM smFLrsHh93Eez7gvQCAtGi0/fA11/uGlreP4JwVecf5yBm+4n3L+jx8/zp3GRVEURee/r96/f98I wBX6//zzTwPQH8Er7l/AH4A9gl8kV3XzWsRVV2+dfyzu3pisf2dSJ+b8Tb64y0WAoig6/wUSYLal 56NjH6Evt2/fvo0uXIy9OPk4jK2NUc/o+GWgm3z+bQrUyuMG46HwmsBdeL+NxzCOvwlIxi+OX27M +SmKon5qdYxkB67p9vvvv+tUzxHkAfptgP7Y4hmv48TPAG9p6xlvEfJj4iM3ce8CfIG93OJvBmM9 IEY/Y3FXruL25Tn5HM35xe0H+A//93//x5yfoijC/4jwT8/9/fffza+//qqD3MZr3NzV/vfff+Pu XnkgnT2yAIikBiA5v0BbFwGJhgT44vIF7vIpmu/rAiCOP4J/MqmTOT9FUdStjlnwxQhovC8Ql/59 iXvi7HwZ6ywwl2mdabEIIJe2TnHpKe6xh7PH7L4PC8d4jc4+FXflsRR4KzZy2fdMURRF538A959G Noj7l/gHd/leXFyM/fsC/HCTCCgVgyXzl5tENdHx97EoPDp+7QpSty+bwCTmEfhL1CMLAx7F+OHD B+b8FEVRzWlaPRGqyf0LlOWJ4P6bN2/epA+Qrh+Je8KiIMXccbJn+HhcUAaNgeQmrZuyIMjXkyt2 9SD4eRQjRVHUrkM/lfsfbzLeOUC7k0Pc9SzfsADIEVt6pGOrI55/+eWXNAZartot9PXr10HjH73C Bq5xE1cG/E3DuT0URdH5n0QTuJ6fn4+ze4TpsgDIVX4DkJz/8vJyiAVh6fBpw28CO3m/LAASBel9 gb7cF9cfXxuhXwB/Q/BTFEXnfzr3n+6/e/eu/fLlS6dHO8oigJ1Ab9++TUc+4hfUjWJyvbq6SguA un3dwDXT1cO4h6Iowv9E8G+8BUCcvURAMf5p8bAXvS/z/0W6M1jhD+BP0Dfzegh+iqKoe4D/7ALQ xBqA/AagvwXIi7IQ6ALgOX8Bvj420G+ausIu4U9RFOF/oj8juwDIAzznV685xdk8TQb69j7BT1EU dWL41ywAO1dZCEpf0AC/5krwUxRF3cMig7cu3lZwW8PtDG9//fXXmX0u3vBz9Ot0cLN/LkVRFHUP QGwLf3a7x/uqjXXo9imKokCre/gz2wMuQsPCxxRFUVRzv1FIe6D3NFQ+R1EURT0A+B/jPRD6FEVR jwT+d30/BD5FUdQjh3/N+yPsKYqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqi KIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiKIqiqBr9vwADAPg3 uH1OFOgQAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 1577 319)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 226,
    height: 238,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOIAAADuCAYAAAAk0tusAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJTZJREFUeNrsnUtvJMcRhKublFbS 6gVZECDoIgN70///KTpZB998MGBIq9U+ZHPaHcWKUnROVU+Tu8tlz0QC7Z4Zch4rz8fIjMyqTsnh cDgcDofD4XA4HA6Hw+FwOBwOh8PhcDgcDofD4XA4HA6Hw+FwOBwOh8PhcDgcDofD4XA4HA7H6Rh2 +Lkm/9/mMIiP73MYTIdBfETvbyAdBvEdvO/wjuAzkA6DeMf3G97i80x3vO9wXDyIa8AN9/g8a9AZ SIdBvAOEw1uAqIBNJx4zjI6LB/GU8g0RyGfPnp38TL/88svUAG86oY6G0XHxIK6d8zEDmP73v//l x3luxfX19cTzDKRCOHVUcTKIjksGMSrgEXxUQICH43A45Mdubm7qc/HYOI4Voqurq3wbjwHGAmRU RsPoMIin1K8o4AJAwIfzNE0DAcT5m2++Sf/5z38S4csvNAwTbgPKBpAtGA2i4yJB3AThn3/+OSqA 8+0R56+//rqCqAHofv311wwijhnEA4H8+OOPD4DxyZMn088//zxtUEeH49HE9QPB3oUQ8AG6+Ri/ /PLLfH/+2UIVVQ2fPn2aIXzx4sUB0ALGOaZSW+J8aHyGqby/IXRcjCKuGTJjhBDHF198MVINecYx Q5eYqgK+ly9fTqqGBHKG9ID7H330UVbITz755NBIU52iOh5tXL1nEBfHrHhjqQszeLg/A3Q1364H lHFOL/Fwvs3HcMypZz7++9//ZgUFpDN06dNPP02vX78GtFBOQJu+/fZb1JbTA9bEDsejSU2Hzhc+ p6QzLMMMUYVwVsYM2QxmPs9QjQW+ChkV8c2bN1UNUQ9CBfF6Wd7m35lfLz1//lzf89D4HJN8Pqui 42wV8ZQajqUmhLJlBQSEs6LNXI1XM1B47HpOMa9wv6geHh/zL1xd5dcgnPPvDTOUaYY7w/jZZ59l ZSzApu+++46O62RVdFy6WZOohqgLi3qNVEZAWBTxqgA4FgBHgMbXmH8/13hwRmfIDkhP5/s383MT lJMAIvC6cFLLYMAU4LMqOi5SEUdVQ6gg1RDwzfBcE0Kc5+MaP58fz/eLIuJ+VsUC1zD/DhxTwJ1r Q6gijBrUi0hjS704dVTR4XhUMb7n+nD46aef8g2q4VdffZXPNGWK8mXo5rjGARjL8ZE89lGBNN9H Covn4D7OqC+hrEx9y3sMMi533+Fyh2NXitisD2fwYMqMZXoG0BGYXAcCqPmcwRIVzLDhflTE0lvE HSgieo2YO0UPMaGZjxQWqeqsird/af5SxWnlMzsc518jIjg9w/OcQuY2xscffzwSUMBZ1I9GDUwd DoJPZbRtnM83ABCNfNSM+Nn8OjgfSqsDqekhqKJrQsdFpKZNleQsqaalTE3L7eygljSz1oUxTZ35 +wjKKffzmSlqAfAK6S7e7/PPP6cK589QUmSnp47LA5H1oUZpM2QYoYZUvgITIaRxg/Q1Q4d0lQCW n/NcAebrCeR1RcecqrbWQBpIx0UoYjVqyjyprrBYnNGqAJDoFRbjJqtiqRGvb9uIt/cFwmtVU6S2 eA20RDg610hPHY7LBLFXLyqAVEaaMwW4fGaznwoJCFU5C4z5+aw5CaDTU4dBlMC6Ql1vCGdTVREH 1FBVMWXTcySMFUBpbxDWsfQia2oqLYxxQ3rqcFyeIlINCQWcUcBEMMttQkilHIsiVjVUVaTrSmVE HVpmWocN6amhdFwGiFxl3wGyDm+XdsUgP6vparndPKiMOJ48eTK00tOegeRwfOi4flDqZe+ZFpTD 7bDoUBb8DgQLt8uvwZBBMx+/P5VFwYeiijdlSucoPVVFLOmp9hTdX3RchiJyb5n8rS9LmcLt5tRL BLLcZ9pa60n+HGsVCSCez/RU3dOQjtq4cZw/iNg7htsfxsBg9oI6AVIUMKmZU1JTBbMaNYBQU9U1 99TQOS7arIGI8RDwprLXTI0ZGAKZ1MBhzVhApSpeyUDAqOkp09KYnpZNjK2GjrMEMe6qPSmATEdV /UJqqvd7EaFk+tpMT9ncD6s+1tJTh+NsFHEBElZE8PZvv/2WQfvjjz8qkFgtoUByuBu3sdawAc2i 51j+DawXr1rpKQ4MmG9ITw2l4yxT07o9PlUxHqKGh2jehLoxpqoDt9AIbQynpw6D2DBsUgFpUR/i 0A2hcJRasZuiAiSsgqJxU6BsuqcKK9PTuIu401PHuYLYvIKvOqdlZ+4D9yUtSngQVTyUtBTnQwfK 2tpIS0d1jO4pmvt0TTllgxdweuq4FEVsGjasE8tmwQdRw4OoYb3N15B6saoiYYs9RZo1sbnPXQI8 BO64FBAXDioMm16diN0vcKg6Qg3FsIm7dB+ZN62RN4WQs6e6lw1ewGsUHRdTI8Y6UdWRAP75558Z wnL/0DFvFnuTQhVLzZhrRfYW2dyXZVV19lTTU69RdJw7iKt1Ig0bXslphvBAJcRR2he5Pox1YmMc 7kgRJT29aqWnbGdgX1W7p45LUcSTdSJ+zvQUdaJAWR1UpqecuIkghnnUbnqq7qlnTx2XZNbU27g6 U6wTCSCOWaEWyljqxIM6qRFCpqdcy8j0VCZsrlrN/bixlKFzXESNqBH7iUhRQz9xASHVUBWypYqq hFxQzJ3dZCsNN/cdFwXi1Li9UMTff/899xKljcEaMSphBVLT1JBOHqWnVMMts6eiigbScbY1Yj3f MT29aaSnR1cDDunpyPWKd5k97YBnCB1nmZpOvfS0tDAO0lO8b3o6tNzTaNyoaRPS05Zp43CcjVmT Wunp8+fP8+3Xr18fOunpzZb0lKNuOm/KdYpURkL45MmTUS8Z7o2lHJeiiIuGfLm2PfuJdarmDu7p UXqqBkwAkru9jXLpt25PsVEnGkLH2aWmVSWhipqeyoQNYLzBIRDW23g+LjAj56hcY6+5v6Wn+OOP P/YgNJCOszBruukp3VOmp1RGODVq3EQXNS2HBeiaVvdUodSeIq+RcaKnaAgdZ6mIR+npFvc0KONi GDyaNrJ1xmJFRuwpRtNG01QA+ezZs9QxbQyk42xS04VKMj3FRX+5RjHOnkIZAWRRwnxGFNMmqm5c kXElzumVmDZXNG04CG5VdFyCWbOannL29NWrVzU9nZm5maGoKSk2EG6YNmsrMrSneNWrF6mGG1sZ BtKxe0XU9LQ5e8oUFRAiPS2p6o3WiwCyqOJU7vdWZPAqU4Rwcfm2eAk3AtlwUA2h4yxT04UqMj19 8eJFTU/fvHnT6yneNBSxuSxKd3kjhLxgjazOuJpfP6erMG06PUUD6TgrsyYqI0ybFA0bzJ7Ksqib RjuDNWJ1T7WVcWobDdkZ/EpbGVTFTivDEDrOShGPgIQqzsp04ELhkprCOb1pmTY0bGTSpquM6a8W xuLip7zKMJv8qoqdRcNWRcfZpqZHpg17ii3TJqpiWKeoqqimjW7NP2p6ukUVXSs6HiquHvj9jr7U uG7iN998k1sH+PKj2Q4YcJ1EHFAnxAxdBgVnHPgdnHXfGkSSay3iLi7fdns3W6f5DGjxBwBnHPN7 ZnXFNh0zkHkPnZLmTt999x2u7Th1/i0Ox24VsZme9kwb1ojFOT0afVPjRlWRMLKVIY39I1UsVxq+ oipiGHyjg2oYHbtUxJ4qcqFuhmdWqHxBUYymwWShKo63RFaFvPVsFqo43opiohpuVsW5VsyKyBUe vCbHCVV0OHZdI25WRR0El1rxptPOOOhGxHdRxVgrrqiiV2g4zkIRU+sL/euvv2ZVRAZaVHGEKkIR cQAGVcWifqwVeUGagWr4Nqr4ySef5DNVES/2t7/9DZ8x/hExhI5dK+JCDVOjlQFVhGs6P3bDVsaa KqZ+g7+lile9WnH+A5DbGaqKjRlUO6mOswEx1lyLVgb7iWxlcOytsWj4hg1+OVcg2cJIZcJGFwzP v3eNY755Pb/WtS4cnlWx9hc5HH6iyW8YHbtLTXumzaKVMcOQzzBtUKthrWHLtClpaE5P9T7fo6Sm gJLnmqLiaY12xqTtjDlFTgVqGjf+5jjOLjVtmjYQLDb4ZxByOgpVDA3+OhC+poohnTyatAkp6jWH wrlesbO3jdsZjrNQxK4q6p6jqoqllbGmimMxZ44a/EEVkfpiCYcaN0lNHBo38/slXijnhCoaQseu QYxADkhPCeJcIw64mlNJT/O0TXFRFxM3iNBXHAqU9XVvjdNUgcOlwBVCAIiAKiM1xX1cUg7u6Wef fVZTVLzO8+fPT/2bHI7dgHgEIf6HrQxp8I+zIqWNqtirFasqKpRaMwLItXYGPgNeA79/op1hGB27 BDF+eReq+Pr167uo4thSRfYTy+3ptpuRr0SVWqkpVRHGDVNUGzeOcwYxmilvo4rZjGmp4l8Z6q0a ijrmXn+sFamIgBEHVXGGMSFV5XOKKjpFdZwNiEePtVRxhmOYgayqCNMUbY1yDQudQa3TNg1VjO2M auCEdkbqGTcbJ24Mo2NXIG5SRTioYRg8Q9hKUUONOFIVZeRtYdxIippNnC3GTdlZIJ1IUQ2jY3cg dlUR4LRUMc6gdlZmqIOaD6ohDRsqIYGkqxqNm/n9kZomwlgmgdJKiupw7ArEnirm9E+nbaCKWCpF RQR8qoqEkONtBBCPF5NGjZujFDUaNwRSJ27wVBo3TlEd5wjiUXz77bdclVFVsaSoVEWK4kAIO+sV m6NvYXUGzZrEMbhSM2YYAWJUxRMpqmF07A5EVcV6H19uVUUqIlJUzqAWw2YsSpjbGACTADI9baji kXFDRSxpa52+wVrH+T2T9hZnGJNTVMe5gngEJFQRoACkYtwk1omdWnGIUzeyXnHVuCmpaIomTqu3 6BTVca4gdlURxk1RqaN2BlWxADmUbfSZro6tdoYYN4tJGyphrBljb9EpquMSQGyqItJTruJnrQgY y45vgyoigWy0M7TJH1PUXCs2IKwwaooaYWSNic/qloZj7yC2VBEqM/RUkaNvMG7opEqKOsTtF4tJ 00pRB123WNoaFcZGippBRHCFRqH7VL1oGB27AVGB7DX5U6udAdWkWdMxbkZNUVUVmaISwjIUnlQV 4aJCGbXRXz5Lfn6YRfU+N47dgthUxdRp8ms7o0A4KpBi3AwEs2XcdHqLqZGiptjo5yyqLpdyveg4 FxBbqnjU5MeZKWpQRe76NkifcehN3GhvsZWitmpH1ouzKqdWS+OHH35I//73vw2jY7cgdr+o2s6A KrKdQeOG7YyWIlINCWKBrZui8sweozqqaHWoecOWBmB89epVfi6e04HR6apjdyBubmfQuJEUlY18 dVK3pKgD60OctdHPRcQFwqOWBp6j9SJeM6SoU/KWjI4dgdhKUasqcvStZ9xw4oYwSm9xU4qK26XR P0htmDh/ynNsaZyoF3vmjWE0iLtTxdrOWDNupMF/pIhrKWoKjX4qYlmzmKJpw2mcXr1Y/likDRtP GUaDuG/jBvcBIs4lRU33TVE79eKwZtq06kUElZEpaqfZbxgN4q5gHHrGDYDDFx6pKbbVuGeKmmKK qi2NAvLUGAzPELK/SCBb5s0GJ9VhEPdt3JTVGWlLihrWLS4a/ZqispWB3w/14qB1ItNTAbJp3tDs cVvDsVcQNxk3W1NUQkhVLClqiikqD6kXEyduWC9qqkpV7Jk30ptM33//vdsajt2DuDBuYIQwRaVx 00lRqyISOkLIepEuqsKo22tIT1HXMOZMVVzVhXmDPwg6BsfBgQCj2xoGcbcwDgXGRW8xpqgFijiL Ws0a1oZMS0NLIwmMfA9Vx9Yo3KJW7Dmp0mN0W8MgnocyxhQV6SDAiY3+MgZX1ZHbMbIWFCgXabDU i3FV/yDbMdZmf0xTo5PqtobjLEFspKgpNvoBBxcRS6o6lhR10DaHQqm1qcJH84ZQxqVTeD8sl2o5 qfh8bms4rnb++bekqCnMoiYuIg71IlPPCp+kqNroTyvmTZLJm0V62nNSY1vDMBrEs0tR8cVmox8r NDRFBZBq2rRaGrrPTWhpVGh1MfHK5M0iRWW92INxQ4/RMBrE3aSotdGPA5d3a82iMj2N6aimn63t NYJ5Q2Uc2MJYc1JLqpqVEa5uhHFDj9EwGsR91YtxFlWXS0GhtKVR0kiaLnXrRQLacFEVRg4UNM0c /kzbGlBEwoia8enTp+nly5eG0SCeDYxHs6ilXsyLiHGbWzGypdHqL4pKcuwtlRRV32ehjC0n9VRb Q2tGw2gQz1IVWS+ypYGWQWxphHoxp5hFuQbZfCpxzxupFxfg66xqhDIqImHkBlRaMxJGuKn4XIbR IJ5NisqWRq9eLGZKr7+4gDSoYoVRZ1KZrur9oqhHA+ItA4fTN1wB0hmFM4wGcTcwLloavXoR6SnA 4NQNgCR4cZUG60ddpdGoGY/aGsFRXYUR+6TiD0aB1zAaxN2CePTFPFUvcpVGq7/YavY36sUKP80b UVKdvkmthn9MU4uTahgN4uXUi/zyyyqNbrP/hHlTARQYj+ZRtb0R1zEi6KZGGF0zGsSzrhcBoS6Z EmNlWDFvhhXzJsUeI5+jS6cijGUIIT+vBSOHFAyjQdwrjMNavRiWTCUxb5L2FwFOMWV08iatOKmp laYWGIe7wlhaK25tGMTd1oupVy8ikKa2zBtt9hO8lpNK0GKt2IAx6XU3YkujnAeFkVe8wue7Z5/R QBrEx10vllJvYd6UNDXFZj9BWXNS2aZYgXHQi6Om20uKr8KIaPUZCePKoLjV0SDuol5smjcIbfZ3 nNSFuvFMOONMagpzqbJhVRNGvBfT1NLaGHowNlZtDE5VDeJjT1G3mDeD9vSKk7oAJex1E9cnpgaM uqj4yE2NMJYUmK2NodX0n/9oDI0lVMNd/v0Og/ihYeyaN6wX1UnVMTgurdKBcHFE61rF0PBfzKWG FR5HMMoQeu0zEkZ8JkwFxVUbeA7+qLjXaBB3Wy/C9GDK2XFSF2NwBEkVTFLUlP5qa/B+uguMhJsw ltS4pqlxCdWcpg66B45hNIi7hBFfWoURgS84vti9NDUYLIvNiBVGSVNPwag1Y2xtDDFNjTBi2w3D aBDPAkZ1UqEyhFHXMGpbQyZwkho1ClWoGbswqgMb+oxDRxlr3xPvgdpWN6Q60fhv7g/rMIiPxbxZ OKll86mjtoaOpUl6mjqrLrbCuHBgdYKnUTsOZe+drNb4Q4Hnw/WNjX87qgZxrzAunNTY1qBxwqa/ wkgTh5M291RGHadbNP/VGOLAuJpKCFXGArcdVYO4KxgXTuqJtgZ7jDp9s9jvhru/bYWRqWkKUzuh dmwqI9NVAgnXF4YT34SOaqPxbxgN4uOtFxEwOzgFw4vbsK1B86aXpgpY6a7KuLKEql5oR4ycunRL U9Vi5gzRUe20N1prOA2kQXw85g2+tOwbcqIlOqm9NDVc0m0NxkW/sQHjUZor228QwqNeIx3VDSaO 60aD+Phh1LYGxsoUxlM14wkYW6v8j2ZTozLq6xFWOqrlM1AZhw0mjutGg7gP82YrjGWFf7orjNL0 X1u10Rypi/Ui61XCuGbibKgbnaoaxP3BKGlqE8bWVoudNFVhHMISqiGM1h1Byd5mz8TBjKrWjRjv c6pqEM8GxlAzNg0chSlM4PRgbC27WtSOQRGrMkYTR2dUoY5OVQ3irmEM0zdZYXB7I4xV2ejIyprI JOsZj9JDrRHD3jktR7VemLVXN94hVbWrahAfH4ycviFAWP1wVxhj7RiXUnW+9AtFDJM3dTQumDjN ulFgzP1GrjxxqmoQdwXj3//+99zUX4MRF5rpuamibosd3ghabw+cRt14tB5Sl2bFmVjWjeVyAzlV BYz3SFWtjgbxw8P4r3/96ySM2tpg0z+sxJ/C2NoiPe1dZyO12xstE2eQRcaLulFW/a+mqlBH7O+z 4Y+TYTSIjwvGXp+xNYGjChmumzGEuvGoTpOtN4bGfOsQrv/YrRvxGeNonKSqAzbZsjoaxN3BeFc3 VS/7HbfqV2XsjMQRmsWlAArIo0ziDOUS40epKtWxlaqeMHKsjgZxnzBiW31NU9VJjdfJ0K0aG8qY FEZNS1UF5/caGwPkNVXtuaplV7umkdNRRzurBvFxwBjd1BaMmqaGhv8UHdXGFYiHtVRVVm+0TJyj VFVXjQiMwykjZ6M6DlZHg/jB3FR8OU81/QFjr17kZdsIY8fESa1UVdohdcV/z8SJrQ293zNyrI4G cVcwtiZwuIQKLQ1ZPpXbG60NhlupajBx1vbC0XWNeP4o/cVcQnZUsmvkrKnjBmfVQBrExwEjV/pj fSBCL9k9f9EnKmM5T6G90TNxVutG3cQYhWKYyjmCMLY5eKk6qOIJdVxzVgebOQbx0cCIy3DjMW67 AUZadSNNnPk8RUdVFVKHx3t1Yy9VVVdVR+RaRg5rxjV1bPQdmxdwdbpqED84jJwrVWVk3Qhl5BRO y1GNJk5sdazVjY1UtVVDDuKuVnVk8/+u6vjVV1/d1cwZDKLjQWDUbTe4OxxhBISxvdFKUVv144a6 sbqokqrqFY8B3wLCWEPeRR2p0HcwcwykQXxYGHVDKqSqmMJhqhodVdSNCl9JVacGhLg/6dIqhTM1 VnCEAYA1I2fcqo7lqstVHRtmzlqtePH1o0F8QBgRhFFUq+mocgInbLtf2xuxbmQfkulpmFNVIKmG RSgzmGMvVW2pI35wqu+4YuakE3XjRaqjQXx4GKfY+O85qit1Y1ZHrRtpCG2oG5upajByRlVHhVHc 1pFgUh1juqrqyA2bO+nqxdePBvEDKqO2N8BEdFQjjHEFR1HHqVU3qqHTSVWHLUaOwtgYKB/jTgCa rmI7xw3pqutHg/hhYdT2Bo0cdVTVxIEC9lZulBbHJHXjFBVxJVWt43Dpr/7jqG2O25duOqsje5HR zJnP46l0Fe5qGAYYLhVIg/gITBx8EddMnN4kjkIp86pTp8UxEYJwefF6zY2OOh61NQgmlbKo4tgw c8YN7mqrftxi6AwG0fFgJs6sjlOvbizOaj56LQ4+3lLKjeq4GAKgKoqjOso0zihmzthKV6O7yg2P Q/24xdA5K4fVID5iE2dD3TipKrLFwVQ1QlgWBlcY30Ido6PKFHUBaUhXF+4q6kcaOniNOxg6PYd1 MIiO92LiaN2oLQ7uhxP7jTFVpasqKjlFAIORs1UdxwLh2Gp1tNLVnrtagBwUyBOGzimFHAyi452Z OLFuZKoKdWS/cf4STzo0HlNVXVK11tq4pzpWJzWFVofAOfbc1aKQYwtIvD6vNyKGzl1mV3cHpEHc Z92YSt04AcZeqlrOhLIaOoS7ADidUMeUZCic0HWGyccT6eqo6ep8e2T9CBjxvLArQMthPUsgDeKO 60ZEL1VlvcizGjrFTZ02qmNqqGNivciakT8jhLjbUMo8kVOAHFv1I/uPOLT/eO5AGsSdKCNSVdj8 sW6Mqaqqo07jhN3iJlknOa2o40KNVR2piJzMUTOnMwwwdpxWTVfHaOjEgYBzBdIg7gRGRK9uDKkq VTIrpKoi68aoimxzEMCGs9r6sqs6qpkzdtLVaugASJo5jNjuiPXjuQNpEHdeNzJVnb+8U3BVOQDQ NXJkkfHUUEfCnovKzm4AC3VMf+0o10pXK4RaMyqEqpCsH6PDeq5AGsSd1o0xVe24qhnIoo7cxnEB I/uNMiI3UW0Lm70h8qPLx0m6OjbS1SMI9TFJXWstKQo5ngLyhMv66EfnDOK+YJxaqSpTSU1VOQAw q+RUjJxF7VhSVJ3IqWmrOKtaR0Yz5+gScmVrjrGXrpZ9cyKEFc5QS7ZS1lUgV9oe6bEDaRD3n6pO dFW1buR4XFDHXDsCwKiOwVlliqo7kNe2B4HsXblqJV3lDgKjpKtMYyuEW4CMNaS6rBuA7KWs6UMB aRD3DeOkrmrPyNHxuJKiTjJETggVzOqs6gxrL11tza5y4yr2HiVdrW0NqSWrobMVSNaQ9wRyy1rI 9JAwGsQzclV7Rg7VETBCFYOzWvuNqpJaO0o9qSs58lnvx2VX3IIjqqPcrzCm5RKsLUAOdwFyg6mT 0gccLDeIZ27kBHWcOrXjwlmV7TgmvRxATFdVHXW3gXgBHapjAHJkWqpmjaayEcK3BbKx9GrL1ZEf BEaDeKbqyFS1p449Z7UzjbPoQTZuV7e1B6SmrIQxhatZEcgCzPgugYxLrxB3uFS5FdGxGch0F3Wc v6xodfTUcQGkgLnYDYALkcW1VYWcGkAOWj+GdHWU3eXGtwVSXVbuwRoHy1cuVX7KzDGIjnejjrgd 1ZFAAi4CydlVEAYgQ7o6iaPaqxenjkLysuVDcFvfGsiwDjKPzZWFyfl90WvFvrL8XPgcUMcVGK2I jncC4yZ1BITFzJlaZk4jXVUIFynqCSDZ9uDP6qjc2wApe7A2l13xqshURzjKAPIEjA+iigbxgtWR MOI2RuROmDnNdFVc1RQmdnRrjmbKykuVUx7ZZ7wLkOX20JpjDRdiTdxPp6Sr+f1bMIYrWz2IOhrE C1ZH7Tv2zJyVdFW344iGzmKEbguQZRuPuwDZdVzjJebwuoQR7jDeD/O4PRjFwJkeykE1iBesjtp3 vG+6ypD6cYqGzgqQk9StFcok+9A0gMxqiCOOz+lO5QSybCHCc1IY8e/h+wNEvDRbMfMfqukh/88y iHZWV82cp0+fNtPVGciDKGHi7ZahAzA7QKYIJKGUOVadaT0aCtC9cvgzTtPIZQIWW1ASxnJpg/ze yAIIY0cV32utaBAvVx2nLWYOasdWuiqjcpNCuNJ/7AE5nQJStuQ4AlKvjFxUMJUtHYewqRbH+DKU 6J0icGaajH/rh1JFg2ggV82ctXQ11o+H21gYOjFdbQCZApBT3BlAFPJImUQdk9aIvB4IlZcpMc7y eXOqTVWE+jdUcbpHpmEQHe/WzGm5qzgIpG7R0TJ0NgB56AHZ2Dun+fnLZzwCj1fNClfRyuN8eC98 TkBXQOypYswerIiOx+Gusn6U6Zz8pVZDh+p4HyBlXG5qGTv6GQkiASSUsulAfR2e58900DqXBhTe 4/PPPz/g34bPhOOHH36YSl9xsmvq+FBmTnVXnz9/flQ/4gwFAYgEMhg6dwKyqNaBC5MDkIu0lX8Q CoSVuvJ4NYs4qF7e51DS03z71mTN1wrJnxfvzX8TXg+fGb++kp4aRMfDqiPrRwKp9SMCENLQ0fqR QJaWx2ENSLqsAUhVxCPnVVSRqpdvEzx5/FDaLPXMPxL4HRpQpZ/Kz5OXhRlEx6NzV1uGDkFASheB 1MXI9wRyAWAZMNc6cioqdyh13iRXxSKAB54xmKPnkp4eAP782aoiMjU9AeI7S1Ov/d1zRNDKF6x1 u8Yvv/ySd3h79uwZJlbw5R15oZsXL15kEOZ6K3+pMfUyp64HjJ3hyz7Dmc9z3MxAXs23r8DC/Dr5 fMtFljQcY7mPHPOqNPDzlA3aFOl29f9AsyXdXk35UMA8sPbDH4Wooo8pDKKjB+QQbk+tnwuQ+LIP BBIAvHz5EkyMM5BYIzjeB0isK5yBIpQ3ALNAOXKqptSruV9IRQSE83FTzgfWjlBsMI4znoN2hWwD 8sHCqanjberHSQydKQ4E0FCJLQ/WkBtT1gPTVtR1KaVFOkrHtQBI6KCEN0xJS8p5U9LRm9u58cMi TZ2BzOkp3mOGNKeoG1JTg+h4nECqoXMfIKPLestgHRJgi+NAMwcwFlh5QBazEgI+qG2BEGzm8/y+ eP7NDFy+P7/2DevD33//PaewaHHgM+CzNpZFpXed4hpEx3t3WN8GSMAlS64O0nOsB2CEklH1kJLe 3Oap9THcx+O4DVABYnm9G6ghHgfcUEOcadb84x//0LryvSmjQXQ8KiAxFEAgAYqOzkGlqkQWCPFY BLOkn1UFAV68XYCDGubUFec//vgjqyJuA378QWgMfk/v+z+mw/GugOxeXvvHH3/MawS5TT6yxXKl 4GzqlL1IsxEzQ5ldUhgzMxQgiS4q9qIZy3IoLotaDqNKKwOgIh1lusqUFCC+efMmp6Y45rQUAMI4 ym2Nf/7znzn1FTWc3heUVkTHQ/1R36qQddtHDgRQJdmBZ+8vqCDUsSoh01GtGefXu6FZU9Qw14ZI RVEbQglp0BQ1nE79e6yIjrNWSCjcF198kVseOMq+pONcS45UST6G/We4ej+qIidlSu2Y1REAvnr1 KteFRQ0P8x+HDOQJNUyNs0F0nC+Q5Vxhm6HMZ31sri25cXDtJyqMIT3NhxozBcQKId3SGfZD6Y9O nbR0ep//sRyORwkk60acWUdy5+6ijtiRLb9WWalfg6nvy5cvpzKDeuB5BnASKDOESEtnNTycANAg Oi4CyITROQBJKLE/qWybn48vv/xycZ8QUhU59iZ1aO4RAkCFEgAWt3R6+vTp4eeff24B+F7H4wyi 47ECmc8RSFVJhfDrr7+uasizrg7B7d9++63CyDPMGZyRjsIU6kCYDKLjEoFcqKOmrbgToVQVjKmp AqkKSQChgjgaNeGDQWgQHY8VyE1pq0LJJ3EHtxi8PgehDACmjfWgQXQYyNYZUBLILW8C+HBuAJg+ FIQG0bFHINdS2fTTTz91X3iu/3pwbQHPIDouHsg1KNe+x8MKQD3QHhRAg+g4ByDf9nu8Bt30If+R DsdegHxX3+EPooAG0XHOUL5LIA2iw/GA3+HpHP4RDsfe4Jz8n8fhcDgcDofD4XA4HA6Hw+FwOBwO h8PhcDgcDofD4XA4HA6Hw+FwOBwOh8PhcDgcDofD4XA4HA6Hw+G4d/xfgAEAqyPykQC8vxkAAAAA SUVORK5CYII=",
    transform: "matrix(1 0 0 1 1291 1687)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_48"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st51",
    points: "2819.44,818.59 2796.68,761.84 2839.13,744.82 2861.89,801.56  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M2915.41,837.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M2957.86,820.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st51",
    points: "2915.41,837.64 2892.65,780.9 2935.1,763.87 2957.86,820.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st51",
    points: "2862.01,918.69 2839.25,861.94 2881.7,844.92 2904.46,901.66  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M2862.01,918.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M2904.46,901.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st51",
    points: "2954.38,934.8 2931.62,878.05 2974.07,861.03 2996.83,917.77  "
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_47"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st52",
    x1: 2907.19,
    y1: 627.68,
    x2: 2901.62,
    y2: 629.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st53",
    x1: 2890.47,
    y1: 634.39,
    x2: 2739.87,
    y2: 694.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st52",
    x1: 2734.29,
    y1: 697.03,
    x2: 2728.72,
    y2: 699.26
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st52",
    x1: 2922.52,
    y1: 632.55,
    x2: 2916.95,
    y2: 634.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st54",
    x1: 2905.76,
    y1: 639.27,
    x2: 2732.28,
    y2: 708.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st52",
    x1: 2726.68,
    y1: 711.1,
    x2: 2721.11,
    y2: 713.33
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_17"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 3707.6279,
    y1: 3.4163,
    x2: 3815.0327,
    y2: 3.4163
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M3767,2c-19.79,0.75-39.58,1.49-59.37,2.15l2.13,0.84l84.28,3.94l20.99-11.02c-0.68,0.03-1.36,0.06-2.03,0.1 C3798-2,3782,2,3767,2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 3005.6831,
    y1: 41.5088,
    x2: 4098.3652,
    y2: 41.5088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M3824.79,0.78l-27.87,11.32l-84.28-3.94l-9.82-3.86C3618.18,7.04,3533.41,7.98,3448,0c-23-2-45-4-68-5 c-3-1-7-3-10-4c-25.16-0.74-50.19-0.79-75.18-0.21l-0.34,7.36c0,0,18.71,2.35,17.31,2.75c-1.4,0.39-18.3,18.42-18.3,18.42 l-119.74-1.47L3094.3,29l-88.62-9.83l10.68,51.32l68.05,22.14l88.16-20.21l118.75-6.84l30.46-13.26l35.88,8.1l183.34,5.82 l62.76-7.16l93.46,23.65l112.06-1.19l48.79-22.51L4000.24,62l13.21-7.64l24.26,11.23l32.06,1.5l7.11-4.72l21.48-54 C4007.18,8.54,3915.98-2.6,3824.79,0.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 3824.7947,
    y1: -4.1384,
    x2: 4096,
    y2: -4.1384
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M3851.52-16.56l-26.72,17.34c91.19-3.38,180.02,7.67,271.21,7.5V0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3448,0c-23-2-45-4-68-5c-0.29-0.1-0.59-0.21-0.9-0.32L3376,61l165.01,5.24l62.76-7.16l7.96-52.85 C3557.33,6.57,3502.8,5.12,3448,0z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3543.21-19.96l-163.06-7.62l-1.04,22.27c0.3,0.11,0.61,0.22,0.9,0.32c23,1,45,3,68,5 c54.8,5.12,109.33,6.57,163.73,6.22l5.36-35.58L3543.21-19.96z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "3712.65,8.16 3689.91,80.87 3809.29,81.53 3796.93,12.1  "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3846.87-3.01l11.22,62.04L4000.24,62l2.68-57.41C3950.91,1.12,3898.89-3.41,3846.87-3.01z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3846.87-3.01L3846.87-3.01c52.02-0.4,104.04,4.13,156.06,7.61l0.66-4.59L3846.87-3.01z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "3293.49,19.32 3291.33,65.58 3321.78,52.31 3311.8,0.89  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "3084.42,92.62 3094.3,29 3173.75,17.85 3172.58,72.42  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 3005.6831,
    y1: 10.6766,
    x2: 3312.2534,
    y2: 10.6766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M3142.06-0.78l-57.5,11.71l-78.88,8.25c0,0,82.17,9.81,86.29,10c4.12,0.19,81.78-11.32,81.78-11.32 l119.74,1.47l18.76-18.4l-56.11-8.73C3226.51-6.37,3196.85-4.07,3167-1C3158.93-0.33,3150.42-0.56,3142.06-0.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 3142.0603,
    y1: -7.6949,
    x2: 3256.146,
    y2: -7.6949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M3142.06-0.78c8.36,0.22,16.87,0.45,24.94-0.22c29.85-3.07,59.51-5.37,89.15-6.82l-45.06-7.01L3142.06-0.78z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 1676.2075,
    y1: 169.1215,
    x2: 1934.0139,
    y2: 169.1215
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M1934.01,157.51l-85.94-9.29l-105.68,26.71l-66.19,10.06c0,0,69.68,5.03,73.16,5.03s68.52-12.77,68.52-12.77 l101.03-3.48L1934.01,157.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_18"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 2072.2075,
    y1: 741.4844,
    x2: 2357.885,
    y2: 741.4844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "2072.21,656.12 2077.26,760.03 2102.81,780.39 2211.97,790.84 2225.91,782.72 2241,801.17  2337.39,826.84 2357.89,726.96  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_16"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 2072.2075,
    y1: 648.8472,
    x2: 2428.3364,
    y2: 648.8472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "2428.34,564.38 2372.59,555.09 2310.66,564.38 2219.3,564.38 2160.47,559.74 2072.21,656.12  2112.47,711.48 2214.66,725.41 2227.05,714.58 2236.34,725.41 2324.26,742.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_8"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 2298.272,
    y1: 802.8342,
    x2: 2756.5945,
    y2: 802.8342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st63",
    points: "2298.27,666.58 2307.56,819.61 2332.34,855.48 2389.63,881.8 2499.56,872.51 2566.14,926.71  2624.98,939.09 2699.3,925.16 2711.69,908.12 2733.37,894.19 2756.59,768.77 2298.27,666.58  "
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2251.82,1885.93"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_30"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_28"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_19"
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2112.47,711.48 2102.81,780.39 2211.97,790.84 2225.91,782.72 2241,801.17 2236.34,725.41  2227.05,714.58 2215.05,725.08  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 2211.9727,
    y1: 752.7102,
    x2: 2227.0461,
    y2: 752.7102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "2211.97,790.84 2225.91,782.72 2227.05,714.58 2215.05,725.08  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2339.29,786.6 2389.63,881.8 2499.56,872.51 2493.37,802.83  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2624.98,939.09 2618.79,855.48 2563.05,844.64 2566.14,926.71  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2702.13,921.27 2711.69,908.12 2733.37,894.19 2756.59,768.77 2705.5,809.03 2700.85,829.16  "
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_22"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M2602.29,145.27"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "2332.34,855.48 2340.52,788.93 2298.27,666.58 2307.56,819.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "2374.14,581.41 2352.98,636.12 2298.27,666.58 2357.88,640.25 2378.27,582.45 2516.59,488  2516.59,483.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "2372.59,555.09 2314.27,566.96 2219.51,566.96 2163.05,563.35 2072.21,656.12 2160.47,559.74  2222.4,564.38 2313.24,563.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "1406.88,149.41 1404.56,178.83 1348.56,241.8 1348.56,248.51 1196.82,393.29 1138.5,534.45  999.27,680.51 1135.14,529.54 1194.98,389.59 1336.69,242.32 1341.85,229.93  "
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_64"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_21"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1011.84,1051.3c0,0-25.99,38.55-3.2,64.99c22.79,26.43,59.59,7.77,85.54-18.66 c25.95-26.43,53.21-72.04,23.81-85c-29.4-12.96-28.82,43.58-47.34,23.86s-27.72-45.11-38.4-23.86 C1021.57,1033.88,1012.95,1023.63,1011.84,1051.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1099.4,660.76c0,0-25.99,14.44-3.2,24.35s59.59,2.91,85.54-6.99c25.95-9.9,53.21-26.99,23.81-31.85 c-29.4-4.85-28.82,16.33-47.34,8.94s-27.72-16.9-38.4-8.94C1109.14,654.23,1100.51,650.39,1099.4,660.76z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_49"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2730.3,309.63c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2734.08,309.49,2732.25,309.63,2730.3,309.63z M2724.61,298.34c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2725.03,298.34,2724.82,298.34,2724.61,298.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2724.61,298.34c0,0,0.11-1.76,0.31-2.09s3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 s-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2726.66,298.32,2724.61,298.34,2724.61,298.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2721.11,291.8c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2718.3,292.76,2721.11,291.8,2721.11,291.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2733.46,306.6c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2737.24,306.46,2735.41,306.6,2733.46,306.6z M2727.77,295.31c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2728.19,295.31,2727.98,295.31,2727.77,295.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2727.77,295.31c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 s-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77S2727.77,295.31,2727.77,295.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2724.27,288.77c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2721.46,289.73,2724.27,288.77,2724.27,288.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2736.88,303.18c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2740.66,303.04,2738.83,303.18,2736.88,303.18z M2731.19,291.89c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2731.61,291.89,2731.4,291.89,2731.19,291.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2731.19,291.89c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04s2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2733.24,291.87,2731.19,291.89,2731.19,291.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2727.69,285.35c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2724.88,286.31,2727.69,285.35,2727.69,285.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2745.44,325.91c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2749.22,325.77,2747.4,325.91,2745.44,325.91z M2739.76,314.61c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2740.17,314.62,2739.96,314.62,2739.76,314.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2739.76,314.61c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2741.8,314.59,2739.76,314.61,2739.76,314.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2736.26,308.07c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2733.45,309.04,2736.26,308.07,2736.26,308.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2748.31,322.17c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2752.09,322.03,2750.26,322.17,2748.31,322.17z M2742.63,310.87c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2743.04,310.88,2742.83,310.87,2742.63,310.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2742.63,310.87c0,0,0.11-1.76,0.31-2.09s3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2744.67,310.85,2742.63,310.87,2742.63,310.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2739.13,304.33c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2736.32,305.29,2739.13,304.33,2739.13,304.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2761.47,341.15c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2765.25,341.01,2763.43,341.15,2761.47,341.15z M2755.79,329.86c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2756.2,329.86,2755.99,329.86,2755.79,329.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2755.79,329.86c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2757.84,329.83,2755.79,329.86,2755.79,329.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2752.29,323.32c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2749.48,324.28,2752.29,323.32,2752.29,323.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2777.21,356.63c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2781,356.49,2779.17,356.63,2777.21,356.63z M2771.53,345.34c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2771.94,345.34,2771.74,345.34,2771.53,345.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2771.53,345.34c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04s2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2773.58,345.32,2771.53,345.34,2771.53,345.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2768.03,338.8c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2765.22,339.76,2768.03,338.8,2768.03,338.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2786.53,374.93c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2790.31,374.79,2788.48,374.93,2786.53,374.93z M2780.85,363.63c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2781.26,363.64,2781.05,363.63,2780.85,363.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2780.85,363.63c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 s-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2782.89,363.61,2780.85,363.63,2780.85,363.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2777.35,357.09c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2774.54,358.05,2777.35,357.09,2777.35,357.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2631.58,285.36c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2635.36,285.22,2633.53,285.36,2631.58,285.36z M2625.9,274.06c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2626.31,274.07,2626.1,274.06,2625.9,274.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2625.89,274.06c0,0,0.11-1.76,0.31-2.09s3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 s-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2627.94,274.04,2625.89,274.06,2625.89,274.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2622.4,267.52c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2619.58,268.48,2622.4,267.52,2622.4,267.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2610.5,279.97c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2614.29,279.83,2612.46,279.97,2610.5,279.97z M2604.82,268.67c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2605.23,268.68,2605.03,268.67,2604.82,268.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2604.82,268.67c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 s-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2606.87,268.65,2604.82,268.67,2604.82,268.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2601.32,262.13c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2598.51,263.09,2601.32,262.13,2601.32,262.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2711.6,297.84c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2715.38,297.7,2713.55,297.84,2711.6,297.84z M2705.92,286.55c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2706.33,286.55,2706.12,286.55,2705.92,286.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2705.92,286.55c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2707.96,286.53,2705.92,286.55,2705.92,286.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2702.42,280.01c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2699.61,280.97,2702.42,280.01,2702.42,280.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2713.81,293.35c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2717.59,293.21,2715.77,293.35,2713.81,293.35z M2708.13,282.06c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2708.54,282.06,2708.33,282.06,2708.13,282.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2708.13,282.06c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77S2708.13,282.06,2708.13,282.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2704.63,275.52c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2701.82,276.48,2704.63,275.52,2704.63,275.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2691.86,291.75c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2695.64,291.61,2693.82,291.75,2691.86,291.75z M2686.18,280.46c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2686.59,280.46,2686.38,280.46,2686.18,280.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2686.18,280.46c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 s-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77S2686.18,280.46,2686.18,280.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2682.68,273.92c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2679.87,274.88,2682.68,273.92,2682.68,273.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2692.67,285.43c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2696.45,285.29,2694.63,285.43,2692.67,285.43z M2686.99,274.13c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2687.4,274.14,2687.19,274.13,2686.99,274.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2686.99,274.13c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2689.03,274.11,2686.99,274.13,2686.99,274.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2683.49,267.59c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2680.68,268.55,2683.49,267.59,2683.49,267.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2672.12,284.6c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2675.91,284.46,2674.08,284.6,2672.12,284.6z M2666.44,273.3c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2666.85,273.31,2666.64,273.3,2666.44,273.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2666.44,273.3c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77C2668.49,273.28,2666.44,273.3,2666.44,273.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2662.94,266.76c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2660.13,267.72,2662.94,266.76,2662.94,266.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2674.06,280.11c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2677.84,279.97,2676.01,280.11,2674.06,280.11z M2668.38,268.81c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2668.79,268.82,2668.58,268.81,2668.38,268.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2668.37,268.81c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77S2668.37,268.81,2668.37,268.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2664.88,262.27c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2662.06,263.23,2664.88,262.27,2664.88,262.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2651.32,277.89c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2655.1,277.75,2653.27,277.89,2651.32,277.89z M2645.63,266.6c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2646.05,266.6,2645.84,266.6,2645.63,266.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2645.63,266.6c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 s-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77S2645.63,266.6,2645.63,266.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2642.13,260.06c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2639.32,261.02,2642.13,260.06,2642.13,260.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2654.41,274.18c-0.23,0-0.47,0-0.71,0l-0.96-0.01c-6.07,0-11.02-4.94-11.02-11.02 c0-1.92,0.13-4.11,1.72-5.68c1.63-1.62,3.73-1.6,5.95-1.58l0.96,0.01c6.07,0,11.02,4.94,11.02,11.02c0,1.92-0.13,4.11-1.72,5.68 C2658.2,274.04,2656.37,274.18,2654.41,274.18z M2648.73,262.88c0,0.08,0,0.17,0,0.27c0,2.21,1.8,4.02,4.02,4.02l1.02,0.01 c0.2,0,0.4,0,0.61,0c0-0.08,0-0.17,0-0.27c0-2.21-1.8-4.02-4.02-4.02l-1.02-0.01C2649.14,262.89,2648.94,262.88,2648.73,262.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M2648.73,262.88c0,0,0.11-1.76,0.31-2.09c0.19-0.32,3.48-0.36,4.77,1.04c1.29,1.41,2.26,4.63,2.06,5.02 c-0.19,0.39-1.5,0.32-1.5,0.32s-0.52-3.23-2.06-3.77S2648.73,262.88,2648.73,262.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M2645.23,256.34c0,0-2.51,6.2,0.84,10.03c5.48,6.29,12.37,5.65,13.65,5.03c0,0,0.88-0.39,1.11-0.6 c0,0-1.29,4.9-10.35,3.12c0,0-10.25-2.08-8.68-12.51C2642.42,257.3,2645.23,256.34,2645.23,256.34z"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M2459.3,1271.48v-7.23c-21.71,2.91-42.01,6.79-61,11.46c-226.49,55.73-265.71,224.67-265.71,224.67l8.77,2.32 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st69",
    x1: 2400.47,
    y1: 1282.83,
    x2: 2398.3,
    y2: 1275.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st69",
    x1: 2301.89,
    y1: 1317.67,
    x2: 2298.51,
    y2: 1312.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st69",
    x1: 2200.72,
    y1: 1389.41,
    x2: 2197.99,
    y2: 1388.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st69",
    x1: 2147.56,
    y1: 1474.32,
    x2: 2142.68,
    y2: 1472.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st69",
    x1: 1377.68,
    y1: 2061.29,
    x2: 1371.42,
    y2: 2052.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M1275.95,2004.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M1191.95,1844.51l-6.68-8.9c0,0,13.08,205.16,294.4,244.26l2.99,8.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st69",
    x1: 1257.76,
    y1: 1975.35,
    x2: 1243.53,
    y2: 1964.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M3104.59,1018.45l-8.13-20.32c0,0,37.88,170.26,20.69,239.22c-20.69,83.04-75.63,211.54-275.38,245.42v17.43"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st69",
    x1: 3086.92,
    y1: 1333.41,
    x2: 3089.9,
    y2: 1313.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st69",
    x1: 3128.21,
    y1: 1187.99,
    x2: 3121.63,
    y2: 1161.67
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "1635.16,759.86 1586.79,759.86 1547.3,741.48 1482.56,739.34 1544.21,752.71 1582.92,772.11  1629.96,779.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "1452.85,808.25 1482.56,814.45 1584.47,819.61 1615.43,830.71 1610.01,849.29 1579.82,833.8  1482.56,819.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "2695.51,558.88 2721.83,543.78 2801.44,479.96 2831.96,467.69 2840.25,485.18 2807.4,493.66  2725.26,547.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "1362.51,1045.93 1444.05,1071.48 1521.76,1071.48 1438.92,1085.41 1356.87,1062.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "2856.47,1246.96 2875.05,1290.32 2879.69,1293.67 2879.69,1283.61 2869.63,1273.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "2876.08,1237.16 2920.47,1254.96 2966.92,1286.71 2925.11,1253.67 2881.5,1233.54 2876.88,1233.54  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M2900.66,1434.58c0,0-5.74-31.48-5.74-34.06s-21.16-40.77-21.16-40.77l30.71,42.32l3,30.22L2900.66,1434.58z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "2148.48,124.19 2143.57,103.11 2082.42,75.24 2161.39,104.27 2169.35,120.54  "
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_57"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1714.16,1186.06c0,0-1.7-10.26-0.03-18.83c0.57-2.92,1.53-5.65,3.08-7.71c6.11-8.09,20.17-7.52,22.62-16.61 c2.44-9.08,19.72-11.79,19.72-11.79"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1703.77,1133.69c2.38,2.7,1.22,11.5,9.63,14.54c8.4,3.04,3.82,11.29,3.82,11.29s7.95-10.93,6.11-17.74 s10.36-19.98,10.36-19.98"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1698.27,1148.23c0,0,7.33,6.75,7.95,10.37c0.61,3.62,7.92,8.63,7.92,8.63"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1736.1,1148.23c0,0,6.38,5.01,10.56,4.11"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1714.14,1173.57c0,0,11.03-0.2,12.86-6.35"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1696.34,656.12c0,0-2.15-13.99-0.04-25.69c0.72-3.99,1.94-7.7,3.91-10.51 c7.74-11.03,25.55-10.26,28.65-22.65c3.1-12.39,24.98-16.07,24.98-16.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1683.18,584.71c3.02,3.68,1.55,15.68,12.19,19.82c10.65,4.15,4.84,15.4,4.84,15.4s10.06-14.9,7.74-24.19 c-2.32-9.29,13.12-27.24,13.12-27.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1676.21,604.53c0,0,9.29,9.2,10.06,14.14c0.77,4.94,10.03,11.77,10.03,11.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1724.12,604.53c0,0,8.08,6.83,13.38,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1696.3,639.09c0,0,13.97-0.27,16.29-8.65"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2569.22,543.08c0,0-2.15-13.99-0.04-25.69c0.72-3.99,1.94-7.7,3.91-10.51 c7.74-11.03,25.55-10.26,28.65-22.65c3.1-12.39,3.11-21.02,3.11-21.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2556.06,471.66c3.02,3.68,1.55,15.68,12.19,19.82c10.65,4.15,4.84,15.4,4.84,15.4s10.06-14.9,7.74-24.19 c-2.32-9.29,13.12-27.24,13.12-27.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2549.09,491.49c0,0,9.29,9.2,10.06,14.14s10.03,11.77,10.03,11.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2597.01,491.49c0,0,13.91,16.63,19.2,15.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2569.19,526.05c0,0,13.97-0.27,16.29-8.65"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2976.92,713.49c0,0,2.15-13.99,0.04-25.69c-0.72-3.99-1.94-7.7-3.91-10.51 c-7.74-11.03-25.55-10.26-28.65-22.65c-3.1-12.39-24.98-16.07-24.98-16.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2990.08,642.07c-3.02,3.68-1.55,15.68-12.19,19.82c-10.65,4.15-4.84,15.4-4.84,15.4s-10.06-14.9-7.74-24.19 c2.32-9.29-13.12-27.24-13.12-27.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2997.04,661.89c0,0-9.29,9.2-10.06,14.14c-0.77,4.94-10.03,11.77-10.03,11.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2949.13,661.89c0,0-8.08,6.83-13.38,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M2976.95,696.46c0,0-13.97-0.27-16.29-8.65"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M3852.86,416.13c0,0,4.63-30.1,0.08-55.25c-1.55-8.57-4.17-16.57-8.41-22.6 c-16.65-23.73-54.96-22.07-61.62-48.71c-6.66-26.65-53.74-34.58-53.74-34.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M3881.17,262.5c-6.5,7.91-3.33,33.72-26.23,42.64c-22.9,8.92-10.41,33.13-10.41,33.13 s-21.65-32.06-16.65-52.04s-28.22-58.6-28.22-58.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M3896.16,305.14c0,0-19.98,19.79-21.65,30.41c-1.67,10.63-21.57,25.32-21.57,25.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M3793.09,305.14c0,0-17.39,14.7-28.77,12.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M3852.93,379.49c0,0-30.05-0.59-35.05-18.61"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M700.53,571.45c0,0-2.82-12.13-8.38-20.98c-1.89-3.02-4.1-5.65-6.63-7.3c-9.93-6.47-24.22-0.01-30.8-9.11 c-6.58-9.1-25.66-4.94-25.66-4.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M687.9,508.83c-1.26,3.99,3.87,13.31-3.46,20.18c-7.33,6.87,1.09,14.16,1.09,14.16s-13.1-8.87-14.24-17.22 c-1.15-8.34-19.63-17.95-19.63-17.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M700.08,522.74c0,0-4.57,10.55-3.59,14.84c0.99,4.29-4.33,12.89-4.33,12.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M660.96,538.42c0,0-4.36,8.22-9.09,8.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M694.99,557.53c0,0-11.5,4.35-16.14-1.73"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.2672,
    y1: 1109.2562,
    x2: 785.6016,
    y2: 1109.2562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M736.32,1246.63c5-7.62,48.17-78.35,26.49-93.09s-167.22-149.99-230.71-147.4s-193.83,54-193.83,54 s77.23-84.7,161.08-88.18c83.85-3.48,290.35,109.38,286.19,187.66C781.39,1237.9,736.32,1246.63,736.32,1246.63z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_58"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 1860.7301,
    y1: 1138.373,
    x2: 2003.1816,
    y2: 1776.3085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1464,
    style: {
      stopColor: "#AE4A42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#333333"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M1558.86,1286.71l260.18-52.42c0,0,135.17,12.42,144.62,12.68s84-50.21,110.21-40.46 s354.46,27.79,354.46,27.79l-295.74,54.64l-100.66,133.26l-409.33,99.1l-190.46,143.74l127.47-190.71l94.59-44.76l128.06-109.18 l-195.53,10.84l-52.6,47.7L1558.86,1286.71z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1963.67,1246.96l29.45,159.74c0,0,20.83,1.03,23.64-9.55c2.81-10.58,38.67-190.65,38.67-190.65 L1963.67,1246.96z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2073.87,1206.5 2055.43,1378.93 2082.52,1355.22 2132.59,1288.93 2171.91,1217.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1954.32,1246.31l17.4,160.42c0,0-116.28,31.75-116.28,22.83c0-8.92-36.39-195.27-36.39-195.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1782.27,1320.38 1827.1,1446.91 1688.67,1505.29 1654.21,1429.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1586.75,1331.22 1558.86,1286.71 1534.14,1378.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1559.62,1474.32 1622.6,1521.29 1432.14,1665.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2248.66,1223.22 2232.06,1270.55 2428.34,1234.29  "
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M2088.08,1347.87l-32.65,28.9l-38.67,20.39l-16.21,9.24l-28.83,0.33l-116.28,22.83l-33.92,1.58l5.59,15.77 l-138.43,58.38l25.46-6.16l126.85-49.41c0,0,14.45-9.98,16-9.98s117.16-26.9,117.16-26.9h26.84l20.65-13.36 c0,0,33.02-14.97,33.8-16c0.78-1.03,24.52-24.77,24.52-24.77L2088.08,1347.87z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_32"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M1864.72,641.41c0.83,0.39,26.44,7.43,26.44,7.43s13.08-10.53,15.31-13.24c2.23-2.71,9.74-18.97,9.74-18.97 l-25.74-1.55l-15.17,7.74L1864.72,641.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M1864.72,641.41l15.03-11.23h6.4c0,0,2.78,5.42,4.31,3.87s3.48-6.58,3.48-6.58v6.97l6.4-12h5.01l10.85-5.81 l-9.74,18.97l-15.31,13.24L1864.72,641.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M1588.14,996.6c1.22,0.33,35.09,1.52,35.09,1.52s6.52-25.43,6.93-31.45s-3.63-39.45-3.63-39.45l-29.83,9 l-10.97,21.25L1588.14,996.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M1588.14,996.6l8.16-27.61l7.12-2.95c0,0,7.23,8.71,7.75,5.15s-1.15-13.73-1.15-13.73l5.32,12.84 l-2.03-25.07l5.57-2.31l7.65-15.7l3.63,39.45l-6.93,31.45L1588.14,996.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M531.79,602.42c1.22,0.33,35.09,1.52,35.09,1.52s6.52-25.43,6.93-31.45c0.41-6.02-3.63-39.45-3.63-39.45 l-29.83,9l-10.97,21.25L531.79,602.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M531.79,602.42l8.16-27.61l7.12-2.95c0,0,7.23,8.71,7.75,5.15c0.52-3.56-1.15-13.73-1.15-13.73l5.32,12.84 l-2.03-25.07l5.57-2.31l7.65-15.7l3.63,39.45l-6.93,31.45L531.79,602.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M1638.96,124.71c0.69,0.18,19.68,0.85,19.68,0.85s3.66-14.26,3.89-17.64c0.23-3.38-2.04-22.12-2.04-22.12 l-16.72,5.05l-6.15,11.92L1638.96,124.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M1638.96,124.71l4.58-15.48l3.99-1.65c0,0,4.05,4.88,4.35,2.89c0.29-2-0.64-7.7-0.64-7.7l2.98,7.2 l-1.14-14.06l3.13-1.29l4.29-8.8l2.04,22.12l-3.89,17.64L1638.96,124.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M3310.67,131.52c0.69,0.18,19.68,0.85,19.68,0.85s3.66-14.26,3.89-17.64s-2.04-22.12-2.04-22.12l-16.72,5.05 l-6.15,11.92L3310.67,131.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M3310.67,131.52l4.58-15.48l3.99-1.65c0,0,4.05,4.88,4.35,2.89c0.29-2-0.64-7.7-0.64-7.7l2.98,7.2 l-1.14-14.06l3.13-1.29l4.29-8.8l2.04,22.12l-3.89,17.64L3310.67,131.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M2005.81,1439.61c0.83,0.39,26.44,7.43,26.44,7.43s13.08-10.53,15.31-13.24c2.23-2.71,9.74-18.97,9.74-18.97 l-25.74-1.55l-15.17,7.74L2005.81,1439.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M2005.81,1439.61l15.03-11.23h6.4c0,0,2.78,5.42,4.31,3.87c1.53-1.55,3.48-6.58,3.48-6.58v6.97l6.4-12h5.01 l10.85-5.81l-9.74,18.97l-15.31,13.24L2005.81,1439.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M2217.99,541.28c0.48,0.43,16.06,9.66,16.06,9.66s10.28-7.32,12.18-9.34c1.9-2.03,9.48-14.92,9.48-14.92 l-16.57-4.56l-11.18,4.68L2217.99,541.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M2217.99,541.28l11.66-7.66l4.18,0.81c0,0,0.93,4.96,2.18,3.84c1.25-1.13,3.35-5.16,3.35-5.16l-1.14,5.93 l6.15-9.41l3.27,0.63l8.05-3.58l-9.48,14.92l-12.18,9.34L2217.99,541.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M1586.75,315.66c0.38,0.34,12.79,7.52,12.79,7.52s8.12-5.6,9.62-7.15c1.5-1.55,7.46-11.47,7.46-11.47 l-13.17-3.59l-8.86,3.56L1586.75,315.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M1586.75,315.66l9.22-5.86l3.32,0.64c0,0,0.76,3.83,1.75,2.97c0.99-0.86,2.64-3.97,2.64-3.97l-0.88,4.57 l4.84-7.23l2.6,0.5l6.37-2.72l-7.46,11.47l-9.62,7.15L1586.75,315.66z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_61"
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M1534.14,1378.93l5.3-23.29l5.37-23.27l5.42-23.26l5.49-23.24l0.44-1.84l2.03-0.49l15.8-3.83 c5.27-1.28,10.53-2.58,15.82-3.72l15.92-3.25l15.9-3.35l63.59-13.41l127.19-26.82l0.59-0.12l0.6,0.06l150.43,13.9l-1.98,0.32 l91.76-40.46l0.91-0.4l1,0.07l186.45,13.89l46.61,3.46l11.66,0.79c3.88,0.31,7.76,0.71,11.63,1.13l23.26,2.43l23.25,2.43 l23.25,2.51c15.5,1.64,30.99,3.41,46.49,5.13c-15.58-0.59-31.16-1.14-46.74-1.81l-23.36-0.97l-23.36-1.04l-23.36-1.04 c-3.89-0.16-7.79-0.34-11.67-0.61l-11.65-0.95l-46.61-3.48l-186.45-13.89l1.91-0.33l-91.76,40.46l-0.95,0.42l-1.03-0.1 l-150.43-13.9l1.19-0.07l-127.19,26.82l-63.59,13.41l-15.9,3.35l-15.88,3.45c-5.31,1.09-10.64,2.03-15.98,2.99l-16,2.88l2.46-2.33 l-6.87,22.87l-6.94,22.85l-6.99,22.84L1534.14,1378.93z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M1432.14,1665.02c9.35-16.74,19.04-33.26,28.73-49.77c1.22-2.06,2.39-4.15,3.71-6.14 c1.32-1.99,2.72-3.93,4.06-5.91l7.98-11.91l15.93-23.84l63.74-95.35l0.61-0.92l1-0.47l87.27-41.29l-0.91,0.6l64.54-56.15 c5.38-4.68,10.77-9.35,16.08-14.1c5.6-4.43,11.29-8.74,16.93-13.12c11.31-8.72,22.69-17.37,34.15-25.91 c-10.05,10.17-20.19,20.24-30.39,30.23c-5.12,4.98-10.18,10.02-15.34,14.95c-5.44,4.61-10.81,9.3-16.19,13.98l-64.54,56.15 l-0.42,0.36l-0.5,0.24l-87.27,41.29l1.61-1.39l-63.74,95.35l-15.93,23.84l-7.96,11.93c-1.32,1.99-2.57,4.03-3.91,6.01 c-1.34,1.98-2.83,3.86-4.26,5.77C1455.6,1634.72,1444.04,1649.98,1432.14,1665.02z"
  }))), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2604.85,761.78 2582.01,790.84 2582.01,818.59 2563.05,844.64 2583.95,848.71 2594.01,826.84  2589.08,800.03  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 516.5845,
    y1: -160.3798,
    x2: 697.0551,
    y2: 647.8143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1464,
    style: {
      stopColor: "#AE4A42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#333333"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M1124.36,54.9c0,0-620.67-34.1-670.22-52.54c-49.55-18.44-190.52,76.99-208.38,76.5 C230.49,78.45,54.61,62.49,0,57.5c0.91,61.57,0,443.44,0,443.44l374.84-90.75l190.32-251.97l689.25,10.9L1124.36,54.9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M245.75,78.87l55.68,302.04c0,0,39.39,1.95,44.7-18.05c5.31-20.01,73.13-360.49,73.13-360.49L245.75,78.87z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "454.13,2.37 419.26,328.39 470.49,283.57 565.17,158.22 639.5,23.36  "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41.1,424.13c0-9.45-40.56-223.14-40.56-223.14L0,57.5l228.21,21.37l32.76,302.09"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "784.62,33.98 753.23,161.19 1105.27,165.38 1124.36,54.9  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st74",
    x1: 260.97,
    y1: 380.96,
    x2: 41.1,
    y2: 424.13
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M1124.36,54.9l-44.16-2.05l-44.15-2.18l-44.14-2.3l-22.07-1.15c-7.36-0.38-14.71-0.76-22.05-1.37 c-14.68-1.24-29.37-2.27-44.06-3.38l-44.07-3.28l-88.14-6.57L418.96,6.35l1.91-0.33l-173.51,76.5l-0.95,0.42l-1.03-0.1 L121.25,71.33c-5.17-0.47-10.34-0.99-15.52-1.41c-2.59-0.2-5.18-0.41-7.76-0.66c-2.58-0.29-5.16-0.6-7.74-0.95l-30.92-4.04 C38.7,61.55,18.09,58.74-2.5,55.83c20.78,0.93,41.55,1.96,62.31,3.08l31.14,1.72c2.6,0.13,5.19,0.29,7.78,0.49 c2.59,0.23,5.17,0.5,7.75,0.78c5.17,0.53,10.34,0.97,15.51,1.47l124.13,11.52l-1.98,0.32l173.51-76.5l0.91-0.4l1,0.07 l352.55,26.27l88.14,6.57l44.07,3.28c14.69,1.08,29.38,2.24,44.08,3.19c7.35,0.49,14.68,1.2,22.01,1.91l22,2.13L1036.4,46 l43.99,4.38L1124.36,54.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_67"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 2642.0139,
    y1: 1181.2213,
    x2: 2688.8528,
    y2: 1181.2213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M2659.82,1196.12c0,0-7.74-20.13-17.81-25.55c0,0,18.19,6.97,23.23,15.87c0,0-0.61-17.81-15.6-24.77 c0,0,20.63,1.55,24.11,24.39c0,0-0.77-10.84,6.19-13.94c0,0-1.55,8.5,0,15.86c0,0,3.1-10.39,8.9-14.29c0,0-5.42,19.33-3.87,27.07 c0,0-7.74-7.74-8.52-10.06l-1.55,5.03l-2.71-4.26l-5.03,5.03L2659.82,1196.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 2586.6592,
    y1: 1482.3878,
    x2: 2648.4011,
    y2: 1482.3878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M2610.13,1497.29c0,0-10.21-20.13-23.47-25.55c0,0,23.98,6.97,30.62,15.87c0,0-0.81-17.81-20.56-24.77 c0,0,27.19,1.55,31.79,24.39c0,0-1.02-10.84,8.16-13.94c0,0-2.04,8.5,0,15.86c0,0,4.08-10.39,11.74-14.29c0,0-7.14,19.33-5.1,27.07 c0,0-10.21-7.74-11.23-10.06l-2.04,5.03l-3.57-4.26l-6.63,5.03L2610.13,1497.29z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_70"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 1864.7236,
    y1: 2070.0923,
    x2: 1940.5209,
    y2: 2070.0923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st80",
    points: "1895.38,2021.22 1940.52,2115.87 1864.72,2118.96 1895.38,2021.22  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_71"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 1192.6827,
    y1: 781.3681,
    x2: 1032.7697,
    y2: 1935.7407,
    gradientTransform: "matrix(-0.8301 0.5577 -0.5577 -0.8301 4795.3647 1026.7997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M3453.51,778.92c0,0-216.07-286.21-220.39-292.63c-4.32-6.43-116.69-207.01-116.69-207.01l-189.85-129.87 l-131.84-30.34l7.87,198.53l54.48,17.1l122.88,181.84l164.4,381.3h66.31l69.06,87.77l130.28-10.87L3453.51,778.92z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 3379.44,
    y1: 1219.63,
    x2: 3385.05,
    y2: 1227.99
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M3490.93,1257.58"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2853.08,165.96"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2995.56,176.04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 864.1016,
    y1: 1411.5814,
    x2: 1154.4241,
    y2: 1411.5814,
    gradientTransform: "matrix(-0.8301 0.5577 -0.5577 -0.8301 4795.3647 1026.7997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M3251.47,750.98l-68.56-77.06l-70.24-187.85l24.09,10.86l-45.2-90.88l-31.26-34.03l-11.45-80.91l-81.75-73.79 l-50.79-61.01l-121.56-37.25l68.83-26.66l163.22-21.52l33.74,66.87l140.29,142.18c0,0,121.33,153.52,127.46,156.4 c6.13,2.88,52.62,34.6,52.62,34.6s70.66,305.09,72.6,307.98S3251.47,750.98,3251.47,750.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 1119.7201,
    y1: 1429.4886,
    x2: 1137.1394,
    y2: 1429.4886,
    gradientTransform: "matrix(-0.8301 0.5577 -0.5577 -0.8301 4795.3647 1026.7997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0726A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2216,
    style: {
      stopColor: "#D46F61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    style: {
      stopColor: "#E06647"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F15A24"
    }
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st83",
    x1: 3068.86,
    y1: 496.07,
    x2: 3054.17,
    y2: 442.98
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.6879,
    y1: 1300.0048,
    x2: 1126.6879,
    y2: 1300.0048,
    gradientTransform: "matrix(-0.8301 0.5577 -0.5577 -0.8301 4795.3647 1026.7997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0726A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2216,
    style: {
      stopColor: "#D46F61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    style: {
      stopColor: "#E06647"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F15A24"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M3135.17,576.03"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_72"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2967.09,217.33 2922.52,431.52 2979.97,516.54 3048.84,291.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "3060.3,372.03 2991.41,543.08 3014.02,595.51 3112.67,486.07 3136.76,496.94 3091.55,406.06  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M3182.91,673.92l-38.54,223.92c0,0,60.53,9.84,66.31,0c5.79-9.84,40.79-146.86,40.79-146.86L3182.91,673.92z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "3279.74,985.6 3251.47,750.98 3453.51,778.92 3410.01,974.74  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_74"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 3001.2397,
    y1: 696.2892,
    x2: 3076.3364,
    y2: 696.2892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M3076.34,699.26l-12.25,51.71l-25.68,9.06c0,0-37.16-58.28-37.16-60.77c0-2.49,15.48-66.72,15.48-66.72 l33.29,65L3076.34,699.26z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_73"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 3016.7236,
    y1: 656.2098,
    x2: 3076.3364,
    y2: 656.2098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M3036.08,613.16l28.01,45.28l12.25,40.83c0,0-27.12-1.57-27.49-2.81c-0.38-1.23-32.12-63.91-32.12-63.91 L3036.08,613.16z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M1916.35,92.62l20.53-13.75l20.59-13.66l0.07-0.04l0.12-0.05l27.64-12.16l27.68-12.07l0.4-0.17l0.51-0.01 c21.29-0.37,42.58-0.58,63.87-0.81c21.29-0.28,42.58-0.34,63.87-0.51c21.29-0.18,42.58-0.18,63.87-0.24l31.94-0.07l31.94,0.06 l0.77,0l0.7,0.28l42.54,17.13l42.47,17.31l-1.31-0.25l26.71,0.2l26.71,0.3l26.71,0.3l26.71,0.41c17.81,0.25,35.61,0.61,53.42,0.97 c17.81,0.38,35.61,0.82,53.42,1.36c-17.81,0.54-35.61,0.99-53.42,1.36c-17.81,0.36-35.61,0.72-53.42,0.97l-26.71,0.41l-26.71,0.3 l-26.71,0.3l-26.71,0.2l-0.66,0l-0.66-0.26l-42.69-16.75l-42.62-16.94l1.46,0.28l-31.94,0.06L2205.52,47 c-21.29-0.06-42.58-0.05-63.87-0.24c-21.29-0.17-42.58-0.23-63.87-0.51c-21.29-0.24-42.58-0.45-63.87-0.81l0.91-0.18l-28.06,11.16 l-28.1,11.07l0.19-0.1l-21.21,12.67L1916.35,92.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M1933.63,157.51c-7.19-0.21-14.37-0.55-21.54-0.94l-10.75-0.62l-10.74-0.72l-10.74-0.76l-10.73-0.86 l-10.73-0.86l-10.71-0.98l1.26-0.09l-13.15,3.57l-13.18,3.47c-8.79,2.27-17.59,4.53-26.41,6.72l-13.23,3.26 c-4.41,1.08-8.83,2.15-13.25,3.19l-13.27,3.11c-4.42,1.04-8.86,2.03-13.29,3.01l-0.24,0.05l-0.06,0.01l-16.62,2.02l-16.65,1.86 l-16.68,1.66l-8.35,0.75c-2.79,0.21-5.57,0.46-8.37,0.65c2.72-0.65,5.45-1.24,8.18-1.87l8.2-1.77l16.42-3.38l16.45-3.17 l16.47-3.01l-0.3,0.06c4.37-1.25,8.74-2.48,13.13-3.67l13.15-3.57c4.38-1.19,8.78-2.35,13.17-3.49l13.19-3.42 c8.8-2.27,17.61-4.46,26.43-6.64l13.24-3.21l13.27-3.11l0.68-0.16l0.58,0.07l10.67,1.34l10.66,1.46l10.66,1.47l10.65,1.57 l10.65,1.6l10.64,1.7C1919.48,154.97,1926.56,156.17,1933.63,157.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M2794.75,119.06l16.89-7.49l16.91-7.43l16.93-7.39l16.96-7.31l0.24-0.1l0.49-0.08l20.3-3.46 c6.76-1.22,13.6-1.83,20.4-2.74l40.81-5.38l81.61-10.76l2.82-0.37l1.28,2.54l30.85,61.16l-0.68-0.97l149.21,155.52l0.11,0.12 l0.1,0.12l60.71,74.39l30.37,37.19c2.54,3.09,5.17,6.11,7.62,9.27l7.25,9.57l14.48,19.17l-0.61-0.55l25.61,18.37l25.52,18.5 l-27.1-16.1l-27.02-16.23l-0.27-0.16l-0.34-0.39l-15.88-18.03l-7.93-9.02c-2.61-3.03-5.04-6.21-7.56-9.32l-30.35-37.2 l-60.71-74.39l0.21,0.24l-149.21-155.52l-0.42-0.43l-0.27-0.54l-30.85-61.16l4.09,2.16l-81.61,10.76l-40.81,5.38 c-6.8,0.88-13.57,2.07-20.41,2.64l-20.5,1.92l0.73-0.19l-17.46,6.02l-17.49,5.94l-17.5,5.9L2794.75,119.06z"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1035.56,380.12c0,0,53.42-83.61,122.32-75.87c0,0,5.42,8.09,3.1,9.85c-2.32,1.76-61.94-1.34-109.94,66.02 H1035.56z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M277.07,1493.4c0,0,2,238.83,0,239.41c-2,0.58,5.07,139.55,23.21,165.29"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M1031.77,364.64c0,0,11.89-23.66,33-19.57c21.12,4.09,35.05,21.9,39.7,35.06s-12.39,13.16-12.39,13.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M1117.63,380.12c0,0-7.38-34.06-30.79-45.68c-23.41-11.61-27.79,9.13-22.07,10.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M1086.84,329.84c0-4.61-6.37-17.07,12.34-21.72c18.71-4.65,32.5,11.55,38.58,31.98 c6.08,20.43-11.61,19.87-11.61,19.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M185.06,1898.1c0,0-40.36-93.83,24.13-146.02s151.65-49.14,202.04-30.18s8.11,69.24,8.11,69.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M443.89,1683.03c0,0-118.9-62.76-211.28-22.48c-92.38,40.28-42.01,104.71-23.43,91.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M219.01,1649.12c-13.6-11.43-66.22-23.56-33.48-90.34c32.74-66.78,114.76-67.28,190.17-34.52 s29.85,83.61,29.85,83.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M181.08,1900.76c0,0-40.36-93.83,24.13-146.02s151.65-49.14,202.04-30.18s8.11,69.24,8.11,69.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M439.91,1685.7c0,0-118.9-62.76-211.28-22.48s-42.01,104.71-23.43,91.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M215.03,1651.79c-13.6-11.43-66.22-23.56-33.48-90.34c32.74-66.78,114.76-67.28,190.17-34.52 c75.41,32.76,29.85,83.61,29.85,83.61"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_77"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_75"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M974.4,473.8c5.81,3.1,3.1,8.13,10.06,8.52c6.97,0.39,9.29-8.33,17.42-9.2c8.13-0.87,8.9,4.27,15.48,4.6 c6.58,0.33,21.68-13.99,18.19-21.73s-17.81-7.74-24.39-15.87s-5.03-18.97-5.03-18.97s0,8.52,7.74,8.9s8.13-13.94,19.74-22.06 s20.9,0.39,31.35,0c10.45-0.39,24.41-12.08,21.85-14.71c-7.33-7.88-18.05-16.27-32.55-20.14c-31.18-8.32-61.94,6.06-69.68,23.09 c-7.74,17.03-2.41,22.45-2.41,22.45s14.02,8.45,14.02,18.55s-6.77,13.71-15.77,22.35c-5.51,5.29-12.28,10.83-14.93,18.94 C968.21,479.2,968.6,470.71,974.4,473.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M966.79,497.65l8.52,12.39l5.13-8.71l8.03,8.71l9.29-8.71l7.74,8.71l4.65-8.71l6.19,2.52 c0,0,13.16-2.26,10.06,9.71c0,0,7.74-9.71,3.87-15.9c-3.87-6.19,10.06-0.77,22.45-25.55c12.39-24.77,46.45-50.8,46.45-61.4 c0,0-3.93-8.36-12.35-17.42c2.56,2.63-11.39,14.32-21.85,14.71c-10.45,0.39-19.74-8.13-31.35,0s-12,22.45-19.74,22.06 s-7.74-8.9-7.74-8.9s-1.55,10.84,5.03,18.97s20.9,8.13,24.39,15.87s-11.61,22.06-18.19,21.73c-6.58-0.33-7.35-5.47-15.48-4.6 c-8.13,0.87-10.45,9.58-17.42,9.2c-6.97-0.39-4.26-5.42-10.06-8.52c-5.8-3.09-6.19,5.4-8.89,4.72 C963.82,483.67,963.79,489.84,966.79,497.65z M1031.77,442.13c-3.81-2.16-3.81-9.51-3.81-9.51s3.48-17.9,10.06-21.92 c6.58-4.02,18.97,12.24,17.81,19.59C1054.66,437.65,1035.58,444.29,1031.77,442.13z"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_69"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 2643.4736,
    y1: 631.7361,
    x2: 3273.4207,
    y2: 631.7361,
    gradientTransform: "matrix(0.2428 0.9701 -0.9701 0.2428 2609.1931 -882.4876)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M3708.66,2178.41l-40.54,48.46l-96.14-14.24l-58.6-52.37l-106.48-52.36l-90.69,1.15l-35.48,30.43 l-201.09,28.79l-108.92-30.2l-132.18,33.09c0,0,11.02,28.37,24.39,27.42c13.36-0.95,72.51,15.37,72.51,15.37l-125.05,26.51 l-117.84-71.06l-155.39-6.6l-95.75,38.33l-200.54,2.31l18.4-18.97l-100.83,11.67l-42.62,17.85l-79.99-16.69l-97.16,51.85 l-74.63,27.06l-59.16,23.91l-64.22-117.68l154.73-161.23l-9.59,83.07l191.11-53.74c0,0,185.59-62.02,190.38-66.81 c4.79-4.79,50.41-37.76,50.41-37.76s310.96,37.09,314.34,36.24s222.77-56.96,222.77-56.96s237.71-16.41,239.68-13.31 c1.97,3.1,179.44,95.15,179.44,95.15s139.99,23.62,147.03,23.05c7.04-0.57,125.92,72.63,125.92,72.63s52.68,38.29,57.19,37.16 c4.51-1.13,75.5,43.35,75.5,43.35L3708.66,2178.41z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_81"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 1922.79,
    y1: 1638.96,
    x2: 1916.21,
    y2: 1517.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 2871.86,
    y1: 1586.32,
    x2: 2871.86,
    y2: 1457.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 1210.63,
    y1: 1489.27,
    x2: 1168.72,
    y2: 1449.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 964.36,
    y1: 1383.48,
    x2: 885.28,
    y2: 1332.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 893.5,
    y1: 1358.15,
    x2: 909.16,
    y2: 1320.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 316.61,
    y1: 1373.05,
    x2: 237.53,
    y2: 1322.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 245.75,
    y1: 1347.71,
    x2: 261.41,
    y2: 1310.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 1180.9,
    y1: 1479.32,
    x2: 1187.92,
    y2: 1443.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 1902.62,
    y1: 1563.09,
    x2: 1931.5,
    y2: 1514.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 2856.47,
    y1: 1500.94,
    x2: 2890.61,
    y2: 1461.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 4011.32,
    y1: 1569.61,
    x2: 4011.32,
    y2: 1440.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st93",
    x1: 3995.93,
    y1: 1484.23,
    x2: 4030.07,
    y2: 1444.38
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_83__x28_\\u043A\\u043E\\u043F\\u0438\\u044F2_x29_"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u0415\\u041D\\u042C_\\u0422\\u0410\\u0427\\u041A\\u0418_2",
    className: "st94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M1818.41,317.62c-5.03,1.51-8.34,3.95-10.23,5.39l-0.45,0.29c-0.14,0.09-3.22,2.31-3.5,19.76 c-0.04,2.06-0.02,3.41-0.02,3.41l0,0c0,0.01-0.01,1.36,0.05,3.42c0.29,11.58,1.75,16.6,2.75,18.71c0,0.01,0.01,0.02,0.01,0.02l0,0 c0.5,1.06,0.88,1.37,0.93,1.4l0.45,0.34c1.94,1.67,5.39,4.55,10.62,6.6c2.07,3.01,5.33,5.08,9,5.27c3.05,0.16,5.81-1,7.83-3.01 c1.01-0.06,2.02-0.18,3.02-0.36c2.19-0.32,4.51-0.82,6.96-1.51c0.98-0.13,1.81-0.25,2.53-0.34l31.32,0.52 c0.55,0.76,1.89,2.62,2.08,2.73l8.52,0.47c1.11,1.02,2.8,2.15,5.25,2.92c1.82,1.43,4.02,2.33,6.38,2.46 c2.73,0.14,5.23-0.77,7.17-2.41c0.39-0.08,0.78-0.17,1.19-0.27c0,0,5.81-0.95,9.15-4.82c3.34-3.86,8.08-6.01,8.25-6.82 c0.02-0.08,0.04-0.26,0.06-0.53c0.03-0.2,0.07-0.8,0.12-1.66c0.22-3.51,0.53-10.04,0.59-11.34l0.01,0l0-0.24l0,0l-0.02-5.04l0,0 l-0.03-5.27l-0.01,0c-0.07-1.31-0.45-7.88-0.7-11.41c-0.05-0.86-0.1-1.46-0.13-1.67c-0.03-0.27-0.05-0.46-0.06-0.54 c-0.18-0.83-4.94-3.48-8.32-7.69c-3.38-4.22-9.2-5.78-9.2-5.78c-0.22-0.08-0.44-0.14-0.65-0.22c-2.03-2.14-4.75-3.55-7.74-3.7 c-2.68-0.14-5.14,0.74-7.07,2.32c-2.06,0.54-3.52,1.4-4.51,2.21l-8.52-0.43c-0.18,0.09-1.51,1.8-2.05,2.51l-32.58-2.87 c-2.93-1.2-5.68-2.09-8.25-2.74c-0.88-0.25-1.77-0.45-2.65-0.61c-2.07-2.46-5-4.1-8.24-4.27 C1823.83,312.63,1820.42,314.55,1818.41,317.62z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u0410\\u0427\\u041A\\u0410_2",
    className: "st94"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st96"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(5.591464e-03 1.1673 -0.9986 -0.0523 1823.0863 323.6004)",
    className: "st97 st98"
  }, "1")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 3175.9617,
    y1: 2998.9812,
    x2: 3175.9617,
    y2: 3017.7837,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    style: {
      stopColor: "#4C4C4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M1889.01,359.19l0.93-40.61c0.13-5.87,5.05-10.56,10.91-10.42l0,0c5.87,0.13,10.56,5.05,10.42,10.91 l-0.93,40.61c-0.13,5.87-5.05,10.56-10.91,10.42l0,0C1893.57,369.97,1888.88,365.06,1889.01,359.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 3175.9617,
    y1: 3069.1309,
    x2: 3175.9617,
    y2: 3087.9333,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    style: {
      stopColor: "#4C4C4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1818.88,357.58l0.93-40.61c0.13-5.87,5.05-10.56,10.91-10.42l0,0c5.87,0.13,10.56,5.05,10.42,10.91 l-0.93,40.61c-0.13,5.87-5.05,10.56-10.91,10.42l0,0C1823.44,368.36,1818.75,363.45,1818.88,357.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "1880.43,365.39 1889.17,365.61 1889.26,361.72 1878.31,362.73 1879.82,364.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 3188.5742,
    y1: 2986.5208,
    x2: 3190.5361,
    y2: 3108.0015,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#A6FFF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M1915.74,339.61l-108.18-2.44c0,0-0.64,17.99,3.39,21.22c4.03,3.23,15.04,11.63,36.62,4.94l24.02-2.87 l18.82-0.45l13.65,0.16l10.66-1.34c0,0,2.49-8.53,2.49-8.82C1917.23,349.74,1915.74,339.61,1915.74,339.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 3186.6958,
    y1: 3074.937,
    x2: 3204.0496,
    y2: 3074.937,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1843.06,348.56l-33.21-0.21l1.1,10.05c0,0,15.49,10.03,29.79,6.6c14.31-3.42,10.7-4.09,10.7-4.09 l-3.15-9.38L1843.06,348.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 3192.4792,
    y1: 3031.2683,
    x2: 3201.3687,
    y2: 3031.2683,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#639DA5"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M1901.23,357.56c0,0-27.35-0.63-37.03-2.74l-13.39,6.65c0,0-2.74,1.77-3.23,1.86l39.26-0.42l13.32-3.38 L1901.23,357.56z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M1879.04,362.74c0,0,1.7,1.84,1.72,2.11s-0.12,0.65-0.34,0.54c-0.22-0.11-2.12-2.67-2.12-2.67 L1879.04,362.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 3185.0247,
    y1: 2979.377,
    x2: 3211.9207,
    y2: 3032.0242,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1886.82,363.63c0,0,4.05,8.08,20.63,3.88c0,0,5.55-1,8.82-4.53c3.27-3.53,7.83-5.57,8.01-6.3 c0.18-0.73,1.08-12.31,1.08-12.31l-10.05-0.29l-0.47,9.64c0,0-0.31,2.63-2.31,2.81s-8.39,0.19-10.11,0.64 C1900.69,357.62,1888.07,362.62,1886.82,363.63z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1852.08,362.77c0.32-0.45,0.39-1.19,0.39-1.19l0.01-0.06l0.05-0.03c0.11-0.05,10.59-5.05,11.63-5.57 c0.94-0.47,1.7-1.94,1.79-2.12l0.22-9.78c0.01-0.6,0.22-1.07,0.61-1.42c0.82-0.72,2.17-0.59,2.22-0.59l8.22,0.19 c0.11,0,2.65,0.07,3.37,0.64c3.4,2.72,2.59,13.69,2.55,14.16l0,0.05l-7.31,5.86l-0.13-0.16l7.24-5.8 c0.06-0.79,0.73-11.37-2.48-13.93c-0.67-0.53-3.22-0.6-3.25-0.6l-8.23-0.19c-0.02,0-1.32-0.13-2.07,0.53 c-0.34,0.3-0.52,0.73-0.54,1.26l-0.23,9.83l-0.01,0.02c-0.03,0.07-0.83,1.71-1.9,2.24c-1,0.5-10.77,5.16-11.58,5.54 c-0.02,0.19-0.12,0.81-0.42,1.23L1852.08,362.77z"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M1925.47,339.87l-0.1,4.5l-10.54-0.31l-26.17,0.12l-45.35-1.01c0,0-22.03,0.51-26.85,0.9 c-8.23,0.67-5.8,13.85-5.8,13.85s-3.3-2.28-2.88-20.75L1925.47,339.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M1807.57,337.17l0.42,0.01c-0.22,9.39,0.55,14.48,1.23,17.1c0.39,1.5,0.8,2.39,1.1,2.89 c-0.28-2.09-0.74-7.75,1.75-11c1.05-1.38,2.52-2.15,4.36-2.3c4.77-0.39,26.64-0.9,26.86-0.9l45.36,1.01l26.16-0.12l10.34,0.3 l0.1-4.28l0.21,0l-0.11,4.71l-10.54-0.31l-26.16,0.12l-45.36-1.01c-0.21,0.01-22.07,0.52-26.83,0.9 c-1.72,0.14-3.08,0.86-4.06,2.14c-2.92,3.81-1.56,11.39-1.54,11.46l0.09,0.5l-0.42-0.29 C1810.4,358.01,1807.15,355.54,1807.57,337.17z"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M1925.26,339.87"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M1807.78,337.18"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "1881.64,312.32 1890.39,312.5 1890.3,316.39 1879.4,314.89 1880.99,313.18  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: -742.8448,
    y1: 2986.5229,
    x2: -740.8828,
    y2: 3108.0037,
    gradientTransform: "matrix(0.0229 -0.9997 -0.9997 -0.0229 4922.688 -346.8854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#A6FFF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M1915.74,339.69l-108.17-2.52c0,0,0.18-18,4.36-21.05c4.17-3.04,15.56-10.93,36.81-3.26l23.87,3.96 l18.78,1.31l13.64,0.46l10.59,1.83c0,0,2.09,8.63,2.09,8.92C1917.69,329.64,1915.74,339.69,1915.74,339.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: -744.7231,
    y1: 3074.9392,
    x2: -727.3694,
    y2: 3074.9392,
    gradientTransform: "matrix(0.0229 -0.9997 -0.9997 -0.0229 4922.688 -346.8854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M1843.54,327.42l-33.18-1.31l1.56-9.99c0,0,15.93-9.31,30.06-5.23s10.5,4.57,10.5,4.57l-3.58,9.23 L1843.54,327.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: -738.9397,
    y1: 3031.2705,
    x2: -730.0502,
    y2: 3031.2705,
    gradientTransform: "matrix(0.0229 -0.9997 -0.9997 -0.0229 4922.688 -346.8854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#639DA5"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M1902.07,321.09c0,0-27.35-0.62-37.12,1.04l-13.08-7.26c0,0-2.66-1.9-3.14-2.01l39.2,2.22l13.16,3.99 L1902.07,321.09z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M1880.14,314.9c0,0,1.78-1.76,1.82-2.03c0.03-0.27-0.09-0.66-0.31-0.55c-0.22,0.1-2.24,2.57-2.24,2.57 L1880.14,314.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -746.3942,
    y1: 2979.3792,
    x2: -719.4984,
    y2: 3032.0264,
    gradientTransform: "matrix(0.0229 -0.9997 -0.9997 -0.0229 4922.688 -346.8854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M1887.95,314.37c0,0,4.42-7.89,20.79-2.93c0,0,5.5,1.25,8.6,4.93c3.1,3.68,7.57,5.92,7.72,6.66 c0.15,0.74,0.52,12.35,0.52,12.35l-10.05-0.17l-0.02-9.65c0,0-0.18-2.64-2.18-2.91s-8.37-0.58-10.07-1.11 S1889.15,315.44,1887.95,314.37z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1853.2,313.64l0.18-0.11c0.28,0.44,0.35,1.06,0.36,1.25c0.79,0.42,10.34,5.53,11.31,6.07 c1.04,0.58,1.76,2.26,1.79,2.33l0.01,0.02l-0.23,9.83c-0.01,0.54,0.15,0.97,0.48,1.29c0.72,0.7,2.02,0.63,2.04,0.63l8.24,0.19 c0.03,0,2.58,0.05,3.27-0.45c3.32-2.41,3.13-13.01,3.11-13.8l-6.97-6.13l0.14-0.16l7.03,6.19l0,0.05 c0.01,0.47,0.33,11.47-3.2,14.03c-0.75,0.54-3.29,0.49-3.4,0.49l-8.23-0.19c-0.05,0-1.4,0.07-2.19-0.69 c-0.37-0.36-0.56-0.85-0.54-1.44l0.22-9.78c-0.09-0.19-0.77-1.69-1.69-2.2c-1.01-0.56-11.26-6.04-11.36-6.09l-0.05-0.03l0-0.06 C1853.54,314.84,1853.5,314.1,1853.2,313.64z"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M1925.26,339.87l0.1-4.5l-10.54-0.18l-26.14-1.32l-45.35-1.07c0,0-21.98-1.52-26.78-2.13 c-8.19-1.05-5.16-14.1-5.16-14.1s-3.19,2.15-3.61,20.63l78.81,1.98L1925.26,339.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M1807.57,337.17l0.42,0.01c0.22-9.39,1.22-14.44,2.02-17.03c0.46-1.48,0.91-2.35,1.23-2.83 c-0.37,2.08-1.1,7.71,1.24,11.07c0.99,1.42,2.42,2.27,4.25,2.5c4.75,0.61,26.57,2.12,26.79,2.13l45.36,1.07l26.13,1.32 l10.34,0.17l-0.1,4.28l0.21,0l0.11-4.71l-10.55-0.18l-26.13-1.32l-45.36-1.07c-0.21-0.01-22.02-1.53-26.76-2.13 c-1.71-0.22-3.04-1-3.96-2.32c-2.74-3.94-1.03-11.45-1.02-11.52l0.12-0.5l-0.43,0.27 C1811.35,316.49,1807.99,318.8,1807.57,337.17z"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M1925.47,339.88"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M1807.78,337.18"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1448.1028 2156.9509)",
    className: "st115",
    cx: 1827.54,
    cy: 337.63,
    rx: 9.37,
    ry: 8.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1909.16,
    y: 333.98,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1531.7837 2240.51)",
    className: "st116",
    width: 5.94,
    height: 5.23
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1912.43,
    y: 338.15,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1531.0167 2243.8057)",
    className: "st117",
    width: 2,
    height: 0.98
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1910.89,
    y: 338.07,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1529.5834 2242.1863)",
    className: "st117",
    width: 2,
    height: 0.98
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1909.34,
    y: 338.04,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1528.1082 2240.606)",
    className: "st117",
    width: 2,
    height: 0.98
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1912.06,
    y: 335.05,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1534.1888 2240.8445)",
    className: "st117",
    width: 2.9,
    height: 0.98
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1910.51,
    y: 334.95,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1532.774 2239.2078)",
    className: "st117",
    width: 2.9,
    height: 0.98
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1908.96,
    y: 334.92,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1531.299 2237.6274)",
    className: "st117",
    width: 2.9,
    height: 0.98
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M1840.74,337.93l-4.79-0.11c0,0,2.88-3.11,4.88-3.43L1840.74,337.93z"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "1825.94,325.9 1826.03,322.32 1822.39,323.79  "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M1889.27,320.78l-3.78-4.07c0,0,11.17,2.6,12.35,3.28S1895.53,321.04,1889.27,320.78z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M1811.41,324.75l8.99,0.21c0,0,0.92-11.67,0.7-12.66c0,0-5.85,1.91-7.35,3.1 C1812.26,316.59,1811.58,317.31,1811.41,324.75z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M1815.1,322.07c0,0-0.3-3.43,0.4-5.41c0,0,1.14,0.16,1.57,0.28c0,0,0.03,3.33-0.37,4.19 C1816.7,321.14,1815.92,322.03,1815.1,322.07z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M1878.6,314.95l0.14-0.16l6.98,6.13l0.01,0.04c0.24,1.47-0.02,17.33-0.03,18.01l-0.21,0 c0-0.16,0.26-16.26,0.04-17.93L1878.6,314.95z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1824.53,
    y: 324.06,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1460.0364 2142.2415)",
    className: "st122",
    width: 2.92,
    height: 0.21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st123",
    x1: 1840.47,
    y1: 337.93,
    x2: 1840.55,
    y2: 334.39
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: -740.2025,
    y1: 3005.4099,
    x2: -720.9639,
    y2: 3004.8103,
    gradientTransform: "matrix(0.0229 -0.9997 -0.9997 -0.0229 4922.688 -346.8854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#D9FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M1904.56,310.4c0,0-4.4-0.89-6.26-0.14s-0.19,6.78-0.44,7.84c-0.25,1.07,0.02,1.26,0.02,1.26 s4.77,2.11,5.66,2.27c0.88,0.16,2.07-2.97,2.29-5.26C1906.05,314.08,1905.7,311.13,1904.56,310.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: -761.3719,
    y1: 3071.3562,
    x2: -717.0464,
    y2: 3069.9749,
    gradientTransform: "matrix(0.0229 -0.9997 -0.9997 -0.0229 4922.688 -346.8854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#D9FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M1850.89,314.85c0,0-9-3.47-13.08-3.64c-4.08-0.18-14.52,1.96-15.19,2.51 c-0.67,0.56-1.22,3.17-1.17,4.52c0.05,1.35,6.27,1.25,9.81,0.22c3.54-1.03,8.45-1.4,9.64,0.22c1.19,1.62,3.23,3.09,2.71,5.23 c-0.51,2.14-0.88,3.48-1.61,3.45s-1.88-0.02-1.88-0.02s0.95,1.26,1.85,1.25c0.9-0.01,0.9-0.11,0.85,2.03s-0.17,7.4-0.17,7.4 l0.63-0.03c0,0,0.06-5.04,0.64-9.35c0.35-2.58,0.46-6.57,3.08-10.35C1848.32,316.42,1850.15,315.36,1850.89,314.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: -759.4045,
    y1: 2983.2751,
    x2: -729.8406,
    y2: 2982.3538,
    gradientTransform: "matrix(0.0229 -0.9997 -0.9997 -0.0229 4922.688 -346.8854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#D9FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M1925.47,339.88c0,0-0.19-15.22-0.37-16.37c-0.17-1.15-1.89-1.07-2.25-1.44 c-0.36-0.37-2.37,1.62-0.87,2.15s2.23,9.82,2.1,15.58L1925.47,339.88z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1814.13,
    y: 331.75,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1444.4165 2143.4558)",
    className: "st127",
    width: 9.32,
    height: 2.04
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1448.1057 2156.9524)",
    className: "st115",
    cx: 1827.54,
    cy: 337.63,
    rx: 9.37,
    ry: 8.41
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1909.03,
    y: 339.92,
    transform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 2298.2771 -1561.1042)",
    className: "st116",
    width: 5.94,
    height: 5.23
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1912.39,
    y: 340.07,
    transform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 2297.7258 -1564.5221)",
    className: "st117",
    width: 2,
    height: 0.98
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1910.84,
    y: 340.07,
    transform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 2296.1489 -1562.97)",
    className: "st117",
    width: 2,
    height: 0.98
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1909.3,
    y: 340.04,
    transform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 2294.532 -1561.4607)",
    className: "st117",
    width: 2,
    height: 0.98
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1911.87,
    y: 343.17,
    transform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 2300.7556 -1561.2765)",
    className: "st117",
    width: 2.9,
    height: 0.98
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1910.32,
    y: 343.2,
    transform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 2299.1965 -1559.7052)",
    className: "st117",
    width: 2.9,
    height: 0.98
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1908.78,
    y: 343.16,
    transform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 2297.5796 -1558.1959)",
    className: "st117",
    width: 2.9,
    height: 0.98
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M1840.74,337.93l-4.79-0.11c0,0,2.73,3.24,4.71,3.65L1840.74,337.93z"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "1825.41,349.27 1825.33,352.85 1821.77,351.21  "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M1888.44,357.29l-3.96,3.89c0,0,11.28-2.09,12.49-2.71C1898.18,357.84,1894.7,357.32,1888.44,357.29z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M1810.84,349.76l8.99,0.21c0,0,0.39,11.7,0.12,12.68c0,0-5.76-2.18-7.2-3.44 C1811.31,357.95,1810.67,357.19,1810.84,349.76z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M1814.4,352.6c0,0-0.46,3.42,0.15,5.42c0,0,1.15-0.11,1.59-0.21c0,0,0.19-3.32-0.18-4.2 C1815.96,353.61,1815.22,352.68,1814.4,352.6z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1813.92,
    y: 341.06,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1434.8961 2152.3474)",
    className: "st127",
    width: 9.32,
    height: 2.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 3155.7246,
    y1: 3000.3103,
    x2: 3155.7246,
    y2: 3064.8899,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42210B"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M1867.02,321.04l15.24-0.3c0,0-4.03-3.53-5.08-4.45s-2.6-0.89-2.6-0.89l-18.47-0.42 C1856.49,315.54,1867.02,321.04,1867.02,321.04z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M1855.93,314.86l18.67,0.43c0.06,0,1.6-0.02,2.66,0.91l5.28,4.63l-15.54,0.31l-0.02-0.01 c-1.08-0.56-10.57-5.52-10.94-6.1L1855.93,314.86z M1881.99,320.63l-4.87-4.27c-1-0.88-2.51-0.86-2.52-0.86l-18.18-0.42 c1.14,0.81,6.78,3.83,10.64,5.85L1881.99,320.63z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 3196.5273,
    y1: 3000.3079,
    x2: 3196.5273,
    y2: 3064.8877,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42210B"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M1876.16,361.23c1.09-0.87,5.28-4.21,5.28-4.21l-15.21-1c0,0-10.77,5-11.17,5.56l18.47,0.42 C1873.53,362,1875.08,362.1,1876.16,361.23z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M1854.85,361.68l0.12-0.16c0.4-0.56,10.1-5.08,11.21-5.59l0.02-0.01l0.03,0l15.49,1.02l-5.49,4.38 c-1.1,0.88-2.64,0.79-2.71,0.79L1854.85,361.68z M1866.24,356.12c-3.95,1.83-9.71,4.59-10.89,5.35l18.18,0.42 c0.02,0,1.53,0.09,2.57-0.74l5.06-4.04L1866.24,356.12z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 3166.0818,
    y1: 2980.4414,
    x2: 3166.0818,
    y2: 3027.8567,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42210B"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M1898.57,334.16c3.57-0.6,9.29-3.97,9.29-3.97c-0.48-5.94-3.07-5.39-3.07-5.39l-15.64-0.81l-0.12,5.17 C1892.36,330.85,1895.89,334.61,1898.57,334.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 3171.4756,
    y1: 2980.4414,
    x2: 3171.4756,
    y2: 3027.8567,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42210B"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M1907.86,330.19l0.2,9.26C1908.08,339.17,1908.32,335.87,1907.86,330.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 3183.6467,
    y1: 2980.4414,
    x2: 3183.6467,
    y2: 3027.8567,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42210B"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M1891.16,345.96c-0.68-0.04-1.53-0.09-2.5-0.15l-0.19,8.26l15.66-0.09c0,0,2.56,0.67,3.31-5.24 c0.75-5.91,0.62-9.27,0.62-9.27S1896.21,346.24,1891.16,345.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 3163.0437,
    y1: 3021.5869,
    x2: 3163.0437,
    y2: 3074.6228,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42210B"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M1859.17,335.38c0.86-0.1,2.14-0.38,3.68-0.77c0.29-3.76,0.93-9.24,2.32-11.44c0,0,0.29-0.81-0.52-1.27 c-0.81-0.45-12.17-6.44-12.17-6.44s-0.73-1.33-2.4-0.05c-1.51,1.15-5.49,2.2-6.56,17.44 C1845.42,333.35,1854.62,335.93,1859.17,335.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 3192.1699,
    y1: 3021.5869,
    x2: 3192.1699,
    y2: 3074.6228,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42210B"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M1851.45,360.91c0,0,11.63-5.46,12.45-5.87s0.57-1.24,0.57-1.24c-0.78-1.37-1.23-3.93-1.49-6.57 c-2.33,1.56-5.11,3.39-8.44,4.33c-3.68,1.05-7.65,0.82-10.44,0.42c1.32,7.02,3.83,7.95,4.94,8.87 C1850.65,362.2,1851.45,360.91,1851.45,360.91z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M1908.06,339.48l0-0.02C1908.06,339.47,1908.06,339.47,1908.06,339.48L1908.06,339.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 3174.6235,
    y1: 2980.4414,
    x2: 3174.6235,
    y2: 3027.8567,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42210B"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M1888.81,339.08l-0.15,6.73c0.97,0.06,1.82,0.11,2.5,0.15c5.06,0.28,16.9-6.48,16.9-6.48l0,0 c0,0,0-0.01,0-0.02l-0.2-9.26c0,0-5.73,3.37-9.29,3.97c-2.68,0.45-6.2-3.31-9.53-5L1888.81,339.08L1888.81,339.08z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1888.81,339.08l-0.15,6.73c0.97,0.06,1.82,0.11,2.5,0.15c5.06,0.28,16.9-6.48,16.9-6.48l0,0 c0,0,0-0.01,0-0.02l-0.2-9.26c0,0-5.73,3.37-9.29,3.97c-2.68,0.45-6.2-3.31-9.53-5L1888.81,339.08L1888.81,339.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 3180.6597,
    y1: 3021.5869,
    x2: 3180.6597,
    y2: 3074.6228,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29ABE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42210B"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M1854.55,351.56c3.32-0.95,6.11-2.77,8.44-4.33c-0.42-4.29-0.34-8.79-0.34-8.79l0,0 c0-0.01,0.05-1.62,0.21-3.82c-1.55,0.39-2.83,0.66-3.68,0.77c-4.56,0.55-13.76-2.04-15.64-2.53 c-0.11,1.56-0.19,3.26-0.23,5.13l0,0c-0.14,6.32,0.21,10.79,0.81,13.99C1846.9,352.38,1850.87,352.6,1854.55,351.56z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M1854.55,351.56c3.32-0.95,6.11-2.77,8.44-4.33c-0.42-4.29-0.34-8.79-0.34-8.79l0,0 c0-0.01,0.05-1.62,0.21-3.82c-1.55,0.39-2.83,0.66-3.68,0.77c-4.56,0.55-13.76-2.04-15.64-2.53 c-0.11,1.56-0.19,3.26-0.23,5.13l0,0c-0.14,6.32,0.21,10.79,0.81,13.99C1846.9,352.38,1850.87,352.6,1854.55,351.56z"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M1811.39,316.57c0,0-7.78,20.51-0.74,41.36c0,0,0.6,0.67,0.9-0.12c0.3-0.79-2.11-13.36-0.94-17.95 C1811.79,335.26,1814.71,312.68,1811.39,316.57z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M1877.51,362.63l7.19-5.75c0.3-1.66,0.78-17.75,0.78-17.92l0.21,0.01c-0.02,0.67-0.49,16.53-0.8,17.99 l-0.01,0.04l-7.25,5.8L1877.51,362.63z"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1823.91,
    y: 350.9,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1432.611 2167.8469)",
    className: "st122",
    width: 2.92,
    height: 0.21
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st123",
    x1: 1840.47,
    y1: 337.93,
    x2: 1840.39,
    y2: 341.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 3191.2166,
    y1: 3005.4077,
    x2: 3210.4551,
    y2: 3004.8081,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#D9FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M1903.24,368.36c0,0-4.44,0.69-6.26-0.14c-1.82-0.83,0.12-6.78-0.08-7.86c-0.2-1.08,0.08-1.25,0.08-1.25 s4.87-1.88,5.75-2.01c0.89-0.12,1.94,3.06,2.05,5.36C1904.89,364.75,1904.41,367.68,1903.24,368.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 3170.0469,
    y1: 3071.354,
    x2: 3214.3726,
    y2: 3069.9727,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#D9FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M1849.83,361.46c0,0-9.15,3.05-13.23,3.04c-4.09-0.01-14.41-2.62-15.05-3.21 c-0.64-0.59-1.07-3.22-0.96-4.57c0.11-1.34,6.32-0.96,9.81,0.22c3.49,1.19,8.38,1.78,9.64,0.22s3.37-2.94,2.95-5.1 c-0.41-2.16-0.72-3.52-1.45-3.52c-0.73,0-1.87-0.07-1.87-0.07s1.01-1.21,1.91-1.16c0.9,0.05,0.9,0.15,0.95-1.99 c0.05-2.14,0.17-7.4,0.17-7.4l0.63,0.06c0,0-0.17,5.04,0.21,9.37c0.23,2.6,0.16,6.58,2.6,10.48 C1847.33,359.77,1849.1,360.91,1849.83,361.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 3171.9124,
    y1: 2983.2759,
    x2: 3201.6143,
    y2: 2982.3503,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9DFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#D9FFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88BCCA"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M1925.47,339.87c0,0-0.89,15.2-1.12,16.33c-0.22,1.14-1.94,0.98-2.31,1.34 c-0.38,0.36-2.29-1.73-0.77-2.19c1.52-0.46,2.68-9.79,2.81-15.55L1925.47,339.87z"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1814.13,
    y: 331.75,
    transform: "matrix(0.0229 -0.9997 0.9997 0.0229 1444.4165 2143.4558)",
    className: "st127",
    width: 9.32,
    height: 2.04
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-0.0252 1.099 -0.9997 -0.0229 1821.1941 332.3313)",
    className: "st97 st144"
  }, "1")), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1897.69,368.03c-0.3-0.03-0.46-0.38-0.54-0.62c-0.13-0.38-0.22-0.79-0.28-1.19 c-0.14-0.84-0.15-1.7-0.03-2.55c0.03-0.2-0.29-0.21-0.32-0.01c-0.12,0.94-0.1,1.9,0.08,2.83c0.08,0.41,0.17,0.85,0.34,1.23 c0.15,0.32,0.39,0.58,0.75,0.62C1897.88,368.37,1897.89,368.05,1897.69,368.03L1897.69,368.03z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1897.93,311.67c-0.51,0.7-0.6,1.65-0.25,2.45c0.08,0.19,0.36,0.03,0.28-0.15 c-0.3-0.69-0.2-1.52,0.24-2.13C1898.32,311.67,1898.05,311.51,1897.93,311.67L1897.93,311.67z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1874.5,355.86c-2.14,0.13-4.24-0.45-6.24-1.16c-0.57-0.2-1.13-0.42-1.69-0.63 c-0.19-0.07-0.28,0.23-0.09,0.3c2.01,0.77,4.05,1.54,6.2,1.77c0.6,0.06,1.2,0.08,1.81,0.04 C1874.7,356.16,1874.71,355.85,1874.5,355.86L1874.5,355.86z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1867.15,322.19c1.99-0.48,4.05-0.66,6.1-0.54c0.2,0.01,0.21-0.3,0.01-0.32 c-2.07-0.12-4.16,0.06-6.18,0.55C1866.87,321.94,1866.95,322.24,1867.15,322.19L1867.15,322.19z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1843.46,352.34c0.15,1.14,0.57,2.23,1.23,3.18c0.11,0.17,0.39,0.01,0.28-0.15 c-0.64-0.93-1.05-1.99-1.2-3.1C1843.74,352.06,1843.43,352.14,1843.46,352.34L1843.46,352.34z"
  })))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1924.79,322.91c0,0-5.78-0.11-6.15,1.93s-1.5,29-1.5,29s-1.65-2.9-2.04-5.32s1.23-22.3-0.86-24.16 c-2.09-1.87-22.57-3.95-28.02-3.35c-5.45,0.6-19.66-1.16-21.66,1.15c-2.01,2.31-3.97,9.32-8.34,10.76 c-4.36,1.44-13.5,3.07-13.5,3.07s1.89-9.48,1.9-12.02c0.01-2.54-20.21-0.44-20.21-0.44s9.87-1.23,11.14-2.65 c1.28-1.42,0.06-4.88-4.1-5.39c-4.17-0.51-15.88-1.96-19,4.86s-4.59,13.31-4.59,13.31s0.01-13.99,5.16-17.5 c5.15-3.51,16.48-7.84,26.65-4.58c10.17,3.27,42.71,4.01,42.71,4.01l5.81-0.75c0,0,4.7-3.24,10.21-3.69 c5.51-0.45,15.52,3.92,19.05,7.41C1920.99,322.03,1924.79,322.91,1924.79,322.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 3167.5039,
    y1: 3043.6172,
    x2: 3203.3105,
    y2: 3047.7864,
    gradientTransform: "matrix(-0.0229 0.9997 -0.9997 -0.0229 4978.187 -2767.0823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M1809.69,356.87c0,0,7.6,8.64,19.7,8.3c13.52-0.38,19.24-2.1,21.63-2.08s10.06-0.31,12.98-0.62 c13.54-1.46,24.63,2.23,24.63,2.23s8.86-4.35,14.77-4.84c5.9-0.49,8.51-1.05,8.51-1.05s-9.33-0.16-14.1-0.97 c-4.76-0.81-19.57-1.66-23.88-1.38c-4.31,0.28-11.73-0.46-16.24-5.56c-4.5-5.09-14.18-17.17-14.18-17.17l-1.04,13.34 c0,0-0.06,3.91-7.6,3.66c-7.54-0.25-27.23-7.21-27.23-7.21S1808.86,355.29,1809.69,356.87z"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u0415\\u041D\\u042C_\\u0422\\u0410\\u0427\\u041A\\u0418",
    className: "st94"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M2843.7,1456.92c-0.11,0.17-0.05,0.46-0.05,0.46l1.21,1.08l1.21,1.08c0,0,0.3,0.03,0.45-0.1 c0.15-0.13,0.71-0.79,0.71-0.79l-1.41-1.26l-1.41-1.26C2844.41,1456.13,2843.81,1456.75,2843.7,1456.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M2933.32,1391.24c0,0-0.22-0.2-0.53-0.49c-0.2-0.9-1.13-2.35-1.89-3.03c-0.63-0.56-1.85-0.81-2.53-0.91 c-0.35-0.32-0.59-0.55-0.59-0.55s-0.58-0.01-1.52,0.61l-0.03-0.01c0.13-0.08,0.2-0.11,0.2-0.11l-1.72-0.26 c0.15-0.77,0.23-1.79,0.18-2.86c0-0.19-0.01-0.35-0.02-0.48c0,0,0,0.01,0,0.01c-0.11-1.34-0.46-2.68-1.18-3.62 c-1.93-2.47-4.41-4.35-4.41-4.35s-0.77-0.8-1.94-1.79c-0.05-0.09-0.11-0.18-0.2-0.26c-0.71-0.63-1.59-1.3-2.62-1.81 c-0.02-0.01-0.03-0.02-0.05-0.03c-0.73-0.45-1.64-0.67-2.6-0.75c-0.24-0.02-0.49-0.03-0.74-0.02c-0.1,0-0.2-0.01-0.3,0 c-0.03,0-0.05,0-0.07,0c-0.13,0-0.29,0.01-0.48,0.03c-1.06,0.07-2.07,0.26-2.82,0.49l-0.45-1.68c0,0-0.02,0.07-0.08,0.21 l-0.01-0.03c0.51-1,0.44-1.58,0.44-1.58s-0.25-0.22-0.62-0.53c-0.17-0.66-0.56-1.85-1.19-2.41c-0.76-0.68-2.31-1.44-3.22-1.54 c-0.32-0.28-0.54-0.47-0.54-0.47l-1.28,0.53c0,0-1.86,0.29-4.73,2l0-0.01c0,0-2.49-0.52-4.35,0.28c-0.04,0.02-0.08,0.04-0.12,0.05 c-0.07,0.03-0.13,0.07-0.2,0.1c-0.03,0.02-0.07,0.03-0.1,0.05c-0.02,0.01-0.04,0.03-0.06,0.04c-0.12,0.07-0.23,0.15-0.34,0.24 c-0.02,0.02-0.04,0.03-0.07,0.05c-0.02,0.02-0.05,0.04-0.07,0.06c0,0,0.02-0.01,0.02-0.01c-0.23,0.18-0.5,0.43-0.81,0.7 c-2.79,0.08-5.55,1.25-7.55,3.48c-1.87,2.1-2.74,4.75-2.65,7.37c-0.36,0.47-0.71,0.95-1.02,1.45c-0.06,0.09-0.07,0.21-0.07,0.33 c-0.6,1.83-0.95,4.7-0.95,4.7h0c-2.71,3.14-5.64,6.53-8.53,9.88l-0.18-0.06c0,0,0.39-1.22-0.5-1.31c-0.84-0.09-3.51,1.1-4.98,2.78 c0,0-0.01-0.01-0.01-0.01l-0.26,0.32c0,0,1.45,1.59,2.55,2.2c-7.7,8.92-14.28,16.56-14.28,16.56s-1.49-0.77-2.96-0.71l0,0 c-1.26-0.08-2.72,0.13-3.98,1.1c-2.43,1.87-4.47,3.69-6.2,5.45c-0.93,0.54-1.79,1.23-2.54,2.07c-0.91,1.02-1.57,2.17-2.02,3.38 c-7.18,10.43-3.29,17.53-3.29,17.53l-0.46,0.51l1.48,1.43l0.51-0.57c0,0,2.89,0.69,3.78,1.51s1.22,1.09,1.22,1.09l4.72,5.36 c0.59,1.03,4,4.08,4,4.08l0.36,0.32l0.36,0.32c0,0,3.16,2.82,4.37,3.45c0.01,0.01,0.02,0.02,0.04,0.03 c0.72,0.52,1.45,1.02,2.2,1.51l3.76,2.62c0,0,0.31,0.3,1.22,1.09c0.92,0.79,1.93,3.59,1.93,3.59l-0.51,0.57l1.59,1.31l0.46-0.51 c0,0,8.56,3.53,19.06-7.11c0.27-0.25,0.54-0.51,0.79-0.79l0,0c0.09-0.1,0.16-0.2,0.24-0.3c2.14-2.34,4.35-5.26,6.58-8.94 c0.83-1.37,0.87-2.84,0.65-4.08l0,0c-0.11-1.47-1.04-2.86-1.04-2.86s6.85-7.4,14.85-16.05c0.73,1.03,2.47,2.28,2.47,2.28l0.29-0.3 c0,0-0.01-0.01-0.01-0.01c1.51-1.64,2.39-4.43,2.21-5.26c-0.19-0.87-1.36-0.35-1.36-0.35l-0.08-0.17 c3.01-3.25,6.05-6.54,8.87-9.59l0,0c0,0,2.93-0.7,4.68-1.52c0.35-0.16,1.01-0.76,1.86-1.6c2.38-0.33,4.66-1.47,6.38-3.39 c1.83-2.05,2.7-4.63,2.65-7.19c0.37-0.5,0.68-0.94,0.9-1.28c0,0,0,0.01,0,0.01c0.01-0.02,0.02-0.04,0.03-0.05 c0.03-0.05,0.06-0.1,0.09-0.15c0.05-0.09,0.1-0.17,0.15-0.26c0.02-0.04,0.04-0.08,0.06-0.12c0.02-0.04,0.03-0.07,0.04-0.11 c0.03-0.07,0.05-0.14,0.08-0.21c0.01-0.04,0.03-0.09,0.04-0.13c0.59-1.94-0.21-4.35-0.21-4.35l0,0c1.38-3.04,1.46-4.93,1.46-4.93 L2933.32,1391.24z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u0410\\u0427\\u041A\\u0410",
    className: "st94"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st96"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 2943.6602,
    y1: 158.9818,
    x2: 2943.6602,
    y2: 177.5248,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    style: {
      stopColor: "#4C4C4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M2846.26,1411.22l29.87,26.7c4.32,3.86,4.69,10.54,0.83,14.86l0,0c-3.86,4.32-10.54,4.69-14.86,0.83 l-29.87-26.7c-4.32-3.86-4.69-10.54-0.83-14.86l0,0C2835.26,1407.74,2841.95,1407.36,2846.26,1411.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 2943.6602,
    y1: 228.8891,
    x2: 2943.6602,
    y2: 247.4322,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    style: {
      stopColor: "#4C4C4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M2892.85,1359.09l29.87,26.7c4.32,3.86,4.69,10.54,0.83,14.86l0,0c-3.86,4.32-10.54,4.69-14.86,0.83 l-29.87-26.7c-4.32-3.86-4.69-10.54-0.83-14.86l0,0C2881.84,1355.61,2888.53,1355.23,2892.85,1359.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 2956.3442,
    y1: 164.2155,
    x2: 2974.8765,
    y2: 164.8374,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    style: {
      stopColor: "#348DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M2847.09,1404.14c0,0-4.01-1.87-6.94,0.39c-20.85,16.07-14.05,28.42-14.05,28.42l1.53,1.37 c0,0,2.89,0.69,3.78,1.51c0.89,0.82,1.22,1.09,1.22,1.09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 2965.668,
    y1: 235.4608,
    x2: 2971.6641,
    y2: 235.662,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    style: {
      stopColor: "#348DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M2891.65,1354.87c0,0-2.97-0.57-4.77,0.49c-1.81,1.05-11.98,11.79-12.6,13.61s-0.98,4.82-0.98,4.82 l4.52-1.22L2891.65,1354.87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 2955.0981,
    y1: 200.6197,
    x2: 2970.9062,
    y2: 201.1501,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    style: {
      stopColor: "#348DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2903.33,1360.37l-0.54-1.49l-6.42-6.01c0,0-5.72,0.89-12.6,8.8c-6.88,7.91-36.68,42.47-36.68,42.47 s-15.92,24.43-14.46,32.79l71.48-75.68L2903.33,1360.37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 2941.8086,
    y1: 202.0184,
    x2: 2965.8337,
    y2: 202.8246,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    style: {
      stopColor: "#348DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M2915.16,1364.51c0,0-2.14-2.25-4.81-3.89c-1.93-1.19-5.23-0.81-7.02-0.25c0,0-1.68,2-2.1,2.34 c-0.42,0.35-41.49,29.93-54.18,45.46c-12.69,15.53-14.42,28.76-14.42,28.76l4.72,5.36l4,4.08l0.36,0.32L2915.16,1364.51z"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "2827.63,1434.33 2826.1,1432.96 2825.64,1433.47 2827.12,1434.9  "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M2840.76,1447.77l-1.21-1.08c0,0-0.06-0.29,0.05-0.46s0.71-0.79,0.71-0.79l1.41,1.26L2840.76,1447.77z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M2914.78,1364.22l-73.42,82.16c0,0-3.41-3.04-4-4.08l72.99-81.68 C2910.35,1360.62,2913.08,1362.49,2914.78,1364.22z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M2898.18,1383.52l-3.13-2.79c0,0-9.65,10.08-10.58,12.44c0,0,9.97-12.66,10.45-13.15l3.55,3.17 L2898.18,1383.52z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M2902.73,1357.25c0,0-0.4-2.09-1.3-2.9c-0.9-0.81-2.89-1.72-3.65-1.54s3.08,4.05,3.08,4.05 L2902.73,1357.25z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M2902.79,1358.88c0,0-4.43-3.69-6.42-6.01l1.28-0.53c0,0,2.07,1.8,2.98,2.66c0.91,0.86,2.6,2.3,2.6,2.3 S2903.31,1357.88,2902.79,1358.88z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M2860.56,1425.96l-12.08-10.8c0,0-4.04-3.4-1.24-6.84c2.8-3.44,12.01-13.02,12.62-13.33 c0.6-0.31,3.64-1.05,14.18,9.36l3.25,2.9L2860.56,1425.96z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M2861.59,1424.46c0,0-2.39-2.23-2.13-2.65s11.93-11.54,14.4-17.62l3.25,2.9L2861.59,1424.46z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M2871.13,1413.78c0,0-0.6-1.08-0.09-1.65c0.51-0.57,1.27-0.7,1.78-0.24L2871.13,1413.78z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M2866.94,1401.44c0,0,4.04,2.96,4.2,4.84s-4.1,7.25-5.41,8.47c-1.3,1.22-6.29,6.31-9.2,5.21 c-2.91-1.1-6.07-3.49-7.49-5.41c-1.42-1.92-1.56-5.39,0.32-7.5c1.88-2.1,8.94-9.31,10.35-10.21 C2861.14,1395.93,2865.21,1400.01,2866.94,1401.44z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M2868.72,1409.95c0,0-5.86,6.55-9.61,7.85c-2.43,0.84-4.58,0.56-7.09-1.91c-2.52-2.47-3.3-4.36-2.1-6.74 c1.21-2.38,9.51-10.64,9.51-10.64s-4.37,7.12-4.19,9.34c0.18,2.22,3.6,4.87,4.68,5.05 C2862.57,1413.33,2867.31,1411.4,2868.72,1409.95z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M2882.87,1400.65l-1.29,1.44c0,0-10.28-9.19-16.77-10.88c0,0,0.79-1.24,1.64-1.35 C2866.45,1389.87,2876.73,1394.08,2882.87,1400.65z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M2866.22,1384.2l-1.63-0.59c0,0,0.39-1.22-0.5-1.31c-0.89-0.09-3.87,1.24-5.25,3.09 c0,0,2.34,2.58,3.33,2.44c0.99-0.14,1.5-2.04,1.5-2.04l1.7,0.64C2865.37,1386.41,2866.88,1385.27,2866.22,1384.2z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M2879.41,1390.31c0,0-0.57,0.08-0.99,0.47s-0.94,0.3-1.15,0.05c-0.21-0.24,0.34-1.59,0.79-1.73 S2879.38,1389.25,2879.41,1390.31z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M2864.81,1391.21c0,0,5.05,0.4,16.77,10.88l-6.39,7.15c0,0-9.85-8.91-17.41-10.36 C2857.78,1398.88,2853.64,1398.64,2864.81,1391.21z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M2875.22,1409.21l-0.07,0.08c-0.09-0.08-9.56-8.4-16.35-10.11l-1.27-0.29c-0.01,0-0.68-0.16-0.55-0.78 l0.1,0.02c-0.11,0.52,0.45,0.65,0.47,0.65l1.27,0.29C2865.65,1400.79,2875.13,1409.12,2875.22,1409.21z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M2859.09,1385.06c0,0,1.97,2.16,2.75,1.85c0.78-0.31,2.37-3.36,2.37-3.36l-0.53,1.9l2.12,0.54l-0.44,0.42 l-1.7-0.64c0,0-0.68,1.75-1.33,1.75c-0.65,0-1.51-0.16-3.51-2.14L2859.09,1385.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 2937.4592,
    y1: 210.7102,
    x2: 2988.4929,
    y2: 209.5009,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    style: {
      stopColor: "#F2F2F2",
      stopOpacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M2901.23,1357.42c0,0-2.93-2.43-3.72-3.32c0,0-7.62,3.02-10.55,6.77c-2.93,3.75-18.24,21.88-19.7,23.51 s-16.33,14.81-21.76,23.05c-5.44,8.24-5.9,10.54-5.9,10.54s7.13-10.42,10.33-14.21c3.21-3.78,34.03-30.47,37.44-33.39 C2890.8,1367.46,2897.14,1363.26,2901.23,1357.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 2937.9553,
    y1: 231.6418,
    x2: 2988.9888,
    y2: 230.4325,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M2913.24,1364.91c0,0-3.11-3.11-5.95-2.29c-2.84,0.82-37.04,29.04-37.04,29.04s4.06,1.33,12.62,8.99 l31.24-34.96L2913.24,1364.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 2936.3037,
    y1: 161.9474,
    x2: 2987.3374,
    y2: 160.7381,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M2860.39,1425.81l-12.08-10.8c0,0-0.8,1.16-0.41,2.41c0.39,1.25,3.24,4.77,2.68,6.3 c-0.56,1.53-5.72,1.78-8.28,3.06c-2.56,1.28-8.73,8.75-7.83,10.36c0.9,1.61,5.82,6.63,8.07,8.65L2860.39,1425.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 2936.2739,
    y1: 160.6945,
    x2: 2987.3076,
    y2: 159.4851,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M2829.27,1432.49c0,0,0.79-9.68,4.86-15.28s5.46-8.79,3.11-7.7c-2.35,1.09-8.24,6.8-10.2,13.05 C2825.08,1428.8,2829.25,1438.32,2829.27,1432.49z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M2853.06,1423.93c-0.21,0.36-0.32,0.5-0.52,0.79c-0.49,0.68-1.01,1.34-1.58,1.95 c-1.29,1.39-2.99,2.83-4.97,2.99c-2.41,0.2-4.63-1.89-5.32-4.08c-0.67-2.11,0.09-4.33,1.18-6.16c0.72-1.21,1.61-2.38,2.64-3.34 c0.49-0.46-0.29-1.15-0.78-0.69c-0.98,0.92-1.82,2.02-2.54,3.15c-1.27,1.99-2.15,4.4-1.65,6.78c0.53,2.53,2.84,5.05,5.49,5.37 c2.32,0.28,4.4-1.06,6.02-2.59c1.14-1.08,2.17-2.34,2.98-3.69C2854.34,1423.82,2853.4,1423.36,2853.06,1423.93L2853.06,1423.93z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M2839.55,1429.95c0.77-0.44,1.55-0.87,2.32-1.31c0.58-0.33,0.02-1.2-0.56-0.88 c-0.77,0.44-1.55,0.87-2.32,1.31C2838.4,1429.41,2838.97,1430.28,2839.55,1429.95L2839.55,1429.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 2956.7141,
    y1: 163.2201,
    x2: 2965.1748,
    y2: 163.2201,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M2832.64,1436.93c0,0,5.22-15.6,13.46-25.71c0,0-0.45-1.61,0.25-2.33 C2846.36,1408.89,2833.81,1424.65,2832.64,1436.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 2963.104,
    y1: 171.7139,
    x2: 2970.4707,
    y2: 171.7139,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M2844.13,1403.43c0,0,0.75,1.98-0.21,4.15c-0.5,1.12-3.66,6.44-5.44,10.13 c-1.66,3.43-1.97,5.31-1.97,5.31s8.06-15.94,10.59-18.87C2847.09,1404.14,2845.61,1403.37,2844.13,1403.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 2952.9116,
    y1: 230.399,
    x2: 2962.8684,
    y2: 230.399,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M2866.45,1389.87c0,0,34.75-28.83,35.29-29.45c1.01-1.15,1.15-1.73,1.15-1.73l0.45,1.68 c0,0,2.45-0.53,3.3-0.52c0,0-33.86,25.73-35.41,27.04C2869.67,1388.2,2866.45,1389.87,2866.45,1389.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 2967.4006,
    y1: 238.6278,
    x2: 2970.7766,
    y2: 238.6278,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M2886.33,1355.75c0,0,1.97-1.24,2.29-0.14s-5.14,4.66-7.24,7.62c-2.1,2.96-4.05,5.87-4.05,5.87 s9.86-12.3,14.31-14.24C2891.65,1354.87,2888.13,1354.12,2886.33,1355.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 1337.382,
    y1: 164.2155,
    x2: 1355.9139,
    y2: 164.8374,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    style: {
      stopColor: "#348DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st180",
    d: "M2883.4,1436.59c0,0,2.31,3.77,0.39,6.94c-13.64,22.52-26.67,17.14-26.67,17.14l-1.53-1.37 c0,0-1.01-2.8-1.93-3.59c-0.92-0.79-1.22-1.09-1.22-1.09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 1346.7056,
    y1: 235.4608,
    x2: 1352.7018,
    y2: 235.662,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    style: {
      stopColor: "#348DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M2927.38,1386.8c0,0,0.9,2.88,0.05,4.8s-10.37,13.22-12.12,14.04c-1.74,0.82-4.68,1.52-4.68,1.52 l0.71-4.63L2927.38,1386.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 1336.1356,
    y1: 200.6197,
    x2: 1351.9437,
    y2: 201.1501,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    style: {
      stopColor: "#348DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M2920.61,1375.81l1.54,0.37l6.69,5.71c0,0-0.24,5.79-7.33,13.5s-38.1,41.2-38.1,41.2 s-22.49,18.55-30.97,18.03l67.21-79.5L2920.61,1375.81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 1322.8461,
    y1: 202.0184,
    x2: 1346.8715,
    y2: 202.8246,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    style: {
      stopColor: "#348DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M2915.16,1364.51c0,0,2.48,1.87,4.41,4.35c1.4,1.79,1.39,5.11,1.04,6.95c0,0-1.8,1.89-2.1,2.34 s-25.09,44.58-39.11,58.92c-14.01,14.35-26.97,17.55-26.97,17.55l-5.86-4.09l-4.5-3.52l-0.36-0.32L2915.16,1364.51z"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "2855.59,1459.31 2857.12,1460.68 2856.66,1461.19 2855.08,1459.88  "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M2840.76,1447.77l1.21,1.08c0,0,0.3,0.03,0.45-0.1c0.15-0.13,0.71-0.79,0.71-0.79l-1.41-1.26 L2840.76,1447.77z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M2915.5,1364.86l-73.42,82.16c0,0,3.41,3.04,4.5,3.52l72.99-81.68 C2919.57,1368.86,2917.41,1366.35,2915.5,1364.86z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M2898.18,1383.52l3.13,2.79c0,0-8.93,10.72-11.18,11.9c0,0,11.47-11.32,11.9-11.86l-3.55-3.17 L2898.18,1383.52z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M2923.77,1376.06c0,0,2.12,0.17,3.02,0.97c0.9,0.81,2.03,2.68,1.94,3.46c-0.1,0.78-4.37-2.61-4.37-2.61 L2923.77,1376.06z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M2922.15,1376.18c0,0,4.16,3.99,6.69,5.71l0.38-1.33c0,0-2.02-1.86-2.98-2.66 c-0.96-0.8-2.57-2.32-2.57-2.32S2923.08,1375.55,2922.15,1376.18z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M2860.39,1425.81l12.08,10.8c0,0,3.83,3.64,6.94,0.47s11.59-13.4,11.84-14.03 c0.24-0.64,0.63-3.73-10.89-13.04l-3.25-2.9L2860.39,1425.81z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M2861.59,1424.46c0,0,2.48,2.13,2.87,1.82c0.39-0.3,10.13-13.14,15.9-16.29l-3.25-2.9L2861.59,1424.46z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M2871.13,1413.78c0,0,1.14,0.48,1.65-0.09c0.51-0.57,0.55-1.34,0.04-1.8L2871.13,1413.78z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M2883.87,1416.57c0,0-3.39-3.68-5.27-3.63c-1.88,0.05-6.75,4.89-7.81,6.32 c-1.06,1.43-5.57,6.96-4.15,9.72c1.42,2.77,4.15,5.64,6.22,6.84c2.07,1.2,5.53,0.95,7.41-1.16c1.88-2.1,8.25-9.93,8.99-11.43 C2889.99,1421.72,2885.48,1418.13,2883.87,1416.57z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M2875.21,1415.75c0,0-5.86,6.55-6.72,10.43c-0.56,2.51-0.04,4.61,2.69,6.83c2.73,2.22,4.7,2.8,6.93,1.33 s9.51-10.64,9.51-10.64s-6.59,5.14-8.81,5.21c-2.22,0.07-5.25-3.03-5.54-4.09C2872.54,1422.24,2873.93,1417.31,2875.21,1415.75z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M2882.87,1400.65l-1.29,1.44c0,0,10.28,9.19,12.69,15.45c0,0,1.15-0.92,1.16-1.78 C2895.42,1415.76,2890.08,1406.01,2882.87,1400.65z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M2901.08,1415.36l0.77,1.56c0,0,1.17-0.52,1.36,0.35c0.19,0.87-0.8,3.98-2.49,5.56 c0,0-2.83-2.04-2.8-3.04c0.03-1,1.86-1.72,1.86-1.72l-0.82-1.62C2898.97,1416.45,2899.94,1414.82,2901.08,1415.36z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M2893.53,1402.93c0,0-0.02,0.58-0.35,1.04c-0.34,0.46-0.19,0.96,0.07,1.15s1.54-0.51,1.63-0.98 C2894.97,1403.68,2894.58,1402.85,2893.53,1402.93z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M2894.27,1417.54c0,0-0.96-4.97-12.69-15.45l-6.39,7.15c0,0,9.95,8.79,12.25,16.14 C2887.43,1425.38,2888.14,1429.47,2894.27,1417.54z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M2875.22,1409.21c0.09,0.08,9.44,8.57,11.9,15.15l0.43,1.23c0.01,0.02,0.2,0.56,0.7,0.4l0.03,0.1 c-0.6,0.2-0.83-0.46-0.83-0.46l-0.43-1.23c-2.46-6.55-11.78-15.03-11.88-15.11L2875.22,1409.21z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M2901.02,1422.53c0,0-2.37-1.72-2.15-2.53s3.07-2.73,3.07-2.73l-1.83,0.74l-0.78-2.05l-0.37,0.49 l0.82,1.62c0,0-1.66,0.87-1.59,1.52s0.33,1.48,2.52,3.25L2901.02,1422.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 1318.4968,
    y1: 210.7102,
    x2: 1369.5304,
    y2: 209.5009,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    style: {
      stopColor: "#F2F2F2",
      stopOpacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M2923.78,1377.56c0,0,2.74,2.64,3.72,3.32c0,0-2.15,7.91-5.55,11.24s-19.7,20.58-21.16,22.2 s-12.89,17.88-20.47,24.21c-7.58,6.32-9.82,7.04-9.82,7.04s9.56-8.25,12.96-11.86c3.4-3.61,26.47-37.22,28.98-40.95 C2914.96,1389.05,2918.42,1382.28,2923.78,1377.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 1318.9928,
    y1: 231.6418,
    x2: 1370.0265,
    y2: 230.4325,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M2914.98,1366.47c0,0,3.44,2.75,2.94,5.66s-24.71,40.06-24.71,40.06s-1.78-3.88-10.34-11.54l31.24-34.96 L2914.98,1366.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 1317.3413,
    y1: 161.9474,
    x2: 1368.3749,
    y2: 160.7381,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M2860.39,1425.81l12.08,10.8c0,0-1.06,0.92-2.34,0.68c-1.29-0.25-5.11-2.68-6.56-1.96 s-1.13,5.88-2.11,8.57c-0.98,2.69-7.72,9.65-9.42,8.94c-1.7-0.71-7.24-5.04-9.5-7.05L2860.39,1425.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 1317.3115,
    y1: 160.6945,
    x2: 1368.3452,
    y2: 159.4851,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24788D"
    }
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M2857.22,1457.47c0,0,9.53-1.86,14.64-6.54s8.13-6.41,7.31-3.96c-0.82,2.46-5.83,8.95-11.82,11.6 C2861.37,1461.23,2851.44,1458.14,2857.22,1457.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 1337.7517,
    y1: 163.2201,
    x2: 1346.2125,
    y2: 163.2201,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M2852.44,1454.63c0,0,14.92-6.93,24.05-16.26c0,0,1.65,0.27,2.29-0.51 C2878.77,1437.86,2864.51,1452.09,2852.44,1454.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 1344.1416,
    y1: 171.7139,
    x2: 1351.5083,
    y2: 171.7139,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M2884.44,1439.46c0,0-2.05-0.52-4.1,0.68c-1.06,0.62-5.99,4.35-9.46,6.54c-3.23,2.03-5.05,2.55-5.05,2.55 s14.94-9.79,17.57-12.63C2883.4,1436.59,2884.33,1437.98,2884.44,1439.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 1333.9491,
    y1: 230.399,
    x2: 1343.9059,
    y2: 230.399,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M2895.42,1415.76c0,0,24.76-37.76,25.31-38.36c1.03-1.13,1.59-1.33,1.59-1.33l-1.72-0.26 c0,0,0.26-2.49,0.15-3.34c0,0-21.77,36.53-22.91,38.22S2895.42,1415.76,2895.42,1415.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 1348.4382,
    y1: 238.6278,
    x2: 1351.8142,
    y2: 238.6278,
    gradientTransform: "matrix(0.7456 0.6664 0.6664 -0.7456 1756.2155 673.7021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M2927.1,1392.18c0,0,1.01-2.1-0.12-2.3c-1.13-0.2-4.06,5.63-6.76,8.05c-2.71,2.42-5.38,4.68-5.38,4.68 s11.11-11.17,12.55-15.81C2927.38,1386.8,2928.52,1390.22,2927.1,1392.18z"
  }))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2924.82,1382.6c-0.17,0.62-0.35,1.24-0.56,1.85c0.02-0.06,0.04-0.13,0.07-0.19 c-0.65,1.89-1.49,3.7-2.51,5.42c-0.29,0.49-0.59,0.96-0.91,1.43c0.04-0.06,0.08-0.12,0.12-0.17c-0.93,1.36-1.97,2.65-3.12,3.83 c-0.28,0.29-0.26,0.84,0.06,1.1c0.34,0.28,0.8,0.25,1.1-0.06c1.37-1.41,2.57-2.96,3.64-4.61c1.03-1.6,1.9-3.3,2.59-5.07 c0.41-1.05,0.77-2.12,1.06-3.21c0.11-0.4-0.21-0.86-0.61-0.92C2925.3,1381.92,2924.93,1382.18,2924.82,1382.6L2924.82,1382.6z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2893.31,1354.74c-1.81,1.13-3.57,2.36-5.26,3.67c-1.73,1.35-3.39,2.78-4.97,4.3 c-0.87,0.83-1.71,1.69-2.52,2.58c-0.28,0.3-0.26,0.84,0.06,1.1c0.33,0.27,0.81,0.26,1.1-0.06c1.26-1.37,2.59-2.68,3.97-3.92 c0.39-0.35,0.79-0.7,1.19-1.04c-0.05,0.05-0.11,0.09-0.16,0.14c1.82-1.56,3.73-3.01,5.72-4.34c0.56-0.38,1.13-0.74,1.7-1.1 c0.35-0.22,0.48-0.74,0.23-1.08C2894.14,1354.62,2893.68,1354.5,2893.31,1354.74L2893.31,1354.74z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2875.71,1369.44c0.11-0.17,0.22-0.34,0.33-0.5c-0.04,0.06-0.08,0.12-0.12,0.17 c0.82-1.2,1.79-2.29,2.89-3.23c-0.05,0.05-0.11,0.09-0.16,0.14c0.23-0.19,0.46-0.38,0.7-0.56c0.17-0.13,0.3-0.29,0.34-0.5 c0.04-0.18,0-0.42-0.11-0.58c-0.23-0.32-0.73-0.5-1.08-0.23c-1.67,1.28-3.08,2.83-4.19,4.61c-0.1,0.16-0.1,0.42-0.04,0.59 c0.06,0.18,0.22,0.38,0.4,0.46c0.18,0.08,0.4,0.11,0.59,0.04C2875.46,1369.76,2875.6,1369.63,2875.71,1369.44L2875.71,1369.44z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2918.14,1369.93c-0.82,2.02-1.71,4.02-2.66,5.98c-0.95,1.97-1.96,3.9-3.03,5.8 c-1.07,1.9-2.2,3.77-3.38,5.6c-0.29,0.45-0.59,0.91-0.89,1.35c-0.08,0.11-0.15,0.22-0.23,0.34c-0.02,0.02-0.12,0.18-0.06,0.09 c0.06-0.09,0,0-0.01,0.02c-0.03,0.04-0.06,0.09-0.09,0.13c-0.15,0.22-0.31,0.45-0.46,0.67c-0.62,0.9-1.26,1.78-1.91,2.66 c-1.3,1.75-2.65,3.47-4.06,5.14c-0.17,0.21-0.35,0.41-0.52,0.62c-0.27,0.31-0.27,0.83,0.06,1.1c0.32,0.26,0.82,0.27,1.1-0.06 c1.43-1.67,2.8-3.38,4.12-5.13c1.35-1.79,2.64-3.63,3.87-5.5c1.2-1.82,2.34-3.68,3.43-5.58c1.09-1.9,2.12-3.84,3.09-5.81 c0.97-1.97,1.88-3.96,2.72-5.99c0.1-0.25,0.21-0.5,0.31-0.75c0.15-0.38,0.05-0.87-0.35-1.05 C2918.82,1369.42,2918.3,1369.53,2918.14,1369.93L2918.14,1369.93z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2827.74,1428.49c0-0.42,0.01-0.84,0.04-1.26c0-0.02,0-0.04,0-0.06c0.01-0.1-0.01,0.17,0,0.07 c0-0.05,0.01-0.1,0.01-0.15c0.01-0.1,0.02-0.2,0.03-0.3c0.02-0.21,0.04-0.42,0.07-0.62c0.11-0.82,0.27-1.64,0.48-2.45 c0.12-0.46,0.26-0.92,0.42-1.37c-0.02,0.06-0.04,0.13-0.07,0.19c0.56-1.63,1.33-3.18,2.3-4.61c-0.04,0.06-0.08,0.12-0.12,0.17 c0.12-0.18,0.25-0.36,0.37-0.53c0.13-0.17,0.21-0.34,0.2-0.56c-0.01-0.19-0.11-0.42-0.26-0.54c-0.3-0.25-0.85-0.29-1.1,0.06 c-0.98,1.35-1.81,2.81-2.43,4.36c-0.62,1.54-1.07,3.16-1.3,4.81c-0.13,0.95-0.2,1.92-0.2,2.88c0,0.41,0.42,0.78,0.82,0.74 C2827.44,1429.27,2827.74,1428.92,2827.74,1428.49L2827.74,1428.49z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2851.44,1451.88c-0.95-0.56-1.88-1.15-2.8-1.76c0.06,0.04,0.12,0.08,0.17,0.12 c-1.46-0.99-2.86-2.05-4.21-3.19c-1.35-1.14-2.65-2.35-3.88-3.62c-0.69-0.72-1.36-1.45-2.01-2.21c0.05,0.05,0.09,0.11,0.14,0.16 c-1.21-1.41-2.34-2.89-3.39-4.43c-0.23-0.34-0.73-0.48-1.08-0.23c-0.34,0.24-0.48,0.72-0.23,1.08c1.69,2.48,3.6,4.81,5.69,6.96 c2.04,2.1,4.27,4.03,6.64,5.74c1.38,1,2.8,1.93,4.27,2.79c0.35,0.21,0.88,0.01,1.05-0.35 C2851.98,1452.52,2851.82,1452.11,2851.44,1451.88L2851.44,1451.88z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2869.39,1434.63c-1.83-1.7-3.67-3.37-5.54-5.03c-1.85-1.64-3.72-3.27-5.61-4.87 c-1.07-0.91-2.14-1.81-3.22-2.7c-0.31-0.26-0.83-0.27-1.1,0.06c-0.26,0.32-0.28,0.82,0.06,1.1c1.92,1.59,3.82,3.2,5.71,4.83 c1.87,1.62,3.73,3.26,5.56,4.92c1.04,0.94,2.07,1.89,3.1,2.84c0.3,0.28,0.84,0.26,1.1-0.06 C2869.72,1435.4,2869.71,1434.93,2869.39,1434.63L2869.39,1434.63z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M2859.29,1460.4c2.35-0.15,4.69-0.66,6.9-1.5c2.2-0.84,4.29-1.99,6.15-3.43c1.07-0.83,2.07-1.74,2.99-2.74 c0.28-0.3,0.26-0.84-0.06-1.1c-0.33-0.27-0.81-0.26-1.1,0.06c-0.61,0.67-1.27,1.3-1.96,1.89c0.05-0.05,0.11-0.09,0.16-0.14 c-1.22,1.04-2.54,1.95-3.95,2.72c-0.4,0.22-0.8,0.42-1.21,0.62c0.06-0.03,0.12-0.06,0.18-0.09c-1.03,0.48-2.08,0.9-3.17,1.23 c-0.53,0.16-1.06,0.3-1.6,0.43c-0.28,0.06-0.55,0.12-0.83,0.17c-0.15,0.03,0.15-0.03,0.05-0.01c-0.03,0.01-0.07,0.01-0.1,0.02 c-0.07,0.01-0.14,0.02-0.21,0.04c-0.14,0.02-0.28,0.05-0.42,0.07c-0.63,0.09-1.27,0.16-1.9,0.2c-0.41,0.03-0.78,0.4-0.74,0.82 C2858.5,1460.08,2858.85,1460.43,2859.29,1460.4L2859.29,1460.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 2945.4763,
    y1: 202.8403,
    x2: 2967.6177,
    y2: 202.8403,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M2913.02,1362.46c0.64,0.58,0.22,1.64-0.64,1.61c-1.69-0.06-3.46-0.92-5.65-0.63 c-2.18,0.29-4.78,1.73-5.85,2.83c-2.69,2.76-25,20.05-30.16,24.04c-0.51,0.4-0.47,1.18,0.09,1.52l1.92,1.16 c0.65,0.39,0.58,1.34-0.12,1.64c-2.66,1.12-7.65,3.29-8.88,4.32l-1.31,1.09c-0.24,0.2-0.57,0.27-0.87,0.17 c-1.28-0.41-4.62-1.54-4.47-2.07c0-0.01,0-0.01,0.01-0.02c0.28-0.82-0.62-1.54-1.35-1.08c-1.15,0.72-2.33,1.61-3.23,2.66 c-2.55,2.97-15.08,23.92-15.75,30.19c-0.44,4.14-0.54,6.35-0.56,7.38c-0.01,0.45-0.34,0.83-0.79,0.9 c-1.11,0.16-2.7-0.89-2.49-2.34c0.29-2.04,8.56-25.64,13.54-30.69c4.37-4.44,12.79-14.21,14.77-16.52 c0.22-0.25,0.55-0.37,0.88-0.3c0.59,0.13,1.83,0.08,4.03-1.21c3.4-1.99,0.65-5.09,4.3-8.81c3.64-3.72,20.75-23.28,24.05-24.37 c3.29-1.1,5.86-0.56,3.07,2.74c-2.79,3.31-14.75,12.33-15.91,14.9c-1.16,2.57,2.23,3.77,2.49,3.62s18.13-15.06,22.5-15.33 C2909.36,1359.67,2911.57,1361.16,2913.02,1362.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 2960.9038,
    y1: 158.3719,
    x2: 2973.7698,
    y2: 158.3719,
    gradientTransform: "matrix(-0.7456 -0.6664 0.6664 -0.7456 4938.5078 3517.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M2829.49,1433.62c0,0-1.51-7.12,3.31-16.05c4.82-8.92,0.44-7.11-1.06-5.22c-1.5,1.89-7.42,12.15-4.74,18.19 C2829.68,1436.59,2829.49,1433.62,2829.49,1433.62z"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_90"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "0,1286.71 178.7,1080 297.07,945.75 477.9,686.32 698.79,543.52 443.89,667.64 253.58,921.6  90.81,950.45 0,1017.93  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M4098.37,1898.1L3903,1753.82l-93.71-184.15c0,0-219.13-597.32-219.13-607c0-9.67,26.93-220.07,26.93-220.07 l-163.58-322.22l44.58-142.49l-7.16-117.61l61.09,136.04v157.1l196.01,301.41v281.04l176.86,457.01l35.5,95.4 c0,0,135.6,61.02,135.6,76.74C4096,1680.74,4098.37,1898.1,4098.37,1898.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_92"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 3488.9346,
    y1: 1131.8591,
    x2: 4098.3652,
    y2: 1131.8591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1464,
    style: {
      stopColor: "#AE4A42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#333333"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st195",
    d: "M4098.37,1825.99l-102.43-83.32L3903,1652.9l-145.61-329.45c0,0-66.58-276.72-66.58-287.58 s7.74-167.58,7.74-167.58L3552.16,599.8l-49.48-146.38l-4.58-65.57c0,0-6.55,60.12-9.12,67.6 c-2.56,7.48,100.29,232.35,100.29,232.35l27.82,54.8l55.14,139.2c0,0-2.32,192.81-2.32,198.2s81.94,253.18,78.13,261.67 s147.16,357.68,147.16,357.68l203.17,176.52V1825.99z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_91"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.8064,
    y1: 1026.6024,
    x2: 261.408,
    y2: 1026.6024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1464,
    style: {
      stopColor: "#AE4A42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#333333"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st196",
    points: "253.58,921.6 261.41,986.2 134.09,1131.6 90.81,950.45  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 443.8884,
    y1: 614.9172,
    x2: 698.7881,
    y2: 614.9172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1464,
    style: {
      stopColor: "#AE4A42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#333333"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "477.9,686.32 443.89,667.64 698.79,543.52  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 3490.9331,
    y1: 274.1339,
    x2: 3552.1616,
    y2: 274.1339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1464,
    style: {
      stopColor: "#AE4A42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#333333"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st198",
    d: "M3498.1,277.89c0,0-3.81,114.62,0,109.96s57.11-84.43,53.93-91.53s-61.09-136.04-61.09-136.04L3498.1,277.89 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 3549.0002,
    y1: 660.8552,
    x2: 3748.0361,
    y2: 660.8552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1464,
    style: {
      stopColor: "#AE4A42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#333333"
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M3552.02,453.42c0,0-6.89,143.12,0.14,146.38c7.03,3.26,146.39,268.49,146.39,268.49l49.49-113.46 L3552.02,453.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 3748.0361,
    y1: 1389.272,
    x2: 3995.9319,
    y2: 1389.272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1464,
    style: {
      stopColor: "#AE4A42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    style: {
      stopColor: "#333333"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st200",
    points: "3748.04,1035.87 3757.39,1323.45 3903,1652.9 3995.93,1742.68 3960.4,1588.28  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_87"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 3707.6279,
    y1: 713.5605,
    x2: 4098.3652,
    y2: 713.5605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st201",
    d: "M4098.37,380.12l-87.04-33.77l-130.06,9.17c0,0-122.18-8.85-119.93-9.17s-53.7,31.87-53.7,31.87 l217.6,338.98v185.77l173.14,177.79V380.12z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_86"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "4095.14,1237.34 4057.77,1282.83 3943.19,1105.35 3791.45,1074.83 3815.03,757.4 3749.6,599.8  3708.66,526.05 3707.63,378.22 3859.58,599.8 3925.23,717.21 3925.23,902.98 4098.37,1080.77  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_88"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 3791.4517,
    y1: 1004.1658,
    x2: 3943.1936,
    y2: 1004.1658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "3791.45,1074.83 3925.23,902.98 3943.19,1105.35  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 3789.7288,
    y1: 678.6005,
    x2: 3925.2253,
    y2: 678.6005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st203",
    points: "3815.03,757.4 3925.23,717.21 3859.58,599.8 3789.73,696.46  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 3707.6279,
    y1: 491.9157,
    x2: 3788.4443,
    y2: 491.9157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#D98B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    style: {
      stopColor: "#C87159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#AE4A42"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st204",
    points: "3752.01,605.61 3788.44,496.07 3707.63,378.22 3708.66,526.05  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u041A\\u0410\\u041A\\u0422\\u0423\\u0421"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 1995.9523,
    y1: 747.4778,
    x2: 2019.7605,
    y2: 747.4778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M1999.3,760.76c0,0,13.35-4.08,18.7-11.39c5.34-7.31-2.67-20.8-7.59-12.65 c-4.92,8.15-9.42,17.71-12.51,15.74C1994.8,750.5,1995.5,760.06,1999.3,760.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 1981.6295,
    y1: 757.3991,
    x2: 2003.8271,
    y2: 757.3991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M1985.09,796.84c0,0,6.45,6.59,16.72,0.85c0,0-0.69-56.88,1.84-73.12c2.53-16.24-23.83-12.02-21.93,10.54 C1983.62,757.67,1985.09,796.84,1985.09,796.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 1955.7286,
    y1: 738.6079,
    x2: 1988.917,
    y2: 738.6079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M1987.07,745.86c0,0-12.93,2.11-16.31-9.14c-3.37-11.25-10.26-16.73-13.35-8.86 c-3.09,7.87-1.97,15.88,3.8,19.26c5.76,3.37,22.35,7.45,25.16,5.34C1989.18,750.36,1990.02,746.85,1987.07,745.86z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M2004.06,747.48c0,0,7.08,3.26,2.41,10.41l-4.6,1.97l0.19-9.6 C2002.07,750.27,2002.63,749.58,2004.06,747.48z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M1968.92,750.25c0,0-5.11-2.38-4.27-4.7c0.84-2.32,8.54,1.12,13.07,2.35s11.07,1.23,11.07,1.23 s0.52,9.17,4.85,12.23c4.32,3.06,11.69,15.6,2.31,13.92c-9.38-1.69-9.16-4.95-9.48-8.96s-2.34-12.74-3.49-13.27 S1974.87,753.27,1968.92,750.25"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1988.92,
    y1: 723.3,
    x2: 1987.28,
    y2: 721.51
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1989.88,
    y1: 718.45,
    x2: 1988.1,
    y2: 714.17
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1982.52,
    y1: 728.47,
    x2: 1980.15,
    y2: 727.2
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1982.99,736.35 1979.09,735.85 1982.99,735.35  "
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2001.62,741.81 2004.22,740.06 2002.3,742.54  "
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1997.42,739.62 2000.49,738.61 1997.87,740.51  "
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1991.38,739.81 1989.42,738.61 1991.7,738.86  "
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.15,748.24 2003.09,746.18 2000.83,748.97  "
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1982.23,744.37 1981.04,742.91 1982.81,743.56  "
  }))), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2001.13,
    y1: 764,
    x2: 2002.67,
    y2: 764
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2001.66,725.17 2004.97,724.17 2002.08,726.07  "
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.99,733.71 2004.22,733.35 2001.26,734.67  "
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1997.86,719.44 2000.49,714.77 1998.77,719.85  "
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.24,721.96 2003.42,720.63 2000.75,722.82  "
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M1993.96,730.61"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1992.41,730.11 1993.11,730.61 1992.41,731.11  "
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.91,756.17 2003.09,755.67 2001.34,757.07  "
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2005,747.6 2004.22,744.76 2005.9,747.18  "
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2008.17,742.42 2007.03,739.34 2009.05,741.93  "
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2010.8,738.83 2009.88,735.85 2011.69,738.39  "
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2013.95,735.64 2015.15,734.19 2014.87,736.05  "
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2017.35,739.62 2019.02,739.34 2017.8,740.51  "
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2018.38,742.42 2021.47,743.44 2018.21,743.4  "
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2016.17,749.69 2019.02,750.61 2016.02,750.68  "
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2014.78,746.98 2016.1,747.48 2014.78,747.98  "
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2011.58,753.82 2011.95,754.83 2010.91,754.56  "
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2011.52,750.19 2013.46,752.08 2010.97,751.02  "
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2009.43,747.24 2010.56,746.18 2010.32,747.71  "
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2012.96,742.17 2013.46,740.06 2013.96,742.17  "
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1984.51,762.25 1981.78,760.76 1984.85,761.31  "
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1984.68,765.34 1981.78,764.84 1984.68,764.34  "
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.16,780.17 2002.67,778.65 2000.82,780.93  "
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.79,773.11 2002.67,772.11 2001.46,773.86  "
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1984.24,756.61 1981.04,754.83 1984.6,755.68  "
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1982.15,747.16 1979.09,742.91 1982.9,746.5  "
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1971.29,742.65 1973.72,739.7 1972.14,743.18  "
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1966.58,729.74 1967.71,726.57 1967.56,729.93  "
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1961.2,725.69 1961.27,722.39 1962.19,725.56  "
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1958.14,730.33 1954.32,729.21 1958.3,729.35  "
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1956.95,737.73 1953.9,737.23 1956.95,736.73  "
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1959.09,743.61 1955.73,744.87 1958.61,742.74  "
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1979.48,752.4 1977.4,754.19 1978.7,751.77  "
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1968.9,736.92 1971.71,734.19 1969.68,737.54  "
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1985.21,777.25 1982.52,776.75 1985.21,776.25  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 1219.1525,
    y1: 164.5371,
    x2: 1242.9607,
    y2: 164.5371,
    gradientTransform: "matrix(0.9785 -0.2062 0.1197 0.5678 -63.5938 334.2773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M1154.85,187.61c0,0,12.29-6.45,16.12-14.17c3.83-7.72-6.59-18.29-9.84-9.89 c-3.26,8.4-5.83,17.99-9.24,16.84C1148.49,179.25,1151,187.76,1154.85,187.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 1204.8297,
    y1: 180.3633,
    x2: 1227.0273,
    y2: 180.3633,
    gradientTransform: "matrix(0.9785 -0.2062 0.1197 0.5678 -63.5938 334.2773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M1147.84,223.22c0,0,7.57,4.64,16.52-2.68c0,0-11.53-51.38-12.15-66.61s-25.61-5.97-19.44,14.07 S1147.84,223.22,1147.84,223.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 1178.9288,
    y1: 150.3881,
    x2: 1212.1173,
    y2: 150.3881,
    gradientTransform: "matrix(0.9785 -0.2062 0.1197 0.5678 -63.5938 334.2773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M1140.04,176.64c0,0-12.25,4.58-17.7-4.91c-5.45-9.49-13.23-13.04-14.76-5.27 c-1.52,7.77,1.11,14.79,7.39,16.66s23.29,2.14,25.64-0.35C1142.96,180.28,1143.12,176.92,1140.04,176.64z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M1156.98,174.6c0,0,7.55,1.49,4.35,8.94l-4.13,2.73l-1.64-8.73 C1155.56,177.53,1155.98,176.8,1156.98,174.6z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M1123.12,184.36c0,0-5.46-1.11-5.08-3.38c0.38-2.27,8.57-0.75,13.24-0.57c4.67,0.18,11.07-1.17,11.07-1.17 s2.26,8.2,7.08,10.08s14.41,11.72,4.92,12.13s-9.91-2.6-10.99-6.16s-4.72-11.05-5.95-11.3S1129.52,185.86,1123.12,184.36"
  }))), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1137.54,
    y1: 155.82,
    x2: 1135.6,
    y2: 154.54
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1137.56,
    y1: 151.23,
    x2: 1135,
    y2: 147.72
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1132.27,
    y1: 161.82,
    x2: 1129.7,
    y2: 161.17
  })), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1134.24,168.9 1130.32,169.21 1134.04,167.92  "
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1153.51,169.92 1155.71,167.85 1154.3,170.53  "
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1148.98,168.81 1151.79,167.3 1149.59,169.6  "
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1143.12,170.3 1140.96,169.58 1143.22,169.31  "
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1153.3,176.05 1155.78,173.62 1154.1,176.66  "
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1135.05,176.32 1133.58,175.21 1135.41,175.39  "
  }))), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1157.26,
    y1: 190.17,
    x2: 1158.77,
    y2: 189.85
  })), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1150.37,154.84 1153.41,153.3 1150.95,155.66  "
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1151.35,162.72 1154.43,161.77 1151.79,163.62  "
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1145.55,150.45 1147.24,145.7 1146.52,150.69  "
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1148.37,152.23 1151.22,150.41 1149.02,152.99  "
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M1143.87,161.4"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1142.25,161.23 1143.04,161.58 1142.46,162.21  "
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1155.55,183.08 1157.59,182.22 1156.14,183.89  "
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1157.93,174.55 1156.61,172.11 1158.71,173.92  "
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1160.05,169.2 1158.33,166.61 1160.78,168.51  "
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1161.93,165.4 1160.45,162.86 1162.7,164.76  "
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1164.4,161.81 1165.29,160.28 1165.37,162.05  "
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1168.48,164.7 1170.05,164.14 1169.08,165.5  "
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1170,167.03 1173.24,167.35 1170.06,168.03  "
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1169.23,174.07 1172.21,174.35 1169.31,175.07  "
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1167.36,171.9 1168.75,172.12 1167.57,172.88  "
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1165.52,178.76 1166.1,179.63 1165.05,179.64  "
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1164.77,175.48 1167.05,176.83 1164.44,176.42  "
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1162.19,173.25 1163.09,172.08 1163.14,173.55  "
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1164.67,167.96 1164.76,165.95 1165.65,167.75  "
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1140.69,192.05 1137.71,191.23 1140.8,191.06  "
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1141.43,194.81 1138.49,194.92 1141.22,193.83  "
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1159.41,204.97 1161.57,203.12 1160.19,205.61  "
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1158.68,198.45 1160.32,197.2 1159.46,199.07  "
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1139.34,186.99 1135.86,186 1139.48,186  "
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1135.49,178.86 1131.67,175.61 1136.06,178.04  "
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1123.99,176.95 1125.8,173.81 1124.91,177.32  "
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1116.92,166.25 1117.41,163.16 1117.92,166.25  "
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1110.88,163.71 1110.32,160.7 1111.82,163.37  "
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1108.78,168.57 1104.81,168.31 1108.72,167.58  "
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1109.03,175.52 1105.93,175.66 1108.82,174.54  "
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1112.23,180.42 1109.18,182.2 1111.6,179.63  "
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1133.86,184.16 1132.17,186.18 1132.99,183.68  "
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1120.55,172.24 1122.79,169.24 1121.43,172.73  "
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1144.22,205.49 1141.49,205.56 1144.01,204.52  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 1998.1089,
    y1: 1961.7614,
    x2: 2031.9387,
    y2: 1961.7614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M2002.86,1972.27c0,0,18.97-3.22,26.56-9.01s-3.8-16.45-10.79-10.01c-6.99,6.45-13.38,14.01-17.78,12.45 C1996.47,1964.15,1997.47,1971.71,2002.86,1972.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.7572,
    y1: 1969.608,
    x2: 2009.2986,
    y2: 1969.608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M1982.68,2000.8c0,0,9.16,5.21,23.76,0.67c0,0-0.97-44.99,2.62-57.83c3.6-12.84-33.86-9.51-31.16,8.34 C1980.59,1969.82,1982.68,2000.8,1982.68,2000.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 1940.9541,
    y1: 1954.7462,
    x2: 1988.1124,
    y2: 1954.7462
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M1985.49,1960.48c0,0-18.38,1.67-23.17-7.23c-4.79-8.89-14.58-13.23-18.97-7 c-4.39,6.23-2.8,12.56,5.39,15.23c8.19,2.67,31.76,5.89,35.75,4.22C1988.48,1964.04,1989.68,1961.26,1985.49,1960.48z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M2009.63,1961.76c0,0,10.06,2.58,3.43,8.24l-6.54,1.56l0.27-7.59 C2006.79,1963.97,2007.6,1963.42,2009.63,1961.76z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M1959.69,1963.95c0,0-7.26-1.89-6.07-3.72c1.2-1.83,12.13,0.89,18.58,1.86 c6.44,0.97,15.73,0.98,15.73,0.98s0.75,7.25,6.89,9.67c6.14,2.42,16.61,12.34,3.29,11.01c-13.32-1.33-13.02-3.92-13.47-7.09 c-0.45-3.17-3.33-10.07-4.96-10.5C1978.05,1965.74,1968.16,1966.34,1959.69,1963.95"
  }))), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1988.11,
    y1: 1942.64,
    x2: 1985.79,
    y2: 1941.22
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1989.48,
    y1: 1938.81,
    x2: 1986.95,
    y2: 1935.41
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1979.03,
    y1: 1946.73,
    x2: 1975.65,
    y2: 1945.73
  })), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1979.69,1953.06 1974.15,1952.56 1979.69,1952.06  "
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2006.41,1957.12 2009.85,1955.9 2006.87,1958.01  "
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.38,1955.42 2004.56,1954.75 2000.65,1956.38  "
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1991.75,1955.81 1988.83,1954.75 1991.93,1954.83  "
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2004.33,1962.21 2008.25,1960.73 2004.79,1963.1  "
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1978.84,1959.45 1976.92,1958.15 1979.21,1958.52  "
  }))), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2005.46,
    y1: 1974.83,
    x2: 2007.66,
    y2: 1974.83
  })), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2006.39,1943.99 2010.92,1943.32 2006.65,1944.96  "
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2005.39,1950.76 2009.85,1950.59 2005.53,1951.75  "
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2001.08,1939.44 2004.56,1935.89 2001.86,1940.06  "
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2004.4,1941.44 2008.72,1940.53 2004.72,1942.39  "
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M1995.27,1948.42"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1993.08,1947.92 1994.07,1948.42 1993.08,1948.92  "
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2005.33,1968.51 2008.25,1968.24 2005.59,1969.47  "
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2011.22,1962.01 2009.85,1959.61 2011.98,1961.37  "
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2015.74,1957.92 2013.85,1955.32 2016.45,1957.21  "
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2019.47,1955.08 2017.89,1952.56 2020.21,1954.41  "
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2023.94,1952.25 2025.38,1951.25 2024.73,1952.88  "
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2028.69,1955.42 2030.88,1955.32 2028.96,1956.38  "
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2029.9,1957.65 2034.37,1958.57 2029.81,1958.65  "
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2026.77,1963.4 2030.88,1964.24 2026.69,1964.4  "
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2024.86,1961.26 2026.73,1961.76 2024.86,1962.26  "
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2020.06,1966.62 2020.84,1967.57 2019.62,1967.52  "
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2020.01,1963.77 2022.99,1965.4 2019.67,1964.71  "
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2017.53,1961.42 2018.87,1960.73 2018.26,1962.11  "
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2022.49,1957.57 2022.99,1955.9 2023.49,1957.57  "
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1981.99,1973.57 1977.98,1972.27 1982.19,1972.58  "
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1982.09,1975.99 1977.98,1975.49 1982.09,1974.99  "
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2004.34,1987.47 2007.66,1986.42 2004.78,1988.37  "
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2005.24,1981.88 2007.66,1981.25 2005.68,1982.78  "
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1981.62,1969.1 1976.92,1967.57 1981.83,1968.13  "
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1978.76,1961.67 1974.15,1958.15 1979.3,1960.83  "
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1963.33,1957.78 1966.51,1955.61 1964,1958.52  "
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1956.6,1947.65 1957.97,1945.23 1957.55,1947.97  "
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1948.95,1944.59 1948.83,1941.92 1949.92,1944.36  "
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1944.45,1948.31 1938.95,1947.31 1944.54,1947.31  "
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1942.69,1954.15 1938.35,1953.65 1942.69,1953.15  "
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1945.53,1958.84 1940.95,1959.7 1945.24,1957.88  "
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1974.44,1965.81 1971.75,1967.07 1973.87,1964.99  "
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1959.93,1953.24 1963.67,1951.25 1960.51,1954.06  "
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1982.84,1985.41 1979.03,1984.91 1982.84,1984.41  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 572.6758,
    y1: 1944.9537,
    x2: 606.5056,
    y2: 1944.9537,
    gradientTransform: "matrix(0.9103 -0.4139 0.4139 0.9103 -757.8989 407.2993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st219",
    d: "M577.15,1948.37c0,0,15.94-10.79,20.45-19.19c4.52-8.4-10.27-13.41-13.96-4.64 c-3.69,8.76-6.38,18.29-11.03,18.69C567.97,1943.63,572.01,1950.1,577.15,1948.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 552.3242,
    y1: 1952.8005,
    x2: 583.8654,
    y2: 1952.8005,
    gradientTransform: "matrix(0.9103 -0.4139 0.4139 0.9103 -757.8989 407.2993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st220",
    d: "M570.58,1982.7c0,0,10.5,0.95,21.9-9.22c0,0-19.51-40.55-21.55-53.73c-2.04-13.18-34.75,5.36-24.91,20.49 C555.86,1955.36,570.58,1982.7,570.58,1982.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 515.5209,
    y1: 1937.9386,
    x2: 562.6793,
    y2: 1937.9386,
    gradientTransform: "matrix(0.9103 -0.4139 0.4139 0.9103 -757.8989 407.2993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st221",
    d: "M556.45,1944.84c0,0-16.04,9.12-24.08,3.01c-8.05-6.11-18.75-6.01-20.17,1.48 c-1.42,7.49,2.65,12.59,11.21,11.63c8.56-0.96,31.35-7.78,34.29-10.95C560.65,1946.83,560.59,1943.81,556.45,1944.84z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M578.96,1936c0,0,10.22-1.82,6.53,6.08l-5.31,4.12l-2.89-7.02C577.29,1939.18,577.8,1938.36,578.96,1936z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M534.41,1958.67c0,0-7.39,1.29-7.06-0.88c0.33-2.17,11.41-4.22,17.68-6c6.27-1.78,14.73-5.62,14.73-5.62 s3.68,6.29,10.27,5.95c6.59-0.34,20.23,4.36,7.55,8.66c-12.68,4.3-13.48,1.82-15.2-0.88s-7.2-7.79-8.86-7.5 C551.85,1952.7,543.1,1957.34,534.41,1958.67"
  }))), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 551.46,
    y1: 1927.51,
    x2: 548.75,
    y2: 1927.18
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 551.12,
    y1: 1923.45,
    x2: 547.41,
    y2: 1921.41
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 544.88,
    y1: 1934.98,
    x2: 541.39,
    y2: 1935.47
  })), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "548.11,1940.48 542.86,1942.32 547.69,1939.57  "
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "574.11,1933.11 576.74,1930.57 574.9,1933.73  "
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "567.91,1934.06 571.44,1931.72 568.56,1934.82  "
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "560.22,1937.99 557.12,1938.23 559.98,1937.02  "
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "574.32,1938.61 577.28,1935.64 575.11,1939.22  "
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "549.98,1946.64 547.69,1946.25 549.93,1945.64  "
  }))), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 580.57,
    y1: 1949.62,
    x2: 582.57,
    y2: 1948.71
  })), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "568.66,1921.17 572.5,1918.69 569.29,1921.94  "
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "570.54,1927.75 574.54,1925.74 571.09,1928.58  "
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "561.93,1919.22 563.64,1914.55 562.9,1919.47  "
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "565.79,1919.67 569.34,1917.05 566.47,1920.41  "
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M560.37,1929.8"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "558.16,1930.26 559.28,1930.3 558.58,1931.17  "
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "577.84,1943.92 580.38,1942.47 578.47,1944.7  "
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "580.51,1935.58 578.27,1933.96 580.94,1934.68  "
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "582.93,1929.98 580.14,1928.4 583.28,1929.04  "
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "585.15,1925.85 582.68,1924.21 585.55,1924.93  "
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "588.05,1921.42 588.95,1919.92 589.02,1921.67  "
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "593.69,1922.34 595.64,1921.35 594.33,1923.1  "
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "595.71,1923.87 600.16,1922.86 596.04,1924.82  "
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "595.24,1930.41 599.33,1929.46 595.58,1931.35  "
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "592.62,1929.25 594.53,1928.93 593.03,1930.16  "
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "590.47,1936.11 591.58,1936.65 590.43,1937.11  "
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "589.24,1933.53 592.63,1933.79 589.32,1934.53  "
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "586.01,1932.42 586.94,1931.25 586.96,1932.75  "
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "588.93,1926.86 588.69,1925.14 589.84,1926.45  "
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "558.69,1958.19 554.49,1958.67 558.46,1957.22  "
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "559.78,1960.36 555.83,1961.61 559.37,1959.45  "
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "584.79,1961.59 587.37,1959.26 585.56,1962.23  "
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "583.29,1956.14 585.23,1954.56 584.06,1956.77  "
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "556.5,1954.28 551.59,1954.83 556.29,1953.3  "
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "550.82,1948.7 545.17,1947.4 550.96,1947.71  "
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "535.17,1951.54 537.16,1948.25 536.08,1951.94  "
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "524.85,1945.1 525.09,1942.33 525.84,1945.01  "
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "516.61,1945.49 515.4,1943.11 517.4,1944.88  "
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "514.05,1950.74 508.64,1952.11 513.72,1949.8  "
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "514.88,1956.79 510.72,1958.13 514.46,1955.88  "
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "519.4,1959.87 515.59,1962.55 518.74,1959.12  "
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "548.6,1954.26 546.68,1956.52 547.74,1953.75  "
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "530.2,1948.82 532.77,1945.47 531.06,1949.33  "
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "564.36,1968.63 560.69,1969.75 563.95,1967.72  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 2776.6028,
    y1: 1475.5353,
    x2: 2802.7273,
    y2: 1475.5353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st222",
    d: "M2780.27,1486.04c0,0,14.65-3.22,20.51-9.01c5.86-5.78-2.93-16.45-8.33-10.01 c-5.4,6.45-10.33,14.01-13.73,12.45C2775.34,1477.93,2776.11,1485.49,2780.27,1486.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 2760.8867,
    y1: 1483.382,
    x2: 2785.2439,
    y2: 1483.382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st223",
    d: "M2764.69,1514.57c0,0,7.08,5.21,18.34,0.67c0,0-0.75-44.99,2.02-57.83c2.78-12.84-26.14-9.51-24.06,8.34 S2764.69,1514.57,2764.69,1514.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 2732.4661,
    y1: 1468.5201,
    x2: 2768.8833,
    y2: 1468.5201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M2766.86,1474.26c0,0-14.19,1.67-17.89-7.23c-3.7-8.89-11.26-13.23-14.65-7s-2.16,12.56,4.16,15.23 c6.32,2.67,24.52,5.89,27.61,4.22C2769.17,1477.82,2770.09,1475.04,2766.86,1474.26z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M2785.5,1475.54c0,0,7.77,2.58,2.65,8.24l-5.05,1.56l0.21-7.59 C2783.31,1477.74,2783.93,1477.2,2785.5,1475.54z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M2746.94,1477.73c0,0-5.61-1.89-4.68-3.72c0.93-1.83,9.37,0.89,14.34,1.86 c4.97,0.97,12.15,0.98,12.15,0.98s0.58,7.25,5.32,9.67c4.74,2.42,12.82,12.34,2.54,11.01c-10.29-1.33-10.06-3.92-10.4-7.09 c-0.35-3.17-2.57-10.07-3.83-10.5C2761.11,1479.51,2753.47,1480.12,2746.94,1477.73"
  }))), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2768.88,
    y1: 1456.42,
    x2: 2767.09,
    y2: 1455
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2769.94,
    y1: 1452.58,
    x2: 2767.98,
    y2: 1449.19
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2761.87,
    y1: 1460.5,
    x2: 2759.26,
    y2: 1459.5
  })), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2762.38,1466.84 2758.1,1466.34 2762.38,1465.84  "
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2782.91,1470.93 2785.67,1469.67 2783.47,1471.76  "
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2778.29,1469.2 2781.59,1468.52 2778.64,1470.14  "
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2771.64,1469.58 2769.44,1468.52 2771.88,1468.61  "
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2781.31,1476.01 2784.43,1474.51 2781.86,1476.84  "
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2761.64,1473.2 2760.24,1471.92 2762.1,1472.31  "
  }))), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2782.28,
    y1: 1488.6,
    x2: 2783.98,
    y2: 1488.6
  })), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2782.94,1457.78 2786.5,1457.1 2783.26,1458.72  "
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2782.18,1464.54 2785.67,1464.36 2782.38,1465.52  "
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2778.77,1453.26 2781.59,1449.66 2779.62,1453.79  "
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2781.39,1455.23 2784.8,1454.3 2781.78,1456.15  "
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M2774.41,1462.2"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2772.72,1461.7 2773.49,1462.2 2772.72,1462.7  "
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2782.11,1482.29 2784.43,1482.01 2782.44,1483.24  "
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2786.6,1475.74 2785.67,1473.39 2787.44,1475.2  "
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2790.1,1471.65 2788.76,1469.1 2790.89,1471.03  "
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2792.97,1468.8 2791.88,1466.34 2793.8,1468.24  "
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2796.43,1466.07 2797.67,1465.03 2797.28,1466.6  "
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2800.15,1469.2 2801.91,1469.1 2800.5,1470.14  "
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2801.18,1471.43 2804.61,1472.34 2801.06,1472.42  "
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2798.76,1477.18 2801.91,1478.01 2798.65,1478.17  "
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2797.26,1475.04 2798.71,1475.54 2797.26,1476.04  "
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2793.66,1480.43 2794.16,1481.35 2793.11,1481.26  "
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2793.6,1477.56 2795.81,1479.18 2793.17,1478.46  "
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2791.48,1475.24 2792.63,1474.51 2792.28,1475.83  "
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2795.31,1471.34 2795.81,1469.67 2796.31,1471.34  "
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2764.11,1487.33 2761.06,1486.04 2764.36,1486.36  "
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2764.23,1489.77 2761.06,1489.27 2764.23,1488.77  "
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2781.32,1501.27 2783.98,1500.19 2781.85,1502.11  "
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2782.01,1495.68 2783.98,1495.02 2782.55,1496.53  "
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2763.81,1482.87 2760.24,1481.35 2764.08,1481.91  "
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2761.55,1475.41 2758.1,1471.92 2762.19,1474.64  "
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2749.63,1471.6 2752.2,1469.38 2750.38,1472.25  "
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2744.43,1461.45 2745.61,1459 2745.4,1461.71  "
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2738.52,1458.34 2738.55,1455.69 2739.51,1458.16  "
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2735.14,1462.08 2730.92,1461.08 2735.26,1461.09  "
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2733.81,1467.93 2730.45,1467.43 2733.81,1466.93  "
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2736.07,1472.6 2732.47,1473.47 2735.71,1471.67  "
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2758.44,1479.55 2756.25,1480.85 2757.77,1478.81  "
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2747.01,1467.06 2750,1465.03 2747.68,1467.8  "
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2764.81,1499.19 2761.87,1498.69 2764.81,1498.19  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 2007.3298,
    y1: 410.295,
    x2: 2020.1469,
    y2: 410.295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st225",
    d: "M2009.13,423.09c0,0,7.19-3.92,10.06-10.96c2.88-7.04-1.44-20.03-4.09-12.18 c-2.65,7.85-5.07,17.05-6.73,15.16S2007.09,422.41,2009.13,423.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 1999.6194,
    y1: 419.847,
    x2: 2011.5692,
    y2: 419.847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st226",
    d: "M2001.48,457.82c0,0,3.47,6.34,9,0.82c0,0-0.37-54.76,0.99-70.39c1.36-15.63-12.83-11.57-11.81,10.15 C2000.69,420.11,2001.48,457.82,2001.48,457.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 1985.6759,
    y1: 401.7554,
    x2: 2003.5426,
    y2: 401.7554
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st227",
    d: "M2002.55,408.74c0,0-6.96,2.03-8.78-8.8c-1.82-10.83-5.52-16.1-7.19-8.53 c-1.66,7.58-1.06,15.29,2.04,18.54c3.1,3.25,12.03,7.17,13.55,5.14C2003.68,413.07,2004.14,409.69,2002.55,408.74z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M2011.7,410.3c0,0,3.81,3.14,1.3,10.03l-2.48,1.89l0.1-9.24C2010.62,412.98,2010.92,412.32,2011.7,410.3z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M1992.78,412.97c0,0-2.75-2.3-2.3-4.53c0.45-2.23,4.6,1.08,7.04,2.26s5.96,1.19,5.96,1.19 s0.28,8.83,2.61,11.77s6.29,15.02,1.24,13.4s-4.93-4.77-5.1-8.63c-0.17-3.86-1.26-12.26-1.88-12.78 C1999.73,415.14,1995.98,415.87,1992.78,412.97"
  }))), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2003.54,
    y1: 387.02,
    x2: 2002.66,
    y2: 385.29
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2004.06,
    y1: 382.35,
    x2: 2003.1,
    y2: 378.22
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2000.1,
    y1: 391.99,
    x2: 1998.82,
    y2: 390.78
  })), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.35,399.6 1998.25,399.1 2000.35,398.6  "
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2010.13,404.93 2011.78,403.16 2010.99,405.45  "
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2007.9,402.79 2009.77,401.76 2008.58,403.53  "
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2004.69,402.88 2003.82,401.76 2005.22,402.03  "
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2009.35,411.12 2011.17,409.05 2010.2,411.64  "
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1999.71,407.22 1999.3,405.9 2000.49,406.6  "
  }))), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 2010.11,
    y1: 426.2,
    x2: 2010.95,
    y2: 426.2
  })), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2010.2,388.87 2012.18,387.85 2010.84,389.64  "
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2009.9,397.05 2011.78,396.7 2010.33,397.95  "
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2008.12,383.38 2009.77,378.8 2009.09,383.62  "
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2009.41,385.8 2011.35,384.45 2010.14,386.48  "
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M2006.26,394.06"
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2005.42,393.56 2005.8,394.06 2005.42,394.56  "
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2009.79,418.72 2011.17,418.18 2010.44,419.47  "
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2011.96,410.34 2011.78,407.68 2012.93,410.09  "
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2013.67,405.34 2013.29,402.46 2014.62,405.04  "
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2015.08,401.89 2014.83,399.1 2016.05,401.62  "
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2016.78,398.98 2017.66,397.5 2017.75,399.22  "
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2018.63,402.79 2019.75,402.46 2019.3,403.53  "
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2019.5,405.42 2021.07,406.41 2019.21,406.38  "
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2018.3,412.42 2019.75,413.31 2018.05,413.39  "
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2017.46,409.8 2018.17,410.3 2017.46,410.8  "
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2015.99,416.5 2015.94,417.37 2015.14,417.02  "
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2015.95,412.99 2016.76,414.73 2015.18,413.63  "
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2014.35,410.15 2015.19,409.05 2015.31,410.44  "
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2016.26,405.19 2016.76,403.16 2017.26,405.19  "
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.99,424.49 1999.7,423.09 2001.53,423.64  "
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2001.26,427.51 1999.7,427.01 2001.26,426.51  "
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2009.35,441.86 2010.95,440.31 2010.2,442.4  "
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2009.69,435.07 2010.95,434.01 2010.54,435.6  "
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2000.84,419.05 1999.3,417.37 2001.41,418.23  "
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1999.65,409.89 1998.25,405.9 2000.55,409.45  "
  }))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1993.81,405.73 1995.36,402.81 1994.75,406.06  "
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1991.29,393.26 1992.12,390.17 1992.28,393.37  "
  }))), _g303 || (_g303 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1988.39,389.29 1988.66,386.14 1989.39,389.22  "
  }))), _g304 || (_g304 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1986.88,393.79 1984.92,392.7 1987.16,392.83  "
  }))), _g305 || (_g305 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1986.33,400.93 1984.69,400.43 1986.33,399.93  "
  }))), _g306 || (_g306 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1987.7,406.51 1985.68,407.78 1987.01,405.79  "
  }))), _g307 || (_g307 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1998.71,414.93 1997.35,416.76 1997.8,414.52  "
  }))), _g308 || (_g308 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1992.52,400.22 1994.28,397.5 1993.43,400.63  "
  }))), _g309 || (_g309 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "2001.54,438.98 2000.1,438.48 2001.54,437.98  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 1642.578,
    y1: 246.174,
    x2: 1655.395,
    y2: 246.174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st228",
    d: "M1644.38,256.83c0,0,7.19-3.27,10.06-9.14c2.88-5.87-1.44-16.69-4.09-10.15 c-2.65,6.54-5.07,14.21-6.73,12.63C1641.96,248.6,1642.34,256.27,1644.38,256.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 1634.8676,
    y1: 254.1349,
    x2: 1646.8174,
    y2: 254.1349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st229",
    d: "M1636.73,285.78c0,0,3.47,5.29,9,0.68c0,0-0.37-45.64,0.99-58.67c1.36-13.03-12.83-9.64-11.81,8.46 C1635.94,254.35,1636.73,285.78,1636.73,285.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 1620.9241,
    y1: 239.0567,
    x2: 1638.7908,
    y2: 239.0567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#987D16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5677,
    style: {
      stopColor: "#A17C0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7B03"
    }
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st230",
    d: "M1637.8,244.88c0,0-6.96,1.69-8.78-7.33c-1.82-9.02-5.52-13.42-7.19-7.11s-1.06,12.75,2.04,15.45 c3.1,2.71,12.03,5.98,13.55,4.29C1638.93,248.49,1639.38,245.67,1637.8,244.88z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M1646.94,246.17c0,0,3.81,2.61,1.3,8.36l-2.48,1.58l0.1-7.7C1645.87,248.41,1646.17,247.86,1646.94,246.17 z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M1628.02,248.4c0,0-2.75-1.91-2.3-3.77c0.45-1.86,4.6,0.9,7.04,1.89s5.96,0.99,5.96,0.99 s0.28,7.36,2.61,9.81c2.33,2.45,6.29,12.52,1.24,11.17c-5.05-1.35-4.93-3.98-5.1-7.19c-0.17-3.21-1.26-10.22-1.88-10.65 C1634.98,250.21,1631.23,250.82,1628.02,248.4"
  }))), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1638.79,
    y1: 226.78,
    x2: 1637.91,
    y2: 225.34
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1639.31,
    y1: 222.88,
    x2: 1638.35,
    y2: 219.44
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1635.35,
    y1: 230.92,
    x2: 1634.07,
    y2: 229.91
  })), _g310 || (_g310 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1635.6,237.34 1633.5,236.84 1635.6,236.34  "
  }))), _g311 || (_g311 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1645.4,241.63 1647.03,240.23 1646.22,242.21  "
  }))), _g312 || (_g312 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1643.19,239.83 1645.02,239.06 1643.79,240.62  "
  }))), _g313 || (_g313 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1639.98,240.09 1639.06,239.06 1640.43,239.2  "
  }))), _g314 || (_g314 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1644.62,246.79 1646.42,245.13 1645.43,247.37  "
  }))), _g315 || (_g315 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1634.99,243.7 1634.55,242.51 1635.71,243.01  "
  }))), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st210",
    x1: 1645.36,
    y1: 259.43,
    x2: 1646.2,
    y2: 259.43
  })), _g316 || (_g316 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1645.48,228.23 1647.43,227.47 1646.05,229.05  "
  }))), _g317 || (_g317 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1645.18,235.05 1647.03,234.84 1645.55,235.98  "
  }))), _g318 || (_g318 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1643.37,223.7 1645.02,219.93 1644.33,223.99  "
  }))), _g319 || (_g319 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1644.69,225.67 1646.6,224.63 1645.36,226.41  "
  }))), _g320 || (_g320 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M1641.5,232.64"
  }))), _g321 || (_g321 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1640.67,232.14 1641.05,232.64 1640.67,233.14  "
  }))), _g322 || (_g322 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1645.07,253.1 1646.42,252.75 1645.66,253.91  "
  }))), _g323 || (_g323 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1647.21,246.25 1647.03,243.99 1648.17,245.96  "
  }))), _g324 || (_g324 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1648.92,242.09 1648.54,239.64 1649.86,241.74  "
  }))), _g325 || (_g325 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1650.34,239.21 1650.07,236.84 1651.29,238.9  "
  }))), _g326 || (_g326 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1652.04,236.7 1652.91,235.51 1652.99,236.99  "
  }))), _g327 || (_g327 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1653.92,239.83 1654.99,239.64 1654.52,240.63  "
  }))), _g328 || (_g328 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1654.73,242.02 1656.32,242.93 1654.49,243  "
  }))), _g329 || (_g329 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1653.53,247.86 1654.99,248.69 1653.32,248.84  "
  }))), _g330 || (_g330 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1652.71,245.67 1653.42,246.17 1652.71,246.67  "
  }))), _g331 || (_g331 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1651.21,251.26 1651.19,252.07 1650.41,251.86  "
  }))), _g332 || (_g332 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1651.16,248.33 1652,249.87 1650.46,249.04  "
  }))), _g333 || (_g333 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1649.6,246.01 1650.44,245.13 1650.55,246.34  "
  }))), _g334 || (_g334 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1651.5,241.92 1652,240.23 1652.5,241.92  "
  }))), _g335 || (_g335 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1636.28,258.09 1634.95,256.83 1636.74,257.21  "
  }))), _g336 || (_g336 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1636.51,260.61 1634.95,260.11 1636.51,259.61  "
  }))), _g337 || (_g337 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1644.63,272.4 1646.2,271.19 1645.42,273.01  "
  }))), _g338 || (_g338 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1644.96,266.74 1646.2,265.94 1645.76,267.34  "
  }))), _g339 || (_g339 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1636.12,253.56 1634.55,252.07 1636.62,252.69  "
  }))), _g340 || (_g340 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1634.92,245.91 1633.5,242.51 1635.78,245.4  "
  }))), _g341 || (_g341 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1629.07,242.32 1630.61,239.93 1629.99,242.7  "
  }))), _g342 || (_g342 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1626.54,231.96 1627.37,229.4 1627.53,232.08  "
  }))), _g343 || (_g343 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1623.64,228.68 1623.91,226.04 1624.63,228.59  "
  }))), _g344 || (_g344 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1622.15,232.51 1620.16,231.51 1622.38,231.53  "
  }))), _g345 || (_g345 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1621.58,238.45 1619.94,237.95 1621.58,237.45  "
  }))), _g346 || (_g346 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1622.92,243.11 1620.92,244.08 1622.29,242.33  "
  }))), _g347 || (_g347 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1633.94,250.11 1632.59,251.56 1633.06,249.63  "
  }))), _g348 || (_g348 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1627.78,237.71 1629.53,235.51 1628.66,238.19  "
  }))), _g349 || (_g349 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "1636.79,270.16 1635.35,269.66 1636.79,269.16  "
  }))))), _g350 || (_g350 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_93"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M3156.61,1723.87l113.5-17.15c37.73-5.77,75.38-11.68,112.8-18.29c9.36-1.63,18.7-3.32,28.01-5.09 c9.32-1.76,18.63-3.5,27.9-5.39c18.53-3.8,37-7.71,55.21-12.26c18.19-4.56,36.25-9.41,53.54-15.47 c8.64-3.02,17.12-6.22,25.13-9.89c7.97-3.65,15.57-7.81,21.57-12.42c3.02-2.27,5.51-4.66,7.23-6.83c0.82-1.08,1.43-2.08,1.84-2.94 c0.43-0.87,0.59-1.55,0.69-2.18c0.09-0.63,0.09-1.23-0.02-1.99c-0.13-0.76-0.46-1.72-0.94-2.81c-0.47-1.09-1.27-2.33-2.12-3.6 c-1.27-1.72-2.57-3.55-3.91-5.29c-10.61-14.11-23.26-26.82-37.16-38.08c-13.88-11.3-29.18-20.98-45.26-29 c-4.03-2-8.1-3.88-12.24-5.62c-2.06-0.9-4.15-1.7-6.23-2.53c-2.1-0.78-4.19-1.58-6.3-2.32c-8.42-3.03-17.01-5.44-25.66-7.15 c-8.64-1.64-17.34-2.69-25.8-2.56c-8.44,0.12-16.64,1.47-23.55,4.38c-3.47,1.45-6.48,3.39-9.04,5.7c-2.57,2.31-4.5,5.14-6.04,8.34 c-0.35,0.82-0.7,1.65-1.01,2.51c-0.25,0.89-0.61,1.73-0.78,2.67l-0.33,1.38c-0.12,0.45-0.18,0.99-0.27,1.48l-0.25,1.51l-0.17,1.49 c-0.48,4-0.29,7.89,0.41,11.64c0.4,1.86,0.91,3.69,1.62,5.46c0.73,1.76,1.61,3.48,2.65,5.14c1.07,1.64,2.3,3.22,3.66,4.73 c1.39,1.49,2.9,2.92,4.52,4.28c6.54,5.43,14.83,9.38,23.48,12.46c8.71,3.03,17.89,5.2,27.22,6.76c9.34,1.57,18.84,2.58,28.42,3.02 c-9.5,1.46-19.15,2-28.85,1.96c-9.7-0.11-19.47-0.88-29.21-2.86c-9.72-1.97-19.51-5.13-28.58-10.83 c-2.25-1.44-4.45-3.04-6.53-4.83c-2.07-1.82-4.03-3.81-5.84-5.98c-1.78-2.2-3.39-4.57-4.79-7.09c-1.38-2.53-2.5-5.2-3.42-7.93 c-1.74-5.49-2.5-11.22-2.44-16.76l0.03-2.08c0.03-0.69,0.08-1.37,0.12-2.06c0.06-0.69,0.07-1.36,0.16-2.08l0.27-2.15 c0.14-1.44,0.52-2.88,0.8-4.32c0.35-1.44,0.76-2.88,1.22-4.3c1.93-5.69,5.07-11.19,9.19-15.7c4.11-4.53,8.98-8.23,14.11-10.95 c5.13-2.76,10.46-4.76,15.81-6.14c5.35-1.4,10.71-2.25,16.02-2.73c10.63-0.95,21.09-0.5,31.31,0.85 c10.21,1.38,20.22,3.54,29.99,6.39c4.89,1.4,9.7,3.03,14.46,4.78c4.77,1.73,9.46,3.64,14.1,5.67c18.59,8.06,36.08,18.5,52.3,30.74 c8.12,6.11,15.82,12.81,23.12,19.96c7.32,7.13,14.18,14.78,20.55,22.85c0.81,1,1.58,2.03,2.35,3.06l2.32,3.13 c1.85,2.66,3.65,5.46,5.17,8.72c1.51,3.25,2.8,6.83,3.54,10.77c0.72,3.94,0.87,8.16,0.33,12.27c-0.53,4.1-1.72,8.07-3.33,11.52 c-1.6,3.47-3.53,6.54-5.59,9.27c-4.16,5.36-8.73,9.54-13.32,13.03c-9.24,6.95-18.65,11.8-28.04,16.07 c-9.41,4.2-18.82,7.76-28.28,10.87c-9.46,3.09-18.94,5.81-28.43,8.3c-9.49,2.48-18.98,4.77-28.5,6.77 c-19.03,4.05-38.08,7.52-57.17,10.4c-9.54,1.45-19.08,2.85-28.64,4.08c-9.56,1.22-19.12,2.36-28.67,3.43 c-38.25,4.18-76.55,7.05-114.89,8.75c-19.17,0.82-38.34,1.41-57.52,1.62C3194.98,1724.61,3175.8,1724.58,3156.61,1723.87z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M3367.97,1786.81c31.54-3.77,62.75-8.29,93.55-14.09c30.76-5.82,61.2-12.84,90.21-22.63 c7.25-2.44,14.39-5.08,21.37-7.96l5.21-2.19l5.16-2.26l5.07-2.37c1.68-0.8,3.32-1.66,4.99-2.48 c13.12-6.79,25.49-14.59,35.38-24.03c4.92-4.72,9.27-9.74,12.73-15.1c3.45-5.36,6.07-11.02,7.6-16.96l0.51-2.24 c0.16-0.75,0.41-1.48,0.49-2.25l0.37-2.28c0.13-0.76,0.27-1.52,0.31-2.3l0.2-2.32l0.11-1.16l0.04-1.29 c0.02-1.73,0.17-3.47,0.1-5.2c-0.02-6.93-0.66-13.84-1.91-20.65c-2.37-13.65-7.14-26.96-13.98-39.32 c-3.35-6.21-7.2-12.2-11.47-17.91c-4.25-5.73-9.03-11.08-14.02-16.23c-10.02-10.27-21.58-19.11-33.94-26.17 c-3.09-1.76-6.26-3.35-9.46-4.84c-3.21-1.43-6.45-2.79-9.73-3.91c-3.27-1.16-6.56-2.16-9.86-2.9c-3.29-0.77-6.6-1.33-9.83-1.58 c-3.24-0.27-6.43-0.29-9.5-0.05c-3.06,0.28-5.99,0.86-8.72,1.77c-5.46,1.83-10.09,4.95-13.7,9.58c-1.8,2.31-3.35,4.98-4.64,7.9 l-0.9,2.25c-0.31,0.75-0.51,1.57-0.78,2.35l-0.38,1.19l-0.36,1.32l-0.71,2.66c-1.76,7.07-2.89,14.22-2.76,21.09 c0.1,6.86,1.57,13.39,4.98,18.85c0.87,1.35,1.83,2.66,2.93,3.88c1.11,1.21,2.31,2.37,3.64,3.42c2.66,2.1,5.71,3.89,9.03,5.33 c6.67,2.85,14.23,4.4,21.92,5.06c7.71,0.68,15.61,0.57,23.51-0.28c-7.5,2.7-15.38,4.39-23.46,5.27 c-8.07,0.8-16.44,0.73-24.83-1.31c-2.09-0.51-4.18-1.16-6.24-1.94c-2.07-0.78-4.08-1.76-6.06-2.87c-1.97-1.12-3.86-2.43-5.68-3.88 c-1.8-1.46-3.47-3.11-5.03-4.87c-3.07-3.56-5.52-7.68-7.25-11.97c-1.76-4.3-2.9-8.75-3.6-13.18c-1.34-8.89-0.92-17.61,0.09-26.06 l0.44-3.15c0.08-0.53,0.14-1.04,0.24-1.58l0.34-1.68c0.24-1.12,0.42-2.25,0.73-3.38l0.93-3.38c1.41-4.49,3.34-8.98,5.94-13.22 c2.59-4.24,5.9-8.22,9.81-11.53c3.89-3.33,8.29-6.05,12.88-8.09c4.59-2.05,9.36-3.43,14.11-4.32c4.75-0.88,9.48-1.15,14.13-1.12 c18.62,0.29,35.73,5.76,51.3,13.38c7.82,3.8,15.24,8.25,22.29,13.22c7.07,4.94,13.72,10.43,20.02,16.33 c12.58,11.8,23.4,25.55,32.11,40.69c8.61,15.19,14.84,31.96,17.99,49.42c1.52,8.73,2.27,17.62,2.22,26.48 c0.05,2.22-0.12,4.43-0.18,6.64l-0.07,1.67l-0.17,1.79l-0.35,3.57c-0.09,1.19-0.3,2.38-0.51,3.56l-0.62,3.56 c-0.43,2.37-1.13,4.69-1.72,7.03c-2.67,9.3-7.01,18.05-12.31,25.82c-5.31,7.78-11.57,14.62-18.33,20.51 c-13.55,11.8-28.62,20.38-43.97,27.14c-15.35,6.84-31.11,11.76-46.91,15.84c-31.66,7.93-63.65,12.01-95.57,13.84 c-15.97,0.87-31.92,1.21-47.85,0.92C3399.69,1789.36,3383.78,1788.6,3367.97,1786.81z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M2949.13,1786.81c29.24,3.23,58.29,6,87.31,7.99c29,1.98,57.92,3.3,86.68,3.22 c7.19,0,14.36-0.08,21.52-0.31c7.16-0.18,14.3-0.46,21.42-0.85c14.22-0.9,28.39-1.99,42.34-3.94c6.99-0.93,13.9-2.06,20.78-3.3 c6.86-1.31,13.66-2.73,20.36-4.41c13.38-3.39,26.42-7.58,38.63-13.05c12.23-5.41,23.59-12.12,33.52-20.2 c2.41-2.08,4.88-4.12,7.1-6.38l1.71-1.65c0.58-0.57,1.18-1.23,1.76-1.84c1.17-1.25,2.4-2.47,3.53-3.74 c4.68-5,9.02-10.22,13.12-15.52c4.08-5.32,7.81-10.81,11.04-16.45c3.19-5.65,5.93-11.41,8-17.24c2.02-5.83,3.3-11.73,3.65-17.49 c0.35-5.75-0.18-11.4-1.91-16.64c-1.72-5.23-4.43-10.15-8.18-14.37c-3.74-4.23-8.48-7.72-13.76-10.25 c-10.56-5.01-23.53-5.83-33.97-0.47c-1.31,0.65-2.57,1.41-3.8,2.23c-0.61,0.42-1.19,0.88-1.79,1.32l-1.95,1.66 c-2.65,2.21-5.07,4.61-7.48,7.04c-1.18,1.23-2.32,2.5-3.45,3.79c-1.07,1.32-2.2,2.62-3.18,4c-2.05,2.73-3.91,5.59-5.52,8.59 c-3.25,6-5.55,12.59-6.43,19.55c-0.86,6.93-0.49,14.26,1.86,21.23c-2.07-3.06-3.56-6.53-4.71-10.12c-1.13-3.6-1.82-7.37-2.15-11.2 c-0.3-3.83-0.17-7.72,0.32-11.59c0.48-3.87,1.42-7.69,2.62-11.42c0.57-1.88,1.31-3.69,2.03-5.53c0.78-1.79,1.58-3.6,2.51-5.32 c0.87-1.77,1.87-3.44,2.85-5.15c1.02-1.67,2.08-3.32,3.18-4.94c1.14-1.58,2.23-3.22,3.48-4.72l1.82-2.29 c0.61-0.76,1.26-1.47,1.9-2.22l1.93-2.21c0.76-0.77,1.51-1.57,2.3-2.32c1.6-1.48,3.29-2.9,5.09-4.16 c7.21-5.08,15.83-8.1,24.54-8.99c8.74-0.91,17.58,0.24,25.9,3.02c8.34,2.76,16.12,7.38,22.75,13.46 c6.62,6.07,12.05,13.67,15.55,22.1c3.57,8.41,5.19,17.48,5.36,26.32c0.12,8.86-1.29,17.47-3.53,25.61 c-2.29,8.12-5.38,15.83-9.11,23.05c-3.71,7.22-7.93,14.04-12.45,20.53c-4.51,6.5-9.42,12.63-14.52,18.48 c-1.26,1.49-2.58,2.9-3.87,4.34c-0.66,0.72-1.27,1.43-1.98,2.16l-2.17,2.21c-2.86,3.01-5.95,5.73-9.02,8.47 c-6.27,5.32-12.94,10.02-19.8,14.28l-5.2,3.07l-5.29,2.84c-1.76,0.98-3.56,1.79-5.35,2.67c-1.79,0.87-3.58,1.75-5.4,2.51 c-14.5,6.45-29.45,11.07-44.46,14.56c-15.03,3.41-30.14,5.74-45.23,7.09c-15.09,1.4-30.13,2-45.12,1.91 c-7.49-0.08-14.97-0.18-22.42-0.56c-7.46-0.35-14.89-0.86-22.31-1.45c-29.66-2.49-58.97-6.96-87.86-13.08 c-14.44-3.1-28.78-6.54-42.98-10.51C2977.02,1796.32,2962.92,1792,2949.13,1786.81z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M75.32,796.84c10.07,4.1,20.2,7.96,30.38,11.65c10.17,3.72,20.39,7.25,30.64,10.67 c20.5,6.8,41.14,13.04,61.91,18.61c20.76,5.6,41.65,10.51,62.62,14.69c10.5,2.04,21,3.97,31.53,5.65 c10.53,1.68,21.09,3.05,31.64,4.3c42.2,4.84,84.67,5.83,126.13,0.83c20.69-2.59,41.14-6.49,60.91-12.43 c19.84-5.89,39.16-13.3,57-22.94c8.94-4.77,17.52-10.06,25.58-15.94c8.06-5.87,15.6-12.32,22.36-19.38 c3.45-3.47,6.59-7.18,9.63-10.94c2.98-3.8,5.74-7.74,8.28-11.78c2.48-4.08,4.73-8.25,6.71-12.53c1.92-4.3,3.58-8.67,4.93-13.11 c2.72-8.87,3.95-18.06,3.59-26.98c-0.4-8.91-2.39-17.59-6.18-25.13c-7.48-15.23-22.46-24.7-40.16-24.56l-3.32,0.1l-3.36,0.29 c-1.12,0.11-2.25,0.33-3.38,0.47l-0.85,0.12l-0.9,0.17l-1.81,0.34c-4.83,0.95-9.65,2.2-14.44,3.69c-9.57,3-18.95,7.08-28.11,11.75 c-9.13,4.74-17.98,10.19-26.5,16.21c-8.54,5.98-16.71,12.58-24.48,19.64c-7.81,7.03-15.13,14.61-21.92,22.64 c-6.79,8.02-12.97,16.58-18.08,25.69c-2.55,4.55-4.74,9.28-6.45,14.14c-0.87,2.43-1.56,4.9-2.06,7.4 c-0.53,2.5-0.78,5.02-0.78,7.52c0.01,2.5,0.29,5.01,1.05,7.37c0.76,2.36,1.97,4.59,3.61,6.53c1.63,1.95,3.7,3.59,5.99,4.93 c2.3,1.32,4.83,2.29,7.43,3.09c-2.69-0.36-5.39-0.89-8.01-1.86c-2.59-1.01-5.09-2.41-7.27-4.32c-2.19-1.89-3.99-4.29-5.28-6.94 c-1.31-2.65-2.06-5.53-2.49-8.42c-0.42-2.89-0.5-5.82-0.28-8.69c0.18-2.88,0.59-5.73,1.18-8.51c1.14-5.6,2.94-10.99,5.06-16.21 c4.23-10.46,9.85-20.22,16.06-29.51c6.25-9.28,13.25-18.03,20.77-26.32c15.09-16.53,32.34-31.24,51.73-43.25 c9.7-6,19.98-11.25,30.84-15.47c5.43-2.1,11.01-3.95,16.73-5.47l2.15-0.56l1.08-0.28l1.14-0.25c1.54-0.32,3.07-0.66,4.63-0.92 c1.57-0.23,3.14-0.47,4.71-0.67l4.79-0.4c6.43-0.34,13.05,0.06,19.58,1.44c6.53,1.37,12.96,3.71,18.92,6.97 c5.97,3.25,11.42,7.44,16.15,12.25c4.74,4.81,8.71,10.27,11.95,16.05c6.48,11.58,9.92,24.39,10.82,37.08 c0.91,12.7-0.48,25.35-3.72,37.3c-1.61,5.98-3.63,11.82-6.06,17.45c-2.46,5.61-5.25,11.03-8.32,16.27 c-3.12,5.19-6.5,10.2-10.12,14.99c-3.67,4.74-7.48,9.37-11.59,13.66c-8.14,8.69-17.12,16.39-26.52,23.34 c-9.41,6.95-19.27,13.12-29.44,18.58c-20.39,10.82-41.8,18.93-63.56,25.12c-10.93,3.1-22,5.54-33.11,7.59 c-11.11,2.02-22.28,3.63-33.48,4.62c-22.39,2.02-44.81,2.49-67.05,1.23c-11.12-0.6-22.2-1.48-33.22-2.75 c-11.02-1.3-21.98-2.9-32.87-4.76c-10.9-1.83-21.72-4.06-32.47-6.48c-10.75-2.44-21.43-5.1-32.01-8.07 c-21.19-5.85-42.05-12.7-62.56-20.33c-20.49-7.69-40.66-16.13-60.38-25.48c-9.87-4.64-19.62-9.53-29.25-14.62 C94.08,807.89,84.54,802.62,75.32,796.84z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M75.32,686.32c12.25,11.88,25.08,22.96,38.2,33.59c13.15,10.58,26.64,20.62,40.53,29.95 c13.84,9.39,28.09,18.04,42.69,25.86c3.67,1.91,7.3,3.89,11.02,5.68c3.7,1.83,7.37,3.71,11.13,5.37l5.61,2.57 c1.87,0.86,3.78,1.6,5.67,2.41l5.67,2.38c1.89,0.77,3.81,1.48,5.72,2.23l5.71,2.21l5.78,1.99l5.77,1.99l5.84,1.75l5.82,1.77 l5.87,1.54l5.86,1.55l5.91,1.28l5.9,1.29l5.95,1l5.94,1.02c1.98,0.28,3.97,0.51,5.96,0.77l5.95,0.76 c1.96,0.23,3.85,0.38,5.79,0.51c3.86,0.26,7.74,0.38,11.64,0.37c7.79-0.05,15.64-0.5,23.5-1.41c7.85-0.91,15.71-2.27,23.52-3.97 c15.64-3.34,31.16-8.04,46.34-13.8c15.23-5.65,30.18-12.32,44.73-19.8c14.61-7.36,28.8-15.64,42.48-24.55 c13.67-8.88,26.86-18.64,38.57-29.14c2.9-2.63,5.68-5.33,8.2-8.04c2.51-2.69,4.8-5.51,6.39-7.91c0.8-1.17,1.35-2.28,1.55-2.68 c0.12-0.2,0.07-0.13,0.09,0.44c0.02,0.55,0.13,1.83,0.93,3.35c0.37,0.75,0.93,1.44,1.45,1.96c0.26,0.27,0.56,0.49,0.78,0.67 c0.12,0.09,0.25,0.17,0.38,0.25c0.11,0.07,0.19,0.13,0.29,0.18c0.8,0.43,1.09,0.41,1.05,0.36c-0.18-0.12-1.36-0.33-2.78-0.3 c-1.46,0-2.94,0.12-5.12,0.38l-6.09,0.71c-4.07,0.5-8.15,1.07-12.22,1.71c-8.16,1.28-16.31,2.83-24.46,4.48 c-8.14,1.67-16.25,3.59-24.32,5.64c-8.08,2.03-16.09,4.33-24.03,6.81c-7.95,2.47-15.8,5.21-23.49,8.27 c-7.69,3.05-15.21,6.5-22.28,10.56c-3.53,2.04-6.9,4.29-9.97,6.81c-1.55,1.25-2.99,2.6-4.29,4.04c-1.32,1.43-2.45,2.98-3.34,4.62 c-0.89,1.64-1.51,3.39-1.71,5.23c-0.21,1.83,0.04,3.73,0.67,5.59c1.32,3.73,4.12,7.05,7.23,9.94c-3.65-2.16-7.23-4.84-9.61-8.82 c-1.17-1.98-1.94-4.3-2.12-6.72c-0.2-2.42,0.19-4.87,0.92-7.14c0.73-2.28,1.82-4.4,3.07-6.34c1.24-1.96,2.64-3.8,4.13-5.5 c2.97-3.45,6.31-6.45,9.75-9.25c6.89-5.62,14.34-10.3,21.92-14.65c7.59-4.33,15.42-8.15,23.31-11.78 c7.92-3.57,15.96-6.84,24.08-9.91c8.12-3.07,16.35-5.81,24.64-8.4c8.29-2.61,16.69-4.89,25.18-6.96c4.24-1.04,8.52-2,12.82-2.9 c2.15-0.45,4.31-0.89,6.49-1.27c2.01-0.38,4.74-0.85,7.53-1.06c2.82-0.2,5.92-0.29,9.9,0.48c2.02,0.44,4.34,1.11,6.96,2.64 c0.33,0.2,0.64,0.38,0.97,0.6c0.34,0.24,0.68,0.48,1.01,0.73c0.65,0.48,1.32,1.08,1.96,1.73c1.28,1.27,2.42,2.86,3.3,4.54 c0.42,0.83,0.78,1.7,1.09,2.55c0.26,0.82,0.52,1.71,0.67,2.5c0.32,1.62,0.42,3.13,0.39,4.48c-0.06,2.7-0.52,4.87-1.04,6.69 c-0.53,1.82-1.15,3.45-1.79,4.87c-0.64,1.45-1.32,2.75-2,3.98c-2.76,4.89-5.76,8.76-8.81,12.48c-3.06,3.68-6.21,7.07-9.43,10.33 c-6.43,6.5-13.11,12.46-20.02,18.07c-6.9,5.61-13.96,10.93-21.16,16.01c-7.19,5.11-14.6,9.86-22.1,14.45 c-7.51,4.58-15.14,8.95-22.9,13.1c-15.57,8.2-31.64,15.52-48.21,21.79c-16.62,6.12-33.71,11.27-51.34,14.78 c-8.82,1.71-17.75,3.05-26.79,3.89c-9.04,0.83-18.18,1.2-27.36,0.84c-4.59-0.17-9.19-0.48-13.79-0.98 c-2.29-0.25-4.62-0.53-6.87-0.87l-6.64-1.11c-2.21-0.38-4.43-0.72-6.63-1.13l-6.56-1.46l-6.54-1.48l-6.46-1.76l-6.45-1.77 l-6.36-2.04l-6.35-2.05l-6.24-2.32l-6.22-2.35l-6.11-2.58l-6.1-2.59l-5.99-2.8c-1.99-0.94-4-1.85-5.98-2.82l-5.86-3.04 c-1.94-1.03-3.91-2-5.83-3.07l-5.73-3.23c-3.85-2.1-7.57-4.41-11.31-6.67c-3.77-2.21-7.36-4.71-11.02-7.08l-2.73-1.8l-2.68-1.87 l-5.35-3.74c-3.55-2.51-7.02-5.14-10.49-7.73c-3.41-2.69-6.84-5.34-10.2-8.08l-5-4.14l-2.49-2.07l-2.44-2.14l-4.87-4.28 l-4.79-4.37c-3.2-2.89-6.31-5.88-9.4-8.88c-6.12-6.07-12.18-12.17-17.92-18.57c-5.79-6.35-11.37-12.87-16.73-19.55 C85.19,700.29,79.99,693.48,75.32,686.32z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st232",
    d: "M90.81,605.61c-3.32,6.23-6.2,12.61-8.6,19.1c-2.42,6.47-4.33,13.07-5.47,19.63 c-1.08,6.55-1.47,13.11-0.38,19.07c0.55,2.97,1.37,5.78,2.56,8.34c1.18,2.56,2.71,4.86,4.51,6.91c1.85,2.02,3.96,3.81,6.29,5.39 l1.79,1.14c0.62,0.36,1.28,0.68,1.91,1.03l0.95,0.51l1.01,0.45l2.01,0.9c5.53,2.21,11.58,3.76,17.87,4.71 c6.3,0.93,12.79,1.46,19.37,1.63c6.6,0.12,13.24-0.06,19.94-0.41c26.8-1.61,53.88-6.22,80.8-11.63 c13.45-2.79,26.97-5.79,40.33-8.97l9.93-2.43c3.3-0.84,6.56-1.76,9.85-2.63c3.29-0.85,6.53-1.82,9.78-2.76l4.87-1.42 c1.62-0.48,3.21-1.02,4.82-1.53c6.45-1.98,12.79-4.18,19.06-6.48c3.1-1.2,6.27-2.31,9.33-3.57c3.04-1.29,6.15-2.5,9.14-3.86 c12.07-5.3,23.57-11.45,34-18.53c5.11-3.63,10.04-7.43,14.39-11.61c4.29-4.21,8.2-8.64,11.36-13.37 c3.17-4.73,5.56-9.75,7.08-14.96c1.55-5.2,2.2-10.62,1.88-16.14c-0.33-5.51-1.63-11.13-3.74-16.61 c-2.12-5.49-5.11-10.81-8.65-15.88c-3.58-5.06-7.85-9.74-12.52-14.07c-4.67-4.34-9.85-8.22-15.36-11.59 c-1.36-0.89-2.79-1.62-4.19-2.45c-1.42-0.78-2.88-1.48-4.32-2.23c-1.48-0.64-2.95-1.35-4.45-1.96l-2.27-0.88l-1.14-0.45 l-1.15-0.39c-6.13-2.14-12.54-3.53-19.05-3.97c-6.49-0.31-13.13,0.31-19.48,2.42c-6.33,2.12-12.32,5.71-17.55,10.47 c3.77-5.97,9.11-11.16,15.45-15c6.39-3.76,13.71-6.08,21.19-7.08c7.49-0.99,15.12-0.6,22.58,0.62c7.47,1.23,14.74,3.49,21.72,6.43 c13.92,5.99,26.78,14.8,37.35,26.41c5.29,5.8,9.9,12.38,13.62,19.62c3.69,7.24,6.54,15.2,7.74,23.63 c1.24,8.4,1.01,17.17-0.73,25.58c-1.75,8.42-5.02,16.4-9.15,23.61c-4.15,7.22-9.15,13.72-14.63,19.53 c-5.5,5.8-11.45,10.87-17.56,15.63c-12.34,9.25-25.53,16.64-38.96,22.91c-1.67,0.83-3.37,1.53-5.06,2.27l-5.08,2.2 c-3.39,1.45-6.82,2.72-10.24,4.09c-6.87,2.55-13.76,4.98-20.7,7.13c-13.88,4.31-27.86,8.02-41.91,11.03 c-3.52,0.82-6.98,1.46-10.47,2.2c-3.48,0.72-6.96,1.43-10.47,2.06c-3.5,0.64-6.99,1.32-10.51,1.94l-10.55,1.76 c-14.11,2.2-28.3,4.16-42.65,5.33c-14.34,1.25-28.82,1.89-43.46,1.43l-5.49-0.2c-1.83-0.06-3.68-0.25-5.51-0.37 c-3.67-0.23-7.37-0.69-11.05-1.09c-7.39-0.94-14.81-2.26-22.2-4.33c-7.37-2.08-14.78-4.77-21.8-8.81l-2.6-1.63l-1.29-0.82 l-1.26-0.91c-0.83-0.62-1.67-1.21-2.49-1.85l-2.39-2.04c-3.11-2.82-6.01-6-8.33-9.62c-2.3-3.63-4.07-7.59-5.2-11.64 c-1.14-4.05-1.68-8.17-1.67-12.17c-0.02-8.04,1.79-15.54,4.38-22.48c2.57-6.96,6-13.38,9.85-19.43 C81.67,616.47,85.95,610.75,90.81,605.61z"
  })))), _g351 || (_g351 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st233",
    d: "M214.68,2160c0,0,238.73-99.94,185.81-155.23c0,0,250.99-176.54,130.14-271.96 c0,0,359.15-326.15,191.92-412.07c0,0,235.26-183.64-83.05-296.61c0,0,175.72-28.87,194.41-175.42 c18.7-146.54-204.94-109.59-133.38-210.13s94.3-95.68,94.3-95.68s149.7-79.13,0-125.61s-259.75-18.53-277.5,65.04 c0,0-149.92-2.5-52.87-77.14s167.21-135.47,274.58-114.34s316.3-7.12,279.97-93.64C982.68,110.68,886.96,31.6,784.62,33.98 s-123.66,65.7-123.66,65.7S712.57-1.11,678.85-0.56L0,0v2160H214.68z"
  }))), _g352 || (_g352 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st234",
    d: "M16.48,10.68c0,0,359.49,127.92,532.78,121.7c173.29-6.22,388.93-98.07,375.56,12.89 c0,0-31.95-53.12-118.66-12.89s-9.3,55.34-117.68,84.95s-327.49,84.7-318.58,160.89s1.04,235.8,92.98,217.29 c91.94-18.51,138.89-190.44,225.6-153.38s49.55,127.58,24.78,148.9c0,0,8.37-63.3-48.46-22.54s-118.76,107.88-72.31,188.9 s147.57,70.27,106.3,157.71c0,0-0.9-61.15-103.15-33.31c-102.25,27.84-70.3,49.31-131.18,167.1s-219.57,114.74-226.93,215.36 c0,0,52.23-32.86,132.37-40.44s151.44,75.16,210.24-17.31c58.8-92.47,199.17-89.97,158.91,21.49c0,0-30.45-78.29-74.57-4.77 c-44.12,73.52,35.71,104.42,14.38,189.62c-21.34,85.2-352.44,36.47-402.11,156.83s130.04,67.26,167.15,154.2 c0,0-17.87-60.1-73.99-20.65c-56.12,39.46-38.07,92.16-62.58,172.65s-148.38,154.59-216.51,98.96 C22.68,1919.19,41.1,2160,41.1,2160H0V0L16.48,10.68z"
  }))), _g353 || (_g353 = /*#__PURE__*/React.createElement("g", {
    id: "green-car"
  }, /*#__PURE__*/React.createElement("image", {
    width: 130,
    height: 170,
    href: "http://185.119.57.142:4500/csgorace/svg/1car.svg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "red-frame"
  }, /*#__PURE__*/React.createElement("image", {
    width: 110,
    height: 130,
    href: "http://185.119.57.142:4500/csgorace/svg/1frame.svg"
  })))), _g354 || (_g354 = /*#__PURE__*/React.createElement("g", {
    id: "blue-car"
  }, /*#__PURE__*/React.createElement("image", {
    width: 130,
    height: 170,
    href: "http://185.119.57.142:4500/csgorace/svg/2car.svg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "blue-frame"
  }, /*#__PURE__*/React.createElement("image", {
    width: 110,
    height: 130,
    href: "http://185.119.57.142:4500/csgorace/svg/2frame.svg"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u0415\\u0420\\u0415\\u041A\\u0420\\u042B\\u0412\\u0410\\u042E\\u0422_\\u0422\\u0420\\u0410\\u0421\\u0421\\u0423"
  }, /*#__PURE__*/React.createElement("g", null, _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "2251.82,1652.9 2235.95,1811.61 2251.82,1885.93 2297.5,1885.93 2334.66,1914.96 2497.24,1875.87  2508.85,1835.61 2514.66,1697.8 2527.43,1628.12 2251.82,1652.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 2235.9495,
    y1: 1769.4148,
    x2: 2270.4011,
    y2: 1769.4148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st235",
    points: "2251.82,1652.9 2235.95,1811.61 2251.82,1885.93 2270.4,1835.61  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 2297.4978,
    y1: 1875.2858,
    x2: 2347.8203,
    y2: 1875.2858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st236",
    points: "2334.66,1914.96 2347.82,1875.87 2313.76,1835.61 2297.5,1885.93  "
  })), _g355 || (_g355 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M2270.4,1835.61c-1.39-7.55-2.74-15.1-4.02-22.67l-1.94-11.34l-1.85-11.35l-1.85-11.35 c-0.31-1.89-0.62-3.78-0.81-5.69c-0.21-1.9-0.31-3.81-0.5-5.72l-2.3-22.84l-9.29-91.35l-0.29-2.86l2.62-1.19l198.19-89.81 l1.4-0.64l1.47,0.47l9.68,3.1c3.22,1.06,6.51,1.89,9.69,3.07l18.98,7.36c6.33,2.44,12.64,4.96,18.95,7.45 c6.32,2.49,12.61,5.04,18.9,7.61c-6.61-1.56-13.22-3.14-19.81-4.78c-6.59-1.64-13.19-3.24-19.76-4.93l-19.73-5.03 c-3.27-0.88-6.43-2.12-9.67-3.13l-9.68-3.1l2.87-0.17l-198.19,89.81l2.33-4.05l9.29,91.35l2.34,22.84c0.2,1.9,0.48,3.8,0.66,5.7 c0.2,1.9,0.28,3.82,0.35,5.73l0.47,11.49l0.47,11.49l0.39,11.5C2270.04,1820.26,2270.25,1827.93,2270.4,1835.61z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 2251.8203,
    y1: 1719.4794,
    x2: 2527.4333,
    y2: 1719.4794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st237",
    points: "2270.4,1835.61 2313.76,1835.61 2347.82,1875.87 2508.85,1835.61 2527.43,1699.35 2508.85,1674.58  2527.43,1628.12 2527.43,1587.87 2450.01,1563.09 2251.82,1652.9  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 2298.272,
    y1: 669.6729,
    x2: 2756.5945,
    y2: 669.6729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DF946D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    style: {
      stopColor: "#E58B68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F1785E"
    }
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st238",
    d: "M2340.08,788.9l-41.81-122.32l54.19-29.42l21.68-55.74l142.45-97.55l103.74,23.23 c0,0,27.87,57.29,35.61,57.29s60.39,17.03,60.39,17.03l30.97,68.13l9.29,119.23l-51.1,40.26l-4.65,20.13l-82.06,26.32l-55.74-10.84 l-69.68-41.81L2389.63,792L2340.08,788.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u043E\\u0431\\u043B\\u0430\\u043A\\u0430"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 2070.0315,
    y1: 792.2229,
    x2: 2045.6906,
    y2: 1006.1671
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st239",
    d: "M1631.44,888.23c0,0,81.44-114.92,181.44-89.59c100,25.33,182.47-2.89,252.54-5.37 c70.07-2.48,114.93,47.61,218.28,59.42c103.35,11.81,217.12,36.19,205.14,51.87c-11.98,15.68-112.43,51.92-227.89,49.28 s-139.26-44.35-215.61-34.33c-76.35,10.02-114.1,71.5-225.29,60.89C1708.86,969.79,1598.11,925.43,1631.44,888.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 3550.6614,
    y1: 1356.9143,
    x2: 3530.8469,
    y2: 1531.0721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st240",
    d: "M3198.75,1420.04c0,0,180.96-0.7,277.16-33.6s203.01-23.25,283.35,7.37 c80.34,30.61,173.88,42.79,138.04,65.25c-35.85,22.45-119.8-7.66-200.15,12.04s-96.31,61.82-179.22,57.44 C3435.04,1524.16,3084.17,1473.16,3198.75,1420.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 3739.5879,
    y1: 420.5114,
    x2: 3717.4543,
    y2: 615.0534,
    gradientTransform: "matrix(0.9776 0.2105 -0.2105 0.9776 147.6216 -545.2084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st241",
    d: "M3427.72,762.45c0,0,155.39,58.97,215.7,46.45c60.31-12.52,210.89,9.04,264.08-2.58 c53.19-11.62,98.58-52.51,39.16-74.82c-59.42-22.31-106.96,11.68-203.01-4.2s-295.2-39.51-324.39-29.46 C3390.05,707.88,3379.86,745.89,3427.72,762.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u0415\\u041D\\u0418",
    className: "st94"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 2118.3813,
    y1: 111.8209,
    x2: 2164.833,
    y2: 381.2402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st242",
    d: "M1687.24,228.12l19.17,91.08l55.74,13.16l56.9-27.87l104.52,5.42l20.52-41.81l-4.26,51.1l48.84,20.9h145.09 l44.79-13.94l77.09,13.94l127.11-7.74l36.68-27.87l114.97-5.03c0,0,19.74-15.6,23.23-15.35c3.48,0.25,36.39,0,36.39,0l0,0 l-12.77-104.65l-5.81,4.26h-27.1l-20.9-8.52l-10.84,6.97l-120,3.1l-40.26,20.9l-50.35,2.89l-44.1,2.26l-79.74-15.99l-52.65,8.24 l-154.84,2.32c0,0-29.49-5.68-30.58-5.15s-25.16,12.11-25.16,12.11l-99.87,10.45l-73.55,20.52L1687.24,228.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 2500.5791,
    y1: 592.3553,
    x2: 2456.4502,
    y2: 980.2263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st243",
    points: "2077.26,760.03 2086.14,834.2 2114.01,861.94 2202.27,865.95 2222.4,861.94 2241,881.8  2292.08,891.87 2298.27,963.25 2357.89,1021.16 2490.27,974.74 2549.11,1021.16 2617.24,1045.93 2728.72,1035.87 2773.63,1013.41  2858.79,970.62 2869.63,901.67 2750.29,802.83 2733.37,894.19 2711.69,908.12 2699.3,925.16 2624.98,939.09 2566.14,926.71  2499.56,872.51 2389.63,881.8 2332.34,855.48 2307.56,819.61 2241,801.17 2225.91,782.72 2211.97,790.84 2102.81,780.39  2077.26,760.03  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 2428.7661,
    y1: 1416.0695,
    x2: 2370.9602,
    y2: 1924.153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st244",
    points: "2235.95,1817.41 2244.08,1945.16 2297.5,1960.25 2322.66,1986.96 2507.69,1942.83 2527.43,1723.87  2543.69,1699.35 2520.67,1665.02 2516.98,1684.64 2527.43,1699.35 2508.85,1835.61 2497.24,1875.87 2334.66,1914.96  2297.5,1885.93 2251.82,1885.93  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 1120.4396,
    y1: 920.3104,
    x2: 1337.2137,
    y2: 1019.4072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st245",
    d: "M1530.76,383.22l22.35,83.61l-22.35,62.71l-25.26,13.94l-61.45,73.16l-51.1,202.97l-67.45,258.06 l-11.57,46.45l-7.76,49.94l-6.22,13.93l6.22,89.43l-13.9,21.68c0,0-11.18,51.07-12,54.2s12,35.41,12,35.41l-16.73,53.61 l-77.68,120.77l-33.55,101.93l47.21-202.74l8.99,4.46l25.19-33.72l15.16-55.48l9.71-35.87l-2.84-17.03l-20.82-9.09l17.07-70.78 l18.4-18.45l11.37-40.26l-11.95-15.15l40.62-174.05h3.21l5.33-22.12l31.56-130.86l5.53-30.6l4.2-17.41l2.56-37.16l5.15-72.39 l3.61-54.9l12.7-94.13l86.31-43.76l14.02-14.69l20.92-40.65L1530.76,383.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 2009.2418,
    y1: 713.0971,
    x2: 1988.5352,
    y2: 895.0977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st246",
    d: "M1985.09,796.84c0,0,1.76,42.77,0.11,48.19c-1.64,5.42-28.36,10.45-28.94,17.42 c-0.58,6.97-5.21,28.65,5.43,26.32s11.87-17.03,15.71-17.42c3.83-0.39,9.87-1.55,9.87-1.55s1.33,25.94,1.71,36.39 c0.38,10.45,21.55,23.23,26.45,9.29c4.9-13.94-9.99-79.35-9.99-79.35s10.1-0.39,12.11,7.35c2.01,7.74,9.36,15.48,11.68,8.9 c2.32-6.58-4.31-23.98-7.77-25.54c-3.46-1.56-18.05-7.36-18.05-7.36l-1.61-21.8C2001.81,797.68,1995.14,803.22,1985.09,796.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 2013.6807,
    y1: 1927.4844,
    x2: 1995.5488,
    y2: 2086.8538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st247",
    d: "M1982.68,2000.8c0,0,4.56,58.55,4.27,59.71c-0.29,1.16-28.01,10.06-26.73,22.45 c1.28,12.39,10.61,10.84,15.43,3.48c4.82-7.35,16.19-12,16.19-12s0.43,24.77,3.43,29.42s18.98,12.39,19.7-6.58 c0.72-18.97-5.67-56.52-5.67-56.52s8.21,2.71,13.69,7.74c5.48,5.03,18.84-4.65,11.39-10.45c-7.45-5.81-24.89-8.13-25.07-9.29 c-0.19-1.16-2.86-27.3-2.86-27.3S1989.15,2004.96,1982.68,2000.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 2015.1443,
    y1: 407.8081,
    x2: 2002.6974,
    y2: 517.2098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st248",
    d: "M2001.48,457.82l1.62,37.28c0,0-18.45,10.45-18.41,17.81c0.03,7.35,5.54,3.1,7.43,0 c1.89-3.1,12.26-6.61,12.26-6.61s0.18,23.05,1.87,25.09s11.69,2.88,11.92-4.7c0.23-7.58-4.44-45.91-4.44-45.91 s4.03,10.84,6.47,10.06c2.45-0.77,6.32-5.03,3.99-8.9c-2.32-3.87-10.91-12.39-10.91-12.39l-2.81-10.91 C2010.48,458.63,2004.31,460.02,2001.48,457.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 1653.4435,
    y1: 243.911,
    x2: 1642.9182,
    y2: 336.423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st249",
    d: "M1636.73,285.78l2.33,32.15c0,0-6.74,9.1-7.7,13.84c-0.96,4.74,1.14,8.83,3.19,8.33 c2.04-0.5,1.68-6.69,3.8-7.46c2.12-0.77,2.7,0,2.7,0s0.18,15.96,4.31,16.5c4.13,0.53,3.74-12.63,3.74-12.63l-1.92-32.26 c0,0,6.06,3.93,6.24,7.82s4.33,5.5,4.33,0s-7.33-14.02-9.21-14.79c-1.88-0.77-2.81-10.83-2.81-10.83S1639.19,287.43,1636.73,285.78 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 2782.7764,
    y1: 1457.8438,
    x2: 2768.8711,
    y2: 1580.0621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st250",
    d: "M2764.69,1514.57l0.12,32.52c0,0-15.36,11.87-17.47,18.58c-2.1,6.71-5.64,13.94,0,13.94 s8.87-7.23,9.83-11.35c0.97-4.13,7.64-5.16,7.64-5.16s-6.23,22.19,0,28.39c6.23,6.19,24.63,9.29,23.95,3.1 c-0.68-6.19-5.4-47.48-5.4-47.48s0.44,8.02,5.42,9.17c4.98,1.15,10.15-5.56,8.08-8.14c-2.07-2.58-13.5-11.95-13.5-11.95 l-0.32-20.93C2783.03,1515.24,2768.65,1516.63,2764.69,1514.57z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st251",
    d: "M2802.62,317.6l77.07,191.74l27.77,3.95l41.67,48.37l3.05,32.55l33.49,13.19l14.4,95.04l16.64-69.9 l19.35-19.39l28.01,45.28l12.25,40.83l-27.49-2.81l-10.44,63.58l85.73,225.57l83.05,32.33c0,0,24.77,61.02,29.42,56.89 c4.65-4.12,195.1,0,195.1,0l-21.68-100.09l-133.16,10.87l-66.11-87.69c0,0-6.45,5.9-15.18,5.07c-8.72-0.83-51.2-5.14-51.2-5.14 l-74.66-170.59l9.34-27.98l-11.61-40.83l-28.65-45.28l-2.19-1.42l-10.61,11.53l-11.97-27.75l-22.61-52.43l-11.44-26.54 l-57.45-85.02l-65.42-96.82L2802.62,317.6z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st252",
    d: "M1166.4,317.8c-0.77-3.87-8.13-10.84-13.16-9.68c-2.32,0.54-20.3,11.24-39.45,23.84 c-3.31-1.01-7.56-2.15-10.68-2.42c-5.87-0.52-6.13,4.11-6.13,4.11s7.78-0.12,12.8,0.97c-4.27,2.85-8.55,5.76-12.68,8.65 c-5.02-2.8-14.43-5.36-14.83-5.86c-0.52-0.66-6.71,3.24,0,4.53c3.96,0.76,7.73,2.96,10.16,4.63c-7.16,5.12-13.63,10.04-18.51,14.26 c-8.89-0.48-32.33-1.47-38.36,1.24c-7.48,3.35,0,4.65,0,4.65s15.69-5.12,23.48-2.03c2.93,1.17,5.74,2.06,8.11,2.71 c-1.08,1.28-1.83,2.4-2.17,3.32c-4.65,12.51-4.26,14.44-14.32,17.15c-10.06,2.71-33.68,9.96-36.39,22.21 c-2.71,12.24-13.35,53.66-15,57.53c-1.65,3.87-17.9,14.72-17.9,14.72l-8.64,23.95c0.72,1.05-8,8.55,7.87,9.71 c15.87,1.16,38.48,2.32,51.18-6.58c12.7-8.9,13.47-20.9,21.6-32.52c8.13-11.61,32.52-39.59,41.42-50.38 c8.9-10.78,18.64-17.36,10.48-23.95c-8.16-6.58-23.25-23.61-27.51-26.71c-1.09-0.79,4.36-13.47,12.31-8.13 c2.11,1.42,7.88,3.89,8.49,9.81c0.84,8.08-2.99,22.06,6.71,17.29c2.18-1.07,11.78-5.84,9.52-10.32 c-3.39-6.72-19.82-16.99-18.84-23.48c0.67-4.45,4.2-7.93,8.51-10.71c3.65,5.03,13.32,19.02,11.4,23.51 c-2.36,5.52-3.39,11.19-0.04,9.39c3.35-1.81,3.35-3.1,3.35-3.1c0.77,0.52,4.39,1.03,1.81-7.23c-2.15-6.89-8.79-21.12-10.93-25.66 c4.85-2.35,9.6-4.02,11.84-5.3c4.43-2.54,9.45-5.06,14.49-7.49c0,0,3.69,17.8-0.28,21.08c-3.98,3.28-9.95,7.31-9.95,7.31l1.29,3.87 c1.29,0,13.74,0.52,16.42-9.29c2.68-9.81-1.45-20.39-1.45-20.39l-6.02-2.58C1151.61,327.12,1166.98,320.71,1166.4,317.8z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st253",
    d: "M3708.66,526.05l28.6,185.43l10.78,43.35l-54.88,294.07l82.79,334.58l119.25,315.87l203.17,176.52v-40.26 l-135.82-151l-2.15-96.33l-85.85-267.9c0,0,108.32,63.9,121.39,63.1c13.07-0.8,102.43,13.68,102.43,13.68v-239.43l-40.59,125.11 l-114.58-177.48l-151.74-30.52l23.58-317.43L3708.66,526.05z"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st254",
    points: "3043.09,103.18 3096.46,119.06 3187.58,103.18 3291.33,95.19 3322.45,81.53 3376,94.17  3579.32,92.62 3693.15,132.38 3799.66,132.38 3895.76,95.19 4002.93,124.61 4025.26,106.96 4048.48,119.06 4082.55,119.06  4098.37,81.53 4096,23.39 4076.88,62.37 4029.97,62 4013.45,54.36 4000.24,62 3858.08,59.03 3817.88,81.53 3697.23,82.72  3603.77,59.07 3541.01,66.24 3376,61 3321.78,52.31 3291.33,65.58 3172.58,72.42 3084.42,92.62 3030.33,77.88  "
  }))), _g356 || (_g356 = /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u0420\\u041E\\u0412\\u041E\\u0414\\u0410",
    className: "st94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st255",
    d: "M698.79,1339.44"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st256",
    d: "M0,1366.42c87.26,7.74,245.75-18.7,245.75-18.7s610.2,34.65,647.75,10.43c0,0,247.8,133.74,287.4,121.17 c0,0,516.53,172.03,721.72,83.78c0,0,643.39,21.24,953.84-62.15c0,0,978.43,65.4,1139.47-16.71c0,0,37.26,25.22,100.07,21.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st256",
    d: "M0,1332.82c77.97,6.65,261.41-22.52,261.41-22.52s610.2,34.65,647.75,10.43 c0,0,239.16,135.81,278.76,123.24c0,0,534.38,165.57,739.58,77.32c0,0,649.84,26.47,960.3-56.92c0,0,981.24,62.12,1142.28-19.98 c0,0,33.31,3.93,65.93,5.37"
  })))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "pathCars",
    d: "M1526 2053.39c-3.73 0-7.41-.04-11.07-.1-93.23-1.77-168.24-26.09-222.95-72.29-48.03-40.56-78.47-95.65-90.46-163.73-11.27-63.97-6.11-137.52 15.76-224.85l.29-1.13L1506.3 495.36l.89-2.71c4.07-12.41 28.04-77.55 100.07-141.14 41.61-36.73 91.3-65.79 147.69-86.35 66.92-24.4 143.45-36.78 227.45-36.78 163.76 0 335.28 3.14 480.21 25.94 82.85 13.03 149.5 31.25 203.75 55.7 71.4 32.17 122.08 76.27 150.61 131.05 76.6 147.08 217.46 469.05 228.43 494.18 4.86 10.51 26.19 58.66 39.7 121.44 9.02 41.91 12.7 81.95 10.94 119.02-2.44 51.55-15.35 97.73-38.38 137.23-24.23 41.58-58.94 74.79-103.15 98.73-44.11 23.88-97.94 38.27-159.99 42.79-24.82 1.8-48.74 3.46-71.88 5.05-111.44 7.69-207.69 14.32-273.78 30.17-71.24 17.08-81.54 38.25-85.94 47.29-9.16 18.84-18.02 39.14-27.39 60.63-22.66 51.96-48.34 110.85-86.27 164.83-47 66.88-104.29 114.51-175.14 145.61-117.56 51.6-227.98 90.28-328.21 114.95C1663.88 2043.17 1589.97 2053.39 1526 2053.39z",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaceTrack);
export default __webpack_public_path__ + "static/media/race-track.6497da65.svg";
export { ForwardRef as ReactComponent };